export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601Date: { input: string; output: string; }
  ISO8601DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  Uuid: { input: string; output: string; }
};

/** Details of the result of looking up support-worker(s) by ABN - eg a business entity */
export type AbnLookup = {
  __typename?: 'AbnLookup';
  /** Status of the entity's ABN */
  abnStatus?: Maybe<Scalars['String']['output']>;
  /** Name of the ABN entity */
  entityName?: Maybe<Scalars['String']['output']>;
  /** Type of entity this ABN belongs to */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Error message if an error occurred */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Location of the ABN entity */
  location?: Maybe<Scalars['String']['output']>;
  /** Does this ABN entity match a user */
  matchesUser?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AcceptCancelFlexJobs */
export type AcceptCancelFlexJobsInput = {
  /** which action are we performing on the flex job */
  action: ClientFlexJobActionOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** id of the flex job to update */
  id: Scalars['ID']['input'];
  /** The ID of the worker whose match we are accepting/cancelling */
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AcceptCancelFlexJobs */
export type AcceptCancelFlexJobsPayload = {
  __typename?: 'AcceptCancelFlexJobsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated flex match response */
  flexMatch?: Maybe<JobMatch>;
  /** Returns the updated Job response */
  job?: Maybe<PostedJob>;
};

/** Autogenerated input type of AcceptCancelTaxAndSuperSyncTerms */
export type AcceptCancelTaxAndSuperSyncTermsInput = {
  /** Desired state of tax and super terms and conditions */
  accepted: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the user */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptCancelTaxAndSuperSyncTerms */
export type AcceptCancelTaxAndSuperSyncTermsPayload = {
  __typename?: 'AcceptCancelTaxAndSuperSyncTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns updated user */
  user?: Maybe<User>;
};

/** Autogenerated input type of AcceptCancelUserOrganisationTerm */
export type AcceptCancelUserOrganisationTermInput = {
  /** What action are we taking (eg accepted/cancelled) */
  action: UserOrganisationTermStatusOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of which organisation is this for */
  userOrganisationTermId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptCancelUserOrganisationTerm */
export type AcceptCancelUserOrganisationTermPayload = {
  __typename?: 'AcceptCancelUserOrganisationTermPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns updated terms user_organisation_term */
  userOrganisationTerm?: Maybe<UserOrganisationTerm>;
};

/** Autogenerated input type of Accept */
export type AcceptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reason for accepting the request */
  reason?: InputMaybe<ApplicationAcceptReason>;
  /** UUID of the request to update */
  requestUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of Accept */
export type AcceptPayload = {
  __typename?: 'AcceptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the response of the update (JSON containing status and body) */
  response: Scalars['JSON']['output'];
};

/** Autogenerated input type of AcceptRescheduleRequest */
export type AcceptRescheduleRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reschedule request ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptRescheduleRequest */
export type AcceptRescheduleRequestPayload = {
  __typename?: 'AcceptRescheduleRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the rescheduled scheduled-event/session */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Represents account holder for an organisation's client */
export type AccountHolder = {
  __typename?: 'AccountHolder';
  /** First name of account holder */
  firstName: Scalars['String']['output'];
  /** Full name of account holder */
  fullName: Scalars['String']['output'];
  /** Id of account holder */
  id: Scalars['ID']['output'];
  /** Account holder permalink */
  permalink: Scalars['String']['output'];
};

/** Autogenerated return type of Account */
export type AccountPayload = {
  __typename?: 'AccountPayload';
  /** User to subscribe to */
  user: User;
};

/** Message in an activity feed on a conversation */
export type ActivityFeed = {
  __typename?: 'ActivityFeed';
  /** Text of message */
  message: Scalars['String']['output'];
  /** When was this message sent */
  timestamp: Scalars['ISO8601DateTime']['output'];
};

/** Activity log for delivered sessions */
export type ActivityLog = {
  __typename?: 'ActivityLog';
  /** Activity name */
  activityType: DeliveredSessionActivityLog;
  /** Time the activity was logged */
  occurredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of AddSavedJob */
export type AddSavedJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The job ID that will be saved */
  postedJobId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddSavedJob */
export type AddSavedJobPayload = {
  __typename?: 'AddSavedJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns newly created shortlist-item if success */
  shortlist?: Maybe<ShortlistItem>;
};

/** Details of an adjustment note */
export type AdjustmentNote = {
  __typename?: 'AdjustmentNote';
  /** ID of the Adjustment Note */
  id: Scalars['ID']['output'];
  /** Link to the adjustment note asset */
  link?: Maybe<Scalars['String']['output']>;
};

/** Agreed flat rate for a service */
export type AgreedFlatRate = {
  __typename?: 'AgreedFlatRate';
  /** Net cents charged to the client */
  clientNetCents?: Maybe<Scalars['Int']['output']>;
  /** Id of the agreedFlatRate */
  id: Scalars['ID']['output'];
  /** cents agreed for this rate */
  rateCents: Scalars['Int']['output'];
  /** Service category for flat rate */
  serviceCategoryable: Service;
  /** Net cents the worker will receive */
  workerNetCents?: Maybe<Scalars['Int']['output']>;
};

/** Agreed hourly rate for a service */
export type AgreedHourlyRate = {
  __typename?: 'AgreedHourlyRate';
  /** Net cents charged to the client */
  clientNetCents?: Maybe<Scalars['Int']['output']>;
  /** Id of the agreedHourlyRate */
  id: Scalars['ID']['output'];
  /** cents agreed for this rate */
  rateCents: Scalars['Int']['output'];
  /** Service category for hourly rate */
  serviceCategoryable: ServiceCategoryable;
  /** Time block assigned for this rate */
  timeBlock: TimeBlock;
  /** Net cents the worker will receive */
  workerNetCents?: Maybe<Scalars['Int']['output']>;
};

/** Agreed hourly rate for a service */
export type AgreedPerKmRate = {
  __typename?: 'AgreedPerKmRate';
  /** Net cents charged to the client */
  clientNetCents?: Maybe<Scalars['Int']['output']>;
  /** Id of the agreedHourlyRate */
  id: Scalars['ID']['output'];
  /** cents agreed for this rate */
  rateCents: Scalars['Int']['output'];
  /** Service category for per km rate */
  serviceCategoryable: ServiceCategoryable;
  /** Net cents the worker will receive */
  workerNetCents?: Maybe<Scalars['Int']['output']>;
};

/** Rates in the agreement which can be per km, flat or hourly rates */
export type AgreedRateAttributes = {
  /** Flat rates negotiated for this agreement */
  agreedFlatRates?: InputMaybe<Array<FlatRateAttributes>>;
  /** Hourly rates negotiated for this agreement */
  agreedHourlyRates: Array<HourlyRateAttributes>;
  /** Per KM rates negotiated for this agreement */
  agreedPerKmRates?: InputMaybe<Array<PerKmRateAttributes>>;
};

/** Agreement between a customer and a carer */
export type Agreement = {
  __typename?: 'Agreement';
  /** Agreed flat rates for this agreement */
  agreedFlatRates?: Maybe<Array<AgreedFlatRate>>;
  /** Whether the participants have agreed on dates and times for their support sessions */
  agreedOnSchedule?: Maybe<Scalars['Boolean']['output']>;
  /** Agreed per KM rates for this agreement */
  agreedPerKmRates?: Maybe<Array<AgreedPerKmRate>>;
  /** Service that will be undertaken by the carer */
  agreedService?: Maybe<Scalars['String']['output']>;
  /** Fields being amended on this agreement */
  agreementAmendment?: Maybe<AgreementBase>;
  /** Hourly rates negotiated for this agreement */
  agreementRates: Array<AgreementRate>;
  /** Audit trail of the agreement */
  auditTrail?: Maybe<Array<AuditTrail>>;
  /** Actions available on the agreement */
  availableActions?: Maybe<AgreementAvailableActions>;
  /** What type of carer are we eg Nurse */
  carerType?: Maybe<Scalars['String']['output']>;
  /** Returns true if Client is the participant */
  consumerIsParticipant?: Maybe<Scalars['Boolean']['output']>;
  /** Client's relationship with participant */
  consumerRelationship?: Maybe<Scalars['String']['output']>;
  /** Conversation among both participants in the agreement */
  conversation: Conversation;
  /** When this agreement was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Current user */
  currentUser?: Maybe<User>;
  /** Customised agreement status field. `requested` to `Agreement requested`, `initiated` to `Pending` and `agreement_amended` to `Changes requested` */
  customStatus?: Maybe<Scalars['String']['output']>;
  /** The days and times that the participants have agreed to providing or receiving support */
  daysAndTimes?: Maybe<AgreementDaysAndTimes>;
  /** Expected date that the agreement between the participants would come to an end */
  expectedEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Expected date that the agreement between the participants would start */
  expectedStartDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Percentage of carer's rates that Mable charges */
  feePercentage?: Maybe<Scalars['String']['output']>;
  /** Date when this agreement was grandfathered */
  grandfatheredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of this agreement */
  id: Scalars['ID']['output'];
  /** Check if the agreement is accepted. */
  isAccepted: Scalars['Boolean']['output'];
  /** Check if the agreement is pending for customer acceptance. */
  isPending: Scalars['Boolean']['output'];
  /** Check if the customer requested for an agreement */
  isRequested: Scalars['Boolean']['output'];
  /** Job attached to the agreement */
  job?: Maybe<PostedJob>;
  /** Whether it's an ongoing on once off job. */
  jobFrequency?: Maybe<PostedJobFrequencyOptions>;
  /** Whether it's a a weekly,fornightly, monthly or other job */
  jobOccurrence?: Maybe<AgreementJobOccurrenceOptions>;
  /** Type of NDIS plan this customer has */
  ndisPlan?: Maybe<NdisPlan>;
  /** Date when the next assessment will be generated for this agreement. */
  nextAssessmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Other participant in the agreement */
  otherUser: User;
  /** Assessment of carer's reliability */
  pendingCarerReliabilityAssessment?: Maybe<CarerReliabilityAssessment>;
  /** Per Km rate in cents */
  perKmRate?: Maybe<Scalars['Int']['output']>;
  /** Per Km rate in dollars */
  perKmRateInDollars?: Maybe<Scalars['String']['output']>;
  /** Agreed ndis support items in the agreement */
  planSupportItems?: Maybe<Array<PlanSupportItem>>;
  /** Returns true if support pair is eligible for QuickPay */
  quickpayEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Timing details of your support sessions e.g. 9am to 11am every fortnight */
  scheduleDescription?: Maybe<Scalars['String']['output']>;
  /** Summary of the agreed scheduling */
  scheduleSummary?: Maybe<Scalars['String']['output']>;
  /** groups of agreed hourly rates for services linked to this agreement */
  serviceGroups?: Maybe<Array<Array<AgreedHourlyRate>>>;
  /** Summary of easch of the agreed sessions */
  sessionSummaries?: Maybe<Array<Scalars['String']['output']>>;
  /** Indicates whether or not the agreement has planned sessions */
  sessionsPlanned: Scalars['Boolean']['output'];
  /** Available status: requested, initiated, offer_amended, offer_declined, accepted, agreement_amended, amendments_accepted, amendments_declined, terminated */
  status: Scalars['String']['output'];
  /** Support terms for cancelling sessions */
  supportCancel?: Maybe<Scalars['String']['output']>;
  /** Support terms for changing or adding sessions */
  supportChange?: Maybe<Scalars['String']['output']>;
  /** Support terms for feedback, complaints or disputes */
  supportFeedback?: Maybe<Scalars['String']['output']>;
  /** Support terms for minimum hours, finishing early and overtime */
  supportMinHours?: Maybe<Scalars['String']['output']>;
  /** Agreement will go either Active or Pending tab */
  tab?: Maybe<Scalars['String']['output']>;
  /** The server time this agreement was terminated */
  terminatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Accepted values for 'termination_reason' when terminating the agreement for this user */
  terminationReasons: Array<AgreementTerminationReason>;
  /** ??? Does this agreement include travel expenses */
  travelExpenseFlag?: Maybe<Scalars['Boolean']['output']>;
  /** `AgreementAmendment` when the agreement is an amendment otherwise null. */
  type?: Maybe<Scalars['String']['output']>;
  /** UUID for this agreement */
  uuid?: Maybe<Scalars['String']['output']>;
  /** Has the other party viewed the acceptance of this agreement */
  viewedAcceptance: Scalars['Boolean']['output'];
  /** ??? Welcome message displayed when... ??? */
  welcomeMessage: Scalars['String']['output'];
};

/** What actions are available for this agreement */
export type AgreementAvailableActions = {
  __typename?: 'AgreementAvailableActions';
  /** Can the party accept this agreement? */
  canAcceptAgreement: Scalars['Boolean']['output'];
  /** Can the party ask for feedback? */
  canAskForFeedback: Scalars['Boolean']['output'];
  /** Can the party view this agreement? */
  canViewAgreement: Scalars['Boolean']['output'];
  /** Can the party view the other party's profile? */
  canViewProfile: Scalars['Boolean']['output'];
};

/** Fields relating to an agreement */
export type AgreementBase = {
  __typename?: 'AgreementBase';
  /** Agreed flat rates for this agreement */
  agreedFlatRates?: Maybe<Array<AgreedFlatRate>>;
  /** Whether the participants have agreed on dates and times for their support sessions */
  agreedOnSchedule?: Maybe<Scalars['Boolean']['output']>;
  /** Agreed per KM rates for this agreement */
  agreedPerKmRates?: Maybe<Array<AgreedPerKmRate>>;
  /** Service that will be undertaken by the carer */
  agreedService?: Maybe<Scalars['String']['output']>;
  /** Hourly rates negotiated for this agreement */
  agreementRates: Array<AgreementRate>;
  /** Audit trail of the agreement */
  auditTrail?: Maybe<Array<AuditTrail>>;
  /** Actions available on the agreement */
  availableActions?: Maybe<AgreementAvailableActions>;
  /** What type of carer are we eg Nurse */
  carerType?: Maybe<Scalars['String']['output']>;
  /** Returns true if Client is the participant */
  consumerIsParticipant?: Maybe<Scalars['Boolean']['output']>;
  /** Client's relationship with participant */
  consumerRelationship?: Maybe<Scalars['String']['output']>;
  /** Conversation among both participants in the agreement */
  conversation: Conversation;
  /** When this agreement was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Current user */
  currentUser?: Maybe<User>;
  /** Customised agreement status field. `requested` to `Agreement requested`, `initiated` to `Pending` and `agreement_amended` to `Changes requested` */
  customStatus?: Maybe<Scalars['String']['output']>;
  /** The days and times that the participants have agreed to providing or receiving support */
  daysAndTimes?: Maybe<AgreementDaysAndTimes>;
  /** Expected date that the agreement between the participants would come to an end */
  expectedEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Expected date that the agreement between the participants would start */
  expectedStartDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Percentage of carer's rates that Mable charges */
  feePercentage?: Maybe<Scalars['String']['output']>;
  /** Date when this agreement was grandfathered */
  grandfatheredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of this agreement */
  id: Scalars['ID']['output'];
  /** Check if the agreement is accepted. */
  isAccepted: Scalars['Boolean']['output'];
  /** Check if the agreement is pending for customer acceptance. */
  isPending: Scalars['Boolean']['output'];
  /** Check if the customer requested for an agreement */
  isRequested: Scalars['Boolean']['output'];
  /** Job attached to the agreement */
  job?: Maybe<PostedJob>;
  /** Whether it's an ongoing on once off job. */
  jobFrequency?: Maybe<PostedJobFrequencyOptions>;
  /** Whether it's a a weekly,fornightly, monthly or other job */
  jobOccurrence?: Maybe<AgreementJobOccurrenceOptions>;
  /** Type of NDIS plan this customer has */
  ndisPlan?: Maybe<NdisPlan>;
  /** Date when the next assessment will be generated for this agreement. */
  nextAssessmentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Other participant in the agreement */
  otherUser: User;
  /** Assessment of carer's reliability */
  pendingCarerReliabilityAssessment?: Maybe<CarerReliabilityAssessment>;
  /** Per Km rate in cents */
  perKmRate?: Maybe<Scalars['Int']['output']>;
  /** Per Km rate in dollars */
  perKmRateInDollars?: Maybe<Scalars['String']['output']>;
  /** Agreed ndis support items in the agreement */
  planSupportItems?: Maybe<Array<PlanSupportItem>>;
  /** Returns true if support pair is eligible for QuickPay */
  quickpayEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Timing details of your support sessions e.g. 9am to 11am every fortnight */
  scheduleDescription?: Maybe<Scalars['String']['output']>;
  /** Summary of the agreed scheduling */
  scheduleSummary?: Maybe<Scalars['String']['output']>;
  /** groups of agreed hourly rates for services linked to this agreement */
  serviceGroups?: Maybe<Array<Array<AgreedHourlyRate>>>;
  /** Summary of easch of the agreed sessions */
  sessionSummaries?: Maybe<Array<Scalars['String']['output']>>;
  /** Indicates whether or not the agreement has planned sessions */
  sessionsPlanned: Scalars['Boolean']['output'];
  /** Available status: requested, initiated, offer_amended, offer_declined, accepted, agreement_amended, amendments_accepted, amendments_declined, terminated */
  status: Scalars['String']['output'];
  /** Support terms for cancelling sessions */
  supportCancel?: Maybe<Scalars['String']['output']>;
  /** Support terms for changing or adding sessions */
  supportChange?: Maybe<Scalars['String']['output']>;
  /** Support terms for feedback, complaints or disputes */
  supportFeedback?: Maybe<Scalars['String']['output']>;
  /** Support terms for minimum hours, finishing early and overtime */
  supportMinHours?: Maybe<Scalars['String']['output']>;
  /** Agreement will go either Active or Pending tab */
  tab?: Maybe<Scalars['String']['output']>;
  /** The server time this agreement was terminated */
  terminatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Accepted values for 'termination_reason' when terminating the agreement for this user */
  terminationReasons: Array<AgreementTerminationReason>;
  /** ??? Does this agreement include travel expenses */
  travelExpenseFlag?: Maybe<Scalars['Boolean']['output']>;
  /** `AgreementAmendment` when the agreement is an amendment otherwise null. */
  type?: Maybe<Scalars['String']['output']>;
  /** UUID for this agreement */
  uuid?: Maybe<Scalars['String']['output']>;
  /** Has the other party viewed the acceptance of this agreement */
  viewedAcceptance: Scalars['Boolean']['output'];
  /** ??? Welcome message displayed when... ??? */
  welcomeMessage: Scalars['String']['output'];
};

/** The connection type for Agreement. */
export type AgreementConnection = {
  __typename?: 'AgreementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AgreementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Agreement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Agreed detail about session days and times for an agreement */
export type AgreementDaysAndTimes = {
  __typename?: 'AgreementDaysAndTimes';
  /** Times agreed for Fridays */
  friday: AgreementDaysAndTimesItem;
  /** Times agreed for Mondays */
  monday: AgreementDaysAndTimesItem;
  /** Times agreed for Saturdays */
  saturday: AgreementDaysAndTimesItem;
  /** Times agreed for Sundays */
  sunday: AgreementDaysAndTimesItem;
  /** Times agreed for Thursdays */
  thursday: AgreementDaysAndTimesItem;
  /** Times agreed for Tuesdays */
  tuesday: AgreementDaysAndTimesItem;
  /** Times agreed for Wednesdays */
  wednesday: AgreementDaysAndTimesItem;
};

/** Details of expected session times for a given day */
export type AgreementDaysAndTimesItem = {
  __typename?: 'AgreementDaysAndTimesItem';
  /** Is there a session expected for this day? */
  expected: Scalars['Boolean']['output'];
  /** List of expected sessions for this day */
  expectedSessions: Array<AgreementExpectedSessions>;
};

/** An edge in a connection. */
export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Agreement>;
};

/** Details for a session expected for this agreement */
export type AgreementExpectedSessions = {
  __typename?: 'AgreementExpectedSessions';
  /** Session ends at this time */
  endAt: Scalars['String']['output'];
  /** Session starts at this time */
  startAt: Scalars['String']['output'];
};

/** Flat rate for an agreement */
export type AgreementFlatRate = {
  __typename?: 'AgreementFlatRate';
  /** Rate amount in cents */
  rateCents: Scalars['Int']['output'];
  /** ID of the service category */
  serviceCategoryableId: Scalars['Int']['output'];
  /** Type of service category */
  serviceCategoryableType: Scalars['String']['output'];
};

/** Hourly rate for an agreement */
export type AgreementHourlyRate = {
  __typename?: 'AgreementHourlyRate';
  /** Rate amount in cents */
  rateCents: Scalars['Int']['output'];
  /** ID of the service category */
  serviceCategoryableId: Scalars['Int']['output'];
  /** Type of service category */
  serviceCategoryableType: Scalars['String']['output'];
  /** Time block for this rate */
  timeBlock: Scalars['String']['output'];
};

/** Whether it's a a weekly, fornightly, monthly or other job */
export enum AgreementJobOccurrenceOptions {
  Fortnightly = 'fortnightly',
  Monthly = 'monthly',
  Other = 'other',
  Weekly = 'weekly'
}

/** Per-kilometer rate for an agreement */
export type AgreementPerKmRate = {
  __typename?: 'AgreementPerKmRate';
  /** Rate amount in cents */
  rateCents: Scalars['Int']['output'];
  /** ID of the service category */
  serviceCategoryableId: Scalars['Int']['output'];
  /** Type of service category */
  serviceCategoryableType: Scalars['String']['output'];
};

/** Agreement pre-fill data from an application */
export type AgreementPrefillData = {
  __typename?: 'AgreementPrefillData';
  /** The agreed service type */
  agreedService?: Maybe<Scalars['String']['output']>;
  /** UUID of the application */
  applicationId: Scalars['String']['output'];
  /** UUID of the job/request */
  jobId?: Maybe<Scalars['String']['output']>;
  /** Rate information for the agreement */
  ratesData?: Maybe<AgreementRatesData>;
  /** Snapshot of service mappings */
  serviceMappingSnapshot?: Maybe<ServiceMappingSnapshot>;
  /** Agreement terms configuration */
  termsData?: Maybe<AgreementTermsData>;
  /** Whether travel expenses are included */
  travelExpenseFlag: Scalars['Boolean']['output'];
};

/** Agreed pay-rate negotiated for this agreement */
export type AgreementRate = {
  __typename?: 'AgreementRate';
  /** Agreement to which this pay-rate relates */
  agreement: AgreementBase;
  /** Type of Budget-support this relates to */
  budgetSupportTypes?: Maybe<Array<BudgetSupportType>>;
  /** Net dollars charged to the client */
  clientNetDollars?: Maybe<Scalars['String']['output']>;
  /** Dollar rate to show at worker profile */
  dollars?: Maybe<Scalars['String']['output']>;
  /** Flat rate OR hourly rate. `True` for flat rate. */
  flatRate: Scalars['Boolean']['output'];
  /** Gross rate charged */
  grossDollars?: Maybe<Scalars['String']['output']>;
  /** ID of the rate information */
  id: Scalars['ID']['output'];
  /** Rate in cents */
  rateCents?: Maybe<Scalars['Int']['output']>;
  /** Description of the rate */
  rateDescription?: Maybe<Scalars['String']['output']>;
  /** Name of the rate */
  rateName?: Maybe<Scalars['String']['output']>;
  /** Rate schedule (when this will be scharged eg daytime/evening/overnight) */
  rateSchedule?: Maybe<RateSchedule>;
  /** Net dollars the worker will receive */
  workerNetDollars?: Maybe<Scalars['String']['output']>;
};

/** Agreement rates data containing hourly, flat, and per-km rates */
export type AgreementRatesData = {
  __typename?: 'AgreementRatesData';
  /** List of flat rates */
  flatRates?: Maybe<Array<AgreementFlatRate>>;
  /** List of hourly rates */
  hourlyRates?: Maybe<Array<AgreementHourlyRate>>;
  /** List of per-kilometer rates */
  perKmRates?: Maybe<Array<AgreementPerKmRate>>;
};

/** Agreement request from a client to a carer */
export type AgreementRequest = {
  __typename?: 'AgreementRequest';
  /** Consumer requesting a new agreement */
  client: User;
  /** ID of the agreement request */
  id: Scalars['ID']['output'];
  /** Sendbird channel details for the agreement request */
  sendbirdChannelDetail?: Maybe<SendbirdChannelDetail>;
  /** SP whose agreement is being requested from */
  supportProvider: User;
  /** uuid for the agreement request */
  uuid: Scalars['String']['output'];
};

/** Which response is being recorded for this agreement */
export enum AgreementResponseOptions {
  /** accept the offer or amendment */
  Accept = 'accept',
  /** decline the offer or amendment */
  Decline = 'decline'
}

/** Options for filtering agreements by their status */
export enum AgreementStatusFilter {
  /** agreements that have been accepted or amended */
  Accepted = 'accepted',
  /** agreements that are pending */
  Pending = 'pending'
}

/** Why was this agreement terminated? */
export type AgreementTerminationReason = {
  __typename?: 'AgreementTerminationReason';
  /** Explanation of why this agreement was terminated */
  description: Scalars['String']['output'];
  /** Key for termination-type */
  key: Scalars['String']['output'];
  /** ??? some kind of sort-order field */
  order: Scalars['Int']['output'];
};

/** When terminating an agreement, this is the set of valid reasons */
export enum AgreementTerminationReasonOptions {
  IssuesWithInvoiceBeingPaid = 'issues_with_invoice_being_paid',
  NoFunds = 'no_funds',
  NoLongerNeedsSupport = 'no_longer_needs_support',
  NotAvailableForWork = 'not_available_for_work',
  NotGoodFit = 'not_good_fit',
  NotSatisfiedWithMable = 'not_satisfied_with_mable',
  NotSatisfiedWithRelationship = 'not_satisfied_with_relationship',
  Other = 'other'
}

/** Agreement terms data */
export type AgreementTermsData = {
  __typename?: 'AgreementTermsData';
  /** Cancellation policy */
  supportCancel?: Maybe<Scalars['String']['output']>;
  /** Change policy */
  supportChange?: Maybe<Scalars['String']['output']>;
  /** Feedback policy */
  supportFeedback?: Maybe<Scalars['String']['output']>;
  /** Minimum hours requirement */
  supportMinHours?: Maybe<Scalars['String']['output']>;
};

/** Type that describes whether an agreement has scheduled-events/sessions or not */
export type AgreementWithScheduledEvents = {
  __typename?: 'AgreementWithScheduledEvents';
  /** Does the agreement have sessions */
  agreementHasScheduledEvents: Scalars['Boolean']['output'];
  /** Have times changed between an agreement and its amendment */
  agreementTimesChanged: Scalars['Boolean']['output'];
  /** Are times able to be turned into sessions */
  amendmentHasValidTimes: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AmendAgreement */
export type AmendAgreementInput = {
  /** Common attributes for updatiga n agreement */
  attributes: UpdateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AmendAgreement */
export type AmendAgreementPayload = {
  __typename?: 'AmendAgreementPayload';
  /** The agreement we're altering */
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AmendAgreementWithStructuredRates */
export type AmendAgreementWithStructuredRatesInput = {
  /** required attributes to update an agreement */
  attributes: UpdateOfferWithStructuredRatesAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AmendAgreementWithStructuredRates */
export type AmendAgreementWithStructuredRatesPayload = {
  __typename?: 'AmendAgreementWithStructuredRatesPayload';
  /** The agreement we're altering */
  agreement: Agreement;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Possible reasons for an application being accepted */
export enum ApplicationAcceptReason {
  /** The application was accepted to arrange a meet and greet */
  MeetAndGreet = 'meet_and_greet',
  /** The application was accepted to send a message (default) */
  SendMessage = 'send_message'
}

/** Autogenerated input type of ApplyVoucher */
export type ApplyVoucherInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** NDIS plan managed voucher code */
  voucherCode: Scalars['String']['input'];
};

/** Autogenerated return type of ApplyVoucher */
export type ApplyVoucherPayload = {
  __typename?: 'ApplyVoucherPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Always returns true whether the voucher has been successfully applied or not */
  success: Scalars['Boolean']['output'];
};

/** Holds data about an asset (eg an image or other file) */
export type Asset = {
  __typename?: 'Asset';
  /** filename of the asset */
  fileName?: Maybe<Scalars['String']['output']>;
  /** URL for fetching this asset */
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignClientsToCoordinator */
export type AssignClientsToCoordinatorInput = {
  /** Requested Client IDs */
  clientIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Coordinator ID to assign them to */
  coordinatorId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignClientsToCoordinator */
export type AssignClientsToCoordinatorPayload = {
  __typename?: 'AssignClientsToCoordinatorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returned client profiles */
  profiles?: Maybe<Array<ClientProfile>>;
};

/** Type used for identifying persisted or projected sessions */
export type AttendeesReminderOption = {
  /** The new reminder-timing */
  clientReminderOption?: InputMaybe<Scalars['Int']['input']>;
  /** The new reminder-timing */
  currentTargetReminderOption: Scalars['Int']['input'];
};

/** Holds information about changes made to an entity for the puroses of maintaining an audit-trail */
export type AuditTrail = {
  __typename?: 'AuditTrail';
  /** Differences between this version of the entity and the previous version */
  diff: Array<AuditTrailDiff>;
  /** Event associated with this version of the entity */
  event: Scalars['String']['output'];
  /** Timestamp of when this entity was updated to this version */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Who committed the change */
  whodunnit?: Maybe<Scalars['String']['output']>;
};

/** Differences between this version of an entity and the previous version - used for creating an audit-trail of changes to an entity */
export type AuditTrailDiff = {
  __typename?: 'AuditTrailDiff';
  /** Name of the field that was changed */
  fieldName: Scalars['String']['output'];
  /** New value of the field */
  newValue?: Maybe<Scalars['String']['output']>;
  /** Old value of the field */
  oldValue?: Maybe<Scalars['String']['output']>;
};

/** Valid Australian States (eg NSW/QLD) */
export enum AustralianStates {
  /** Australian Capital Territory */
  Act = 'ACT',
  /** New South Wales */
  Nsw = 'NSW',
  /** Northern Territory */
  Nt = 'NT',
  /** Queensland */
  Qld = 'QLD',
  /** South Australia */
  Sa = 'SA',
  /** Tasmania */
  Tas = 'TAS',
  /** Victoria */
  Vic = 'VIC',
  /** Western Australia */
  Wa = 'WA'
}

/** Information about worker availablility (dates/times they can work) */
export type Availability = {
  __typename?: 'Availability';
  /** Overall availability */
  available: Scalars['Boolean']['output'];
  /** Whether the user has opted-in to be contacted about new jobs */
  availableForJobOpportunities: Scalars['Boolean']['output'];
  /** Total hours user is available */
  desiredHours: Scalars['Int']['output'];
  /** Availability on Friday */
  friday: Scalars['Boolean']['output'];
  /** Specific availability times on Friday */
  fridayTimes: Array<AvailabilityTimes>;
  /** Overnight working hours available */
  hasOvernightAvailability: Scalars['Boolean']['output'];
  /** Boolean whether carer is migrated to availability uplift */
  isMigratedToAvailabilityUplift: Scalars['Boolean']['output'];
  /** Availability on Monday */
  monday: Scalars['Boolean']['output'];
  /** Specific availability times on Monday */
  mondayTimes: Array<AvailabilityTimes>;
  /** Availability on Saturday */
  saturday: Scalars['Boolean']['output'];
  /** Specific availability times on Saturday */
  saturdayTimes: Array<AvailabilityTimes>;
  /** Availability on Sunday */
  sunday: Scalars['Boolean']['output'];
  /** Specific availability times on Sunday */
  sundayTimes: Array<AvailabilityTimes>;
  /** Availability on Thursday */
  thursday: Scalars['Boolean']['output'];
  /** Specific availability times on Thursday */
  thursdayTimes: Array<AvailabilityTimes>;
  /** Availability on Tuesday */
  tuesday: Scalars['Boolean']['output'];
  /** Specific availability times on Tuesday */
  tuesdayTimes: Array<AvailabilityTimes>;
  /** Availability on Wednesday */
  wednesday: Scalars['Boolean']['output'];
  /** Specific availability times on Wednesday */
  wednesdayTimes: Array<AvailabilityTimes>;
};

/** Attributes of worker availability */
export type AvailabilityTimeAttributes = {
  /** Delete an availability time by `id` */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** End time of availability in 24 hour format (`HH:MM`) */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Supply the `id` of an existing availability time to modify or delete (`_destroy` must be `true`) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Start time of availability in 24 hour format (`HH:MM`) */
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes of carer availability */
export type AvailabilityTimes = {
  __typename?: 'AvailabilityTimes';
  /** Availability end time */
  endTime: Scalars['String']['output'];
  /** ID of the availability times */
  id: Scalars['ID']['output'];
  /** Availability start time */
  startTime: Scalars['String']['output'];
};

/** User's avatar image */
export type Avatar = {
  __typename?: 'Avatar';
  /** Big version of the image */
  big?: Maybe<Scalars['String']['output']>;
  /**
   * Legacy - medium version of the image
   * @deprecated Use big or small instead.
   */
  medium?: Maybe<Scalars['String']['output']>;
  /** Small version of the image */
  small?: Maybe<Scalars['String']['output']>;
};

/** Information to help display a worker badge */
export type Badge = {
  __typename?: 'Badge';
  /** Description of the badge */
  description?: Maybe<Scalars['String']['output']>;
  /** Icon associated with the badge */
  icon?: Maybe<Scalars['String']['output']>;
  /** Name of the badge */
  name?: Maybe<Scalars['String']['output']>;
  /** Show this badge in the profile view */
  showIcon?: Maybe<Scalars['Boolean']['output']>;
  /** Value of the badge */
  value?: Maybe<Scalars['String']['output']>;
};

/** Details of a bank account */
export type BankAccount = {
  __typename?: 'BankAccount';
  /** Account name */
  bankAccountDetailsAccountName?: Maybe<Scalars['String']['output']>;
  /** Account number */
  bankAccountDetailsAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Bank name */
  bankAccountDetailsBankName?: Maybe<Scalars['String']['output']>;
  /** BSB */
  bankAccountDetailsBsb?: Maybe<Scalars['String']['output']>;
  /** Checkbox for worker responsibility on checking the accuracy of account information */
  bankResponsibility?: Maybe<Scalars['Boolean']['output']>;
};

/** Attributes of a bank account */
export type BankAccountAttributes = {
  /** Account name */
  bankAccountDetailsAccountName?: InputMaybe<Scalars['String']['input']>;
  /** Account number */
  bankAccountDetailsAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Bank name */
  bankAccountDetailsBankName?: InputMaybe<Scalars['String']['input']>;
  /** BSB */
  bankAccountDetailsBsb?: InputMaybe<Scalars['String']['input']>;
  /** Checkbox for worker responsibility on checking the accuracy of account information */
  bankResponsibility?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Wallet payout destination bank account details */
export type BankAccountDetails = {
  __typename?: 'BankAccountDetails';
  /** Payout destination bsb number */
  bsbNumber?: Maybe<Scalars['String']['output']>;
  /** Payout destination account name */
  name?: Maybe<Scalars['String']['output']>;
  /** Payout destination account number */
  number?: Maybe<Scalars['String']['output']>;
  /** Payout destination account type */
  type?: Maybe<Scalars['String']['output']>;
};

/** Checks if banned words are present */
export type BannedWords = {
  __typename?: 'BannedWords';
  /** List of banned words */
  bannedWords?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns message about the banned words */
  bannedWordsMessage?: Maybe<Scalars['String']['output']>;
  /** Returns true if banned words present */
  hasBannedWords: Scalars['Boolean']['output'];
};

/** Details returned by the billing query */
export type Billing = {
  __typename?: 'Billing';
  /** Return account balance */
  accountBalance?: Maybe<Scalars['Float']['output']>;
  /** Exported file of the billing info */
  exportFile?: Maybe<Export>;
  /** Paynow remittance details */
  paynowRemittance?: Maybe<PaynowRemittance>;
  /** Statements */
  statements?: Maybe<InvoiceStatementConnection>;
  /** Return all tax statements */
  taxStatements?: Maybe<Array<TaxStatement>>;
  /** Transactions */
  transactions?: Maybe<PaymentConnection>;
};


/** Details returned by the billing query */
export type BillingStatementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Details returned by the billing query */
export type BillingTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of Block */
export type BlockInput = {
  /** Attributes required to block the user */
  attributes: PhoneCallsBlock;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Block */
export type BlockPayload = {
  __typename?: 'BlockPayload';
  /** Return true if blocked successfully */
  blocked?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Valid set of reasons for blocking another user */
export enum BlockReasons {
  /** Inappropriate conduct */
  InappropriateConduct = 'inappropriate_conduct',
  /** Offensive conduct */
  OffensiveConduct = 'offensive_conduct',
  /** Offering support outside of Mable */
  OfferingSupportOutsideOfMable = 'offering_support_outside_of_mable',
  /** Other */
  Other = 'other',
  /** Persistent calling */
  PersistentCalling = 'persistent_calling',
  /** Persistent messaging */
  PersistentMessaging = 'persistent_messaging',
  /** Safety concerns */
  SafetyConcerns = 'safety_concerns',
  /** Unprofessional behaviour */
  UnprofessionalBehaviour = 'unprofessional_behaviour'
}

/** Information to display as a reminder for a COVID booster */
export type BoosterReminder = {
  __typename?: 'BoosterReminder';
  /** Body of the reminder */
  body?: Maybe<Scalars['String']['output']>;
  /** CTA-text on the close button */
  closeCta?: Maybe<Scalars['String']['output']>;
  /** CTA-text on the confirm button */
  confirmCta?: Maybe<Scalars['String']['output']>;
  /** CTA URL for the confirm button */
  confirmCtaLink?: Maybe<Scalars['String']['output']>;
  /** Title of the reminder */
  title?: Maybe<Scalars['String']['output']>;
};

/** Details about the kind of BudgetSupportType (BST) this is */
export type BudgetSupportType = {
  __typename?: 'BudgetSupportType';
  /** Display-ready name for this type of BST */
  displayName?: Maybe<Scalars['String']['output']>;
  /** ID of the type */
  id: Scalars['ID']['output'];
  /** Is this BST only available for admins to select */
  isAdminOnlyType?: Maybe<Scalars['Boolean']['output']>;
  /** Internal name for this type of BST */
  name: Scalars['String']['output'];
  /** ndis service category or mable service */
  serviceType: ServiceCategoryableType;
};

/** Autogenerated input type of BulkCreateScheduledEvents */
export type BulkCreateScheduledEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the sesions to create */
  scheduledEventsAttributes: BulkScheduledEventAttributes;
};

/** Autogenerated return type of BulkCreateScheduledEvents */
export type BulkCreateScheduledEventsPayload = {
  __typename?: 'BulkCreateScheduledEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Details of the sessions that were just created */
  scheduledEvents: Array<ScheduledEvent>;
  /** Returns whether creation was successful */
  status: Scalars['Boolean']['output'];
};

/** Data for when bulk messaging a set of carers */
export type BulkMessageCarer = {
  __typename?: 'BulkMessageCarer';
  /** The combined status of all of the jobs */
  statusAllJob: Scalars['String']['output'];
  /** Data for each carer in the list */
  statusEachCarer: Array<BulkMessageForEachCarer>;
};

/** Data for each carer - when bulk messaging a set of carers */
export type BulkMessageForEachCarer = {
  __typename?: 'BulkMessageForEachCarer';
  /** ID of the carer to be messaged */
  carerId: Scalars['ID']['output'];
  /** Conversation between the current target and the specified carer */
  conversation?: Maybe<Conversation>;
  /** Full name of the carer (used to personalise mssages) */
  fullName: Scalars['String']['output'];
  /** Status of the messaging for this carer */
  status: Scalars['String']['output'];
};

/** Arguments to create scheduled-events/sessions */
export type BulkScheduledEventAttributes = {
  /** Agreement between the creator and invitee */
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the user wants to receive check in/check out notifications */
  checkInCheckOutReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notification for the other attendee of the session */
  clientReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notification for the creator of the session */
  creatorReminder: Scalars['Boolean']['input'];
  /** The date the sessions repeat until; dd/mm/yyyy format */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** participant_ids are other members in the session, which is accepted as an array of user_ids */
  participantIds: Array<Scalars['Int']['input']>;
  /** Support session inputs needed when the scheduleType is 'Support Session' */
  plannedSupportSession?: InputMaybe<PlannedSupportSessionAttributes>;
  /** Reccurence details */
  recurrenceRules: BulkScheduledEventRecurrenceAttributes;
  /** Type of session */
  scheduleType: ScheduleOptions;
  /** Channel through which an attendee has been invited */
  source?: InputMaybe<ScheduleSource>;
  /** The date that the session starts, dd/mm/yyyy format */
  startDate: Scalars['String']['input'];
  /** Timezone name - full name (eg. 'Australia/Sydney') */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Details of the recurrence of a scheduled-event/session */
export type BulkScheduledEventRecurrenceAttributes = {
  /** rules for daily/one off recurrence */
  dailyOneOffRules?: InputMaybe<Array<RecurrenceTimes>>;
  /** rules for monthly recurrence */
  monthlyRules?: InputMaybe<MonthlyRecurrenceRules>;
  /** The type of recurrence a session has */
  recurrenceType: RecurrenceOptions;
  /** rules for weekly/fortnightly recurrence */
  weeklyFortnightlyRules?: InputMaybe<Array<WeeklyFortnightlyRecurrenceRules>>;
};

/** Autogenerated input type of CancelScheduledEvent */
export type CancelScheduledEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID of the session */
  derivedUniqueId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes to cancel the session - is the user cancelling a single or multiple session(s) */
  editOption: ScheduledEventEditOptions;
  /** Id of the occurrence */
  occurrenceId?: InputMaybe<Scalars['String']['input']>;
  /** Id type of the occurrence */
  occurrenceIdType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelScheduledEvent */
export type CancelScheduledEventPayload = {
  __typename?: 'CancelScheduledEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns status of cancellation */
  status: Scalars['Boolean']['output'];
};

/** Input attributes for CareExperienceAndKnowledge */
export type CareExperienceAndKnowledgeAttributes = {
  /** Experience and knowledge in aged care */
  agedCare?: InputMaybe<CareExperienceAndKnowledgeItemAttributes>;
  /** Experience and knowledge in chronic medical condition */
  chronicMedicalCondition?: InputMaybe<CareExperienceAndKnowledgeItemAttributes>;
  /** Experience and knowledge in disability */
  disability?: InputMaybe<CareExperienceAndKnowledgeItemAttributes>;
  /** Experience and knowledge in mental health */
  mentalHealth?: InputMaybe<CareExperienceAndKnowledgeItemAttributes>;
};

/** Input attributes for each CareExperienceAndKnowledge kind */
export type CareExperienceAndKnowledgeItemAttributes = {
  /** Description of the care */
  description: Scalars['String']['input'];
  /** Worker experience in this aspect of care */
  experience: Array<CareKnowledgeOptions>;
  /** Kind of care */
  kind: CareExperienceOptions;
  /** Type of care-knowledge needed */
  knowledge: Array<CareKnowledgeOptions>;
  /** Has the worker selected this care type */
  selected: Scalars['Boolean']['input'];
};

/** Flags for managing new care experience sections */
export type CareExperienceFlags = {
  __typename?: 'CareExperienceFlags';
  /** When `true`, show a new care experience section with a message to ask the provider for more info about their experience. */
  askForMoreExperience: Scalars['Boolean']['output'];
  /** When `true`, show the banner for the new care experience section telling me to add my experience. */
  bannerPrompt: Scalars['Boolean']['output'];
  /** When `false`, hide the entire experience and knowledge section from view profile in the new care experience journey */
  displaySection: Scalars['Boolean']['output'];
  /** When `true`, show the new care experience journey, when `false` show the old journey */
  enabled: Scalars['Boolean']['output'];
  /** When `true`, show the empty state for the new care experience section telling me to add my experience. */
  fillMainExperience: Scalars['Boolean']['output'];
  /** When `true`, show the empty state for the new care experience section telling me to fill it out. */
  fillProfessionalExperience: Scalars['Boolean']['output'];
  /** When `true`, show a popup alerting existing workers to the 2021 care experience profile section changes */
  popup: Scalars['Boolean']['output'];
};

/** Kind of care that a support-worker could offer - eg professional/personal */
export enum CareExperienceOptions {
  Both = 'both',
  None = 'none',
  Personal = 'personal',
  Professional = 'professional'
}

/** Enum for CareExperienceSelectionCategoryOptions */
export enum CareExperienceSelectionCategoryOptions {
  Experience = 'experience',
  Knowledge = 'knowledge'
}

/** Worker experience in this aspect of care */
export enum CareKnowledgeOptions {
  AcquiredBrainInjury = 'acquired_brain_injury',
  AgedCare = 'aged_care',
  Anxiety = 'anxiety',
  Arthritis = 'arthritis',
  Asthma = 'asthma',
  Autism = 'autism',
  BipolarDisorder = 'bipolar_disorder',
  CardiovascularDisease = 'cardiovascular_disease',
  CerebralPalsy = 'cerebral_palsy',
  ChronicMedical = 'chronic_medical',
  CopdRespiratoryIllness = 'copd_respiratory_illness',
  CysticFibrosis = 'cystic_fibrosis',
  Dementia = 'dementia',
  Depression = 'depression',
  Diabetes = 'diabetes',
  Disability = 'disability',
  DownSyndrome = 'down_syndrome',
  EatingDisorders = 'eating_disorders',
  Epilepsy = 'epilepsy',
  HearingImpairment = 'hearing_impairment',
  Hoarding = 'hoarding',
  IntellectualDisabilities = 'intellectual_disabilities',
  MentalHealth = 'mental_health',
  MotorNeuronDisease = 'motor_neuron_disease',
  MuscularDystrophy = 'muscular_dystrophy',
  Ocd = 'ocd',
  ParkinsonsDisease = 'parkinsons_disease',
  PhysicalDisabilities = 'physical_disabilities',
  Ptsd = 'ptsd',
  Schizophrenia = 'schizophrenia',
  SpinaBifida = 'spina_bifida',
  SpinalCordInjurty = 'spinal_cord_injurty',
  SubstanceAbuseAddiction = 'substance_abuse_addiction',
  VisionImpairment = 'vision_impairment'
}

/** The type of carer this is (eg Personal/Nurse/allied) - we can use this to filter workers for a client */
export enum Carer {
  Allied = 'Allied',
  Nurse = 'Nurse',
  Personal = 'Personal',
  Social = 'Social'
}

/** The set of budget support types (BST) for a given carer */
export type CarerBudgetSupport = {
  __typename?: 'CarerBudgetSupport';
  /** All available BST for the carer */
  availableBudgetSupportTypes?: Maybe<Array<BudgetSupportType>>;
  /** The default set of BST for the carer */
  defaultBudgetSupportTypes?: Maybe<Array<BudgetSupportType>>;
};

/** Details of an invoice statement specifically for carers */
export type CarerInvoiceStatement = {
  __typename?: 'CarerInvoiceStatement';
  /** ID of the invoice statement */
  carerInvoiceStatementId?: Maybe<Scalars['ID']['output']>;
  /** Is this carer invoice statement eligible for expresspay */
  expressPayEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Has the carer requested express pay for this invoice */
  expressPayRequested?: Maybe<Scalars['Boolean']['output']>;
  /** Total of the statement, net of fees */
  netTotal?: Maybe<Scalars['Float']['output']>;
  /** What is the status of any request for paynow */
  paynowRequestedStatus?: Maybe<Scalars['String']['output']>;
};

/** Attributes of a carer-profile */
export type CarerProfileAttributes = {
  /** Last name of the emergency contact */
  emergencyContactsLastName?: InputMaybe<Scalars['String']['input']>;
  /** First name of the emergency contact */
  emergencyContactsName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the emergency contact */
  emergencyContactsPhone?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the emergency contact */
  emergencyContactsRelationship?: InputMaybe<ContactRelationshipOptions>;
  /** Determine if PayNow modal should be shown */
  paynowModalStatus?: InputMaybe<PaynowModalStatusOptions>;
  /** Carer's postal address line 1 */
  postalAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Carer's postal address line 2 */
  postalAddressLine2?: InputMaybe<Scalars['String']['input']>;
};

/** Options for filtering agreements by their status */
export type CarerProfileCategories = {
  /** Sub category values under services category */
  careKnowledge?: InputMaybe<Array<Experiences>>;
  /** Sub category values under general category */
  general?: InputMaybe<Array<General>>;
  /** Sub category values under other category */
  other?: InputMaybe<Array<Other>>;
  /** Sub category values under other category */
  qualificationsParent?: InputMaybe<Array<Qualifications>>;
  /** Sub category values under services category */
  services?: InputMaybe<Array<Services>>;
};

/** Details of an agreement between a carer/support-worker and a client (including carer's qualifications */
export type CarerQualification = {
  __typename?: 'CarerQualification';
  /** What type of account are we fetching - used for consumer profile managed_as */
  accountType?: Maybe<Scalars['String']['output']>;
  /** The carer/support-worker is the person providing care */
  carer?: Maybe<User>;
  /** Birth Date of the client */
  clientBirthDay?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Cultural background of the client */
  clientCulturalBackground?: Maybe<Scalars['String']['output']>;
  /** Native language of the client */
  clientLanguage?: Maybe<Scalars['String']['output']>;
  /** Name of the client */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Postcode of the client */
  clientPostcode?: Maybe<Scalars['String']['output']>;
  /** Suburb of the client */
  clientSuburb?: Maybe<Scalars['String']['output']>;
  /** The consumer/client is the person requesting the care */
  consumer?: Maybe<User>;
  /** Desired cultural background of the support worker */
  desiredCulturalBackground?: Maybe<Scalars['String']['output']>;
  /** ID of the agreement */
  id: Scalars['ID']['output'];
  /** Is the client considered a minor */
  ifClientMinor?: Maybe<Scalars['Boolean']['output']>;
  /** Insurance document list */
  insurances?: Maybe<Array<CarerQualificationDocument>>;
  /** Job-description of the job that this agreement was a response to */
  jobDescription?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the most recent session of care for this agreement */
  lastSupportSessionDateTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Other Qualification document list */
  otherQualifications?: Maybe<Array<CarerQualificationDocument>>;
  /** The participant is the person receiving care (may or may not be the client) */
  participant?: Maybe<Participant>;
  /** Police check qualification */
  policeCheck?: Maybe<CarerQualificationDocument>;
  /**
   * Legacy - we now use police_check
   * @deprecated Use police_check field
   */
  policeCheckAsset?: Maybe<Scalars['String']['output']>;
  /** Qualification document list */
  qualifications?: Maybe<Array<CarerQualificationDocument>>;
  /** Services requested by the client */
  servicesRequested?: Maybe<Scalars['String']['output']>;
  /** The file containing the client's support-plan */
  supportPlanAsset?: Maybe<Asset>;
  /** Expiry Date of the support-plan */
  supportPlanExpiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the support-worker read the Support Plan */
  supportPlanReadAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Actual cultural background of the support-worker */
  supportWorkerCulturalBackground?: Maybe<Scalars['String']['output']>;
  /** Native language of the support-worker */
  supportWorkerLanguage?: Maybe<Scalars['String']['output']>;
  /** Name of the support-worker */
  supportWorkerName?: Maybe<Scalars['String']['output']>;
  /** For consumer profile type_of_care */
  typeOfCare?: Maybe<Scalars['String']['output']>;
  /** What verified-services are offerred by the support-worker */
  verifiedServicesOffered?: Maybe<Scalars['String']['output']>;
  /** Verified Support Categories */
  verifiedSupportCategories?: Maybe<Scalars['String']['output']>;
  /** Working-with-children-check qualification */
  wwcc?: Maybe<Array<CarerQualificationDocument>>;
};

/** The connection type for CarerQualification. */
export type CarerQualificationConnection = {
  __typename?: 'CarerQualificationConnection';
  csvDownloadParam?: Maybe<Scalars['String']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CarerQualificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CarerQualification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Information about a qualification-document for a carer */
export type CarerQualificationDocument = {
  __typename?: 'CarerQualificationDocument';
  /** Name of the document */
  name?: Maybe<Scalars['String']['output']>;
  /** URL to fetch the document */
  value?: Maybe<Scalars['String']['output']>;
};

/** An edge in a connection. */
export type CarerQualificationEdge = {
  __typename?: 'CarerQualificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CarerQualification>;
};

/** Possible sort-columns by which the carer qualifications can be ordered eg client_name/type_of_care */
export enum CarerQualificationOrderColumn {
  /** Sort by client name */
  ClientName = 'client_name',
  /** Sort by managed_as */
  ManagedAs = 'managed_as',
  /** Sort by support_plan_expiry_date */
  SupportPlanExpiryDate = 'support_plan_expiry_date',
  /** Sort by support_plan_read_at */
  SupportPlanReadAt = 'support_plan_read_at',
  /** Sort by carer name */
  SupportWorkerName = 'support_worker_name',
  /** Sort by type_of_care */
  TypeOfCare = 'type_of_care'
}

/** Attributes for filtering/sorting a list of carer-qualifications */
export type CarerQualificationSortInput = {
  /** Direction of the sort (asc/desc) */
  direction: Scalars['String']['input'];
  /** Field to sort by */
  field: CarerQualificationOrderColumn;
  /** Filter from this value when the search-filter is a range */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Filter qualifications using this field and the search_text */
  searchByField?: InputMaybe<ComplianceSearchField>;
  /** Filter qualifications using this search_text in the search_by_field */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Filter up to this value when the search-filter is a range */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Details of a Carer Reliability Assessment */
export type CarerReliabilityAssessment = {
  __typename?: 'CarerReliabilityAssessment';
  /** Whether the assessment is an active one */
  active: Scalars['Boolean']['output'];
  /** Agreement relating this client and carer */
  agreement: AgreementBase;
  /** Type of assessment for the carer reiability assessment */
  assessmentType: CarerReliabilityAssessmentOptions;
  /** ID of the carer reliability assessment */
  id: Scalars['ID']['output'];
  /** How many incomplete tasks were left */
  incompleteTasks: Scalars['Int']['output'];
  /** Returns true if this is an assessment for the first week. Otherwise returns false. */
  isFirstWeekly: Scalars['Boolean']['output'];
  /** Is the carer usually on time */
  isOnTime: Scalars['Boolean']['output'];
  /** Does the carer usually show up */
  isShowedUp: Scalars['Boolean']['output'];
  /** Is the task usually completed */
  isTaskCompleted: Scalars['Boolean']['output'];
  /** How many late arrivals have there been */
  lateArrivals: Scalars['Int']['output'];
  /** How many no-shows have there been */
  noShows: Scalars['Int']['output'];
  /** Score assessing how reliably on-time the carer is */
  onTimeScore: Scalars['Float']['output'];
  /** Any other feedback about reliability */
  otherFeedback?: Maybe<Scalars['String']['output']>;
  /** What period does this assessment cover - end-date */
  periodEndDate: Scalars['ISO8601DateTime']['output'];
  /** What period does this assessment cover - start-date */
  periodStartDate: Scalars['ISO8601DateTime']['output'];
  /** How many scheduled sessions have there been */
  scheduledSessions: Scalars['Int']['output'];
  /** Score assessing how reliably the carer shows-up */
  showUpScore: Scalars['Float']['output'];
  /** Score assessing how reliably the carer completes tasks */
  taskCompletionScore: Scalars['Float']['output'];
};

/** What types of assessment are available for carer reliability assessments */
export enum CarerReliabilityAssessmentOptions {
  Monthly = 'monthly',
  OnceOff = 'once_off',
  Weekly = 'weekly'
}

/** Attributes for updating a carer reliability assessment */
export type CarerReliabilityAttributes = {
  /** Number of tasks left incomplete */
  incompleteTasks?: InputMaybe<Scalars['Int']['input']>;
  /** Is the carer usually on time */
  isOnTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Did the carer show up */
  isShowedUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Did the carer complete the task */
  isTaskCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** How many times did the carer arrive late */
  lateArrivals?: InputMaybe<Scalars['Int']['input']>;
  /** How many times was the carer a no-show */
  noShows?: InputMaybe<Scalars['Int']['input']>;
  /** Score calculated showing how reliably on-time the carer is */
  onTimeScore?: InputMaybe<Scalars['Float']['input']>;
  /** Details of any other feedback */
  otherFeedback?: InputMaybe<Scalars['String']['input']>;
  /** How many scheduled sessions have there been */
  scheduledSessions: Scalars['Int']['input'];
  /** Score calculated showing how reliably the carer completes tasks */
  taskCompletionScore?: InputMaybe<Scalars['Float']['input']>;
};

/** Status of a police-check eg results_pending/submitted/completed */
export enum CheckedCheckStatusOptions {
  Completed = 'completed',
  Rejected = 'rejected',
  ResultsPending = 'results_pending',
  Submitted = 'submitted'
}

/** Different kinds of things we can have a status-check for */
export enum CheckedCheckTypeOptions {
  /** BYO police check */
  NpcVerification = 'npc_verification',
  /** New police check */
  PoliceCheck = 'police_check'
}

/** Represents organisation client attributes */
export type Client = {
  __typename?: 'Client';
  /** Account holder details */
  accountHolder: AccountHolder;
  /** Date of birth of client */
  birthDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Full name of the client */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Clients' user id */
  id: Scalars['ID']['output'];
  /** Client profile updated at */
  profileUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Postal code of client */
  shortAddress?: Maybe<Scalars['String']['output']>;
  /** Tags of clients */
  tags: Array<Scalars['String']['output']>;
};

/** Attributes of a client */
export type ClientAttributes = {
  /** Address line 1 */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Birthdate */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the user given consent to collect sensitive information */
  consentToCollectSensitiveInformation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contact phone */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal first name */
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Legal last name */
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal middle name */
  legalMiddleName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the client needs to be notified of automatic sessions termination */
  needsToBeNotifiedOfAutomaticSessionsTermination?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tokenised credit card value from payment gateway */
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  /** Postcode */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** Primary emergency contact */
  primaryEmergencyContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** In-depth detail about the client and their care situation */
  profile?: InputMaybe<ClientProfileAttributes>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Use preferred names for legal */
  usePreferredNamesForLegal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicate user has seen prompt about posting job */
  viewedPostNewJobPrompt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicate if user should see provider onboarding welcome page on login */
  viewedProviderWelcomePage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for Client. */
export type ClientConnection = {
  __typename?: 'ClientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ClientEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Client>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A query containing everything the frontend needs to generate the client dashboard */
export type ClientDashboard = {
  __typename?: 'ClientDashboard';
  /** A tile to have clients a getting started call. */
  bookACall?: Maybe<ClientsBookACall>;
  /** Any call to actions for the client */
  callToActions?: Maybe<ClientsCallToActions>;
  /** A tile directing clients to complete their profile */
  completeProfile?: Maybe<ClientsCompleteProfile>;
  /** A sub list of dashboard tiles */
  dashboardChecklist?: Maybe<ClientsDashboardChecklist>;
  /** Deprecated: A sub list of dashboard tiles */
  dashboardTiles?: Maybe<ClientsDashboardTiles>;
  /** Tiles the client can dismiss after viewing */
  dismissableTiles?: Maybe<ClientsDismissableTiles>;
  /** Dashboard flags used by the frontend to control pieces of functionality */
  flags?: Maybe<ClientsFlags>;
  /** A new clients getting started checklist tile. */
  getStarted?: Maybe<ClientsGetStarted>;
  /** The dashboards hero image. */
  heroImage?: Maybe<ClientsHeroImage>;
  /** Unique ID for the dashboard */
  id?: Maybe<Scalars['ID']['output']>;
  /** A tile for displaying the clients identity verification */
  identityVerification?: Maybe<ClientsIdentityVerificationType>;
  /** A tile for displaying important news for the client */
  mableNews?: Maybe<ClientsMableNews>;
  /** A tile that will display only for NDIS ready clients, either prompting them to search for a worker or post a job */
  ndisReady?: Maybe<ClientsNdisReadyType>;
  /** The client dashboards phase, used to determine state */
  phase?: Maybe<Scalars['String']['output']>;
  /** A tile for displaying the clients ready now */
  readyNow?: Maybe<ClientsReadyNowType>;
};

/** An edge in a connection. */
export type ClientEdge = {
  __typename?: 'ClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Client>;
};

/** Information about how this client has interacted with this worker */
export type ClientFields = {
  __typename?: 'ClientFields';
  /** Does this worker have any last minute job with the visiting client */
  hasLmj?: Maybe<Scalars['Boolean']['output']>;
  /** Has an agreement been requested of this worker by the visiting client */
  hasRequestedAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** Does this worker have any reviewable agreement with the visiting client */
  hasReviewableAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** Does this worker have been shortlisted by the visiting client */
  shortlisted?: Maybe<Scalars['Boolean']['output']>;
  /** Should we show the stat-dec to this client */
  showStatDecInfoPanel?: Maybe<Scalars['Boolean']['output']>;
};

/** Actions that can be performed on Last-minute/flex jobs by the client */
export enum ClientFlexJobActionOptions {
  /** Accept last minute job offer */
  Accept = 'accept',
  /** Cancel last minute job offer */
  Cancel = 'cancel'
}

/** Data relating to the onboarding-status for a client */
export type ClientOnboardingStatus = {
  __typename?: 'ClientOnboardingStatus';
  /** Completed all steps and payment verified */
  completedAndVerified: Scalars['Boolean']['output'];
  /** Indicate if client has any agreements */
  hasAgreement: Scalars['Boolean']['output'];
  /** Onboarding completion percentage */
  percentage: Scalars['Int']['output'];
  /** Show Verification Message */
  showVerificationMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Shows onboarding-steps that a client has completed */
  status?: Maybe<ClientStepStatus>;
};

/** All of the fields required for Client Profile GraphQL Type */
export type ClientProfile = {
  __typename?: 'ClientProfile';
  /** Any information required to access the client's house */
  accessInformation?: Maybe<Scalars['String']['output']>;
  /** Organisation name that is handling the funding */
  assignPartnerFundingOrganisation?: Maybe<Scalars['String']['output']>;
  /** Is the Credit-card authorised */
  authoriseCc?: Maybe<Scalars['Boolean']['output']>;
  /** Date when the balance payment was acknowledged */
  balancePaymentAcknowledgeDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Account number for the client's bank account */
  bankAccountDetailsAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Bank-name the client's bank account */
  bankAccountDetailsBank?: Maybe<Scalars['String']['output']>;
  /** BSB for the client's bank account */
  bankAccountDetailsBsb?: Maybe<Scalars['String']['output']>;
  /** Account name for the client's bank account */
  bankAccountDetailsName?: Maybe<Scalars['String']['output']>;
  /** What kind of support-plan is in place for behaviour (eg restrictive_behaviour_support) */
  behaviourSupportPlan?: Maybe<Scalars['String']['output']>;
  /** How much of the profile is complete */
  completedProfilePercent?: Maybe<Scalars['Int']['output']>;
  /** Details for any contacts */
  contactsAttributes?: Maybe<Array<Contact>>;
  /** Is the client coordinator-managed */
  coordinatorManaged?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the coordinator is NDIS Agency managed organistation */
  coordinatorNdisAgencyManaged?: Maybe<Scalars['Boolean']['output']>;
  /** Email alert settings */
  emailAlerts?: Maybe<Array<Scalars['String']['output']>>;
  /** What instructions are needed in an emergency */
  emergencyInstructions?: Maybe<Scalars['String']['output']>;
  /** Indicating if there are over 10 support workers in the consumer's suburb. */
  enoughCarersInSuburb: Scalars['Boolean']['output'];
  /** What equipment does the client have/need */
  equipmentList?: Maybe<Scalars['String']['output']>;
  /** A rough gauge of how many support hours are needed weeky by this client (low/med/high) */
  estimatedWeeklySupportHour?: Maybe<Scalars['String']['output']>;
  /** What kind of funding source does this client have (eg home_care_package) */
  fundingSourceCode?: Maybe<Scalars['String']['output']>;
  /** Does this client have an active suspension */
  hasActiveSuspension?: Maybe<Scalars['Boolean']['output']>;
  /** Assets that exist for user */
  hasAsset?: Maybe<HasAsset>;
  /** Does the house have access */
  householdAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Does the household have a cat */
  householdCat?: Maybe<Scalars['Boolean']['output']>;
  /** Other relevant details about the house */
  householdDetails?: Maybe<Array<Scalars['String']['output']>>;
  /** Does the household have a dog */
  householdDog?: Maybe<Scalars['Boolean']['output']>;
  /** Is all the relevant equipment available at the house */
  householdEquipment?: Maybe<Scalars['Boolean']['output']>;
  /** Is parking available at the house */
  householdParking?: Maybe<Scalars['Boolean']['output']>;
  /** Does the household have a pet other than a cat/dog */
  householdPetsOthers?: Maybe<Scalars['Boolean']['output']>;
  /** Is the household considered safe */
  householdPremisesConsideredSafe?: Maybe<Scalars['Boolean']['output']>;
  /** Does the house have smokers */
  householdSmokers?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the client profile */
  id: Scalars['ID']['output'];
  /** Extra email address to cc invoice emails to */
  invoiceEmailsCc?: Maybe<Array<Scalars['String']['output']>>;
  /** Main email address to send invoice emails to */
  invoiceEmailsTo?: Maybe<Scalars['String']['output']>;
  /** Reference number to use on all invoices */
  invoiceReferenceNumber?: Maybe<Scalars['String']['output']>;
  /** NDIS number for this client */
  ndisNumber?: Maybe<Scalars['String']['output']>;
  /** Details about any onboarding already completed by the client */
  onboardingCompleted?: Maybe<OnboardingCompleted>;
  /** What percent has the onboarding been completed */
  onboardingStatusPercentage?: Maybe<Scalars['Int']['output']>;
  /** Details about the related organisation */
  organisationRequest?: Maybe<OrganisationRequest>;
  /** Address line 1 for the participant */
  participantAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Address line 2 for the participant */
  participantAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Details of the participant */
  participantAttributes?: Maybe<Participant>;
  /** Postcode of the participant */
  participantPostcode?: Maybe<Scalars['String']['output']>;
  /** ID of the PostcodeGeo for the participant */
  participantPostcodeGeoId?: Maybe<Scalars['Int']['output']>;
  /** Relationship of the client to the participant (eg self/parent) */
  participantRelationship?: Maybe<Scalars['String']['output']>;
  /** State (postal address) of the participant */
  participantState?: Maybe<Scalars['String']['output']>;
  /** Code for the chosen payment method (credit_card, direct_debit, invoice) */
  paymentMethodCode?: Maybe<Scalars['String']['output']>;
  /** Has this payment method been verified */
  paymentMethodVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Client's postal address line 1 */
  postalAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Client's postal address line 2 */
  postalAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Details about which steps of profile building are complete */
  profileBuildingCompleted?: Maybe<Scalars['String']['output']>;
  /** Status about how much of the profile-building is complete (eg percent completion) */
  profileBuildingStatus?: Maybe<Scalars['String']['output']>;
  /** If this is set to true, the client will receive a copy of the invoice email */
  receiveCopyInvoiceReceiptEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Is this client funded privately */
  signupPrivateFunding?: Maybe<Scalars['Boolean']['output']>;
  /** What type of care did the client say they wanted during signup (eg aged_care/disability_support/post_surgery) */
  typeOfCare?: Maybe<Scalars['String']['output']>;
  /** ID of the related user object */
  userId?: Maybe<Scalars['Int']['output']>;
  /** When did the client request to start receiving care (during signup) */
  whenIsSupportNeeded?: Maybe<Scalars['String']['output']>;
};

/** Attributes for a client profile */
export type ClientProfileAttributes = {
  /** Any information required to access the client's house */
  accessInformation?: InputMaybe<Scalars['String']['input']>;
  /** Organisation name that is handling the funding */
  assignPartnerFundingOrganisation?: InputMaybe<Scalars['String']['input']>;
  /** Is the Credit-card authorised */
  authoriseCc?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when the balance payment was acknowledged */
  balancePaymentAcknowledgeDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Account number for the client's bank account */
  bankAccountDetailsAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Bank-name the client's bank account */
  bankAccountDetailsBank?: InputMaybe<Scalars['String']['input']>;
  /** BSB for the client's bank account */
  bankAccountDetailsBsb?: InputMaybe<Scalars['String']['input']>;
  /** Account name for the client's bank account */
  bankAccountDetailsName?: InputMaybe<Scalars['String']['input']>;
  /** What kind of support-plan is in place for behaviour (eg restrictive_behaviour_support) */
  behaviourSupportPlan?: InputMaybe<Scalars['String']['input']>;
  /** Details for any contacts */
  contactsAttributes?: InputMaybe<Array<ContactAttributes>>;
  /** What instructions are needed in an emergency */
  emergencyInstructions?: InputMaybe<Scalars['String']['input']>;
  /** What equipment does the client have/need */
  equipmentList?: InputMaybe<Scalars['String']['input']>;
  /** What kind of funding source does this client have (eg home_care_package) */
  fundingSourceCode?: InputMaybe<Scalars['String']['input']>;
  /** Does the house have access */
  householdAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does the household have a cat */
  householdCat?: InputMaybe<Scalars['Boolean']['input']>;
  /** Other relevant details about the house */
  householdDetails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does the household have a dog */
  householdDog?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is all the relevant equipment available at the house */
  householdEquipment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is parking available at the house */
  householdParking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does the household have a pet other than a cat/dog */
  householdPetsOthers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the household considered safe */
  householdPremisesConsideredSafe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does the house have smokers */
  householdSmokers?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the client-profile */
  id: Scalars['ID']['input'];
  /** Extra email address to cc invoice emails to */
  invoiceEmailsCc?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Main email address to send invoice emails to */
  invoiceEmailsTo?: InputMaybe<Scalars['String']['input']>;
  /** Reference number to use on all invoices */
  invoiceReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** NDIS number for this client */
  ndisNumber?: InputMaybe<Scalars['String']['input']>;
  /** ??? Details about the related organisation */
  organisationRequest?: InputMaybe<OrganisationRequestAttribute>;
  /** Address line 1 for the participant */
  participantAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 for the participant */
  participantAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Details of the participant */
  participantAttributes?: InputMaybe<ParticipantAttribute>;
  /** Postcode of the participant */
  participantPostcode?: InputMaybe<Scalars['String']['input']>;
  /** Relationship of the client to the participant (eg self/parent) */
  participantRelationship?: InputMaybe<Scalars['String']['input']>;
  /** State (postal address) of the participant */
  participantState?: InputMaybe<Scalars['String']['input']>;
  /** Code for the chosen payment method (credit_card, direct_debit, invoice) */
  paymentMethodCode?: InputMaybe<Scalars['String']['input']>;
  /** If this is set to true, the client will receive a copy of the invoice email */
  receiveCopyInvoiceReceiptEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** What type of care did the client say they wanted during signup (eg aged_care/disability_support/post_surgery) */
  typeOfCare?: InputMaybe<Scalars['String']['input']>;
};

/** Shows onboarding-steps that a client has completed */
export type ClientStepStatus = {
  __typename?: 'ClientStepStatus';
  /** Has client completed the my-support step */
  mySupport: Scalars['Boolean']['output'];
  /** Has client completed the ndis-plan step */
  ndisPlan?: Maybe<Scalars['Boolean']['output']>;
  /** Has client completed the payment step */
  payment?: Maybe<Scalars['Boolean']['output']>;
  /** Has client completed the personal step */
  personal: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ClientUpdate */
export type ClientUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user we're updating */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Attributes we are updating */
  userAttributes: ClientAttributes;
};

/** Autogenerated return type of ClientUpdate */
export type ClientUpdatePayload = {
  __typename?: 'ClientUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated user */
  user?: Maybe<User>;
};

/** Field definitions for Client Dashboard Agreements Component */
export type ClientsAgreements = {
  __typename?: 'ClientsAgreements';
  /** ??? Extra data for this field */
  data?: Maybe<Array<ClientsAgreementsData>>;
  /** Heading displayed in the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Sub-heading displayed in the component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Client Dashboard Agreements Component Data */
export type ClientsAgreementsData = {
  __typename?: 'ClientsAgreementsData';
  /** The conversation between the parties on this agreement */
  conversation?: Maybe<Conversation>;
  /** ID of conversation - see conversation for more attributes */
  conversationId?: Maybe<Scalars['Int']['output']>;
  /** Name of the other party to this agreement */
  nameOfOtherParticipant?: Maybe<Scalars['String']['output']>;
  /** Avatar for the other party */
  otherUserAvatar?: Maybe<Scalars['String']['output']>;
  /** ID for the other party */
  otherUserId?: Maybe<Scalars['Int']['output']>;
  /** Status of this agreement */
  status?: Maybe<Scalars['String']['output']>;
};

/** Details for displaying the dashboard tile for booking a call */
export type ClientsBookACall = {
  __typename?: 'ClientsBookACall';
  /** Display-text for the dashboard tile */
  body?: Maybe<Scalars['String']['output']>;
  /** Text for the CTA button */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Heading for the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Subheading for the component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this tile visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Client Dashboard Call To Actions Component */
export type ClientsCallToActions = {
  __typename?: 'ClientsCallToActions';
  /** Data for the Call to Action component */
  data?: Maybe<Array<ClientsCallToActionsData>>;
  /** Heading for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Client Dashboard Call To Actions Component Data */
export type ClientsCallToActionsData = {
  __typename?: 'ClientsCallToActionsData';
  /** Display text for the body of this dashboard tile */
  body?: Maybe<Scalars['String']['output']>;
  /** HTTP action for the CTA link */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA link */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the CTA link */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Input-type for the CTA link */
  ctaType?: Maybe<Scalars['String']['output']>;
  /** Image for this component tile */
  image?: Maybe<Scalars['String']['output']>;
  /** Column used for ordering dashboard tiles */
  order?: Maybe<Scalars['Int']['output']>;
  /** Title of the dashboard tile */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Client Dashboard Complete Profile Component */
export type ClientsCompleteProfile = {
  __typename?: 'ClientsCompleteProfile';
  /** Data about a complete client profile to show on the dashboard */
  data?: Maybe<ClientsCompleteProfileData>;
  /** Heading for the component on the dashboard */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Client Dashboard Complete Profile Component Data */
export type ClientsCompleteProfileData = {
  __typename?: 'ClientsCompleteProfileData';
  /** A text-based alert about who can see the profile */
  alert?: Maybe<Scalars['String']['output']>;
  /** Text body of the component */
  body?: Maybe<Scalars['String']['output']>;
  /** http action on the CTA */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Text on the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Input-type of the CTA */
  ctaType?: Maybe<Scalars['String']['output']>;
  /** Image for the component */
  image?: Maybe<Scalars['String']['output']>;
  /** Order this will appear on the dashboard */
  order?: Maybe<Scalars['Int']['output']>;
  /** Title for the component */
  title?: Maybe<Scalars['String']['output']>;
};

/** A dashboard checklist the client is encouraged to complete to setup their account */
export type ClientsDashboardChecklist = {
  __typename?: 'ClientsDashboardChecklist';
  /** Data for the checklist dashboard */
  data?: Maybe<ClientsDashboardChecklistData>;
  /** Whether or not the checklist should be visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** The clients CTA action for the client dashboard checklist */
export type ClientsDashboardChecklistButtons = {
  __typename?: 'ClientsDashboardChecklistButtons';
  /** One of Internal or External */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** One of Primary or Secondary */
  ctaType?: Maybe<Scalars['String']['output']>;
};

/** Contains steps for the client dashboard checklist */
export type ClientsDashboardChecklistData = {
  __typename?: 'ClientsDashboardChecklistData';
  /** An array of steps to be completed by the client */
  steps?: Maybe<Array<ClientsDashboardChecklistSteps>>;
};

/** Deprecated, A field containing everything the frontend needs to generate a client dashboard checklist field */
export type ClientsDashboardChecklistGettingStarted = {
  __typename?: 'ClientsDashboardChecklistGettingStarted';
  /** The main body for the checklist field */
  body?: Maybe<Scalars['String']['output']>;
  /** Whether the step has been completed */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** Is the link to a external source */
  isExternalLink?: Maybe<Scalars['Boolean']['output']>;
  /** A step number indicating display order */
  stepNumber?: Maybe<Scalars['String']['output']>;
  /** Title for the step */
  title?: Maybe<Scalars['String']['output']>;
  /** The CTA link for the step */
  url?: Maybe<Scalars['String']['output']>;
};

/** A single step withen the client dashboard checklist */
export type ClientsDashboardChecklistSteps = {
  __typename?: 'ClientsDashboardChecklistSteps';
  /** The main body text for the step (aka description to client) */
  body?: Maybe<Scalars['String']['output']>;
  /** Details controlling the steps CTA */
  buttons?: Maybe<Array<ClientsDashboardChecklistButtons>>;
  /** Indicates whether the steps been completed or not */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** The steps number / order */
  stepNumber?: Maybe<Scalars['String']['output']>;
  /** Heading for the step */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Client Dashboard - Dashboard Tiles Component */
export type ClientsDashboardTiles = {
  __typename?: 'ClientsDashboardTiles';
  /** Agreements this client has made */
  agreements?: Maybe<ClientsAgreements>;
  /** Links to display for this client */
  helpfulLinks?: Maybe<ClientsHelpfulLinks>;
  /** Invitations this client has recevied */
  invitations?: Maybe<ClientsInvitations>;
  /** Messages for this client */
  messages?: Maybe<ClientsMessages>;
  /** Recent jobs this client has posted */
  recentJobs?: Maybe<ClientsRecentJobs>;
};

/** Detail for tiles the client can dismiss after viewing */
export type ClientsDismissableTiles = {
  __typename?: 'ClientsDismissableTiles';
  /** Data containing dismissable tiles for this component */
  data?: Maybe<Array<ClientsDismissableTilesData>>;
  /** Heading for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Sub-heading for this component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Detail for internal content for tiles the client can dismiss after viewing */
export type ClientsDismissableTilesData = {
  __typename?: 'ClientsDismissableTilesData';
  /** Display text for the body of this dashboard tile */
  body?: Maybe<Scalars['String']['output']>;
  /** HTTP action for the CTA link */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** Any additional data about the tile as json. e.g. {id: 1} */
  ctaData?: Maybe<Scalars['JSON']['output']>;
  /** URL for the CTA link */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the CTA link */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Input-type for the CTA link */
  ctaType?: Maybe<Scalars['String']['output']>;
  /** Type of the tile. e.g. carer_reliability_assessment, share_support_needs, etc. */
  id?: Maybe<Scalars['String']['output']>;
  /** Column used for ordering dashboard tiles */
  order?: Maybe<Scalars['Int']['output']>;
  /** Title of the dashboard tile */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Client Dashboard Flags Component */
export type ClientsFlags = {
  __typename?: 'ClientsFlags';
  /** Does this client have an agreement */
  haveAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** Should we show the download-app CTA to this client */
  showDownloadApp?: Maybe<Scalars['Boolean']['output']>;
};

/** Client checklist dashboard, deprecated. */
export type ClientsGetStarted = {
  __typename?: 'ClientsGetStarted';
  /** The contents of the checklist dashboard. Deprecated. */
  dashboardChecklist?: Maybe<Array<ClientsDashboardChecklistGettingStarted>>;
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Client Dashboard Helpful Links Component */
export type ClientsHelpfulLinks = {
  __typename?: 'ClientsHelpfulLinks';
  /** Data for the list of links displayed in this component */
  data?: Maybe<Array<ClientsHelpfulLinksData>>;
  /** Heading for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Subheading for this component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Client Dashboard Helpful Links Component Data */
export type ClientsHelpfulLinksData = {
  __typename?: 'ClientsHelpfulLinksData';
  /** URL for the link */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the link */
  ctaText?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Client Dashboard Hero Image Component */
export type ClientsHeroImage = {
  __typename?: 'ClientsHeroImage';
  /** Heading for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Subheading for this component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fetches the copy for the 'Get Started' tile for clients who need to verify their identity. */
export type ClientsIdentityVerificationDataType = {
  __typename?: 'ClientsIdentityVerificationDataType';
  /** The description for each advantage of verifying client's identity */
  body?: Maybe<Scalars['String']['output']>;
};

/** Fetches all the items for the 'Get Started' tile that will be displayed for clients who need to verify their identity. */
export type ClientsIdentityVerificationType = {
  __typename?: 'ClientsIdentityVerificationType';
  /** The cta actions of the tile */
  ctaActions?: Maybe<CtaActions>;
  /** The content of the tile */
  data?: Maybe<ClientsIdentityVerificationVerifyDataType>;
  /** The heading for the content of the tile. */
  dataHeading?: Maybe<Scalars['String']['output']>;
  /** The heading for the tile */
  heading?: Maybe<Scalars['String']['output']>;
  /** The subheading for the tile */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Whether the tile is visible or not */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fetches the copy for the 'Get Started' tile for clients who needs to verify their identity */
export type ClientsIdentityVerificationVerifyDataType = {
  __typename?: 'ClientsIdentityVerificationVerifyDataType';
  /** The content of the tile */
  verifyData?: Maybe<Array<ClientsIdentityVerificationDataType>>;
};

/** Fields for Client Dashboard Invitations component - displaying any invitations received by the client */
export type ClientsInvitations = {
  __typename?: 'ClientsInvitations';
  /** Data for each individual invitation to display in the component */
  data?: Maybe<Array<ClientsInvitationsData>>;
  /** Heading for the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Sub-heading explaining the component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for an individual Inivitation sent to/by this client - to be displayed in the client invitation dashboard component */
export type ClientsInvitationsData = {
  __typename?: 'ClientsInvitationsData';
  /** Creation timestamp of the invitation */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Avatar URL of the receiver of the invitation */
  receiverAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Full name of the receiver of the invitation */
  receiverFullName?: Maybe<Scalars['String']['output']>;
  /** Status of the invitation */
  status?: Maybe<Scalars['String']['output']>;
};

/** Fields for displaying the Client Dashboard News Component */
export type ClientsMableNews = {
  __typename?: 'ClientsMableNews';
  /** Data for individual news items to be displayed */
  data?: Maybe<Array<ClientsMableNewsData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for individual news-item in the Client Dashboard News component */
export type ClientsMableNewsData = {
  __typename?: 'ClientsMableNewsData';
  /** Body of the news item */
  body?: Maybe<Scalars['String']['output']>;
  /** HTTP action of the CTA of the news item */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL of the CTA of the news item */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Link-text of the CTA of the news item */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Type of the CTA of the news item */
  ctaType?: Maybe<Scalars['String']['output']>;
  /** Image displayed alongside the news item */
  image?: Maybe<Scalars['String']['output']>;
  /** HTTP action of the 'learn more' CTA of the news item */
  learnMoreCtaAction?: Maybe<Scalars['String']['output']>;
  /** URL of the 'learn more' CTA of the news item */
  learnMoreCtaLink?: Maybe<Scalars['String']['output']>;
  /** Link-text of the 'learn more' CTA of the news item */
  learnMoreCtaText?: Maybe<Scalars['String']['output']>;
  /** Type of the 'learn more' CTA of the news item */
  learnMoreCtaType?: Maybe<Scalars['String']['output']>;
  /** Field used for ordering the news items */
  order?: Maybe<Scalars['Int']['output']>;
  /** Display-title of the news item */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Client Dashboard Messages Component */
export type ClientsMessages = {
  __typename?: 'ClientsMessages';
  /** Data to be displayed in the component */
  data?: Maybe<Array<ClientsMessagesData>>;
  /** Main heading of the dashboard component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Subheading of the dashboard component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Client Dashboard Messages Component Data */
export type ClientsMessagesData = {
  __typename?: 'ClientsMessagesData';
  /** When was this message created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the message */
  id?: Maybe<Scalars['ID']['output']>;
  /** Date of a scheduled meet and greet (if any) */
  meetAndGreetDate?: Maybe<Scalars['String']['output']>;
  /** Name of the person requested for the meet and greet (if any) */
  meetAndGreetRequesteeFirstName?: Maybe<Scalars['String']['output']>;
  /** Name of the person requesting the greet (if any) */
  meetAndGreetRequestorFirstName?: Maybe<Scalars['String']['output']>;
  /** Time of a scheduled meet and greet (if any) */
  meetAndGreetTime?: Maybe<Scalars['String']['output']>;
  /** Main body of the message */
  messageBody?: Maybe<Scalars['String']['output']>;
  /** What kind of message is this */
  messageKind?: Maybe<Scalars['String']['output']>;
  /** Who wrote this message */
  messageOwner?: Maybe<Scalars['String']['output']>;
  /** Avatar of the person who wrote this message */
  workerAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the person who wrote this message */
  workerName?: Maybe<Scalars['String']['output']>;
};

/** Represents either a ClientsSearchWorkers tile or ClientsGetStarted tile in the NDIS Ready Dashboard */
export type ClientsNdisReadyData = ClientsNdisReadyJobPostDataType | ClientsNdisReadySearchWorkersDataType;

/** Fetch the copy for the get started modal for ndis ready clients */
export type ClientsNdisReadyGetStartedDataType = {
  __typename?: 'ClientsNdisReadyGetStartedDataType';
  /** The description for each tip for finding a support worker that matches a clients needs */
  body?: Maybe<Scalars['String']['output']>;
  /** The heading for each tip for finding a support worker that matches a clients needs  */
  heading?: Maybe<Scalars['String']['output']>;
};

/** Fetch additional information for the get started tile for ndis ready clients */
export type ClientsNdisReadyGetStartedMoreInfoBodyType = {
  __typename?: 'ClientsNdisReadyGetStartedMoreInfoBodyType';
  /** The description for each type of support you can find on Mable */
  body?: Maybe<Scalars['String']['output']>;
  /** The heading for each type of support you can find on Mable */
  heading?: Maybe<Scalars['String']['output']>;
};

/** Fetch additional information for the get started tile for ndis ready clients */
export type ClientsNdisReadyGetStartedMoreInfoType = {
  __typename?: 'ClientsNdisReadyGetStartedMoreInfoType';
  /** The list of types of support clients can find on Mable */
  body?: Maybe<Array<ClientsNdisReadyGetStartedMoreInfoBodyType>>;
  /** What types of support can I find on Mable? */
  heading?: Maybe<Scalars['String']['output']>;
};

/** Fetch the copy for the get started modal for ndis ready clients */
export type ClientsNdisReadyJobPostDataType = {
  __typename?: 'ClientsNdisReadyJobPostDataType';
  /** The content of the tile */
  jobPostData?: Maybe<Array<ClientsNdisReadyGetStartedDataType>>;
};

/** Fetch the copy for the get started modal for ndis ready clients */
export type ClientsNdisReadySearchWorkersDataType = {
  __typename?: 'ClientsNdisReadySearchWorkersDataType';
  /** The description for each tip for finding a support worker that matches a clients needs */
  searchWorkersData?: Maybe<Array<Scalars['String']['output']>>;
};

/** Fetch all the items for the Get Started or Search Worker tile that will be displayed for NDIS ready clients only */
export type ClientsNdisReadyType = {
  __typename?: 'ClientsNdisReadyType';
  /** The cta actions of the tile */
  ctaActions?: Maybe<CtaActions>;
  /** The content of the tile */
  data?: Maybe<ClientsNdisReadyData>;
  /** The heading for the main datapoints */
  dataHeading?: Maybe<Scalars['String']['output']>;
  /** The heading for the tile */
  heading?: Maybe<Scalars['String']['output']>;
  /** Additional information in the tile */
  moreInfo?: Maybe<ClientsNdisReadyGetStartedMoreInfoType>;
  /** The subheading for the tile */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Whether the tile is visible or not */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fetch the copy for the get started modal for ready now clients */
export type ClientsReadyNowGetStartedDataType = {
  __typename?: 'ClientsReadyNowGetStartedDataType';
  /** The description for each tip for finding a support worker that matches a clients needs */
  body?: Maybe<Scalars['String']['output']>;
  /** The heading for each tip for finding a support worker that matches a clients needs  */
  heading?: Maybe<Scalars['String']['output']>;
};

/** Fetch additional information for the get started tile for ready now clients */
export type ClientsReadyNowGetStartedMoreInfoBodyType = {
  __typename?: 'ClientsReadyNowGetStartedMoreInfoBodyType';
  /** The description for each type of support you can find on Mable */
  body?: Maybe<Scalars['String']['output']>;
  /** The heading for each type of support you can find on Mable */
  heading?: Maybe<Scalars['String']['output']>;
};

/** Fetch additional information for the get started tile for ndis ready clients */
export type ClientsReadyNowGetStartedMoreInfoType = {
  __typename?: 'ClientsReadyNowGetStartedMoreInfoType';
  /** The list of types of support clients can find on Mable */
  body?: Maybe<Array<ClientsReadyNowGetStartedMoreInfoBodyType>>;
  /** What types of support can I find on Mable? */
  heading?: Maybe<Scalars['String']['output']>;
};

/** Fetch the copy for the get started modal for ndis ready clients */
export type ClientsReadyNowJobPostDataType = {
  __typename?: 'ClientsReadyNowJobPostDataType';
  /** The content of the tile */
  jobPostData?: Maybe<Array<ClientsReadyNowGetStartedDataType>>;
};

/** Fetch all the items for the Get Started or Search Worker tile that will be displayed for ready now clients only */
export type ClientsReadyNowType = {
  __typename?: 'ClientsReadyNowType';
  /** The cta actions of the tile */
  ctaActions?: Maybe<CtaActions>;
  /** The content of the tile */
  data?: Maybe<ClientsReadyNowJobPostDataType>;
  /** The heading for the tile */
  heading?: Maybe<Scalars['String']['output']>;
  /** Additional information in the tile */
  moreInfo?: Maybe<ClientsReadyNowGetStartedMoreInfoType>;
  /** The subheading for the tile */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Whether the tile is visible or not */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for Client Recent Jobs component */
export type ClientsRecentJobs = {
  __typename?: 'ClientsRecentJobs';
  /** Details of the recent jobs to be displayed */
  data?: Maybe<Array<ClientsRecentJobsData>>;
  /** Heading for the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Subheading for the component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for individual recent jobs displayed on the Client Dashboard Recent Jobs Component */
export type ClientsRecentJobsData = {
  __typename?: 'ClientsRecentJobsData';
  /** ID of the job */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is this a last-minute (flex) job */
  isLastMinuteJob?: Maybe<Scalars['Boolean']['output']>;
  /** Is this a private job */
  isPrivateJob?: Maybe<Scalars['Boolean']['output']>;
  /** Job title */
  title?: Maybe<Scalars['String']['output']>;
  /** How many replies has this job received */
  totalReplies?: Maybe<Scalars['Int']['output']>;
};

/** Details storing when a user has accepted the code of conduct */
export type CodeOfConductAcknowledgement = {
  __typename?: 'CodeOfConductAcknowledgement';
  /** Conversation in which the user was prompted */
  conversation: Conversation;
  /** ID of the prompt-acknowledgment */
  id: Scalars['ID']['output'];
  /** User that acknowledged the prompt */
  user: User;
};

/** Status of the user's acknowledgement of the code-of-conduct prompt */
export type CodeOfConductAcknowledgementStatus = {
  __typename?: 'CodeOfConductAcknowledgementStatus';
  /** Should we show the prompt */
  showCodeOfConductPrompt: Scalars['Boolean']['output'];
};

/** Details of a prompt for the user to accept the code of conduct */
export type CodeOfConductPrompt = {
  __typename?: 'CodeOfConductPrompt';
  /** Conversation in which this prompt is displayed */
  conversation: Conversation;
  /** ID of the prompt */
  id: Scalars['ID']['output'];
  /** User being prompted */
  user: User;
};

/** Search field used to filter a list of items (eg incidents) */
export enum ComplianceSearchField {
  ClientId = 'client_id',
  ClientName = 'client_name',
  Id = 'id',
  Keyword = 'keyword',
  SessionId = 'session_id',
  SupportWorkerId = 'support_worker_id',
  SupportWorkerName = 'support_worker_name'
}

/** Normalized Job information for Expression of Interest */
export type ConnectionJob = {
  __typename?: 'ConnectionJob';
  /** Timestamp when the job was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Bettercaring database ID */
  externalId: Scalars['Int']['output'];
  /** External UUID reference */
  externalUuid: Scalars['String']['output'];
  /** UUID of the job */
  id: Scalars['ID']['output'];
  /** Timestamp when the job was posted */
  postedAt: Scalars['ISO8601DateTime']['output'];
  /** Current state of the job */
  state: Scalars['String']['output'];
  /** Title of the job */
  title: Scalars['String']['output'];
  /** Timestamp when the job was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Details of a user's contact */
export type Contact = {
  __typename?: 'Contact';
  /** Are we authorised to share information with this contact */
  authorisedInformation?: Maybe<Scalars['Boolean']['output']>;
  /** Email address of the contact */
  email?: Maybe<Scalars['String']['output']>;
  /** Is this contact to be contacted in the event of an emergency for this user */
  emergency?: Maybe<Scalars['Boolean']['output']>;
  /** ID of this contact */
  id: Scalars['ID']['output'];
  /** Name of the contact */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone of the contact */
  phone?: Maybe<Scalars['String']['output']>;
  /** Code for the type of relationship to the client eg Spouse */
  relationshipCode?: Maybe<Scalars['String']['output']>;
};

/** Different actions we can perform when working with contacts - eg create/update/delete */
export enum ContactActionOptions {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

/** Attributes for creating/updating a client contact */
export type ContactAttributes = {
  /** If true, this will delete the contact */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are we authorised to share information with this contact */
  authorisedInformation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email address of the contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Is this an emergency-contact for the client */
  emergency?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of this contact */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the contact */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone of the contact */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Code for the type of relationship to the client eg Spouse */
  relationshipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ContactCreateDeleteUpdate */
export type ContactCreateDeleteUpdateInput = {
  /** What action are we performing (create/update) */
  action: ContactActionOptions;
  /** Attributes for creating/updating */
  attributes?: InputMaybe<ContactAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the contact (if updating) */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ContactCreateDeleteUpdate */
export type ContactCreateDeleteUpdatePayload = {
  __typename?: 'ContactCreateDeleteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the resulting contact details */
  contact?: Maybe<Contact>;
};

/** Different kinds of relationships between the contact and the user - eg Spouse */
export enum ContactRelationshipOptions {
  /** Approved Provider / Care Coordinator */
  ApprovedProviderCareCoordinator = 'ApprovedProviderCareCoordinator',
  /** Extended Family */
  ExtendedFamily = 'ExtendedFamily',
  /** Friend / Neighbour */
  FriendNeighbour = 'FriendNeighbour',
  /** Immediate Family */
  ImmediateFamily = 'ImmediateFamily',
  /** Legal Representative / Advocate */
  LegalRepresentativeAdvocate = 'LegalRepresentativeAdvocate',
  /** Partner / Spouse */
  PartnerSpouse = 'PartnerSpouse'
}

/** Fields for a conversation between two parties - usually a carer and a customer */
export type Conversation = {
  __typename?: 'Conversation';
  /** Feed of activity for this conversation */
  activityFeed: Array<ActivityFeed>;
  /** Agreement between the two parties (for an agreed service at specified rates) */
  agreement?: Maybe<Agreement>;
  /** Allowed actions with other user */
  allowedActions: ConversationAllowedActions;
  /** Relevant fields for a client */
  clientFields?: Maybe<ClientFields>;
  /** The client participants and only available when other user is client. AKA consumer summary */
  consumerParticipants?: Maybe<Array<Participant>>;
  /** Current user */
  currentUser?: Maybe<User>;
  /** Do these parties have an agreement */
  hasAgreement: Scalars['Boolean']['output'];
  /** ID of this conversation */
  id: Scalars['ID']['output'];
  /** The experiment group of the consumer in the conversation */
  isHcpManagedOrOtherManagedClient: Scalars['Boolean']['output'];
  /** Meet and Greet set up between these two parties */
  meetAndGreet?: Maybe<MeetAndGreet>;
  /** The latest flex match that were offered to this conversation */
  offeredFlexMatch?: Maybe<JobMatch>;
  /**
   * Legacy field that used to fetch the other user, when there could only be one other
   * @deprecated Conversation may have multiple other users, use `Conversation.otherUsers` instead.
   */
  otherUser: User;
  /** Any other users on this conversation, apart from the current target */
  otherUsers: Array<User>;
  /** Label to use if this person is recommended */
  recommendedLabel?: Maybe<ConversationRecommendedLabel>;
  /** Details of the related sendbird_channel */
  sendbirdChannelDetail?: Maybe<SendbirdChannelDetail>;
  /** Whether or not a linked agreement should be visible */
  showAgreement: Scalars['Boolean']['output'];
  /** Information about the current status of this conversation */
  status: ConversationStatus;
  /** The unread message count for current user */
  unread: Scalars['Int']['output'];
  /** The messages from the other user */
  userMessages: MessageConnection;
};


/** Fields for a conversation between two parties - usually a carer and a customer */
export type ConversationUserMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Set of actions that can be performed on a conversation (with their relevant attributes) */
export type ConversationAllowedActions = {
  __typename?: 'ConversationAllowedActions';
  /** Negotiate an agreement */
  createAgreement: ConversationAllowedActionsItem;
  /** Negotiate a meet and greet */
  meetAndGreet: ConversationAllowedActionsItem;
  /** Set up a phonecall */
  phoneCall: ConversationAllowedActionsItem;
  /** Request an agreement */
  requestAgreement: ConversationAllowedActionsItem;
  /** Set up a video-call */
  videoCall: ConversationAllowedActionsItem;
};

/** Fields relating to an action peformable on a conversation */
export type ConversationAllowedActionsItem = {
  __typename?: 'ConversationAllowedActionsItem';
  /** Was a banner for this item dismissed over 24 hrs ago */
  bannerDismissed24HoursAgo?: Maybe<Scalars['Boolean']['output']>;
  /** Errors on this item */
  errors?: Maybe<Array<ConversationAllowedActionsItemError>>;
  /** Is this action allowed */
  isAllowed: Scalars['Boolean']['output'];
};

/** Errors on any of the allowed-action items for a converstion */
export type ConversationAllowedActionsItemError = {
  __typename?: 'ConversationAllowedActionsItemError';
  /** What category of error is this */
  category?: Maybe<Scalars['String']['output']>;
  /** Details of the error */
  errorMessage: Scalars['String']['output'];
  /** Is the link for more info external to our site */
  externalInfoLink?: Maybe<Scalars['Boolean']['output']>;
  /** Link to external info for this error */
  moreInfoLink?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Conversation. */
export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConversationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Conversation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Conversation>;
};

/** Flag to indicate whether a requested conversation exists */
export type ConversationExists = {
  __typename?: 'ConversationExists';
  /** Does this conversation exist */
  conversationExists: Scalars['Boolean']['output'];
};

/** How the client-worker connection was made eg through search, recommended worker etc */
export enum ConversationMechanismOptions {
  BulkMessage = 'bulk_message',
  Byo = 'byo',
  IndividualMessage = 'individual_message',
  JobFilterRec = 'job_filter_rec',
  JobRec = 'job_rec',
  JobRefRec = 'job_ref_rec',
  JobSearch = 'job_search',
  RecWorker = 'rec_worker',
  RecWorkerJobPage = 'rec_worker_job_page'
}

/** Label details for when a person is recommended to the current target */
export type ConversationRecommendedLabel = {
  __typename?: 'ConversationRecommendedLabel';
  /** Is this label enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Text of the label */
  text?: Maybe<Scalars['String']['output']>;
};

/** Categories of reasons why an incident has been reported */
export enum ConversationReportReasons {
  /** Financial or rate disputes */
  FinancialDispute = 'financial_dispute',
  /** Inappropriate or offensive conduct */
  InappropriateOffensiveMessaging = 'inappropriate_offensive_messaging',
  /** Off-platform requests */
  OffPlatformRequests = 'off_platform_requests',
  /** Other */
  Other = 'other',
  /** Persistent calling */
  PersistentCalling = 'persistent_calling',
  /** Persistent messaging */
  PersistentMessaging = 'persistent_messaging',
  /** Misleading profile */
  SpamMisleadingProfile = 'spam_misleading_profile',
  /** Unprofessional behaviour */
  UnprofessionalBehaviour = 'unprofessional_behaviour',
  /** Unreliable behaviour */
  UnreliableBehaviour = 'unreliable_behaviour',
  /** Unresponsive to messages */
  UnresponsiveToMessages = 'unresponsive_to_messages'
}

/** Information about the status of a conversation */
export type ConversationStatus = {
  __typename?: 'ConversationStatus';
  /** Has this conversation been archived */
  archived: Scalars['Boolean']['output'];
  /** Has the carer met the StatDec condition */
  carerStatDecConditionMet: Scalars['Boolean']['output'];
  /** Are there messages from the client in this conversation */
  hasClientMessage: Scalars['Boolean']['output'];
  /** Does the current user have any reviewable agreement with other user */
  hasReviewableAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** Shows 'Keep yourself safe' banner */
  showCircumventionBanner?: Maybe<Scalars['Boolean']['output']>;
  /** Shows 'share your job with 5-10 workers' banner */
  showShareYourJobBanner: Scalars['Boolean']['output'];
  /** Has this user blocked the client */
  userHasBlocked: Scalars['Boolean']['output'];
  /** Has this user blocked calls from the client */
  userHasBlockedCalls: Scalars['Boolean']['output'];
  /** Is this user blocked by the client */
  userIsBlocked: Scalars['Boolean']['output'];
};

/** Quick replies are shorter messages with fewer attributes */
export type ConversationsQuickReply = {
  __typename?: 'ConversationsQuickReply';
  /** Conversation between the relevant parties */
  conversationId: Scalars['ID']['output'];
  /** ID of the join model between conversation and quick reply */
  id: Scalars['ID']['output'];
  /** Posted job being shared (if any) */
  postedJobId: Scalars['ID']['output'];
  /** ID of the quick-reply */
  quickReplyId: Scalars['ID']['output'];
};

/** Details stored when a user dismisses this banner */
export type ConversationsUpdateCircumventionBannerFlagAttributes = {
  /** Consumer dismissed circumvention banner status */
  consumerDismissedCircumventionBanner?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the conversation where the banner was shown */
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated input type of ConvertJobToPublic */
export type ConvertJobToPublicInput = {
  /** Job attributes */
  attributes: PostedJobStandardAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Private job ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ConvertJobToPublic */
export type ConvertJobToPublicPayload = {
  __typename?: 'ConvertJobToPublicPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns PostedJob */
  postedJob: PostedJob;
};

/** Details for a coordinator */
export type Coordinator = {
  __typename?: 'Coordinator';
  /** Contact phone for the coordinator */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Full name of the coordinator */
  fullName: Scalars['String']['output'];
  /** ID of the coordinator */
  id: Scalars['ID']['output'];
  /** Organisation to which the coordinator belongs */
  organisation?: Maybe<Organisation>;
  /** Truncated display-name for the coordinator */
  truncatedName: Scalars['String']['output'];
};

/** Coverage */
export type Coverage = {
  __typename?: 'Coverage';
  /** coverage */
  coverage?: Maybe<Scalars['Float']['output']>;
  /** covered */
  covered?: Maybe<Array<Scalars['String']['output']>>;
  /** notcovered */
  notCovered?: Maybe<Array<Scalars['String']['output']>>;
};

/** Covered */
export type Covered = {
  __typename?: 'Covered';
  /** covered */
  covered?: Maybe<Array<Scalars['String']['output']>>;
  /** notcovered */
  notCovered?: Maybe<Array<Scalars['String']['output']>>;
};

/** Display-ready information about the user's COVID vaccine status (eg which vaccine, which dose etc) */
export enum CovidVaccineStatusDisplayOptions {
  Booster = 'booster',
  FinalDose = 'final_dose',
  FirstDose = 'first_dose',
  FirstDoseJanssen = 'first_dose_janssen',
  No = 'no',
  NoMedicalExemption = 'no_medical_exemption',
  NoRemoteSupport = 'no_remote_support',
  YesUpdateToDate = 'yes_update_to_date'
}

/** Information about the user's COVID vaccine status (eg which vaccine, which dose etc) */
export enum CovidVaccineStatusOptions {
  NoMedicalExemption = 'no_medical_exemption',
  NoRemoteSupport = 'no_remote_support',
  YesUpdateToDate = 'yes_update_to_date'
}

/** Autogenerated input type of CreateCodeOfConductAcknowledgement */
export type CreateCodeOfConductAcknowledgementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the conversation in which the acknowledgement was shown */
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCodeOfConductAcknowledgement */
export type CreateCodeOfConductAcknowledgementPayload = {
  __typename?: 'CreateCodeOfConductAcknowledgementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return code of conduct acknowledgement details */
  codeOfConductAcknowledgement?: Maybe<CodeOfConductAcknowledgement>;
};

/** Autogenerated input type of CreateCodeOfConductPrompt */
export type CreateCodeOfConductPromptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the conversation where the prompt is shown */
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCodeOfConductPrompt */
export type CreateCodeOfConductPromptPayload = {
  __typename?: 'CreateCodeOfConductPromptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return code of conduct prompt details */
  codeOfConductPrompt?: Maybe<CodeOfConductPrompt>;
};

/** Autogenerated input type of CreateConversationsQuickReply */
export type CreateConversationsQuickReplyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the conversation we are replying to */
  conversationId: Scalars['ID']['input'];
  /** ID of the job we are repying to */
  postedJobId: Scalars['ID']['input'];
  /** ID of the quick reply created */
  quickReplyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateConversationsQuickReply */
export type CreateConversationsQuickReplyPayload = {
  __typename?: 'CreateConversationsQuickReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the recorded conversations quick reply */
  conversationsQuickReply?: Maybe<ConversationsQuickReply>;
};

/** Different actions we can perform when working with an object - eg create/update/delete */
export enum CreateDeleteUpdateOptions {
  Create = 'create',
  Delete = 'delete',
  Update = 'update'
}

/** Autogenerated input type of CreateDownloadAppOffer */
export type CreateDownloadAppOfferInput = {
  /** Attributes of the offer-download attempt (eg whether they accepted the offer) */
  attributes: DownloadAppOfferAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDownloadAppOffer */
export type CreateDownloadAppOfferPayload = {
  __typename?: 'CreateDownloadAppOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the response from the attempt to download the offer */
  downloadAppOffer?: Maybe<DownloadAppOffer>;
};

/** Autogenerated input type of CreateExceededRateReason */
export type CreateExceededRateReasonInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** mutation attributes */
  exceededRateReasonAttributes: ExceededRateReasonAttributes;
};

/** Autogenerated return type of CreateExceededRateReason */
export type CreateExceededRateReasonPayload = {
  __typename?: 'CreateExceededRateReasonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return-status of the service that creates the ExceededRateReason */
  status: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateExpressJobSelection */
export type CreateExpressJobSelectionInput = {
  /** Client ID when current target is a coordinator. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Selected service recommendation. */
  selected: Scalars['String']['input'];
};

/** Autogenerated return type of CreateExpressJobSelection */
export type CreateExpressJobSelectionPayload = {
  __typename?: 'CreateExpressJobSelectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns express job selection. */
  expressJobSelection?: Maybe<ExpressJobSelection>;
};

/** Autogenerated input type of CreateExpressJobSession */
export type CreateExpressJobSessionInput = {
  /** Client ID when current target is a coordinator. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set of recommended bundles that a customer has selected from the given list */
  selections: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateExpressJobSession */
export type CreateExpressJobSessionPayload = {
  __typename?: 'CreateExpressJobSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns express job session - which holds information about the customer journey through the express-job process */
  expressJobSession?: Maybe<ExpressJobSession>;
};

/** Autogenerated input type of Create */
export type CreateInput = {
  /** UUID of the carer to invite */
  carerUuid: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the job to invite the carer to */
  jobUuid: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateJobReply */
export type CreateJobReplyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The job reply message when worker applies for a job */
  jobReplyAttributes: JobReplyAttributes;
  /** The posted job id to reply to */
  postedJobId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateJobReply */
export type CreateJobReplyPayload = {
  __typename?: 'CreateJobReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the posted job that the reply has been added to */
  postedJob: PostedJob;
};

/** Autogenerated input type of CreateJobResponseAnswer */
export type CreateJobResponseAnswerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the job response we're creating */
  lastJobResponseAnswerAttributes?: InputMaybe<Array<JobResponseAnswerAttributes>>;
};

/** Autogenerated return type of CreateJobResponseAnswer */
export type CreateJobResponseAnswerPayload = {
  __typename?: 'CreateJobResponseAnswerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the newly created job-response answers */
  jobResponseAnswers: Array<JobResponseAnswer>;
};

/** Autogenerated input type of CreateMeetAndGreet */
export type CreateMeetAndGreetInput = {
  /** Attributes of the new MeetAndGreet */
  attributes: MeetAndGreetAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateMeetAndGreet */
export type CreateMeetAndGreetPayload = {
  __typename?: 'CreateMeetAndGreetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns created meet and greet */
  meetAndGreet?: Maybe<MeetAndGreet>;
};

/** Autogenerated input type of CreateMobileNotificationAllowBannerDismissal */
export type CreateMobileNotificationAllowBannerDismissalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the user's device */
  deviceUuid: Scalars['String']['input'];
  /** What platform is the user on */
  platform?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateMobileNotificationAllowBannerDismissal */
export type CreateMobileNotificationAllowBannerDismissalPayload = {
  __typename?: 'CreateMobileNotificationAllowBannerDismissalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Attributes of the banner */
  mobileNotificationAllowBannerDismissal?: Maybe<MobileNotificationAllowBannerDismissal>;
};

/** Autogenerated input type of CreateMobileRatingPrompt */
export type CreateMobileRatingPromptInput = {
  /** Attributes required for creating the rating-prompt */
  attributes: MobileRatingPromptAttribute;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateMobileRatingPrompt */
export type CreateMobileRatingPromptPayload = {
  __typename?: 'CreateMobileRatingPromptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the rating-prompt */
  mobileRatingPrompt?: Maybe<MobileRatingPrompt>;
};

/** Autogenerated return type of Create */
export type CreatePayload = {
  __typename?: 'CreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the response of the update (JSON containing status and body) */
  response: Scalars['JSON']['output'];
};

/** Autogenerated input type of CreatePhoneCall */
export type CreatePhoneCallInput = {
  /** Optional phone number to use for proxy call instead of registered number */
  anotherPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Client id if the call is from coordinator login */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the conversation we're attaching this call to */
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePhoneCall */
export type CreatePhoneCallPayload = {
  __typename?: 'CreatePhoneCallPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns phone call details */
  phoneCall?: Maybe<PhoneCall>;
};

/** Autogenerated input type of CreatePhoneVerificationSchedule */
export type CreatePhoneVerificationScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User's contact phone number */
  contactPhone: Scalars['String']['input'];
  /** Attributes for creating a phone verification schedule */
  phoneVerificationScheduleAttributes: PhoneVerificationScheduleAttributes;
};

/** Autogenerated return type of CreatePhoneVerificationSchedule */
export type CreatePhoneVerificationSchedulePayload = {
  __typename?: 'CreatePhoneVerificationSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the user with updated fields */
  user: User;
};

/** Autogenerated input type of CreatePostedJobDraftFromSupportNeed */
export type CreatePostedJobDraftFromSupportNeedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** id of a user draft with posted_job_support_need kind */
  supportNeedId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePostedJobDraftFromSupportNeed */
export type CreatePostedJobDraftFromSupportNeedPayload = {
  __typename?: 'CreatePostedJobDraftFromSupportNeedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns user draft details. */
  userDraft?: Maybe<UserDraft>;
};

/** Autogenerated input type of CreateReference */
export type CreateReferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Provide attributes to create a new reference */
  referenceAttributes: ReferenceCreateAttributesType;
};

/** Autogenerated return type of CreateReference */
export type CreateReferencePayload = {
  __typename?: 'CreateReferencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the new Reference */
  reference: Reference;
};

/** Autogenerated input type of CreateScheduledEvent */
export type CreateScheduledEventInput = {
  /** Arguments required to create a new scheduled-event/session */
  attributes: ScheduledEventAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateScheduledEvent */
export type CreateScheduledEventPayload = {
  __typename?: 'CreateScheduledEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the new scheduled-event/session */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Autogenerated input type of CreateScheduledEventRescheduleRequest */
export type CreateScheduledEventRescheduleRequestInput = {
  /** Attributes required for this request */
  attributes: ScheduledEventRescheduleRequestAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateScheduledEventRescheduleRequest */
export type CreateScheduledEventRescheduleRequestPayload = {
  __typename?: 'CreateScheduledEventRescheduleRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the proposed new time */
  scheduledEventRescheduleRequest: ScheduledEventRescheduleRequest;
};

/** Autogenerated input type of CreateSendbirdChannel */
export type CreateSendbirdChannelInput = {
  /** Sendbird channel attributes */
  attributes: SendbirdChannelAttributes;
  /** client_id provided if user is coordinator */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSendbirdChannel */
export type CreateSendbirdChannelPayload = {
  __typename?: 'CreateSendbirdChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns sendbird_channel details and checks if channel is empty */
  createSendbirdChannelResponse?: Maybe<SendbirdChannelDetailResponse>;
};

/** Autogenerated input type of CreateSessionImpression */
export type CreateSessionImpressionInput = {
  /** Attributes for the session impression */
  attributes: SessionImpressionAttribute;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSessionImpression */
export type CreateSessionImpressionPayload = {
  __typename?: 'CreateSessionImpressionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the new session impression */
  sessionImpression?: Maybe<SessionImpression>;
};

/** Autogenerated input type of CreateSessionsFromAgreement */
export type CreateSessionsFromAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Agreement for which we're creating sessions */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSessionsFromAgreement */
export type CreateSessionsFromAgreementPayload = {
  __typename?: 'CreateSessionsFromAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns true if events were created without errors */
  status: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateShortlist */
export type CreateShortlistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** How the client-worker connection was made eg through search, recommended worker etc */
  mechanism?: InputMaybe<ConversationMechanismOptions>;
  /** The shortlist profile ID */
  shortlistProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateShortlist */
export type CreateShortlistPayload = {
  __typename?: 'CreateShortlistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns newly created shortlist-item if success */
  shortlist?: Maybe<ShortlistItem>;
};

/** Autogenerated input type of CreateStructuredRates */
export type CreateStructuredRatesInput = {
  /** Details of the structured rates for this agreement */
  agreedRates: AgreedRateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the agreement being updated */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateStructuredRates */
export type CreateStructuredRatesPayload = {
  __typename?: 'CreateStructuredRatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns status of creation */
  status: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateSupportHealthChangeAnswers */
export type CreateSupportHealthChangeAnswersInput = {
  /** Attributes of the health-change answer */
  answerAttributes: Array<SupportHealthChangeAnswerAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of a health-change note */
  healthChangeAttributes: HealthChangeAttributes;
};

/** Autogenerated return type of CreateSupportHealthChangeAnswers */
export type CreateSupportHealthChangeAnswersPayload = {
  __typename?: 'CreateSupportHealthChangeAnswersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns a support health change */
  supportHealthChange?: Maybe<SupportHealthChangeForEventDelivery>;
};

/** Autogenerated input type of CreateWallet */
export type CreateWalletInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** All the wallet attributes */
  walletAttributes: WalletAttributes;
};

/** Autogenerated return type of CreateWallet */
export type CreateWalletPayload = {
  __typename?: 'CreateWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Created wallet */
  wallet?: Maybe<Wallet>;
};

/** Autogenerated input type of CreateWalletPayoutDestination */
export type CreateWalletPayoutDestinationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Wallet payout destination input attributes */
  walletPayoutDestinationAttributes: WalletPayoutDestinationAttributes;
};

/** Autogenerated return type of CreateWalletPayoutDestination */
export type CreateWalletPayoutDestinationPayload = {
  __typename?: 'CreateWalletPayoutDestinationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of error messages */
  errors: Array<Scalars['String']['output']>;
  /** Newly created wallet payout destination */
  walletPayoutDestinationResponse: WalletPayoutDestination;
};

/** Autogenerated input type of CreateWorkerPreferences */
export type CreateWorkerPreferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input of worker preference */
  workerPreferencesInput: WorkerPreferencesInput;
};

/** Autogenerated return type of CreateWorkerPreferences */
export type CreateWorkerPreferencesPayload = {
  __typename?: 'CreateWorkerPreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns worker preferences selected by client */
  workerPreferences?: Maybe<WorkerPreferences>;
};

/** Autogenerated return type of CreatedJobReply */
export type CreatedJobReplyPayload = {
  __typename?: 'CreatedJobReplyPayload';
  /** Return the posted job we are subscribed to */
  postedJob: PostedJob;
};

/** Details of a Credit Note */
export type CreditNote = {
  __typename?: 'CreditNote';
  /** Credit note pdf link */
  link?: Maybe<Scalars['String']['output']>;
  /** Credit note reference number */
  referenceNumber: Scalars['String']['output'];
};

/** Details used to display a Call to Action (CTA) */
export type CtaActions = {
  __typename?: 'CtaActions';
  /** One of Internal or External */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** One of Primary or Secondary */
  ctaType?: Maybe<Scalars['String']['output']>;
};

/** Worker's list of cultural background(s) */
export enum CulturalBackgroundOptions {
  Albania = 'Albania',
  Asian = 'Asian',
  Australian = 'Australian',
  AustralianAboriginal = 'AustralianAboriginal',
  AustralianSouthEastIslander = 'AustralianSouthEastIslander',
  Austrian = 'Austrian',
  Balinese = 'Balinese',
  Bosnian = 'Bosnian',
  British = 'British',
  CarribbeanIslander = 'CarribbeanIslander',
  CentralAmerican = 'CentralAmerican',
  Chinese = 'Chinese',
  Croatian = 'Croatian',
  Cypriot = 'Cypriot',
  Czech = 'Czech',
  Dutch = 'Dutch',
  Egyptian = 'Egyptian',
  Filipino = 'Filipino',
  French = 'French',
  Greek = 'Greek',
  Hungarian = 'Hungarian',
  Indian = 'Indian',
  Indonesian = 'Indonesian',
  Iraqi = 'Iraqi',
  Irish = 'Irish',
  Italian = 'Italian',
  Japanese = 'Japanese',
  Jewish = 'Jewish',
  Korean = 'Korean',
  Lebanese = 'Lebanese',
  Macedonian = 'Macedonian',
  Malay = 'Malay',
  Maltese = 'Maltese',
  Maori = 'Maori',
  MiddleEastern = 'MiddleEastern',
  Montenegrin = 'Montenegrin',
  NewZealander = 'NewZealander',
  NorthAmerican = 'NorthAmerican',
  NorthernEuropean = 'NorthernEuropean',
  OtherAfrican = 'OtherAfrican',
  OtherMiddleEastern = 'OtherMiddleEastern',
  OtherOceanian = 'OtherOceanian',
  Pakistani = 'Pakistani',
  Persian = 'Persian',
  Polish = 'Polish',
  Polynesian = 'Polynesian',
  Portuguese = 'Portuguese',
  Russian = 'Russian',
  Serbian = 'Serbian',
  Singaporean = 'Singaporean',
  SouthAfrican = 'SouthAfrican',
  SouthAmerican = 'SouthAmerican',
  SouthernAndEasternEuropean = 'SouthernAndEasternEuropean',
  Spanish = 'Spanish',
  Taiwanese = 'Taiwanese',
  Thai = 'Thai',
  Timorese = 'Timorese',
  TorresStraitIslander = 'TorresStraitIslander',
  Turkish = 'Turkish',
  Vietnamese = 'Vietnamese',
  WesternEuropean = 'WesternEuropean'
}

/** What cultural background does this worker have */
export type Culture = {
  __typename?: 'Culture';
  /** Asian backgrounds */
  asian: Array<CultureItem>;
  /** Cultures */
  general: Array<CultureItem>;
  /** Middle eastern backgrounds */
  middleEast: Array<CultureItem>;
  /** South east european backgrounds */
  southEastEurope: Array<CultureItem>;
  /** West european backgrounds */
  westEurope: Array<CultureItem>;
};

/** Information about the user's cultural background */
export type CultureItem = {
  __typename?: 'CultureItem';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** Fields to be used by frontend display. Each field contains structure for a specific prompt */
export type Data = {
  __typename?: 'Data';
  /** Details about the need prompt */
  needDetails?: Maybe<NeedDetails>;
};

/** Contains details of the day and any related session requested/available for this day */
export type Day = {
  __typename?: 'Day';
  /** Which day of the week is this */
  day?: Maybe<Scalars['String']['output']>;
  /** A summary of the sessions requested/available for this day */
  session?: Maybe<Scalars['String']['output']>;
};

/** Day names - needed by anything that requires day-specific data */
export enum DayOptions {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

/** Agreed detail about session days and times for an agreement */
export type DaysAndTimes = {
  /** Times agreed for Fridays */
  friday: DaysAndTimesItem;
  /** Times agreed for Mondays */
  monday: DaysAndTimesItem;
  /** Times agreed for Saturdays */
  saturday: DaysAndTimesItem;
  /** Times agreed for Sundays */
  sunday: DaysAndTimesItem;
  /** Times agreed for Thursdays */
  thursday: DaysAndTimesItem;
  /** Times agreed for Tuesdays */
  tuesday: DaysAndTimesItem;
  /** Times agreed for Wednesdays */
  wednesday: DaysAndTimesItem;
};

/** Detail for specified times for a given day */
export type DaysAndTimesItem = {
  /** Are any sessions expected for this day */
  expected: Scalars['Boolean']['input'];
  /** Details of any expected sessions for this day */
  expectedSessions: Array<ExpectedSessions>;
};

/** Autogenerated input type of DeclineAgreement */
export type DeclineAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the requested agreement */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineAgreement */
export type DeclineAgreementPayload = {
  __typename?: 'DeclineAgreementPayload';
  /** The declined agreement (null if not found) */
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of Decline */
export type DeclineInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the request to update */
  requestUuid: Scalars['ID']['input'];
};

/** Autogenerated input type of DeclineInvitation */
export type DeclineInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the invitation */
  invitationUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineInvitation */
export type DeclineInvitationPayload = {
  __typename?: 'DeclineInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the response of the update (JSON containing status and body) */
  response: Scalars['JSON']['output'];
};

/** Autogenerated input type of DeclineMultipleSessions */
export type DeclineMultipleSessionsInput = {
  /** Session declining/cancelling update attributes */
  attributes: ScheduledEventRsvpUpdate;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the session's occurrence */
  sessionId: Scalars['String']['input'];
  /** Id type of the session's occurrence */
  sessionIdType: Scalars['String']['input'];
};

/** Autogenerated return type of DeclineMultipleSessions */
export type DeclineMultipleSessionsPayload = {
  __typename?: 'DeclineMultipleSessionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the scheduled event */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Autogenerated return type of Decline */
export type DeclinePayload = {
  __typename?: 'DeclinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the response of the update (JSON containing status and body) */
  response: Scalars['JSON']['output'];
};

/** Autogenerated input type of DeclineRescheduleRequest */
export type DeclineRescheduleRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reason for declining the reschedule request */
  declineReason?: InputMaybe<Scalars['String']['input']>;
  /** Reschedule request ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineRescheduleRequest */
export type DeclineRescheduleRequestPayload = {
  __typename?: 'DeclineRescheduleRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns status of cancellation for the reschedule request */
  status: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeclineSingleSession */
export type DeclineSingleSessionInput = {
  /** Session declining/cancelling update attributes */
  attributes: ScheduledEventRsvpUpdate;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the session's occurrence */
  sessionId: Scalars['String']['input'];
  /** Id type of the session's occurrence */
  sessionIdType: Scalars['String']['input'];
};

/** Autogenerated return type of DeclineSingleSession */
export type DeclineSingleSessionPayload = {
  __typename?: 'DeclineSingleSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the scheduled event */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Get the default rates */
export type DefaultRate = {
  __typename?: 'DefaultRate';
  /** The default per km rate */
  defaultPerKmRate: Scalars['Float']['output'];
  /** The NDIA price guide travel rate */
  ndiaPriceGuideTravelRate: Scalars['Float']['output'];
};

/** Autogenerated input type of DeleteAgreementRequest */
export type DeleteAgreementRequestInput = {
  /** ID of the agreement request to be deleted */
  agreementRequestId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteAgreementRequest */
export type DeleteAgreementRequestPayload = {
  __typename?: 'DeleteAgreementRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns status of deletion */
  status: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteMultipleSessions */
export type DeleteMultipleSessionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Details identifying the session */
  sessionId: SessionId;
};

/** Autogenerated return type of DeleteMultipleSessions */
export type DeleteMultipleSessionsPayload = {
  __typename?: 'DeleteMultipleSessionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns status of the operation */
  status: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteReference */
export type DeleteReferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the refrence to be deleted */
  referenceAttributes: ReferenceUpdateAttributesType;
};

/** Autogenerated return type of DeleteReference */
export type DeleteReferencePayload = {
  __typename?: 'DeleteReferencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns reference: nil if deletion successful */
  reference?: Maybe<Reference>;
};

/** Autogenerated input type of DeleteRescheduleRequest */
export type DeleteRescheduleRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reschedule request ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRescheduleRequest */
export type DeleteRescheduleRequestPayload = {
  __typename?: 'DeleteRescheduleRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns status of deletion */
  status: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteShiftNoteAttachment */
export type DeleteShiftNoteAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the deletion */
  deletionReason?: InputMaybe<DeletionReasonOptions>;
  /** ID of the shift note to delete */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteShiftNoteAttachment */
export type DeleteShiftNoteAttachmentPayload = {
  __typename?: 'DeleteShiftNoteAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns shift note asset's details */
  shiftNoteAssets?: Maybe<ShiftNoteAsset>;
};

/** Autogenerated input type of DeleteShortlist */
export type DeleteShortlistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the support-worker's carer-profile to be deleted */
  shortlistProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteShortlist */
export type DeleteShortlistPayload = {
  __typename?: 'DeleteShortlistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the newly removed carer_profile if success, otherwise null */
  shortlist?: Maybe<ShortlistItem>;
};

/** Autogenerated input type of DeleteSingleSession */
export type DeleteSingleSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Details identifying a session */
  sessionId: SessionId;
};

/** Autogenerated return type of DeleteSingleSession */
export type DeleteSingleSessionPayload = {
  __typename?: 'DeleteSingleSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns status of cancellation */
  status: Scalars['Boolean']['output'];
};

/** Different reasons why an object would be deleted */
export enum DeletionReasonOptions {
  IDidNotGiveMyConsent = 'i_did_not_give_my_consent',
  IDoNotLikeIt = 'i_do_not_like_it',
  ItIncludesPersonalOrSensitiveInformation = 'it_includes_personal_or_sensitive_information',
  ItIsNotRelevantToMe = 'it_is_not_relevant_to_me',
  NoReasonProvided = 'no_reason_provided',
  NotSafeResultsByRekognitionApi = 'not_safe_results_by_rekognition_api',
  SomethingElse = 'something_else'
}

/** Service type for delivered sessions */
export type DeliveredService = {
  __typename?: 'DeliveredService';
  /** Delivered service rates related to this service */
  deliveredServiceRates: Array<DeliveredServiceRate>;
  /** Time the delivered service ended */
  endedAt: Scalars['ISO8601DateTime']['output'];
  /** ID of this delivered service record */
  id: Scalars['ID']['output'];
  /** ID of the linked invoice statement */
  invoiceStatementId?: Maybe<Scalars['ID']['output']>;
  /** Status of the invoice */
  invoiceStatus?: Maybe<Scalars['String']['output']>;
  /** Source of truth invoiced or not - Date and time when this service was invoiced - nil when not invoiced */
  invoicedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the service was resubmitted or not */
  resubmitted?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the service that was provided */
  serviceId: Scalars['ID']['output'];
  /** Name of service that was provided */
  serviceName: Scalars['String']['output'];
  /** Time the delivered service started */
  startedAt: Scalars['ISO8601DateTime']['output'];
  /** Status of the service */
  status: SessionServiceStatus;
  /** Total rate in cents including fees */
  totalRateCents: Scalars['Int']['output'];
};

/** Service Rate type for a delivered service */
export type DeliveredServiceRate = {
  __typename?: 'DeliveredServiceRate';
  /** ID of the linked agreed rate */
  agreedRateId: Scalars['ID']['output'];
  /** ID of this delivered service rate record */
  id: Scalars['ID']['output'];
  /** Net rate in cents including fees */
  netRateCents: Scalars['Int']['output'];
  /** Amount of units (in minutes for hourly unit) */
  quantity: Scalars['Float']['output'];
  /** Units value of the quantity related to this rate */
  unit: DeliveredSessionRateUnit;
};

/** Delivered Session details for a scheduled event occurrence */
export type DeliveredSession = {
  __typename?: 'DeliveredSession';
  /** Activity logs for delivered sessions */
  activityLogs: Array<ActivityLog>;
  /** List of services that were delivered in this session */
  deliveredServices?: Maybe<Array<DeliveredService>>;
  /** Time the delivered session ended at */
  endedAt: Scalars['ISO8601DateTime']['output'];
  /** Timesheet ID */
  eventDeliveryId?: Maybe<Scalars['ID']['output']>;
  /** Express pay details for delivered session */
  expressPay?: Maybe<ExpressPay>;
  /** Id of the delivered session */
  id: Scalars['ID']['output'];
  /** Incident report for this session */
  incidentReport?: Maybe<IncidentReport>;
  /** Carer invoice statement ID */
  invoiceStatementId?: Maybe<Scalars['ID']['output']>;
  /** Rates applied to this delivered session */
  rates?: Maybe<Array<DeliveredSessionRate>>;
  /** ID of the scheduled event occurrence linked to the delivered session */
  scheduledEventOccurrenceId: Scalars['ID']['output'];
  /** Time the delivered session started at */
  startedAt: Scalars['ISO8601DateTime']['output'];
  /** Total amount due */
  supportHealthChange?: Maybe<SupportHealthChange>;
  /** Support note description for this session */
  supportNotes?: Maybe<Scalars['String']['output']>;
  /** Total amount due */
  totalAmountDue?: Maybe<Scalars['Float']['output']>;
  /** Total not including express pay fees */
  totalInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  /** UUID of the delivered session */
  uuid: Scalars['String']['output'];
};

/** Type of activity logged for a delivered session */
export enum DeliveredSessionActivityLog {
  ApprovedAt = 'approved_at',
  CreatedAt = 'created_at',
  EditedAt = 'edited_at',
  RejectedAt = 'rejected_at'
}

/** Rate type for delivered sessions */
export type DeliveredSessionRate = {
  __typename?: 'DeliveredSessionRate';
  /** Amount of units (in minutes for hourly unit) */
  quantity: Scalars['Int']['output'];
  /** Net rate cents, including fees */
  rateCents: Scalars['Int']['output'];
  /** ID of agreed rate */
  rateId?: Maybe<Scalars['ID']['output']>;
  /** ID of service linked to rate */
  serviceId?: Maybe<Scalars['ID']['output']>;
  /** Name of service linked to rate */
  serviceName?: Maybe<Scalars['String']['output']>;
  /** Timeblock applied to the rate */
  timeblock?: Maybe<TimeBlock>;
  /** Total rate in cents including fees */
  totalCents: Scalars['Int']['output'];
  /** Units the rate is calculated on */
  unit: DeliveredSessionRateUnit;
};

/** Whether a rate is a flat rate, hourly rate or per km rate */
export enum DeliveredSessionRateUnit {
  Flat = 'flat',
  Hourly = 'hourly',
  PerKm = 'per_km'
}

/** Autogenerated input type of Dismiss */
export type DismissInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the request to update */
  requestUuid: Scalars['ID']['input'];
};

/** Autogenerated input type of DismissMeetAndGreet */
export type DismissMeetAndGreetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Conversation that owns this meet and greet */
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissMeetAndGreet */
export type DismissMeetAndGreetPayload = {
  __typename?: 'DismissMeetAndGreetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns conversation ID */
  conversationId?: Maybe<Scalars['String']['output']>;
  /** Returns meet and greet dismissal date */
  meetAndGreetDismissedAt?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of Dismiss */
export type DismissPayload = {
  __typename?: 'DismissPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the response of the update (JSON containing status and body) */
  response: Scalars['JSON']['output'];
};

/** The response returned after a client downloads the mobile-app offer */
export type DownloadAppOffer = {
  __typename?: 'DownloadAppOffer';
  /** Was the offer accepted */
  accepted?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when this response was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the response */
  id: Scalars['ID']['output'];
};

/** Attributes needed when downloading the mobile-app offer */
export type DownloadAppOfferAttributes = {
  /** Was the offer accepted */
  accepted: Scalars['Boolean']['input'];
};

/** Type of edit */
export enum EditOptions {
  /** Edition for multiple_occurrence */
  MultipleOccurrence = 'multiple_occurrence',
  /** Edition for single_occurrence */
  SingleOccurrence = 'single_occurrence'
}

/** Kinds of training that we might hold a record of training-completion for */
export enum EducateTrainingTask {
  Sirs = 'sirs',
  Wcc = 'wcc'
}

/** Information about this item of the worker's education/training */
export type EducationAndTraining = {
  __typename?: 'EducationAndTraining';
  /** Degree/Course name */
  degree: Scalars['String']['output'];
  /** End date/current */
  endAt: Scalars['String']['output'];
  /** Where did the training take place */
  institution: Scalars['String']['output'];
  /** Start date */
  startAt: Scalars['String']['output'];
};

/** Holds details of worker education/courses completed */
export type EducationAndTrainingAttributes = {
  /** Degree/Course */
  degree: Scalars['String']['input'];
  /** Current OR end date in dd/mm/yyyy format */
  endAt: Scalars['String']['input'];
  /** Name of Institution */
  institution: Scalars['String']['input'];
  /** Start date in dd/mm/yyyy format */
  startAt: Scalars['String']['input'];
};

/** Details of whether the user is eligible for a group chat */
export type EligibleForGroupChat = {
  __typename?: 'EligibleForGroupChat';
  /** Is the user eligible for group chat */
  eligible: Scalars['Boolean']['output'];
};

/** List of services */
export type EligibleService = {
  __typename?: 'EligibleService';
  /** Is the service a default one */
  defaultService: Scalars['Boolean']['output'];
  /** Code of the service */
  displayCode?: Maybe<Scalars['String']['output']>;
  /** Name of the service */
  displayName: Scalars['String']['output'];
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Is this BST only available for admins to select */
  isAdminOnlyType: Scalars['Boolean']['output'];
  /** Whether this service is included in the job */
  serviceInJob: Scalars['Boolean']['output'];
  /** Type of NDIS Service Category/Mable Service this relates to */
  serviceType: ServiceCategoryableType;
};

/** List of services */
export type EligibleServicesForAgreement = {
  __typename?: 'EligibleServicesForAgreement';
  /** List of services for flat rates */
  flatRateServices: Array<EligibleService>;
  /** List of services for hourly rates */
  hourlyRateServices: Array<EligibleService>;
};

/** Details of whether the email is valid */
export type EmailValid = {
  __typename?: 'EmailValid';
  /** Is the email valid */
  emailValid: Scalars['Boolean']['output'];
};

/** Expression of Interest Request (Application/Share) */
export type EoiRequest = {
  __typename?: 'EoiRequest';
  /** Timestamp when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Unique identifier for the object */
  id: Scalars['ID']['output'];
  /** Indicative rates for expression of interest */
  indicativeRates?: Maybe<Array<IndicativeRate>>;
  /** Created by invitation */
  invitation: Scalars['Boolean']['output'];
  /** Normalized job information */
  job?: Maybe<ConnectionJob>;
  /** Job detail for job related to expression of interest */
  jobDetail?: Maybe<JobDetail>;
  /** Matching detail for expression of interest */
  matchingDetail?: Maybe<MatchingDetail>;
  /** Message content, if available */
  message?: Maybe<Scalars['String']['output']>;
  /** Message metadata, if available */
  messageMeta?: Maybe<MessageMeta>;
  /** User who initiated the request */
  requester: Requester;
  /** Flag indicating whether the requester has dismissed the object */
  requesterDismissed: Scalars['Boolean']['output'];
  /** Current state of the requester in the workflow */
  requesterState: Scalars['String']['output'];
  /** User designated as the responder */
  responder: Responder;
  /** Flag indicating whether the responder has dismissed the object */
  responderDismissed: Scalars['Boolean']['output'];
  /** Current state of the responder in the workflow */
  responderState: Scalars['String']['output'];
  /** Overall state of the object */
  state: Scalars['String']['output'];
  /** Timeslots for expression of Interest */
  timeslots?: Maybe<Array<Timeslot>>;
  /** Timestamp when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Universally Unique Identifier for the object */
  uuid: Scalars['ID']['output'];
  /** Timestamp when the object will expire */
  willExpireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for EoiRequest. */
export type EoiRequestConnection = {
  __typename?: 'EoiRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EoiRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EoiRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EoiRequestEdge = {
  __typename?: 'EoiRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EoiRequest>;
};

/** An EventDelivery is what we call a Timesheet, and these are all the fields for one */
export type EventDelivery = {
  __typename?: 'EventDelivery';
  /** State of the timesheet (as opposed to the combined state that includes invoicing state) */
  actualState?: Maybe<Scalars['String']['output']>;
  /** ID of the agreed_rate */
  agreedRateId?: Maybe<Scalars['ID']['output']>;
  /** Agreement against which the service has been delivered */
  agreement: Agreement;
  /** ID of the related agreement */
  agreementRateId?: Maybe<Scalars['ID']['output']>;
  /** When was this timesheet approved */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Can the current-target delete this asset */
  canDeleteAssets?: Maybe<Scalars['Boolean']['output']>;
  /** Can the current target edit an approved timesheet */
  canEditApproved?: Maybe<Scalars['Boolean']['output']>;
  /** Can the curent target query the payment status */
  canQuery?: Maybe<Scalars['Boolean']['output']>;
  /** Phone number of the carer */
  carerContactPhone?: Maybe<Scalars['String']['output']>;
  /** Full name of the carer */
  carerFullName?: Maybe<Scalars['String']['output']>;
  /** ID of the invoice-statement for this carer */
  carerInvoiceStatementId?: Maybe<Scalars['ID']['output']>;
  /** When was the carer paid for this timesheet */
  carerPaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Was the carer paid by paynow */
  carerPaidByPaynow?: Maybe<Scalars['Boolean']['output']>;
  /** What is the status of the carer payment */
  carerPaidStatus?: Maybe<Scalars['String']['output']>;
  /** Details of the client receiving the services */
  client?: Maybe<User>;
  /** Returns true if the client has approved the first event delivery */
  clientFirstApproved?: Maybe<Scalars['Boolean']['output']>;
  /** When was payment for this timesheet collected */
  collectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is payment overdue */
  collectionOverdue?: Maybe<Scalars['Boolean']['output']>;
  /** Legacy - alias for client */
  consumer?: Maybe<User>;
  /** When did the consumer pay */
  consumerPaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Code for the payment method used for the payment */
  consumerPaymentMethodCode?: Maybe<Scalars['String']['output']>;
  /** UUID of the coordinator managing timesheet */
  coordinatorUuid?: Maybe<Scalars['String']['output']>;
  /** When the tinesheet was first created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is this timesheet deletable */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** When was the service delivered to the client */
  deliveredAt: Scalars['String']['output'];
  /** Cost of the delivered care covered by this timesheet */
  deliveredCost?: Maybe<Scalars['String']['output']>;
  /** When the delivered care ended */
  deliveredEndTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How many hours of care were delivered */
  deliveredHours?: Maybe<Scalars['Float']['output']>;
  /** Displayable string of how many hours and minutes were delivered */
  deliveredHoursAndMinutes?: Maybe<Scalars['String']['output']>;
  /** ID of the delivered session linked to the event-delivery */
  deliveredSessionId?: Maybe<Scalars['ID']['output']>;
  /** When did the delivered care begin */
  deliveredStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** On what date was the care delivered (start date) */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** How many hours (truncated) was the delivered care */
  deliveryHours?: Maybe<Scalars['Int']['output']>;
  /** After removing the hours, how many minutes of care were left over */
  deliveryMinutes?: Maybe<Scalars['Int']['output']>;
  /** Displayable delivery time */
  deliveryTime?: Maybe<Scalars['String']['output']>;
  /** At what time of day did the care end */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is this eligible for expresspay */
  expresspayEligible?: Maybe<Scalars['Boolean']['output']>;
  /** What percentage of fees will be applied to the carer rate */
  feePercentage?: Maybe<Scalars['String']['output']>;
  /** First name of the carer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Formatted string to show GST */
  formattedGstClient?: Maybe<Scalars['String']['output']>;
  /** Was an incident reported for this timesheet */
  hasIncident?: Maybe<Scalars['Boolean']['output']>;
  /** Health answers */
  healthAnswers?: Maybe<Array<Scalars['String']['output']>>;
  /** Details of any change in health observed during care */
  healthChangeDetail?: Maybe<SupportHealthChangeForEventDelivery>;
  /** The reason why HorizonOne offer was declined */
  horizonOfferDeclinedReason?: Maybe<Scalars['String']['output']>;
  /** Status of the HorizonOne offer */
  horizonOfferStatus?: Maybe<Scalars['String']['output']>;
  /** ??? The reason why HorizonOne offer showed a warning */
  horizonOfferWarningReason?: Maybe<Scalars['String']['output']>;
  /** The date at which the HorizonOne offer was approved */
  horizonOneOfferApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date at which the HorizonOne offer was declined */
  horizonOneOfferDeclinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** What hourly fee is the carer charging */
  hourlyFee?: Maybe<Scalars['String']['output']>;
  /** What hourly fee is the carer charging if paid with paynow */
  hourlyPaynowFee?: Maybe<Scalars['String']['output']>;
  /** ID of this event-delivery (timesheet) */
  id: Scalars['ID']['output'];
  /** Incident report information */
  incidentReport?: Maybe<IncidentReport>;
  /** Has payment for this session been advanced */
  invoiceCarerAdvanced?: Maybe<Scalars['Boolean']['output']>;
  /** Link to an invoice-related asset */
  invoiceLink?: Maybe<Scalars['String']['output']>;
  /** Time at which this timesheet was invoiced */
  invoicedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is this tinmsheet pending */
  isPending?: Maybe<Scalars['Boolean']['output']>;
  /** How many km were travelled during care */
  kmTravelled?: Maybe<Scalars['Float']['output']>;
  /** What time was the invoice manually advanced */
  manuallyAdvancedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Hourly rate charged (net of fees) */
  netHourlyRate?: Maybe<Scalars['String']['output']>;
  /** Net pay (including paynow fee) */
  netPayIncludingPaynowFee: Scalars['Float']['output'];
  /** ID of the carer */
  otherUserId?: Maybe<Scalars['ID']['output']>;
  /** When was the invoice paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date by which payment is due */
  paymentDueByDate?: Maybe<Scalars['String']['output']>;
  /** Tooltip to display next to payment info */
  paymentTooltip?: Maybe<Scalars['String']['output']>;
  /** When was paynow approved */
  paynowApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is paynow available for this invoice */
  paynowAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** When was paynow declined */
  paynowDeclinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is paynow displayable */
  paynowDisplayable?: Maybe<Scalars['Boolean']['output']>;
  /** Fee percentage for paynow */
  paynowFeePercentage?: Maybe<Scalars['String']['output']>;
  /** Has paynow been requested */
  paynowRequested?: Maybe<Scalars['Boolean']['output']>;
  /** At what time was paynow requested */
  paynowRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status of the paynow request */
  paynowRequestedStatus?: Maybe<Scalars['String']['output']>;
  /** Rate charged for travel per km */
  perKmRate?: Maybe<Scalars['Float']['output']>;
  /** State of per km rate on agreement at time of creation */
  perKmRateAvailable: Scalars['Boolean']['output'];
  /** Displayable string for paynow rate in dollars */
  perKmRateInDollars?: Maybe<Scalars['String']['output']>;
  /** Returns true if SP is eligible for QuickPay */
  quickpayEligible?: Maybe<Scalars['Boolean']['output']>;
  /** When SP will be paid if QuickPay eligible */
  quickpayScheduledDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Rate carer is charging for care */
  rate?: Maybe<Scalars['String']['output']>;
  /** What kind of rate is this (flat-rate or hourly) */
  rateKindLabel?: Maybe<Scalars['String']['output']>;
  /** ID of the occurrence that is linked to this timesheet's delivered session */
  scheduledEventOccurrenceId?: Maybe<Scalars['ID']['output']>;
  /** ID for the Service category */
  serviceCategoryableId?: Maybe<Scalars['ID']['output']>;
  /** Shift-note associated with this timesheet */
  shiftNote?: Maybe<ShiftNote>;
  /** Should a related incident be shown to the client */
  showIncidentToClient?: Maybe<Scalars['Boolean']['output']>;
  /** Should we display the NDIS items for this timesheet */
  showNdisItems?: Maybe<Scalars['Boolean']['output']>;
  /** At what time of day did the care start */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Combined state that includes the timesheet and details about invoicing */
  state?: Maybe<Scalars['String']['output']>;
  /** What durations were covered by this timesheet */
  supportDurations?: Maybe<Array<SupportDuration>>;
  /** Details of a health-change noted by carer */
  supportHealthChange?: Maybe<SupportHealthChangeForEventDelivery>;
  /** Answers to health-change questions */
  supportHealthChangeAnswers?: Maybe<Array<SupportHealthChangeAnswerForEventDelivery>>;
  /** Questions about a health-change that have been checked */
  supportHealthChangeCheckedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  /** Total amount paid for support given */
  supportTotal: Scalars['String']['output'];
  /** Invoice is due to be paid at this time */
  toBePaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The formatted user cost */
  total: Scalars['String']['output'];
  /** The total of the calculated fees */
  totalFee?: Maybe<Scalars['String']['output']>;
  /** The total calculated paynow fees */
  totalPaynowFee: Scalars['Float']['output'];
  /** The total travel expense */
  totalTravelExpense?: Maybe<Scalars['String']['output']>;
  /** The total of the travel fees */
  totalTravelFee?: Maybe<Scalars['String']['output']>;
  /** The kms multipled by the fee per km */
  totalTravelledInDollars?: Maybe<Scalars['String']['output']>;
  /** Total on timesheet with total travel cost. */
  totalWithTravelCost?: Maybe<Scalars['String']['output']>;
  /** The travel rate */
  travelRate?: Maybe<Scalars['String']['output']>;
  /** Warn the carer that the timesheet has been edited */
  warnEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Any warnings */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
  /** Does this timesheet have an incident */
  withIncidentCase?: Maybe<Scalars['Boolean']['output']>;
  /** Is there a banner associated with this timesheet */
  withInfoBanner?: Maybe<Scalars['Boolean']['output']>;
  /** Is there a health-change support-note */
  withSupportHealthChange?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the first event delivery that the worker has submitted */
  workerFirstDelivered?: Maybe<Scalars['Boolean']['output']>;
  /** When was the worker payment queried */
  workerPaymentQueriedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for EventDelivery. */
export type EventDeliveryConnection = {
  __typename?: 'EventDeliveryConnection';
  csvDownloadParam?: Maybe<Scalars['String']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventDeliveryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventDelivery>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventDeliveryEdge = {
  __typename?: 'EventDeliveryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventDelivery>;
};

/** reason why user is proceeding with exceeded rate */
export enum ExceededRateReason {
  Other = 'other',
  RemoteVeryRemoteWork = 'remote_very_remote_work',
  SpecialisedServiceRequest = 'specialised_service_request'
}

/** Data related to why someone exceeds their agreement rate limits. */
export type ExceededRateReasonAttributes = {
  /** carers id */
  carerId: Scalars['ID']['input'];
  /** consumers id */
  consumerId: Scalars['ID']['input'];
  /** reason as to why user is proceeding with exceeded rate */
  reason: ExceededRateReason;
  /** details as to why user is proceeding with exceeded rate */
  reasonOtherText?: InputMaybe<Scalars['String']['input']>;
};

/** Details for a session expected for this agreement */
export type ExpectedSessions = {
  /** Session ends at this time */
  endAt: Scalars['String']['input'];
  /** Session starts at this time */
  startAt: Scalars['String']['input'];
};

/** Information about worker experience in various aspects of care */
export type Experience = {
  __typename?: 'Experience';
  /** Experience in aged care */
  agedCare: Array<ExperienceItem>;
  /** Experience in chronic medical condition */
  chronicMedicalCondition: Array<ExperienceItem>;
  /** Experience in disability */
  disability: Array<ExperienceItem>;
  /** General experiences */
  general: Array<ExperienceItem>;
  /** Experience in mental health */
  mentalHealth: Array<ExperienceItem>;
};

/** Type for worker CareExperienceAndKnowledge */
export type ExperienceAndKnowledge = {
  __typename?: 'ExperienceAndKnowledge';
  /** Experiences and knowledge in aged care */
  agedCare: ExperienceAndKnowledgeItem;
  /** Experiences and knowledge in chronic medical condition */
  chronicMedicalCondition: ExperienceAndKnowledgeItem;
  /** Experiences and knowledge in disability */
  disability: ExperienceAndKnowledgeItem;
  /** Experiences and knowledge in mental health */
  mentalHealth: ExperienceAndKnowledgeItem;
  /** Summary of experiences and knowledge */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Information about each kind of worker CareExperienceAndKnowledge item (eg aged_care) */
export type ExperienceAndKnowledgeItem = {
  __typename?: 'ExperienceAndKnowledgeItem';
  /** All items in the category */
  all?: Maybe<Array<ExperienceItem>>;
  /** Description of the experience in this area of care */
  description?: Maybe<Scalars['String']['output']>;
  /** Details of the experience in this area of care */
  experience?: Maybe<Array<ExperienceItem>>;
  /** What kind of experience does the worker have in this aspect of care */
  kind?: Maybe<CareExperienceOptions>;
  /** What knowledge does this worker have in this aspect of care */
  knowledge?: Maybe<Array<ExperienceItem>>;
  /** Has this aspect of care been selected at all */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Item type for experience and knowledge */
export type ExperienceItem = {
  __typename?: 'ExperienceItem';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Knowledge or experience */
  selectionCategory?: Maybe<CareExperienceSelectionCategoryOptions>;
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** Sub category values under services category */
export enum Experiences {
  ExperienceAged = 'experience_aged',
  ExperienceChronic = 'experience_chronic',
  ExperienceDisability = 'experience_disability',
  ExperienceGeneral = 'experience_general',
  ExperienceMental = 'experience_mental'
}

/** Details of an optimizely experiment */
export type Experiment = {
  __typename?: 'Experiment';
  /** Is this experiment enabled */
  enabled: Scalars['Boolean']['output'];
  /** Optimizely variables, if available in the experiment or feature */
  variables?: Maybe<Scalars['JSON']['output']>;
  /** Variation name (experiments are run with different, named, variants run in parallel) */
  variation?: Maybe<Scalars['String']['output']>;
};

/** Details to be exported */
export type Export = {
  __typename?: 'Export';
  /** Timesheets to export */
  timesheets?: Maybe<Scalars['String']['output']>;
  /** Transactions to export */
  transactions?: Maybe<Scalars['String']['output']>;
};

/** Express job recommendation option fields */
export type ExpressJobRecommendationOptions = {
  __typename?: 'ExpressJobRecommendationOptions';
  /** Description for each job recommendation option */
  details: Scalars['String']['output'];
  /** Title for job recommendation option */
  displayName: Scalars['String']['output'];
  /** Indicator if the option is recommended */
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  /** Indicator if the option is suggested */
  isSuggested?: Maybe<Scalars['Boolean']['output']>;
  /** Full description of services */
  serviceCategoryNames?: Maybe<Array<Scalars['String']['output']>>;
  /** Posted job services related to option */
  services?: Maybe<Array<Scalars['String']['output']>>;
  /** Identifier for recommendation options */
  value: Scalars['String']['output'];
};

/** Express job selection fields */
export type ExpressJobSelection = {
  __typename?: 'ExpressJobSelection';
  /** ID of selected service recommendation */
  id: Scalars['ID']['output'];
  /** Selected service recommendation. */
  selected: Scalars['String']['output'];
};

/** Express job session fields */
export type ExpressJobSession = {
  __typename?: 'ExpressJobSession';
  /** Selected expressJobSelection's */
  expressJobSelections?: Maybe<Array<ExpressJobSelection>>;
  /** ID of selected express job session */
  id: Scalars['ID']['output'];
};

/** Express pay details for delivered session */
export type ExpressPay = {
  __typename?: 'ExpressPay';
  /** Express pay fee percentage */
  feePercentage?: Maybe<Scalars['Float']['output']>;
  /** Hourly fees for express pay */
  fees: Scalars['Float']['output'];
};

/** Filter for ConnectionRequests queries */
export type ExpressionOfInterestFilter = {
  /** Filter availability overlap */
  availability?: InputMaybe<Overlap>;
  /** Filter gender */
  gender?: InputMaybe<Gender>;
  /** Filter services overlap */
  serviceOverlap?: InputMaybe<Overlap>;
  /** filter for states accepted, declined, expired, etc. */
  states?: InputMaybe<Array<State>>;
};

/** Details of a user flag */
export type Flag = {
  __typename?: 'Flag';
  /** Timestamp of when the flag was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Date when the flag was created */
  date?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the entity that owns the flag */
  flaggedId?: Maybe<Scalars['Int']['output']>;
  /** Type/class of the entity that owns the flag */
  flaggedType?: Maybe<Scalars['String']['output']>;
  /** ID of the flag */
  id: Scalars['ID']['output'];
  /** Name of the flag */
  name?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the flag was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Is the flag enabled */
  value: Scalars['Boolean']['output'];
};

/** Attributes for creating a flag */
export type FlagAttributes = {
  /** Timestamp when the flag was created */
  date?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** ID of the entity being flagged */
  flaggedId?: InputMaybe<Scalars['Int']['input']>;
  /** Type of the entity being flagged (eg User) */
  flaggedType: Scalars['String']['input'];
  /** Name of the flag */
  name: Scalars['String']['input'];
  /** Is the flag enabled */
  value: Scalars['Boolean']['input'];
};

/** Autogenerated input type of FlagReadGroupChatInfo */
export type FlagReadGroupChatInfoInput = {
  /** Attributes for creating a flag */
  attributes: FlagAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FlagReadGroupChatInfo */
export type FlagReadGroupChatInfoPayload = {
  __typename?: 'FlagReadGroupChatInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created flag */
  flag: Flag;
};

/** Details of an hourly rate that could be applied to an agreement through agreed rate */
export type FlatRateAttributes = {
  /** Rate charged in cents */
  rateCents: Scalars['Int']['input'];
  /** ID of NDIS Service Category/Mable Service this relates to */
  serviceCategoryableId: Scalars['ID']['input'];
  /** Type of NDIS Service Category/Mable Service this relates to */
  serviceCategoryableType: Scalars['String']['input'];
};

/** Autogenerated input type of FlexJobCreateUpdate */
export type FlexJobCreateUpdateInput = {
  /** which action are we performing on this flex job */
  action: PostedJobCreateUpdateActionOptions;
  /** what attributes are we using to create or update this flex job */
  attributes?: InputMaybe<PostedJobFlexAttributes>;
  /** ID of the coordinator managed client */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the flex-job we are updating */
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of FlexJobCreateUpdate */
export type FlexJobCreateUpdatePayload = {
  __typename?: 'FlexJobCreateUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** the flex job that we are updating */
  postedJob?: Maybe<PostedJob>;
};

/** Attributes for adding/updating the flex-match which is an offer on a flex/last-minute job */
export type FlexMatchAttributes = {
  /** Comment for the flex-match/offer */
  comment: Scalars['String']['input'];
  /** Per-hour pay-rate offered for this flex-job */
  rateOffer: Scalars['Int']['input'];
};

/** Possible values for gender */
export enum Gender {
  Female = 'female',
  Male = 'male'
}

/** List of available gender options */
export type GenderIdentity = {
  __typename?: 'GenderIdentity';
  /** The key used to identify the gender option */
  key: Scalars['String']['output'];
  /** The display value for the gender option */
  label: Scalars['String']['output'];
};

/** Sub category values under general category */
export enum General {
  AvailableDays = 'available_days',
  Gender = 'gender',
  ReviewChildrenCheckVerified = 'review_children_check_verified'
}

/** Autogenerated input type of GenerateSendbirdSessionToken */
export type GenerateSendbirdSessionTokenInput = {
  /** A coordinator's client's user_id */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A coordinator's client's user_uid */
  clientUid?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateSendbirdSessionToken */
export type GenerateSendbirdSessionTokenPayload = {
  __typename?: 'GenerateSendbirdSessionTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns session token */
  userSessionToken?: Maybe<UserSendbirdSessionToken>;
};

/** Checks whether the client has read the information about group chat */
export type GroupChatInfoReadState = {
  __typename?: 'GroupChatInfoReadState';
  /** Has the user read the information about group chat */
  readGroupChatInfo: Scalars['Boolean']['output'];
};

/** Fields that indicate if specific assets exist for user */
export type HasAsset = {
  __typename?: 'HasAsset';
  /** Returns true if user has uploaded direct debit asset (asset exists with asset_id: asset_direct_debit_form) */
  directDebit: Scalars['Boolean']['output'];
  /** Returns true if user has uploaded ndis letter asset (any asset exists with asset_id: [asset_payment_method_document_1, asset_payment_method_document_2, asset_payment_method_document_3] */
  ndisLetter: Scalars['Boolean']['output'];
  /** Returns true if user has uploaded power of attorney asset (asset exists with asset_id: power_of_attorney) */
  powerOfAttorney: Scalars['Boolean']['output'];
  /** Returns true if user has uploaded any support need documents */
  supportNeedDocuments: Scalars['Boolean']['output'];
};

/** Attributes of a health-change note - written into a timesheet when a support-worker notices a change in health of the participant */
export type HealthChangeAttributes = {
  /** ID of the timesheet/event_delivery the change was noted */
  eventDeliveryId: Scalars['ID']['input'];
  /** Details of the health changes noticed */
  healthChangeAdditionalDetails?: InputMaybe<Scalars['String']['input']>;
  /** ID of the health-change kind */
  healthChangeId?: InputMaybe<Scalars['ID']['input']>;
  /** Is it ok to share this health change note with the client */
  shareHealthChangeInformation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Details of a Horizon-one offer */
export type HorizonOneOffer = {
  __typename?: 'HorizonOneOffer';
  /** Is the support worker eligible for the offer */
  eligibility: Scalars['Boolean']['output'];
  /** ID of the offer */
  id?: Maybe<Scalars['ID']['output']>;
  /** Reasons why the support-worker opted out */
  optedOutReasons?: Maybe<Scalars['JSON']['output']>;
  /** Should we show the offer modal */
  showModal?: Maybe<Scalars['Boolean']['output']>;
  /** Status of the offer */
  status?: Maybe<Scalars['String']['output']>;
  /** Clients for which the offer is suspended */
  suspendedClients?: Maybe<Array<User>>;
  /** Reason why the offer is suspended */
  suspensionReason?: Maybe<Scalars['String']['output']>;
  /** Status of the suspension */
  suspensionStatus?: Maybe<Scalars['String']['output']>;
  /** ??? Unsure what this is seems not to be used */
  testGroup?: Maybe<Scalars['String']['output']>;
};

/** Details of a Horizon-one offer for a support-worker */
export type HorizonOneOfferAttributes = {
  /** Reason given as to why the worker opted out of the offer */
  optedOutReasons?: InputMaybe<Scalars['JSON']['input']>;
  /** Status of the offer */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Status as to why the offer was suspended */
  suspensionStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Details of an hourly rate that could be applied to an agreement through agreed rate */
export type HourlyRateAttributes = {
  /** Rate charged in cents */
  rateCents: Scalars['Int']['input'];
  /** ID of NDIS Service Category/Mable Service this relates to */
  serviceCategoryableId: Scalars['ID']['input'];
  /** Type of NDIS Service Category/Mable Service this relates to */
  serviceCategoryableType: Scalars['String']['input'];
  /** Day of Week / Time of Day for this rate */
  timeBlock: TimeBlock;
};

/** Type for identity verification eligibility status */
export type IdentityVerificationEligibility = {
  __typename?: 'IdentityVerificationEligibility';
  /** Whether the user is eligible for identity verification */
  eligible: Scalars['Boolean']['output'];
  /** Whether identity verification is mandatory for the user */
  mandatory: Scalars['Boolean']['output'];
};

/** Information about worker immunisations */
export type Immunisation = {
  __typename?: 'Immunisation';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
  /** Name of this immunisation */
  title?: Maybe<Scalars['String']['output']>;
  /** Immunisation last updated at */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Has this been verified */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** Attributes of an incident */
export type Incident = {
  __typename?: 'Incident';
  /** What kind of incident is this? */
  category?: Maybe<Scalars['String']['output']>;
  /** Comment explaining what happened during the incident */
  comment?: Maybe<Scalars['String']['output']>;
  /** ID of the incident */
  id?: Maybe<Scalars['ID']['output']>;
  /** ID of the object to which this incident is attached */
  incidentableId?: Maybe<Scalars['ID']['output']>;
  /** Class of the object to which the incident is attached */
  incidentableType?: Maybe<Incidentable>;
  /** Reason for the incident */
  reason?: Maybe<Scalars['String']['output']>;
  /** Person receiving the message about the incident */
  receiverId?: Maybe<Scalars['ID']['output']>;
  /** Person sending the message about the incident */
  senderId?: Maybe<Scalars['ID']['output']>;
};

/** Set of valid actions that can be performed to create an incident */
export enum IncidentActions {
  Block = 'block',
  ReportConversation = 'report_conversation',
  ReportPostedJob = 'report_posted_job',
  Unblock = 'unblock'
}

/** Details of a reported incident */
export type IncidentCase = {
  __typename?: 'IncidentCase';
  /** Carer involved in the case */
  carer?: Maybe<User>;
  /** What type of incident was this */
  caseType?: Maybe<Scalars['String']['output']>;
  /** Legacy - Name of the client */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Name of the consumer involved in the case */
  consumer?: Maybe<User>;
  /** Relevant timesheet/shift to the incident */
  eventDelivery?: Maybe<EventDelivery>;
  /** ID of the incident */
  id?: Maybe<Scalars['ID']['output']>;
  /** Actions taken as a result of this incident */
  incidentActionsTake?: Maybe<Scalars['String']['output']>;
  /** Incident also notified to */
  incidentAlreadyNotified?: Maybe<Scalars['String']['output']>;
  /** Incident date */
  incidentDate?: Maybe<Scalars['String']['output']>;
  /** Incident reported/created time */
  incidentDatetime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Incident description */
  incidentDetail?: Maybe<Scalars['String']['output']>;
  /** Injuries or damages reported */
  incidentInjuriesDamage?: Maybe<Scalars['String']['output']>;
  /** Location at which this incident occurred */
  incidentLocation?: Maybe<Scalars['String']['output']>;
  /** Reported to organisation by worker */
  incidentReportToOrg?: Maybe<Scalars['String']['output']>;
  /** Mitigation steps taken */
  incidentStepsPrevent?: Maybe<Scalars['String']['output']>;
  /** Incident time */
  incidentTime?: Maybe<Scalars['String']['output']>;
  /** Before the incident */
  incidentWhat?: Maybe<Scalars['String']['output']>;
  /** Person involved in the incident */
  incidentWho?: Maybe<Scalars['String']['output']>;
  /** Witnesses to the incident */
  incidentWitness?: Maybe<Scalars['String']['output']>;
  /** The incident's occurred_at time */
  occurredAt?: Maybe<Scalars['String']['output']>;
  /** Where did the incident come from? */
  origin?: Maybe<Scalars['String']['output']>;
  /** Participant involved in the incident */
  participant?: Maybe<Participant>;
  /** When was the incident read_at */
  readAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When was the incident reported_at */
  reportedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Has the incident been shared with the client */
  sharedWithClient?: Maybe<Scalars['Boolean']['output']>;
  /** Legacy - support worker name */
  supportWorkerName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for IncidentCase. */
export type IncidentCaseConnection = {
  __typename?: 'IncidentCaseConnection';
  csvDownloadParam?: Maybe<Scalars['String']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IncidentCaseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IncidentCase>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalUnread?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type IncidentCaseEdge = {
  __typename?: 'IncidentCaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IncidentCase>;
};

/** Filters for a list of incidents */
export type IncidentCaseFilterData = {
  /** Beginning of a range */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Direction in which to order the results */
  orderDirection?: InputMaybe<IncidentOrderDirection>;
  /** Search field */
  searchByField?: InputMaybe<ComplianceSearchField>;
  /** Searchable text */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** End of a range */
  to?: InputMaybe<Scalars['String']['input']>;
  /** Only unread incidents */
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Incident-ordering directions (asc/desc) */
export enum IncidentOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

/** Details of an incident report */
export type IncidentReport = {
  __typename?: 'IncidentReport';
  /** Actions taken as a result of this incident */
  incidentActionsTake?: Maybe<Scalars['String']['output']>;
  /** Incident also notified to */
  incidentAlreadyNotified?: Maybe<Scalars['String']['output']>;
  /** Incident date */
  incidentDate?: Maybe<Scalars['String']['output']>;
  /** Incident description */
  incidentDetail?: Maybe<Scalars['String']['output']>;
  /** Injuries or damages reported */
  incidentInjuriesDamage?: Maybe<Scalars['String']['output']>;
  /** Location at which this incident occurred */
  incidentLocation?: Maybe<Scalars['String']['output']>;
  /** Reported to organisation by worker */
  incidentReportToOrg?: Maybe<IncidentReportToOrgOptions>;
  /** Questionnaire for the incident */
  incidentShortQuestionnaire?: Maybe<Scalars['String']['output']>;
  /** Mitigation steps taken */
  incidentStepsPrevent?: Maybe<Scalars['String']['output']>;
  /** Incident time */
  incidentTime?: Maybe<Scalars['String']['output']>;
  /** Before the incident */
  incidentWhat?: Maybe<Scalars['String']['output']>;
  /** Person involved in the incident */
  incidentWho?: Maybe<Scalars['String']['output']>;
  /** Witnesses to the incident */
  incidentWitness?: Maybe<Scalars['String']['output']>;
  /** Whether or not incident can be shown to client */
  showIncidentToClient?: Maybe<Scalars['Boolean']['output']>;
};

/** Options to explain whether incident is reported to an organisation */
export enum IncidentReportToOrgOptions {
  No = 'No',
  /** Don't know provider organisation */
  Non = 'Non',
  Yes = 'Yes'
}

/** Set of objects to which an incident can be attached */
export enum Incidentable {
  Conversation = 'Conversation',
  PostedJob = 'PostedJob',
  User = 'User'
}

/** Indicative Rate for a Carer related to a Expression of Interest */
export type IndicativeRate = {
  __typename?: 'IndicativeRate';
  /** Amount in cents of rate */
  cents: Scalars['Int']['output'];
  /** Name of rate */
  name: IndicativeRateName;
};

/** Possible values for indicative rate name */
export enum IndicativeRateName {
  FlatRate = 'flat_rate',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Weekday = 'weekday'
}

/** Information about a worker's interest or hobby */
export type Interest = {
  __typename?: 'Interest';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** A client's interests. We can use this to filter workers to fit their interests */
export enum InterestOptions {
  Cooking = 'Cooking',
  CulturalFestivities = 'CulturalFestivities',
  Gardening = 'Gardening',
  IndoorGames = 'IndoorGames',
  Movies = 'Movies',
  Music = 'Music',
  Other = 'Other',
  Pets = 'Pets',
  PhotographyArt = 'PhotographyArt',
  Reading = 'Reading',
  Sports = 'Sports',
  Travel = 'Travel'
}

/** Details of an invoice */
export type Invoice = {
  __typename?: 'Invoice';
  /** Link to an invoice-related asset */
  link?: Maybe<Scalars['String']['output']>;
  /** Reference for the invoice */
  reference?: Maybe<Scalars['String']['output']>;
};

/** Details of an invoice statement */
export type InvoiceStatement = {
  __typename?: 'InvoiceStatement';
  /** Any adjustment notes for this invoice */
  adjustmentNotes?: Maybe<Array<AdjustmentNote>>;
  /** Have all the timesheets been voided */
  allVoidedTimesheet?: Maybe<Scalars['Boolean']['output']>;
  /** Are there any voided timesheets */
  anyVoidedTimesheet?: Maybe<Scalars['Boolean']['output']>;
  /** Related carer invoice statment */
  carerInvoiceStatement?: Maybe<CarerInvoiceStatement>;
  /** Client that is being invoiced */
  client?: Maybe<User>;
  /** Status of the payment to be collected */
  collectionStatus?: Maybe<Scalars['String']['output']>;
  /** Credit notes relating to this invoice */
  creditNotes?: Maybe<Array<CreditNote>>;
  /** Any credit used to pay this invoice */
  creditUsed?: Maybe<Scalars['Float']['output']>;
  /** Invoice date */
  date?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the invoice statement */
  id?: Maybe<Scalars['ID']['output']>;
  /** Invoice that is relating to this statement */
  invoice?: Maybe<Invoice>;
  /** Invoice number for the related invoice */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** Participants in this invoie */
  invoiceStatementParticipants?: Maybe<Array<Participant>>;
  /** Link to NDIS bulk claim */
  ndisBulkClaimLink?: Maybe<Scalars['String']['output']>;
  /** Status of the payment */
  paymentStatus?: Maybe<Scalars['String']['output']>;
  /** Link to the receipt */
  receipt?: Maybe<Scalars['String']['output']>;
  /** Total payment due */
  total?: Maybe<Scalars['Float']['output']>;
};

/** The connection type for InvoiceStatement. */
export type InvoiceStatementConnection = {
  __typename?: 'InvoiceStatementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvoiceStatementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InvoiceStatement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InvoiceStatementEdge = {
  __typename?: 'InvoiceStatementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InvoiceStatement>;
};

/** Fields that a client wants to see that relate this job to workers and communication */
export type JobClientFields = {
  __typename?: 'JobClientFields';
  /** Accepted flex match */
  acceptedMatch?: Maybe<JobMatch>;
  /** Is this the first job that the client has posted? */
  firstPostedJob?: Maybe<Scalars['Boolean']['output']>;
  /** The carers that the job has been shared with by the client */
  jobShares?: Maybe<Array<User>>;
  /** Matched workers. FlexMatches for Last minute job otherwise JobMatches */
  matches?: Maybe<Array<JobMatch>>;
  /** Is the job posted within 14 days of the client signing up? */
  postedWithin14DaysOfUserSignUp?: Maybe<Scalars['Boolean']['output']>;
  /** The number of job replies to this job */
  repliedCount?: Maybe<Scalars['Int']['output']>;
  /** The job replies from workers interested to this job */
  replies: Array<Message>;
};

/** Job Detail For Expression of Interest */
export type JobDetail = {
  __typename?: 'JobDetail';
  /** Estimated hours per period of the job */
  estimatedHoursPerPeriod?: Maybe<Scalars['Float']['output']>;
  /** Estimated hours per week of the job */
  estimatedHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  /** Frequency of the job */
  frequency?: Maybe<Scalars['String']['output']>;
  /** External reference of the job */
  id: Scalars['String']['output'];
  /** Location of the job */
  location?: Maybe<Scalars['String']['output']>;
  /** Scheduling of the job */
  scheduling?: Maybe<Scalars['String']['output']>;
  /** Session frequency of the job */
  sessionFrequency?: Maybe<Scalars['String']['output']>;
  /** Support sessions per period of the job */
  supportSessionsPerPeriod?: Maybe<Scalars['Float']['output']>;
  /** Support sessions per week of the job */
  supportSessionsPerWeek?: Maybe<Scalars['Int']['output']>;
  /** Title of the job */
  title: Scalars['String']['output'];
};

/** What kind of job is this (public/private/flex) */
export type JobKind = {
  __typename?: 'JobKind';
  /** Is it a last minute job */
  isFlex: Scalars['Boolean']['output'];
  /** Is it a private job */
  isPrivate: Scalars['Boolean']['output'];
  /** Is it a public job */
  isPublic: Scalars['Boolean']['output'];
  /** Stores the job-kind string */
  kind: PostedJobKindOptions;
};

/** Attributes relating to the matched worker for this job */
export type JobMatch = {
  __typename?: 'JobMatch';
  /** Agreement relating to this job match */
  agreement?: Maybe<Agreement>;
  /** Formatted rate-offer for a flex-job (LMJ) */
  amount?: Maybe<Scalars['String']['output']>;
  /** Comment on a flex-job (LMJ) */
  comment?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this job was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Distance between worker and this job's location */
  distance?: Maybe<Scalars['String']['output']>;
  /** ID of the job-match instance */
  id: Scalars['ID']['output'];
  /** Posted job this match relates to */
  postedJob: PostedJob;
  /** Offered rate in cents for a flex job (LMJ) */
  rateOffer?: Maybe<Scalars['Int']['output']>;
  /** Raw rate-offer for a flex-job (LMJ) */
  rawAmount?: Maybe<Scalars['Float']['output']>;
  /** Timestamp for when job was replied-to */
  repliedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status of this match */
  status: Scalars['String']['output'];
  /** Timestamp for when this match was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User (client) associated with this match */
  user: User;
};

/** Details of a set of filters for reducing the scope of a job-notification to only the results that a worker would like to see */
export type JobNotificationFilter = {
  __typename?: 'JobNotificationFilter';
  /** How many filters have been applied */
  appliedFiltersCount: Scalars['Int']['output'];
  /** Filter by the workers available days for work */
  days?: Maybe<Array<Scalars['String']['output']>>;
  /** If true will filter jobs based on distance to the workers location */
  distance?: Maybe<Scalars['Boolean']['output']>;
  /** Key for the filter */
  filterKey: Scalars['String']['output'];
  /** Filter by preferred gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** Filter by this amount of hours */
  hours?: Maybe<Scalars['String']['output']>;
  /** ID of the notification filter */
  id: Scalars['ID']['output'];
  /** A URL to a job-search with these filters applied */
  linkToSearch: Scalars['String']['output'];
  /** Filter by distance from this location */
  location?: Maybe<Scalars['String']['output']>;
  /** Filter by these participant age-groups */
  participantsAge?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by these services */
  services?: Maybe<Array<Scalars['String']['output']>>;
};

/** Calls to Action (cta) available on the "worker replied" modal */
export type JobRepliedModalCtaActions = {
  __typename?: 'JobRepliedModalCtaActions';
  /** One of Internal or External */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** One of Primary or Secondary */
  ctaType?: Maybe<Scalars['String']['output']>;
};

/** Fields that are returned when a worker has responded to a job */
export type JobRepliedModalFields = {
  __typename?: 'JobRepliedModalFields';
  /** CTA actions available on the modal */
  ctaActions?: Maybe<Array<JobRepliedModalCtaActions>>;
  /** Name of the icon for the modal */
  iconName?: Maybe<Scalars['String']['output']>;
  /** List of text in the modal */
  listItems?: Maybe<Array<Scalars['String']['output']>>;
  /** Title of the modal */
  title?: Maybe<Scalars['String']['output']>;
};

/** Attributes of the job reply message when support-worker applies for a job */
export type JobReplyAttributes = {
  /** Was the support-worker recommended for this job */
  isReferredByRecommended: Scalars['Boolean']['input'];
  /** Message of the reply from the support-worker */
  message: Scalars['String']['input'];
};

/** Represents job response attributes */
export type JobResponse = {
  __typename?: 'JobResponse';
  /** Support provider has applied to the job */
  applied?: Maybe<Scalars['Boolean']['output']>;
  /** Represents the job message */
  inboxMessage?: Maybe<Scalars['String']['output']>;
  /** Represents offer rate for flex job */
  offerRate?: Maybe<Scalars['Int']['output']>;
  /** Job has shared to the support provider */
  shared?: Maybe<Scalars['Boolean']['output']>;
  /** Represents the worker */
  worker: User;
};

/** What kind of job-response answer is this */
export type JobResponseAnswer = {
  __typename?: 'JobResponseAnswer';
  /** Type of the answer (eg description/skills) */
  answerType: JobResponseAnswerOptions;
  /** Content of the answer */
  content?: Maybe<Scalars['String']['output']>;
};

/** When responding to a posted job, these are the response attributes */
export type JobResponseAnswerAttributes = {
  /** Type of the answer (eg description/skills) */
  answerType: JobResponseAnswerOptions;
  /** Detailed content of the answer */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID of the job we're responding to */
  postedJobId: Scalars['String']['input'];
};

/** Type of JobResponseAnswer (eg description/introduction/skills) */
export enum JobResponseAnswerOptions {
  /** availability */
  Availability = 'availability',
  /** description */
  Description = 'description',
  /** introduction */
  Introduction = 'introduction',
  /** skills */
  Skills = 'skills'
}

/** The connection type for JobResponse. */
export type JobResponseConnection = {
  __typename?: 'JobResponseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<JobResponseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<JobResponse>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type JobResponseEdge = {
  __typename?: 'JobResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<JobResponse>;
};

/** Filters for posted job responded support workers */
export type JobResponsesFiltersAttribute = {
  /** Filter by whether worker has completed statutory declaration or not */
  completedStatutoryDeclaration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by workers by interests */
  interests?: InputMaybe<Array<WorkerInterestOptions>>;
  /** Filter by workers by qualifications */
  qualifications?: InputMaybe<Array<WorkerQualificationsOptions>>;
};

/** Job search filters - used to filter a set of jobs from the worker perspective */
export type JobSearch = {
  /** Filter by available days */
  availableDays?: InputMaybe<Array<DayOptions>>;
  /** If true, will filter by distance from the workers location */
  distance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by gender */
  gender?: InputMaybe<PostedJobsGenderPref>;
  /** Filter by hours requested */
  hours?: InputMaybe<PostedJobsHours>;
  /** Column used for ordering the resulting posted jobs list */
  order?: InputMaybe<PostedJobsOrder>;
  /** Filter by age-group of the participant */
  participantsAge?: InputMaybe<Array<ParticipantAgeGroup>>;
  /** Filter by postcode/location */
  postCodeGeoId: Scalars['Int']['input'];
  /** Filter by service(s) requested eg basic_companionship, basic_community, etc */
  services?: InputMaybe<Array<ServiceCodeOptions>>;
  /** Filter by suburb name */
  suburb: Scalars['String']['input'];
};

/** Attributes of a job session - that the client created for a posted job */
export type JobSession = {
  __typename?: 'JobSession';
  /** ID of the session */
  id: Scalars['ID']['output'];
  /** Time period (start-end) covered by the session */
  period: JobSessionPeriod;
  /** Posted Job this session is for */
  postedJob: PostedJob;
  /** Week day on which the session occurs */
  weekDay: DayOptions;
};

/** Attributes for a job-session related to a posted job */
export type JobSessionAttributes = {
  /** Set to `true` to delete the job session */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** End time of availability in 24 hour format (`HH:MM`) */
  endTime: Scalars['String']['input'];
  /** ID of the job-session (required to delete the session) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Start time of availability in 24 hour format (`HH:MM`) */
  startTime: Scalars['String']['input'];
  /** What day of the week will this session be held on */
  weekDay: DayOptions;
};

/** Time period (start-end) covered by a job session */
export type JobSessionPeriod = {
  __typename?: 'JobSessionPeriod';
  /** End-time of the job session */
  endTime: Scalars['String']['output'];
  /** Start-time of the job session */
  startTime: Scalars['String']['output'];
};

/** Job shared by client OR worker replied to the job */
export type JobShared = {
  __typename?: 'JobShared';
  /** Date time when the job is shared/replied */
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** shared/replied */
  type: Scalars['String']['output'];
};

/** Static Answer details */
export type JobStaticAnswer = {
  __typename?: 'JobStaticAnswer';
  /** Category for this answer */
  category: Scalars['String']['output'];
  /** Describes the answer */
  label: Scalars['String']['output'];
  /** Answer value */
  value: Scalars['String']['output'];
};

/** Static question details */
export type JobStaticQuestion = {
  __typename?: 'JobStaticQuestion';
  /** Name of the Question */
  name: Scalars['String']['output'];
  /** List of possible options that can be selected */
  options: Array<JobStaticAnswer>;
};

/** Status of the job - for client and worker */
export type JobStatus = {
  __typename?: 'JobStatus';
  /** Check if job can convert to public */
  canConvertToPublic: Scalars['Boolean']['output'];
  /** Check if job can repost */
  canRepost: Scalars['Boolean']['output'];
  /** Client-related internal state */
  clientState?: Maybe<PostedJobClientStateOptions>;
  /** Client-related public status */
  clientStatus?: Maybe<PostedJobClientStatusOptions>;
  /** Descriptive version of client status */
  clientStatusDescription?: Maybe<Scalars['String']['output']>;
  /** Job state */
  state: PostedJobStateOptions;
  /** Worker public status */
  workerStatus?: Maybe<PostedJobWorkerStatusOptions>;
};

/** Summary of support details */
export type JobSupportDetails = {
  __typename?: 'JobSupportDetails';
  /** Summary of service details */
  details?: Maybe<Array<Scalars['String']['output']>>;
  /** Name of service */
  name: Scalars['String']['output'];
};

/** Timestamps relating to posted jobs */
export type JobTimestamps = {
  __typename?: 'JobTimestamps';
  /** Time this job was authorised */
  authorisedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time job closes for flex job (LMJ) */
  closingTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time this job was first created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** End time for flex job (LMJ) */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Time this job expires */
  expiryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** This will be a regular job start date, or flex job start time */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this job was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Fields of the worker linked to a job */
export type JobWorkerFields = {
  __typename?: 'JobWorkerFields';
  /** The agreement relating to this job */
  agreement?: Maybe<Agreement>;
  /** is there an agreement relating to this job */
  agreementMadeByThisJob: Scalars['Boolean']['output'];
  /** What actions are allowed for this job */
  allowActions?: Maybe<PostedJobAllowedActions>;
  /** Can an agreement be made for this job */
  canCreateAgreement: Scalars['Boolean']['output'];
  /** Can the worker see the client's info? */
  canSeeClientInfo: Scalars['Boolean']['output'];
  /** What is the conversation relating to this job */
  conversation?: Maybe<Conversation>;
  /** Does this job require qualifications */
  isQualified: Scalars['Boolean']['output'];
  /** Flag for checking if the current user saved this job to shortlist */
  isSaved?: Maybe<Scalars['Boolean']['output']>;
  /** Fields that are returned when a worker has responded to a job */
  jobRepliedModalFields?: Maybe<JobRepliedModalFields>;
  /** Job shared by client OR worker replied to the job */
  jobShared?: Maybe<JobShared>;
  /** Provides FlexMatch in case of last minute job, otherwise JobMatch */
  match?: Maybe<JobMatch>;
  /** The explanation for why the job was matched */
  matchExplanation?: Maybe<Array<MatchExplanation>>;
  /** Number of replies to this job */
  repliedCount?: Maybe<Scalars['Int']['output']>;
  /** Estimated driving time (in seconds) from a support worker's home suburb */
  travelTime?: Maybe<Scalars['Int']['output']>;
  /** Has this user blocked the client? */
  userHasBlocked: Scalars['Boolean']['output'];
  /** Has this user sent a message */
  userHasSentMessage: Scalars['Boolean']['output'];
  /** Is this user blocked by the client? */
  userIsBlocked: Scalars['Boolean']['output'];
};

/** Information about a worker's spoken languages */
export type Language = {
  __typename?: 'Language';
  /** Language(s) spoken natively */
  firstLanguages: Array<LanguageItem>;
  /** Other language(s) spoken */
  secondLanguages: Array<LanguageItem>;
};

/** Holds details of languages a user speaks */
export type LanguageAttributes = {
  /** Languages a person speaks natively */
  firstLanguages: Array<LanguageOptions>;
  /** Other languages the person speaks */
  secondLanguages: Array<LanguageOptions>;
};

/** Detail of an individual language spoken */
export type LanguageItem = {
  __typename?: 'LanguageItem';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** A client's spoken languages - we can use this to filter workers by desired languages */
export enum LanguageOptions {
  Arabic = 'Arabic',
  Auslan = 'Auslan',
  Cantonese = 'Cantonese',
  Croatian = 'Croatian',
  English = 'English',
  French = 'French',
  German = 'German',
  Greek = 'Greek',
  Hebrew = 'Hebrew',
  Hindi = 'Hindi',
  Hungarian = 'Hungarian',
  Indonesian = 'Indonesian',
  Italian = 'Italian',
  Japanese = 'Japanese',
  Korean = 'Korean',
  Macedonian = 'Macedonian',
  Maltese = 'Maltese',
  Mandarin = 'Mandarin',
  Nepali = 'Nepali',
  Netherlandic = 'Netherlandic',
  Other = 'Other',
  Persian = 'Persian',
  Polish = 'Polish',
  Portugese = 'Portugese',
  Russian = 'Russian',
  Serbian = 'Serbian',
  Sinhalese = 'Sinhalese',
  Somoan = 'Somoan',
  Spanish = 'Spanish',
  Tagalog = 'Tagalog',
  Tamil = 'Tamil',
  Turkish = 'Turkish',
  Vietnamese = 'Vietnamese'
}

/** Details about a location (eg where suopport work will take place or where a support-worker is willing to work nearby) */
export type Location = {
  __typename?: 'Location';
  /** Address of the location */
  address: Scalars['String']['output'];
  /** ID of the location */
  id: Scalars['ID']['output'];
  /** Latitude of the location */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Longitude of the location */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Name of the location */
  name?: Maybe<Scalars['String']['output']>;
  /** PostcodeGeo of the location */
  postCodeGeoId: Scalars['ID']['output'];
  /** Postcode of the location */
  postcode?: Maybe<Scalars['String']['output']>;
  /** State of the location */
  state?: Maybe<Scalars['String']['output']>;
  /** Suburb of the location */
  suburb?: Maybe<Scalars['String']['output']>;
};

/** location relevance */
export type LocationRelevance = {
  __typename?: 'LocationRelevance';
  /** straigth line distance in metres */
  straightLineDistanceMetres?: Maybe<Scalars['Int']['output']>;
};

/** Loyalty information for a member */
export type Loyalty = {
  __typename?: 'Loyalty';
  /** Loyalty category of the member */
  category?: Maybe<Scalars['String']['output']>;
  /** Loyalty name of the member */
  name?: Maybe<Scalars['String']['output']>;
  /** Loyalty rank of the member */
  rank?: Maybe<Scalars['Int']['output']>;
};

/** Get the Mable fees for the client or worker */
export type MableFee = {
  __typename?: 'MableFee';
  /** The client fee percentage */
  clientFeePercentage: Scalars['Float']['output'];
  /** The worker fee percentage */
  workerFeePercentage: Scalars['Float']['output'];
};

/** Information about Mable-verifiable information */
export type MableVerified = {
  __typename?: 'MableVerified';
  /** Badges - verified by Mable */
  badges?: Maybe<Array<MableVerifiedItem>>;
  /** Qualifications - verified by Mable */
  qualifications?: Maybe<Array<MableVerifiedItem>>;
  /** Ticks - verified by Mable */
  ticks?: Maybe<Array<MableVerifiedItem>>;
  /** Ticks that can be optionally added */
  unverifiedTicks?: Maybe<Array<MableVerifiedItem>>;
};

/** An item that can be verified by Mable eg a badge/qualification */
export type MableVerifiedItem = {
  __typename?: 'MableVerifiedItem';
  /** CTA URL */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Short description of the item */
  details?: Maybe<Scalars['String']['output']>;
  /** Icon associated with the item */
  icon?: Maybe<Scalars['String']['output']>;
  /** Title of the item */
  title: Scalars['String']['output'];
};

/** Manage job search filters for coordinators */
export type ManageJobsSearchFilterAttribute = {
  /** client id associated with the posted job */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** flag for the job created in last 30 days */
  createdInLast30Days?: InputMaybe<Scalars['Boolean']['input']>;
  /** job status filter */
  jobStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** job types */
  jobTypes?: InputMaybe<Array<PostedJobKindOptions>>;
  /** sort order of results */
  sortOrder?: InputMaybe<PostedJobSortOrder>;
};

/** Attributes required to update the plan */
export type ManagePlanAttributes = {
  /** Contribution rate for the wallet */
  contributionRate: Scalars['Float']['input'];
  /** Status of wallet */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Wallet payout destination attributes */
  walletPayoutDestination: WalletPayoutDestinationAttributes;
};

/** Autogenerated input type of ManagePlan */
export type ManagePlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Input type required to edit the existing plan */
  managePlanAttributes: ManagePlanAttributes;
};

/** Autogenerated return type of ManagePlan */
export type ManagePlanPayload = {
  __typename?: 'ManagePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated wallet */
  wallet?: Maybe<Wallet>;
};

/** Match type of the services */
export enum Match {
  /** Full match with the job services */
  Full = 'full',
  /** No match */
  None = 'none',
  /** Partial match with the job services */
  Partial = 'partial'
}

/** Details about why a job was matched */
export type MatchExplanation = {
  __typename?: 'MatchExplanation';
  /** Match-explanation type eg specific_days_and_times/services */
  name: MatchExplanationName;
  /** The match-percentage showing how close a match this is */
  percentage: Scalars['Int']['output'];
};

/** When a job is matched with a support-worker - these are the types of matches */
export enum MatchExplanationName {
  FlexibleDaysAndTimes = 'flexible_days_and_times',
  Services = 'services',
  SpecificDaysAndTimes = 'specific_days_and_times'
}

/** Matching Detail for Expression of Interest */
export type MatchingDetail = {
  __typename?: 'MatchingDetail';
  /** The availability overlap for why the job was matched full/partial */
  availability?: Maybe<Scalars['String']['output']>;
  /** The explanation for why the job was matched */
  explanation: Array<MatchExplanation>;
  /** The service overlap for why the job was matched full/partial */
  serviceOverlap?: Maybe<Scalars['String']['output']>;
  /** Estimated driving time (in seconds) from a support worker's home suburb */
  travelTime?: Maybe<Scalars['Int']['output']>;
};

/** Details of medication relevant to taking care of the participant */
export type MedicationJson = {
  __typename?: 'MedicationJson';
  /** Dosage of medication */
  dosage?: Maybe<Scalars['String']['output']>;
  /** Frequency to be given */
  frequency?: Maybe<Scalars['String']['output']>;
  /** Medication name */
  medication?: Maybe<Scalars['String']['output']>;
  /** Reason for taking the medication */
  reasonTaken?: Maybe<Scalars['String']['output']>;
};

/** Medication(s) the participant needs to take */
export type MedicationJsonAttribute = {
  /** How much of the medication is to be taken each time */
  dosage?: InputMaybe<Scalars['String']['input']>;
  /** How often should the medication be taken */
  frequency?: InputMaybe<Scalars['String']['input']>;
  /** What is the medication to be taken */
  medication?: InputMaybe<Scalars['String']['input']>;
  /** What is the reason why the medication is to be taken */
  reasonTaken?: InputMaybe<Scalars['String']['input']>;
};

/** Details of a Meet-and-greet negotiated between participants */
export type MeetAndGreet = {
  __typename?: 'MeetAndGreet';
  /** Time when the requestee accepted the meet and greet */
  acceptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Has a callback been requested */
  callbackRequest?: Maybe<Scalars['Boolean']['output']>;
  /** Time when the revoker cancelled the meet and greet */
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Comment describing the Meet and greet */
  comment?: Maybe<Scalars['String']['output']>;
  /** Conversation between the current participants */
  conversation: Conversation;
  /** When the Meet and Greet was first created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Time when the requestee declined the meet and greet */
  declinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Any feedback following the meet and greet */
  feedbackComments?: Maybe<Scalars['String']['output']>;
  /** ID of the meet and greet */
  id: Scalars['ID']['output'];
  /** Intended location of the meet and greet */
  location?: Maybe<Scalars['String']['output']>;
  /** Detailed description of the intended meet and greet location */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** Type of result of the meet and greet */
  meetingResult?: Maybe<MeetAndGreetFeedbackResultOptions>;
  /** Type of meeting that this meet and greet will be */
  meetingType: Scalars['String']['output'];
  reason?: Maybe<Array<MeetAndGreetFeedbackReasonOptions>>;
  /** Party requesting the meet and greet */
  requestee: User;
  /** Other party being requested to come to the meet and greet */
  requestor: User;
  /** Party revoking the meet and greet */
  revoker?: Maybe<User>;
  /** What time/date is this meet and greet scheduled for */
  scheduledAt: Scalars['ISO8601DateTime']['output'];
  /** Current status of the meet and greet */
  status: Scalars['String']['output'];
};

/** Feedback given when accepting a meet and greet */
export type MeetAndGreetAcceptedFeedbackReason = {
  __typename?: 'MeetAndGreetAcceptedFeedbackReason';
  /** Details of the feedback given */
  description: Scalars['String']['output'];
  /** Category of feedback */
  key: MeetAndGreetFeedbackReasonOptions;
};

/** Atributes needed when creating a MeetAndGreet */
export type MeetAndGreetAttributes = {
  /** Id of conversation for which meet and greet is being created */
  conversationId: Scalars['ID']['input'];
  /** Location where the meeting will take place */
  meetingPlace: Scalars['String']['input'];
  /** Location where the meeting will take place */
  meetingType: MeetAndGreetMeetingTypeOptions;
  /** Scheduled at date at dd/mm/yyyy format */
  scheduledAtDate: Scalars['String']['input'];
  /** Scheduled at time at hh:mm AM/PM format */
  scheduledAtTime: Scalars['String']['input'];
  /** Offset to UTC time in integer */
  scheduledAtTzoffset: Scalars['Int']['input'];
};

/** Categories of reasons when feedback is given on a meet-and-greet */
export enum MeetAndGreetFeedbackReasonOptions {
  CouldntMakeIt = 'couldnt_make_it',
  NotAsDescribed = 'not_as_described',
  OtherConcerns = 'other_concerns',
  OtherPartyCancelled = 'other_party_cancelled',
  OtherPartyDidntTurnUp = 'other_party_didnt_turn_up',
  PersonalConnection = 'personal_connection',
  SupportWorkerAvailability = 'support_worker_availability',
  SupportWorkerExperience = 'support_worker_experience',
  TimesDidntSuit = 'times_didnt_suit',
  WasntConfirmed = 'wasnt_confirmed'
}

/** Category of results for a meet-and-greet */
export enum MeetAndGreetFeedbackResultOptions {
  /** We didn't meet */
  DidntMeet = 'didnt_meet',
  /** It was great! */
  Great = 'great',
  /** It wasn't a fit */
  NotAFit = 'not_a_fit'
}

/** Type of meet-and-greet */
export enum MeetAndGreetMeetingTypeOptions {
  /** Phone call */
  PhoneCall = 'phone_call',
  /** In person */
  Physical = 'physical',
  /** Video call */
  Virtual = 'virtual'
}

/** Category of meet-and-greet */
export type MeetAndGreetMeetingTypes = {
  __typename?: 'MeetAndGreetMeetingTypes';
  /** Key for easily finding this category */
  key: Scalars['String']['output'];
  /** Human-friendly label */
  label: Scalars['String']['output'];
};

/** Valid kinds of response made to an offer to meet and greet */
export enum MeetAndGreetResponseOptions {
  Accept = 'accept',
  Cancel = 'cancel',
  Decline = 'decline'
}

/** Message from one party to another in a conversation */
export type Message = {
  __typename?: 'Message';
  /** Main text of the message */
  body: Scalars['String']['output'];
  /** Conversation in which message is posted */
  conversation?: Maybe<Conversation>;
  /** When message was initially posted */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the message */
  id: Scalars['ID']['output'];
  /** What kind of message is this */
  kind: Scalars['String']['output'];
  /** Shortlist mechanism used (if any) */
  mechanism: Scalars['String']['output'];
  /** Meet and greet for this message */
  meetAndGreet?: Maybe<MeetAndGreet>;
  /** Has the other party been notified */
  notified: Scalars['Boolean']['output'];
  /** User that owns this message */
  owner: Scalars['String']['output'];
  /** Posted Job shared in this message (if any) */
  postedJob?: Maybe<PostedJob>;
  /** Has this message been read by the other party */
  read: Scalars['Boolean']['output'];
  /** User that this message was shared with */
  receiver?: Maybe<User>;
  /** Time when other party responded to the message */
  responseAt: Scalars['ISO8601DateTime']['output'];
  /** Sender of the message */
  sender: User;
  /** Latest time this message was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Message circumvention indicators */
export type MessageCircumvention = {
  __typename?: 'MessageCircumvention';
  /** Indicates if message contains an email address */
  emailAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if message contains a phone number */
  phoneNumber?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if message contains a social media handle */
  socialHandle?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if message contains a social media URL */
  socialUrl?: Maybe<Scalars['Boolean']['output']>;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Message>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Message>;
};

/** Message meta for expression of interest */
export type MessageMeta = {
  __typename?: 'MessageMeta';
  /** Indicators for potential communication circumvention */
  contains?: Maybe<MessageCircumvention>;
};

/** Minimum rate */
export type MinimumRate = {
  __typename?: 'MinimumRate';
  /** Minimum rate in dollars */
  minimumRateInDollars: Scalars['Float']['output'];
};

/** A device token for a user who has dismissed the banner notifications */
export type MobileNotificationAllowBannerDismissal = {
  __typename?: 'MobileNotificationAllowBannerDismissal';
  /** Timestamp the dismissal token was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** UUID of the device the user was logged in with */
  deviceUuid: Scalars['String']['output'];
  /** ID of the dismissal token */
  id: Scalars['ID']['output'];
  /** Platform the user was logged in with */
  platform?: Maybe<Scalars['String']['output']>;
  /** Timestamp the dismissal token was updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Details of the user that did the dismissing */
  user: User;
};

/** Contains fields returned for a rating-prompt for the mobile app */
export type MobileRatingPrompt = {
  __typename?: 'MobileRatingPrompt';
  /** Written feedback */
  feedback?: Maybe<Scalars['String']['output']>;
  /** ID of the rating-prompt */
  id: Scalars['ID']['output'];
  /** Type of the mobile rating-prompt */
  response: MobileRatingPromptOptions;
  /** User providing the rating */
  user: User;
};

/** Attributes required for a rating-prompt for the mobile app */
export type MobileRatingPromptAttribute = {
  /** Written feedback */
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** Type of rating given */
  response: MobileRatingPromptOptions;
};

/** Valid rating-type for a mobile-app rating-prompt */
export enum MobileRatingPromptOptions {
  /** negative */
  Negative = 'negative',
  /** positive */
  Positive = 'positive'
}

/** Attributes required for checking if a user qualifies for a rating-prompt on the mobile app */
export type MobileRatingPromptQualification = {
  __typename?: 'MobileRatingPromptQualification';
  /** Do we allow a rating prompt for this user */
  allowRating: Scalars['Boolean']['output'];
};

/** Rules for monthly recurrence */
export type MonthlyRecurrenceRules = {
  /** type of month recurrence */
  monthOptionSelection: Scalars['String']['input'];
  /** weekday it recurs */
  monthlyDay?: InputMaybe<Scalars['String']['input']>;
  /** the week of the month it recurs */
  monthlyWeekOptions?: InputMaybe<Scalars['String']['input']>;
  /** times it recurs */
  times: Array<RecurrenceTimes>;
};

/** List of mutations and what they do */
export type Mutation = {
  __typename?: 'Mutation';
  /** Accept or cancel tax and super sync terms */
  acceptCancelTaxAndSuperSyncTerms?: Maybe<AcceptCancelTaxAndSuperSyncTermsPayload>;
  /** Update status when SP press cancelled/accepted the term */
  acceptCancelUserOrganisationTerm?: Maybe<AcceptCancelUserOrganisationTermPayload>;
  /** Accept a connection request */
  acceptRequest?: Maybe<AcceptPayload>;
  /** Accepts a scheduled event's reschedule request */
  acceptScheduledEventRescheduleRequest?: Maybe<AcceptRescheduleRequestPayload>;
  /** Save a job to shortlist */
  addSavedJob?: Maybe<AddSavedJobPayload>;
  /** Amend an existing agreement */
  amendAgreement?: Maybe<AmendAgreementPayload>;
  /** Amend an existing agreement using new structure rates */
  amendAgreementWithStructuredRates?: Maybe<AmendAgreementWithStructuredRatesPayload>;
  /** Applying a voucher to a client account */
  applyVoucher?: Maybe<ApplyVoucherPayload>;
  /** Assign clients to Coordinator */
  assignClientsToCoordinator?: Maybe<AssignClientsToCoordinatorPayload>;
  /** Block the phone calls of a user */
  blockPhoneCalls?: Maybe<BlockPayload>;
  /** Creates multiple events in one mutation */
  bulkCreateScheduledEvents?: Maybe<BulkCreateScheduledEventsPayload>;
  /** Cancel a scheduled event */
  cancelScheduledEvent?: Maybe<CancelScheduledEventPayload>;
  /** Accept or Cancel flex jobs */
  clientFlexJobs?: Maybe<AcceptCancelFlexJobsPayload>;
  /** Update client */
  clientUpdate?: Maybe<ClientUpdatePayload>;
  /** Create/Delete/Update Contacts */
  contactCreateDeleteUpdate?: Maybe<ContactCreateDeleteUpdatePayload>;
  /** Convert a job deom private to public */
  convertJobToPublic?: Maybe<ConvertJobToPublicPayload>;
  /** Record users' acknowledgement of the onboarding code of conduct prompt */
  createCodeOfConductAcknowledgement?: Maybe<CreateCodeOfConductAcknowledgementPayload>;
  /** Record user has been presented with code of conduct prompt */
  createCodeOfConductPrompt?: Maybe<CreateCodeOfConductPromptPayload>;
  /** Create conversations quick reply */
  createConversationsQuickReply?: Maybe<CreateConversationsQuickReplyPayload>;
  /** Record download mobile app offer response */
  createDownloadAppOffer?: Maybe<CreateDownloadAppOfferPayload>;
  /** Store reasons for exceeded rates on agreements. */
  createExceededRateReason?: Maybe<CreateExceededRateReasonPayload>;
  /** Create express job selection */
  createExpressJobSelection?: Maybe<CreateExpressJobSelectionPayload>;
  /** Create express job session */
  createExpressJobSession?: Maybe<CreateExpressJobSessionPayload>;
  /** Create a connection invitation */
  createInvitation?: Maybe<CreatePayload>;
  /** Create a job reply for applying to a job. NOTE: Subscribe to CreatedJobReply subscription first before running this mutation to receive update when message was created. */
  createJobReply?: Maybe<CreateJobReplyPayload>;
  /** Create a Job Response Answers */
  createJobResponseAnswer?: Maybe<CreateJobResponseAnswerPayload>;
  /** Create a meet and greet */
  createMeetAndGreet?: Maybe<CreateMeetAndGreetPayload>;
  /** Create mobile notification allow banner dismissal */
  createMobileNotificationAllowBannerDismissal?: Maybe<CreateMobileNotificationAllowBannerDismissalPayload>;
  /** Create app rating */
  createMobileRatingPrompt?: Maybe<CreateMobileRatingPromptPayload>;
  /** Connect caller to recipient and create a phone call record */
  createPhoneCall?: Maybe<CreatePhoneCallPayload>;
  /** Create a phone verification schedule */
  createPhoneVerificationSchedule?: Maybe<CreatePhoneVerificationSchedulePayload>;
  /** Create a job from a support need */
  createPostedJobDraftFromSupportNeed?: Maybe<CreatePostedJobDraftFromSupportNeedPayload>;
  /** Create a Reference */
  createReference?: Maybe<CreateReferencePayload>;
  /** Create a scheduled event */
  createScheduledEvent?: Maybe<CreateScheduledEventPayload>;
  /** Create a new  reschedule request for a scheduled event */
  createScheduledEventRescheduleRequest?: Maybe<CreateScheduledEventRescheduleRequestPayload>;
  /** Create sendbird chat */
  createSendbirdChannel?: Maybe<CreateSendbirdChannelPayload>;
  /** Create a session impression */
  createSessionImpression?: Maybe<CreateSessionImpressionPayload>;
  /** Creates new scheduled event sessions from agreement destails */
  createSessionsFromAgreement?: Maybe<CreateSessionsFromAgreementPayload>;
  /** Create a Shortlist profile */
  createShortlist?: Maybe<CreateShortlistPayload>;
  /** Create structured rates on an agreement without client approval */
  createStructuredRates?: Maybe<CreateStructuredRatesPayload>;
  /** Create support health change and health change answers */
  createSupportHealthChangeAnswers?: Maybe<CreateSupportHealthChangeAnswersPayload>;
  /** Create or update a wallet */
  createWallet?: Maybe<CreateWalletPayload>;
  /** Create wallet payout destination */
  createWalletPayoutDestination?: Maybe<CreateWalletPayoutDestinationPayload>;
  /** Create worker preferences */
  createWorkerPreferences?: Maybe<CreateWorkerPreferencesPayload>;
  /** Decline a requested agreement */
  declineAgreement?: Maybe<DeclineAgreementPayload>;
  /** Declines a connection invitation */
  declineInvitation?: Maybe<DeclineInvitationPayload>;
  /** Decline or cancel a multiple sessions of a scheduled event */
  declineMultipleSessions?: Maybe<DeclineMultipleSessionsPayload>;
  /** Decline a connection request */
  declineRequest?: Maybe<DeclinePayload>;
  /** Declines a scheduled event's reschedule request */
  declineScheduledEventRescheduleRequest?: Maybe<DeclineRescheduleRequestPayload>;
  /** Decline or cancel a single session of a scheduled event */
  declineSingleSession?: Maybe<DeclineSingleSessionPayload>;
  /** Delete an agreement request */
  deleteAgreementRequest?: Maybe<DeleteAgreementRequestPayload>;
  /** Deletes all session after a specific occurrence */
  deleteMultipleSessions?: Maybe<DeleteMultipleSessionsPayload>;
  /** Destroy a Reference */
  deleteReference?: Maybe<DeleteReferencePayload>;
  /** Deletes a scheduled event's reschedule request */
  deleteScheduledEventRescheduleRequest?: Maybe<DeleteRescheduleRequestPayload>;
  /** Delete shift note attachment */
  deleteShiftNoteAsset?: Maybe<DeleteShiftNoteAttachmentPayload>;
  /** Delete current user shortlist */
  deleteShortlist?: Maybe<DeleteShortlistPayload>;
  /** Deletes a single session */
  deleteSingleSession?: Maybe<DeleteSingleSessionPayload>;
  /** Update the meet_and_greet_dismissed_at field in conversation */
  dismissMeetAndGreet?: Maybe<DismissMeetAndGreetPayload>;
  /** Dismiss a connection request */
  dismissRequest?: Maybe<DismissPayload>;
  /** Generates a flag that signifies the client has read the information about group chat. */
  flagReadGroupChatInfo?: Maybe<FlagReadGroupChatInfoPayload>;
  /** Create or update a flex (last minute) job */
  flexJobCreateUpdate?: Maybe<FlexJobCreateUpdatePayload>;
  /** Get user session token */
  generateSendbirdSessionToken?: Maybe<GenerateSendbirdSessionTokenPayload>;
  /** Manage the existing plan by editing the contribution rate and payout destination */
  managePlan?: Maybe<ManagePlanPayload>;
  /** Update or creates ndis plan for client */
  ndisPlanUpdate?: Maybe<NdisPlanUpdatePayload>;
  /** Return a new timesheet */
  newTimesheet?: Maybe<NewTimesheetPayload>;
  /** Create or update a public or private job */
  postedJobCreateUpdate?: Maybe<PostedJobCreateUpdatePayload>;
  /** Provide feedback to a worker. */
  provideFeedback?: Maybe<ProvideFeedbackPayload>;
  /** Provide feedback for a meet and greet */
  provideMeetAndGreetFeedback?: Maybe<ProvideMeetAndGreetFeedbackPayload>;
  /** Delete saved job from shortlist */
  removeSavedJob?: Maybe<RemoveSavedJobPayload>;
  /** Consumer removes a user from sendbird channel */
  removeUserSendbirdChannel?: Maybe<RemoveUserSendbirdChannelPayload>;
  /** Replaces existing sessions created from agreements with sessions from agreement days and times */
  replaceSessionsFromAgreement?: Maybe<ReplaceSessionsFromAgreementPayload>;
  /** Report a Conversation/PostedJob or Block/Unblock a user */
  reportBlockUnblock?: Maybe<ReportBlockUnblockPayload>;
  /** From a conversation, request an agreement from the carer in the conversation */
  requestAgreement?: Maybe<RequestAgreementPayload>;
  /** Request a client for a feedback. */
  requestFeedback?: Maybe<RequestFeedbackPayload>;
  /** Resend unlock instructions */
  resendUnlockInstructions?: Maybe<ResendUnlockInstructionsPayload>;
  /** Respond to an agreement offer from a worker */
  respondToAgreementOffer?: Maybe<RespondToAgreementOfferPayload>;
  /** Respond to a meet and greet */
  respondToMeetAndGreet?: Maybe<RespondToMeetAndGreetPayload>;
  /** Send message to carers on behalf of the client. */
  sendMessageToCarersOnBehalfOfClient?: Maybe<SendMessageToCarersOnBehalfOfClientPayload>;
  /** Send an offer to a client */
  sendOffer?: Maybe<SendOfferPayload>;
  /** Send an offer with structured rates to a client */
  sendOfferWithStructuredRates?: Maybe<SendOfferWithStructuredRatesPayload>;
  /** Share a job post in a conversation */
  sharePostedJob?: Maybe<SharePostedJobPayload>;
  /** Share a job post in conversation as coordinator */
  sharePostedJobWithWorkers?: Maybe<SharePostedJobWithWorkersPayload>;
  /** Share a shift note with a client contact */
  shareShiftNote?: Maybe<ShareShiftNotePayload>;
  /** Terminate an accepted agreement */
  terminateAgreement?: Maybe<TerminateAgreementPayload>;
  /** Generate admin message to protect user from sharing their phone number */
  triggerPrivacyProtectionNudge?: Maybe<TriggerPrivacyProtectionNudgePayload>;
  /** Unblock the phone calls of a user */
  unblockPhoneCalls?: Maybe<UnblockPayload>;
  /** Update the terms_accepted_at time in agreement model */
  updateAgreementTermsAcceptedAt?: Maybe<UpdateAgreementTermsAcceptedAtPayload>;
  /** Update CarerReliabilityAssessment */
  updateCarerReliabilityAssessment?: Maybe<UpdateCarerReliabilityAssessmentPayload>;
  /** Update the circumvention flag for conversations. */
  updateCircumventionBannerFlag?: Maybe<UpdateCircumventionBannerFlagPayload>;
  /** Update conversation */
  updateConversation?: Maybe<UpdateConversationPayload>;
  /** Update educate training task completed at for SIRS and WCC */
  updateEducateTrainingTaskCompleted?: Maybe<UpdateEducateTrainingTaskCompletedPayload>;
  /** Update incident case */
  updateIncidentCase?: Maybe<UpdateIncidentCasePayload>;
  /** Update a worker's filter for job notifications */
  updateJobNotificationFilter?: Maybe<UpdateJobNotificationFilterPayload>;
  /** Updates multiple sessions */
  updateMultipleSessions?: Maybe<UpdateMultipleSessionsPayload>;
  /** Update an existing offer before approval */
  updateOffer?: Maybe<UpdateOfferPayload>;
  /** Update and existing offer before approval using structured rates */
  updateOfferWithStructuredRates?: Maybe<UpdateOfferWithStructuredRatesPayload>;
  /** Update OrganisationTerm */
  updateOrganisationTerm?: Maybe<UpdateOrganisationTermPayload>;
  /** Fulfil/Cancel/Archive the job */
  updatePostedJobStatus?: Maybe<UpdatePostedJobStatusPayload>;
  /** Update a Reference */
  updateReference?: Maybe<UpdateReferencePayload>;
  /** Update a scheduled event */
  updateScheduledEvent?: Maybe<UpdateScheduledEventPayload>;
  /** Update the notification option for a scheduled event */
  updateScheduledEventNotifySeconds?: Maybe<UpdateScheduledEventNotifySecondsPayload>;
  /** Update RSVP of a scheduled event */
  updateScheduledEventRsvp?: Maybe<UpdateScheduledEventRsvpPayload>;
  /** Update session impression to provide feedback */
  updateSessionImpression?: Maybe<UpdateSessionImpressionPayload>;
  /** Updates a single session */
  updateSingleSession?: Maybe<UpdateSingleSessionPayload>;
  /** Update support health change and health change answers */
  updateSupportHealthChangeAnswers?: Maybe<UpdateSupportHealthChangeAnswersPayload>;
  /** Update the outcome of upcoming prompt */
  updateUpcomingPrompt?: Maybe<UpdateUpcomingPromptPayload>;
  /** It updates the status of a ui global banner for the current user */
  updateUserGlobalBanner?: Maybe<UpdateUserGlobalBannerPayload>;
  /** update a wallet */
  updateWallet?: Maybe<UpdateWalletPayload>;
  /** Update status of all given wallets */
  updateWalletsStatus?: Maybe<UpdateWalletsStatusPayload>;
  /** Update general worker availability and available days */
  updateWorkerAvailability?: Maybe<UpdateWorkerAvailabilityPayload>;
  /** Update worker location */
  updateWorkerLocation?: Maybe<UpdateWorkerLocationPayload>;
  /** Update worker rate */
  updateWorkerRate?: Maybe<UpdateWorkerRatePayload>;
  /** Update worker account details */
  userAccountUpdate?: Maybe<UserAccountUpdatePayload>;
  /** Soft delete user */
  userDelete?: Maybe<UserDeletePayload>;
  /** Create, update, or delete User drafts */
  userDraft?: Maybe<UserDraftCreateDeleteUpdatePayload>;
  /** Password resetting */
  userPasswordRecovery?: Maybe<UserPasswordRecoveryPayload>;
  /** Responder views a connection request */
  viewRequest?: Maybe<ViewPayload>;
  /** Offer, Decline or Withdraw flex jobs */
  workerFlexJobs?: Maybe<OfferDeclineWithdrawFlexJobsPayload>;
  /** Update worker */
  workerUpdate?: Maybe<WorkerUpdatePayload>;
};


/** List of mutations and what they do */
export type MutationAcceptCancelTaxAndSuperSyncTermsArgs = {
  input: AcceptCancelTaxAndSuperSyncTermsInput;
};


/** List of mutations and what they do */
export type MutationAcceptCancelUserOrganisationTermArgs = {
  input: AcceptCancelUserOrganisationTermInput;
};


/** List of mutations and what they do */
export type MutationAcceptRequestArgs = {
  input: AcceptInput;
};


/** List of mutations and what they do */
export type MutationAcceptScheduledEventRescheduleRequestArgs = {
  input: AcceptRescheduleRequestInput;
};


/** List of mutations and what they do */
export type MutationAddSavedJobArgs = {
  input: AddSavedJobInput;
};


/** List of mutations and what they do */
export type MutationAmendAgreementArgs = {
  input: AmendAgreementInput;
};


/** List of mutations and what they do */
export type MutationAmendAgreementWithStructuredRatesArgs = {
  input: AmendAgreementWithStructuredRatesInput;
};


/** List of mutations and what they do */
export type MutationApplyVoucherArgs = {
  input: ApplyVoucherInput;
};


/** List of mutations and what they do */
export type MutationAssignClientsToCoordinatorArgs = {
  input: AssignClientsToCoordinatorInput;
};


/** List of mutations and what they do */
export type MutationBlockPhoneCallsArgs = {
  input: BlockInput;
};


/** List of mutations and what they do */
export type MutationBulkCreateScheduledEventsArgs = {
  input: BulkCreateScheduledEventsInput;
};


/** List of mutations and what they do */
export type MutationCancelScheduledEventArgs = {
  input: CancelScheduledEventInput;
};


/** List of mutations and what they do */
export type MutationClientFlexJobsArgs = {
  input: AcceptCancelFlexJobsInput;
};


/** List of mutations and what they do */
export type MutationClientUpdateArgs = {
  input: ClientUpdateInput;
};


/** List of mutations and what they do */
export type MutationContactCreateDeleteUpdateArgs = {
  input: ContactCreateDeleteUpdateInput;
};


/** List of mutations and what they do */
export type MutationConvertJobToPublicArgs = {
  input: ConvertJobToPublicInput;
};


/** List of mutations and what they do */
export type MutationCreateCodeOfConductAcknowledgementArgs = {
  input: CreateCodeOfConductAcknowledgementInput;
};


/** List of mutations and what they do */
export type MutationCreateCodeOfConductPromptArgs = {
  input: CreateCodeOfConductPromptInput;
};


/** List of mutations and what they do */
export type MutationCreateConversationsQuickReplyArgs = {
  input: CreateConversationsQuickReplyInput;
};


/** List of mutations and what they do */
export type MutationCreateDownloadAppOfferArgs = {
  input: CreateDownloadAppOfferInput;
};


/** List of mutations and what they do */
export type MutationCreateExceededRateReasonArgs = {
  input: CreateExceededRateReasonInput;
};


/** List of mutations and what they do */
export type MutationCreateExpressJobSelectionArgs = {
  input: CreateExpressJobSelectionInput;
};


/** List of mutations and what they do */
export type MutationCreateExpressJobSessionArgs = {
  input: CreateExpressJobSessionInput;
};


/** List of mutations and what they do */
export type MutationCreateInvitationArgs = {
  input: CreateInput;
};


/** List of mutations and what they do */
export type MutationCreateJobReplyArgs = {
  input: CreateJobReplyInput;
};


/** List of mutations and what they do */
export type MutationCreateJobResponseAnswerArgs = {
  input: CreateJobResponseAnswerInput;
};


/** List of mutations and what they do */
export type MutationCreateMeetAndGreetArgs = {
  input: CreateMeetAndGreetInput;
};


/** List of mutations and what they do */
export type MutationCreateMobileNotificationAllowBannerDismissalArgs = {
  input: CreateMobileNotificationAllowBannerDismissalInput;
};


/** List of mutations and what they do */
export type MutationCreateMobileRatingPromptArgs = {
  input: CreateMobileRatingPromptInput;
};


/** List of mutations and what they do */
export type MutationCreatePhoneCallArgs = {
  input: CreatePhoneCallInput;
};


/** List of mutations and what they do */
export type MutationCreatePhoneVerificationScheduleArgs = {
  input: CreatePhoneVerificationScheduleInput;
};


/** List of mutations and what they do */
export type MutationCreatePostedJobDraftFromSupportNeedArgs = {
  input: CreatePostedJobDraftFromSupportNeedInput;
};


/** List of mutations and what they do */
export type MutationCreateReferenceArgs = {
  input: CreateReferenceInput;
};


/** List of mutations and what they do */
export type MutationCreateScheduledEventArgs = {
  input: CreateScheduledEventInput;
};


/** List of mutations and what they do */
export type MutationCreateScheduledEventRescheduleRequestArgs = {
  input: CreateScheduledEventRescheduleRequestInput;
};


/** List of mutations and what they do */
export type MutationCreateSendbirdChannelArgs = {
  input: CreateSendbirdChannelInput;
};


/** List of mutations and what they do */
export type MutationCreateSessionImpressionArgs = {
  input: CreateSessionImpressionInput;
};


/** List of mutations and what they do */
export type MutationCreateSessionsFromAgreementArgs = {
  input: CreateSessionsFromAgreementInput;
};


/** List of mutations and what they do */
export type MutationCreateShortlistArgs = {
  input: CreateShortlistInput;
};


/** List of mutations and what they do */
export type MutationCreateStructuredRatesArgs = {
  input: CreateStructuredRatesInput;
};


/** List of mutations and what they do */
export type MutationCreateSupportHealthChangeAnswersArgs = {
  input: CreateSupportHealthChangeAnswersInput;
};


/** List of mutations and what they do */
export type MutationCreateWalletArgs = {
  input: CreateWalletInput;
};


/** List of mutations and what they do */
export type MutationCreateWalletPayoutDestinationArgs = {
  input: CreateWalletPayoutDestinationInput;
};


/** List of mutations and what they do */
export type MutationCreateWorkerPreferencesArgs = {
  input: CreateWorkerPreferencesInput;
};


/** List of mutations and what they do */
export type MutationDeclineAgreementArgs = {
  input: DeclineAgreementInput;
};


/** List of mutations and what they do */
export type MutationDeclineInvitationArgs = {
  input: DeclineInvitationInput;
};


/** List of mutations and what they do */
export type MutationDeclineMultipleSessionsArgs = {
  input: DeclineMultipleSessionsInput;
};


/** List of mutations and what they do */
export type MutationDeclineRequestArgs = {
  input: DeclineInput;
};


/** List of mutations and what they do */
export type MutationDeclineScheduledEventRescheduleRequestArgs = {
  input: DeclineRescheduleRequestInput;
};


/** List of mutations and what they do */
export type MutationDeclineSingleSessionArgs = {
  input: DeclineSingleSessionInput;
};


/** List of mutations and what they do */
export type MutationDeleteAgreementRequestArgs = {
  input: DeleteAgreementRequestInput;
};


/** List of mutations and what they do */
export type MutationDeleteMultipleSessionsArgs = {
  input: DeleteMultipleSessionsInput;
};


/** List of mutations and what they do */
export type MutationDeleteReferenceArgs = {
  input: DeleteReferenceInput;
};


/** List of mutations and what they do */
export type MutationDeleteScheduledEventRescheduleRequestArgs = {
  input: DeleteRescheduleRequestInput;
};


/** List of mutations and what they do */
export type MutationDeleteShiftNoteAssetArgs = {
  input: DeleteShiftNoteAttachmentInput;
};


/** List of mutations and what they do */
export type MutationDeleteShortlistArgs = {
  input: DeleteShortlistInput;
};


/** List of mutations and what they do */
export type MutationDeleteSingleSessionArgs = {
  input: DeleteSingleSessionInput;
};


/** List of mutations and what they do */
export type MutationDismissMeetAndGreetArgs = {
  input: DismissMeetAndGreetInput;
};


/** List of mutations and what they do */
export type MutationDismissRequestArgs = {
  input: DismissInput;
};


/** List of mutations and what they do */
export type MutationFlagReadGroupChatInfoArgs = {
  input: FlagReadGroupChatInfoInput;
};


/** List of mutations and what they do */
export type MutationFlexJobCreateUpdateArgs = {
  input: FlexJobCreateUpdateInput;
};


/** List of mutations and what they do */
export type MutationGenerateSendbirdSessionTokenArgs = {
  input: GenerateSendbirdSessionTokenInput;
};


/** List of mutations and what they do */
export type MutationManagePlanArgs = {
  input: ManagePlanInput;
};


/** List of mutations and what they do */
export type MutationNdisPlanUpdateArgs = {
  input: NdisPlanUpdateInput;
};


/** List of mutations and what they do */
export type MutationNewTimesheetArgs = {
  input: NewTimesheetInput;
};


/** List of mutations and what they do */
export type MutationPostedJobCreateUpdateArgs = {
  input: PostedJobCreateUpdateInput;
};


/** List of mutations and what they do */
export type MutationProvideFeedbackArgs = {
  input: ProvideFeedbackInput;
};


/** List of mutations and what they do */
export type MutationProvideMeetAndGreetFeedbackArgs = {
  input: ProvideMeetAndGreetFeedbackInput;
};


/** List of mutations and what they do */
export type MutationRemoveSavedJobArgs = {
  input: RemoveSavedJobInput;
};


/** List of mutations and what they do */
export type MutationRemoveUserSendbirdChannelArgs = {
  input: RemoveUserSendbirdChannelInput;
};


/** List of mutations and what they do */
export type MutationReplaceSessionsFromAgreementArgs = {
  input: ReplaceSessionsFromAgreementInput;
};


/** List of mutations and what they do */
export type MutationReportBlockUnblockArgs = {
  input: ReportBlockUnblockInput;
};


/** List of mutations and what they do */
export type MutationRequestAgreementArgs = {
  input: RequestAgreementInput;
};


/** List of mutations and what they do */
export type MutationRequestFeedbackArgs = {
  input: RequestFeedbackInput;
};


/** List of mutations and what they do */
export type MutationResendUnlockInstructionsArgs = {
  input: ResendUnlockInstructionsInput;
};


/** List of mutations and what they do */
export type MutationRespondToAgreementOfferArgs = {
  input: RespondToAgreementOfferInput;
};


/** List of mutations and what they do */
export type MutationRespondToMeetAndGreetArgs = {
  input: RespondToMeetAndGreetInput;
};


/** List of mutations and what they do */
export type MutationSendMessageToCarersOnBehalfOfClientArgs = {
  input: SendMessageToCarersOnBehalfOfClientInput;
};


/** List of mutations and what they do */
export type MutationSendOfferArgs = {
  input: SendOfferInput;
};


/** List of mutations and what they do */
export type MutationSendOfferWithStructuredRatesArgs = {
  input: SendOfferWithStructuredRatesInput;
};


/** List of mutations and what they do */
export type MutationSharePostedJobArgs = {
  input: SharePostedJobInput;
};


/** List of mutations and what they do */
export type MutationSharePostedJobWithWorkersArgs = {
  input: SharePostedJobWithWorkersInput;
};


/** List of mutations and what they do */
export type MutationShareShiftNoteArgs = {
  input: ShareShiftNoteInput;
};


/** List of mutations and what they do */
export type MutationTerminateAgreementArgs = {
  input: TerminateAgreementInput;
};


/** List of mutations and what they do */
export type MutationTriggerPrivacyProtectionNudgeArgs = {
  input: TriggerPrivacyProtectionNudgeInput;
};


/** List of mutations and what they do */
export type MutationUnblockPhoneCallsArgs = {
  input: UnblockInput;
};


/** List of mutations and what they do */
export type MutationUpdateAgreementTermsAcceptedAtArgs = {
  input: UpdateAgreementTermsAcceptedAtInput;
};


/** List of mutations and what they do */
export type MutationUpdateCarerReliabilityAssessmentArgs = {
  input: UpdateCarerReliabilityAssessmentInput;
};


/** List of mutations and what they do */
export type MutationUpdateCircumventionBannerFlagArgs = {
  input: UpdateCircumventionBannerFlagInput;
};


/** List of mutations and what they do */
export type MutationUpdateConversationArgs = {
  input: UpdateConversationInput;
};


/** List of mutations and what they do */
export type MutationUpdateEducateTrainingTaskCompletedArgs = {
  input: UpdateEducateTrainingTaskCompletedInput;
};


/** List of mutations and what they do */
export type MutationUpdateIncidentCaseArgs = {
  input: UpdateIncidentCaseInput;
};


/** List of mutations and what they do */
export type MutationUpdateJobNotificationFilterArgs = {
  input: UpdateJobNotificationFilterInput;
};


/** List of mutations and what they do */
export type MutationUpdateMultipleSessionsArgs = {
  input: UpdateMultipleSessionsInput;
};


/** List of mutations and what they do */
export type MutationUpdateOfferArgs = {
  input: UpdateOfferInput;
};


/** List of mutations and what they do */
export type MutationUpdateOfferWithStructuredRatesArgs = {
  input: UpdateOfferWithStructuredRatesInput;
};


/** List of mutations and what they do */
export type MutationUpdateOrganisationTermArgs = {
  input: UpdateOrganisationTermInput;
};


/** List of mutations and what they do */
export type MutationUpdatePostedJobStatusArgs = {
  input: UpdatePostedJobStatusInput;
};


/** List of mutations and what they do */
export type MutationUpdateReferenceArgs = {
  input: UpdateReferenceInput;
};


/** List of mutations and what they do */
export type MutationUpdateScheduledEventArgs = {
  input: UpdateScheduledEventInput;
};


/** List of mutations and what they do */
export type MutationUpdateScheduledEventNotifySecondsArgs = {
  input: UpdateScheduledEventNotifySecondsInput;
};


/** List of mutations and what they do */
export type MutationUpdateScheduledEventRsvpArgs = {
  input: UpdateScheduledEventRsvpInput;
};


/** List of mutations and what they do */
export type MutationUpdateSessionImpressionArgs = {
  input: UpdateSessionImpressionInput;
};


/** List of mutations and what they do */
export type MutationUpdateSingleSessionArgs = {
  input: UpdateSingleSessionInput;
};


/** List of mutations and what they do */
export type MutationUpdateSupportHealthChangeAnswersArgs = {
  input: UpdateSupportHealthChangeAnswersInput;
};


/** List of mutations and what they do */
export type MutationUpdateUpcomingPromptArgs = {
  input: UpdateUpcomingPromptInput;
};


/** List of mutations and what they do */
export type MutationUpdateUserGlobalBannerArgs = {
  input: UpdateUserGlobalBannerInput;
};


/** List of mutations and what they do */
export type MutationUpdateWalletArgs = {
  input: UpdateWalletInput;
};


/** List of mutations and what they do */
export type MutationUpdateWalletsStatusArgs = {
  input: UpdateWalletsStatusInput;
};


/** List of mutations and what they do */
export type MutationUpdateWorkerAvailabilityArgs = {
  input: UpdateWorkerAvailabilityInput;
};


/** List of mutations and what they do */
export type MutationUpdateWorkerLocationArgs = {
  input: UpdateWorkerLocationInput;
};


/** List of mutations and what they do */
export type MutationUpdateWorkerRateArgs = {
  input: UpdateWorkerRateInput;
};


/** List of mutations and what they do */
export type MutationUserAccountUpdateArgs = {
  input: UserAccountUpdateInput;
};


/** List of mutations and what they do */
export type MutationUserDeleteArgs = {
  input: UserDeleteInput;
};


/** List of mutations and what they do */
export type MutationUserDraftArgs = {
  input: UserDraftCreateDeleteUpdateInput;
};


/** List of mutations and what they do */
export type MutationUserPasswordRecoveryArgs = {
  input: UserPasswordRecoveryInput;
};


/** List of mutations and what they do */
export type MutationViewRequestArgs = {
  input: ViewInput;
};


/** List of mutations and what they do */
export type MutationWorkerFlexJobsArgs = {
  input: OfferDeclineWithdrawFlexJobsInput;
};


/** List of mutations and what they do */
export type MutationWorkerUpdateArgs = {
  input: WorkerUpdateInput;
};

/** Details of an NDIS plan */
export type NdisPlan = {
  __typename?: 'NdisPlan';
  /** ID of the plan */
  id?: Maybe<Scalars['ID']['output']>;
  /** NDIS number of the client */
  ndisNumber?: Maybe<Scalars['String']['output']>;
  /** Date NDIS plan was last reviewed (yyyy-mm-dd) */
  reviewDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date NDIS plan started (yyyy-mm-dd) */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Details of Support-areas covered by this plan */
  supportAreasAttributes?: Maybe<Array<SupportArea>>;
  /** Details of Support-items covered-for by this plan */
  supportItems?: Maybe<Array<SupportItem>>;
};

/** Attributes of an NDIS plan */
export type NdisPlanAttributes = {
  /** ID of the plan */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** NDIS number */
  ndisNumber?: InputMaybe<Scalars['String']['input']>;
  /** Date review was done (dd/mm/yyy) */
  reviewDate?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the plan (dd/mm/yyy) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Areas of support this plan allows for */
  supportAreasAttributes?: InputMaybe<Array<SupportAreaAttributes>>;
};

/** Autogenerated input type of NdisPlanUpdate */
export type NdisPlanUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the NDIS plan */
  ndisPlanAttributes: NdisPlanAttributes;
};

/** Autogenerated return type of NdisPlanUpdate */
export type NdisPlanUpdatePayload = {
  __typename?: 'NdisPlanUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the ndis plan */
  ndisPlan?: Maybe<NdisPlan>;
};

/** NDIS support-area - the NDIS lists a number of support-areas that a client may be funded for in their plan (each support-area has many NDIS support-items) */
export type NdisSupportArea = {
  __typename?: 'NdisSupportArea';
  /** ID of the support-area */
  id: Scalars['ID']['output'];
  /** Name of the support-area */
  name: Scalars['String']['output'];
};

/** NDIS Support Item - the NDIS lists a number of support line-items that a client may be funded for in their plan (belongs to an NDIS support-area) */
export type NdisSupportItem = {
  __typename?: 'NdisSupportItem';
  /** ID of the support-item */
  id: Scalars['ID']['output'];
  /** Name of the support-item */
  name: Scalars['String']['output'];
  /** Name and code of the support-item (combines Number and Name) */
  nameWithCode?: Maybe<Scalars['String']['output']>;
  /** NDIS number of the support-item */
  number: Scalars['String']['output'];
};

/** Fields for unfilled need data */
export type NeedDetails = {
  __typename?: 'NeedDetails';
  /** ID of agreement */
  agreementId?: Maybe<Scalars['ID']['output']>;
  /** Prompt heading */
  heading?: Maybe<Scalars['String']['output']>;
  /** Posted job details */
  postedJob?: Maybe<NeedJob>;
  /** unmet hours on posted job */
  remainingHours?: Maybe<Scalars['String']['output']>;
  /** Job sessions unfilled */
  unfilledJobSessions?: Maybe<Array<JobSession>>;
};

/** Posted job fields */
export type NeedJob = {
  __typename?: 'NeedJob';
  /** ID of posted job */
  id?: Maybe<Scalars['ID']['output']>;
  /** Service categories that this job will cover */
  serviceCategories?: Maybe<Array<ServiceCategory>>;
  /** Title of the posted job */
  title?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of NewTimesheet */
export type NewTimesheetInput = {
  /** Attributes to initialise the timesheet */
  attributes?: InputMaybe<TimesheetAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of NewTimesheet */
export type NewTimesheetPayload = {
  __typename?: 'NewTimesheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the created timesheet */
  timesheet?: Maybe<EventDelivery>;
};

/** A user type that also implements some extra fields */
export type NorestrictUser = {
  __typename?: 'NorestrictUser';
  /** Whether current user has accepted Tax and super sync terms and conditions */
  acceptedTaxAndSuperSyncTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  /** The type of the user's account */
  accountType: UserAccountTypes;
  /** Indicates whether the user's account is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Active optimizely or other experiments for the user */
  activeExperiments?: Maybe<UserActiveExperiment>;
  /** User's address, visible only to the users with an agreement */
  address?: Maybe<Scalars['String']['output']>;
  /** Street address for the user */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Address line 2 */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** Age of the user */
  age?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the user is approved */
  approved: Scalars['Boolean']['output'];
  /** Whether current user is an approved carer but doesn't have a timesheet yet */
  approvedCarerWithoutTimesheet?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the user should be asked for a flu shot */
  askForFluShot: Scalars['Boolean']['output'];
  /** User's avatar image */
  avatar?: Maybe<Avatar>;
  /** User's birth date, visible only to the user themselves. */
  birthDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User's Calendly link for scheduling meetings */
  calendlyLink?: Maybe<Scalars['String']['output']>;
  /** Indicates if the user can create last minute jobs */
  canCreateLmj?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the user would like to receive emails about new support workers */
  carersInArea?: Maybe<Scalars['Boolean']['output']>;
  /** The type of client account, the returned values are 'Independent', 'Client Managed', 'Coordinator Managed' and 'Third Party Coordinator' */
  clientAccountType?: Maybe<Scalars['String']['output']>;
  /** The name of the client type. The returned values are 'Coordinator Managed', 'Self Managed' and 'Independent'. */
  clientTypeName?: Maybe<Scalars['String']['output']>;
  /** Percentage of the user's profile that has been completed */
  completedProfilePercent?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the user given consent to collect sensitive information */
  consentToCollectSensitiveInformation?: Maybe<Scalars['Boolean']['output']>;
  /** User's contact phone number, visible only to the users with an agreement */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Whether the contact phone number is verified via SMS code or phone call */
  contactPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Coordinator assigned to account if present */
  coordinator?: Maybe<Coordinator>;
  /** Timestamp of the last update to the user's COVID vaccine status */
  covidVaccineUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if per kilometer travel is disabled */
  disablePerKmTravel?: Maybe<Scalars['Boolean']['output']>;
  /** The display name of the user, visible only to the authorized users. */
  displayName: Scalars['String']['output'];
  /** The email address of the user, visible only to the user themselves. */
  email: Scalars['String']['output'];
  /** The first name of the user. */
  firstName: Scalars['String']['output'];
  /** Timestamp when flex feature was enabled for the userm which indicates if sp has enabled available for LMJ */
  flexEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The full name of the user. */
  fullName: Scalars['String']['output'];
  /** The gender of the user. */
  gender?: Maybe<Scalars['String']['output']>;
  /** Whether the user has any active agreements */
  hasActiveAgreement: Scalars['Boolean']['output'];
  /** Whether the user has a soft ban suspension */
  hasActiveSoftBan?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has any timesheets approved. */
  hasApprovedTimesheet?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has received the COVID-19 vaccine. */
  hasCovidVaccine?: Maybe<Scalars['Boolean']['output']>;
  /** Whether there are any pending notifications regarding fair work for the user. */
  hasFairworkPendingNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has any accepted agreement. */
  hasFirstAgreement: Scalars['Boolean']['output'];
  /** Whether the user reached the maximum number of times they can receive a verification SMS code */
  hasMaxedSmsVerificationRequests?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has the mobile app installed. */
  hasMobileApp?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has any timesheets pending that have auto-approval turned off. */
  hasPendingTimesheetsWithAutoApprovalOff: Scalars['Boolean']['output'];
  /** The Horizon One offer details for the user. */
  horizonOneOffer?: Maybe<HorizonOneOffer>;
  /** The unique identifier of the user. */
  id: Scalars['ID']['output'];
  /** Whether the user is funded by Support at Home funding. */
  isHcpFunded?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has completed the onboarding process. */
  isOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user wish to receives the emails about jobs in their area. */
  jobsInArea?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The timestamp of the user's last login via mobile.
   * @deprecated This field is no longer maintained and will always return null
   */
  lastMobileLoginAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The last name of the user, visible with an agreement. */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp of the user's last login via web.
   * @deprecated This field is no longer maintained and will always return null
   */
  lastWebLoginAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The URL for the user to access the Learning Hub. */
  learningHubAccessUrl?: Maybe<Scalars['String']['output']>;
  /** The legal first name of the user, visible only to the user themselves. */
  legalFirstName?: Maybe<Scalars['String']['output']>;
  /** The legal last name of the user, visible only to the user themselves. */
  legalLastName?: Maybe<Scalars['String']['output']>;
  /** The legal middle name of the user, visible only to the user themselves. */
  legalMiddleName?: Maybe<Scalars['String']['output']>;
  /** The middle name of the user. */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Whether the user is agency-managed under the National Disability Insurance Scheme (NDIS). */
  ndisAgencyManaged?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user is funded under the National Disability Insurance Scheme (NDIS). */
  ndisFunded?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user is part of the NDIS but not managed by the NDIA. */
  ndisNonNdia?: Maybe<Scalars['Boolean']['output']>;
  /** NDIS plan */
  ndisPlan?: Maybe<NdisPlan>;
  /** Whether the user needs to be notified of automatic sessions termination */
  needsToBeNotifiedOfAutomaticSessionsTermination: Scalars['Boolean']['output'];
  /** User work type */
  normalizedType: Scalars['String']['output'];
  /** Whether current target is opted in to carer reliability assessment */
  optInCarerReliabilityAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Organisation details */
  organisation?: Maybe<Organisation>;
  /** Original email address */
  originalEmail?: Maybe<Scalars['String']['output']>;
  /** List of participants */
  participants?: Maybe<Array<Participant>>;
  /** Tokenised credit card value from payment gateway */
  paymentToken?: Maybe<Scalars['String']['output']>;
  /** Indicates if paynow trial is enabled */
  paynowTrialEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** User's permalink */
  permalink: Scalars['String']['output'];
  /** The user's phone verification schedule. */
  phoneVerificationSchedule?: Maybe<PhoneVerificationSchedule>;
  /** postcode of address */
  postcode?: Maybe<Scalars['String']['output']>;
  /** PostCodeGeo record id */
  postcodeGeoId?: Maybe<Scalars['Int']['output']>;
  /** Previous search filter */
  previousSearch?: Maybe<Scalars['JSON']['output']>;
  /** The previous worker search this user performed, if client */
  previousSearchStructured?: Maybe<PreviousSearch>;
  /** Whether the user has a primary emergency contact */
  primaryEmergencyContact?: Maybe<Scalars['Boolean']['output']>;
  /** whether the user is privately funded */
  privatlyFunded?: Maybe<Scalars['Boolean']['output']>;
  /** User profile */
  profile?: Maybe<Profile>;
  /** Profile steps */
  profileSteps?: Maybe<Array<ProfileSteps>>;
  /** Whether current target is eligible for insurance on quickpay enabled agreements */
  quickpayInsured?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving agreements emails */
  receiveAgreementsEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving event deliveries emails */
  receiveEventDeliveriesEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving messages emails */
  receiveMessagesEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving planned session reminder emails */
  receivePlannedSessionReminderEmails: Scalars['Boolean']['output'];
  /** Opt-in for receiving SMS */
  receiveSms?: Maybe<Scalars['Boolean']['output']>;
  /** User roles */
  roles: Array<Scalars['String']['output']>;
  /** The source from which the user signed up */
  signupSource: SignUpSource;
  /** SMS verification status */
  smsVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Statutory declaration outstanding flag */
  statDecOutstanding?: Maybe<Scalars['Boolean']['output']>;
  /** state of address */
  state?: Maybe<Scalars['String']['output']>;
  /** Timezone at user's location */
  timezone: Scalars['String']['output'];
  /** Total earnings of the user */
  totalEarnings?: Maybe<Scalars['Float']['output']>;
  /** Total earnings current financial year */
  totalEarningsInCurrentFinancialYear?: Maybe<Scalars['Float']['output']>;
  /** Truncated name */
  truncatedName: Scalars['String']['output'];
  /** Short unique identifier */
  uid?: Maybe<Scalars['String']['output']>;
  /** Use preferred names for legal documents flag */
  usePreferredNamesForLegal?: Maybe<Scalars['Boolean']['output']>;
  /** Whether current target has used quickpay in any agreement in the past */
  usedQuickpay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether current target has blocked this user */
  userHasBlocked?: Maybe<Scalars['Boolean']['output']>;
  /** Whether current target is blocked by this user */
  userIsBlocked?: Maybe<Scalars['Boolean']['output']>;
  /** Universally unique identifier of the user */
  uuid?: Maybe<Scalars['String']['output']>;
  /** If user should see prompt about posting a job */
  viewedPostNewJobPrompt?: Maybe<Scalars['Boolean']['output']>;
  /** If user should see provider onboarding welcome page on login */
  viewedProviderWelcomePage?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents qualification for notification allowance reminder banner presentation on a user's mobile device */
export type NotificationAllowBanner = {
  __typename?: 'NotificationAllowBanner';
  /** Do we allow this banner for this user */
  allowBanner: Scalars['Boolean']['output'];
};

/** Autogenerated input type of OfferDeclineWithdrawFlexJobs */
export type OfferDeclineWithdrawFlexJobsInput = {
  /** Which action are we performing on the flex job */
  action: WorkerFlexJobActionOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the offer for a flex-job if making one */
  flexMatchAttributes?: InputMaybe<FlexMatchAttributes>;
  /** ID of the flex job that we are updating */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of OfferDeclineWithdrawFlexJobs */
export type OfferDeclineWithdrawFlexJobsPayload = {
  __typename?: 'OfferDeclineWithdrawFlexJobsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated Flex match response */
  flexMatch: JobMatch;
};

/** A representation of a new service Taxonomy platform service. */
export type OfferedPlatformService = {
  /** UUID of the service taxonomy Mable service an SP offers to deliver on the platform. */
  id: Scalars['Uuid']['input'];
};

/** Platform service offered by the worker */
export type OfferedPlatformServiceItem = {
  __typename?: 'OfferedPlatformServiceItem';
  /** UUID of the platform service */
  id: Scalars['String']['output'];
  /** Legacy slug identifier */
  legacySlug: Scalars['String']['output'];
  /** Display name of the service */
  name: Scalars['String']['output'];
};

/** Details of a service offered by the worker */
export type OfferedServiceItem = {
  __typename?: 'OfferedServiceItem';
  /** Description detailing the service */
  description?: Maybe<Array<Scalars['String']['output']>>;
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** Details of how much of the onboarding process is complete */
export type OnboardingCompleted = {
  __typename?: 'OnboardingCompleted';
  /** My Network */
  myNetwork?: Maybe<Scalars['String']['output']>;
  /** NDIS Plan */
  ndisPlan?: Maybe<Scalars['String']['output']>;
  /** Payment */
  payment?: Maybe<Scalars['String']['output']>;
  /** Personal Details */
  personalDetails?: Maybe<Scalars['String']['output']>;
};

/** Status of major onboarding steps */
export type OnboardingMajorStepStatus = {
  __typename?: 'OnboardingMajorStepStatus';
  /** Is the account section completed */
  account: Scalars['Boolean']['output'];
  /** Is the mandatory training section completed */
  mandatoryTraining?: Maybe<Scalars['Boolean']['output']>;
  /** Is the services section completed */
  services: Scalars['Boolean']['output'];
  /** Is the verification section completed */
  verification: Scalars['Boolean']['output'];
};

/** Overall status of the worker onboarding process */
export type OnboardingStatus = {
  __typename?: 'OnboardingStatus';
  /** Onboarding current step */
  currentStep?: Maybe<Scalars['String']['output']>;
  /** Status of major onboarding steps */
  majorStatus: OnboardingMajorStepStatus;
  /** Onboarding completion percentage */
  percentage: Scalars['Int']['output'];
  /** Status of onboarding steps */
  status: OnboardingStepStatus;
  /** Value to be updated */
  type?: Maybe<Scalars['String']['output']>;
};

/** Detail of the worker onboarding process */
export type OnboardingStepStatus = {
  __typename?: 'OnboardingStepStatus';
  /** Has the worker supplied an ABN */
  abn?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the additional training section */
  additionalTraining?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker filled in their address */
  address?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the allied health details section */
  alliedHealthDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker filled out their bio */
  bio?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed COVID training */
  covidTraining?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker filled out the COVID vaccination declaration */
  covidVaccination?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker provided an emergency contact */
  emergencyContact?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker filled out the insurance declaration */
  insuranceDeclaration?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the insurance questions */
  insuranceQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker filled out the name section */
  name?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker provided an NDIS Worker Screening Check */
  ndisWorkerScreeningCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker filled in the nursing registration details */
  nursingRegistrationDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker provided a list of nursing services offered */
  nursingServices?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker filled out the overseas residency declaration */
  overseasResidency?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker provided a list of personal care services offered */
  personalCareServices?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the personal details section */
  personalDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the police check */
  policeCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker provided any professional references */
  professionalReferences?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the professional responsibility training */
  professionalResponsibilityTraining?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker uploaded a profile photo */
  profilePhoto: Scalars['Boolean']['output'];
  /** Has the worker outlined their qualifications */
  qualifications?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker described the services they offer */
  servicesOffered?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker provided a list of SSDA services offered */
  ssdaServices?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the working-with-children section */
  workingWithChildren?: Maybe<Scalars['Boolean']['output']>;
};

/** Options for a quick reply */
export type Option = {
  __typename?: 'Option';
  /** ID of the option */
  id: Scalars['ID']['output'];
  /** Key for the option */
  key: Scalars['String']['output'];
  /** Text of a link */
  linkText: Scalars['String']['output'];
};

/** Details of an organisation that a customer belongs to - along with some details of the customer as well */
export type Organisation = {
  __typename?: 'Organisation';
  /** Business name */
  businessName?: Maybe<Scalars['String']['output']>;
  /** Coordinators that belong to this organisation */
  coordinators?: Maybe<Array<Coordinator>>;
  /** Contact email for the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** ID of the organisation */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the client linked to an organisation */
  isClientLinkedToOrg?: Maybe<Scalars['Boolean']['output']>;
  /** Is the client HCP funded */
  isHcpFunded?: Maybe<Scalars['Boolean']['output']>;
  /** Do we show the terms-popup for this organisation */
  isShowingTermPopup?: Maybe<Scalars['Boolean']['output']>;
  /** Primary contact email for the organisation */
  organisationEmail?: Maybe<Scalars['String']['output']>;
  /** Primary phone number for the organisation */
  organisationPhone?: Maybe<Scalars['String']['output']>;
  /** Contact phone number for the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Terms and conditions */
  terms?: Maybe<Scalars['String']['output']>;
  /** Website for the organisation */
  website?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Organisation. */
export type OrganisationConnection = {
  __typename?: 'OrganisationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganisationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organisation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganisationEdge = {
  __typename?: 'OrganisationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organisation>;
};

/** Requested details about an organisation (for a client) */
export type OrganisationRequest = {
  __typename?: 'OrganisationRequest';
  /** Organisation primary email */
  email?: Maybe<Scalars['String']['output']>;
  /** Organisation name */
  name?: Maybe<Scalars['String']['output']>;
  /** Organisation primary phone number */
  phone?: Maybe<Scalars['String']['output']>;
};

/** Attributes of an organisation */
export type OrganisationRequestAttribute = {
  /** Organisation primary email */
  email: Scalars['String']['input'];
  /** Organisation name */
  name: Scalars['String']['input'];
  /** Organisation primary phone number */
  phone: Scalars['String']['input'];
};

/** Fields returned after updating an organisation's terms */
export type OrganisationTerm = {
  __typename?: 'OrganisationTerm';
  /** New terms content */
  contentOfTerms?: Maybe<Scalars['String']['output']>;
  /** Email to send the updated details to */
  email?: Maybe<Scalars['String']['output']>;
  /** When was the email sent */
  emailSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the organisation */
  id?: Maybe<Scalars['ID']['output']>;
  /** Details of the organisation */
  organisation?: Maybe<Organisation>;
  /** Phone number of the organisation */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Attributes required to update the terms */
export type OrganisationTermUpdateAttributes = {
  /** New terms content */
  contentOfTerms?: InputMaybe<Scalars['String']['input']>;
  /** Email to send the updated details to */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the organisation */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Sub category values under other category */
export enum Other {
  CulturalBackgrounds = 'cultural_backgrounds',
  Interests = 'interests',
  Languages = 'languages',
  Properties = 'properties',
  Religions = 'religions'
}

/** Possible values for the overlap */
export enum Overlap {
  Full = 'full',
  Partial = 'partial'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Information about the Participant (the person receiving care) */
export type Participant = {
  __typename?: 'Participant';
  /** Details about participant's social needs */
  aboutSocialNeeds?: Maybe<Scalars['String']['output']>;
  /** Name of person managing account. Eg coordinator or relative */
  accountManagerName?: Maybe<Scalars['String']['output']>;
  /** Participant's Age */
  age?: Maybe<Scalars['Int']['output']>;
  /** Participant's birth date */
  birthDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Participant's phone */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Details about participant's cultural background */
  culturalBackgrounds?: Maybe<Array<Scalars['String']['output']>>;
  /** Diagnoses, conditions and disabilities relevant to the participant */
  diagnosesConditionsDisabilities?: Maybe<Array<Scalars['String']['output']>>;
  /** Other diagnosis information not in the provided list */
  diagnosesConditionsDisabilitiesOther?: Maybe<Scalars['String']['output']>;
  /** Participant's display-ready first name (eg 'MayLyn'). Use this everywhere a legal name is not needed. This will use preferred name or obfuscate the name if the viewer is not yet approved. */
  displayFirstName: Scalars['String']['output'];
  /** Participant's display-ready full name (eg 'MayLyn McNab'). Use this everywhere a legal name is not needed. This will use preferred name or obfuscate the name if the viewer is not yet approved. */
  displayFullName: Scalars['String']['output'];
  /** The display value for gender */
  displayGender?: Maybe<Scalars['String']['output']>;
  /** display_name has been deprecated in favour of display_full_name! Please use that instead */
  displayName: Scalars['String']['output'];
  /** Participant's display-ready first name made into the posessive case (eg "MayLyn's"). Use this everywhere a legal name is not needed. This will use preferred name or obfuscate the name if the viewer is not yet approved. */
  displayPossessiveName: Scalars['String']['output'];
  /** Participant's name with surname truncated to an initial (eg 'MayLyn M'). Use this everywhere a legal name is not needed. This will use preferred name or obfuscate the name if the viewer is not yet approved. */
  displayTruncatedName: Scalars['String']['output'];
  /** Participant's first language(s) */
  firstLanguages?: Maybe<Array<Scalars['String']['output']>>;
  /** Participant's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Participant's full legal name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** Participant's gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** ID of the participant */
  id: Scalars['ID']['output'];
  /** Any instructions the participant has for a potential carer */
  instructionsForCarer?: Maybe<Scalars['String']['output']>;
  /** Participant's interests and hobbies */
  interests?: Maybe<Array<Scalars['String']['output']>>;
  /** Participant's last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Participant's legal first name (for use on legal documents eg invoices) */
  legalFirstName?: Maybe<Scalars['String']['output']>;
  /** Participant's full legal name (for use on legal documents eg invoices) */
  legalFullName?: Maybe<Scalars['String']['output']>;
  /** Participant's legal last name (for use on legal documents eg invoices) */
  legalLastName?: Maybe<Scalars['String']['output']>;
  /** Any medical concerns the participant may wish to share */
  medicalConcerns?: Maybe<Array<Scalars['String']['output']>>;
  /** Medication relevant to taking care of the participant */
  medicationJson?: Maybe<Array<MedicationJson>>;
  /** Is this participant a minor (<18) */
  minor: Scalars['Boolean']['output'];
  /** Main postcode for the participant */
  postcode?: Maybe<Scalars['String']['output']>;
  /** Participant's preferred name */
  preferredName?: Maybe<Scalars['String']['output']>;
  /** Participant's address */
  shortAddress: Scalars['String']['output'];
  /** Participant's suburb */
  suburbName?: Maybe<Scalars['String']['output']>;
  /** Participant's truncated name */
  truncatedName?: Maybe<Scalars['String']['output']>;
  /** Is this participant object valid */
  valid: Scalars['Boolean']['output'];
};

/** Age-groups for the participant of a posted job eg baby/teen/aged */
export enum ParticipantAgeGroup {
  /** 65+ */
  Aged = 'aged',
  /** 0-5 */
  Baby = 'baby',
  /** 5-12 */
  GradeSchooler = 'grade_schooler',
  /** 26-45 */
  MiddleAgedAdult = 'middle_aged_adult',
  /** 46-65 */
  OldAdult = 'old_adult',
  /** 13-18 */
  Teen = 'teen',
  /** 19-25 */
  YoungAdult = 'young_adult'
}

/** Information about the Participant (the person receiving care) */
export type ParticipantAttribute = {
  /** Social needs of the participant */
  aboutSocialNeeds?: InputMaybe<Scalars['String']['input']>;
  /** Date-of-birth of the participant */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the participant */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Relevant cultural background(s) of the participant */
  culturalBackgrounds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Diagnoses, conditions and disabilities relevant to the participant */
  diagnosesConditionsDisabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Other diagnosis information not in the provided list */
  diagnosesConditionsDisabilitiesOther?: InputMaybe<Scalars['String']['input']>;
  /** Native languages of the participant */
  firstLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** First name of the participant */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the participant */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** ID of the participant */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Relevant instructions for the carer */
  instructionsForCarer?: InputMaybe<Scalars['String']['input']>;
  /** Interests/hobbies of the participant */
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Last name of the participant */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Relevant medical concerns */
  medicalConcerns?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Medication(s) the participant is on */
  medicationJson?: InputMaybe<Array<MedicationJsonAttribute>>;
  /** Preferred name for the participant */
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

/** Details of an individual payment transaction */
export type Payment = {
  __typename?: 'Payment';
  /** Payment amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Shift end (from timesheet) */
  deliveredEndTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Shift start (from timesheet) */
  deliveredStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Description of the payment */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether payment is incoming or outgoing */
  direction?: Maybe<Scalars['String']['output']>;
  /** event_delivery (timesheet) ID associated with the payment */
  eventId?: Maybe<Scalars['ID']['output']>;
  /** ID of the payment */
  id: Scalars['ID']['output'];
  /** Date payment was paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for Payment. */
export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Payment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Payment>;
};

/** Stores response from spreedly saying if this payment-method is valid or not */
export type PaymentMethodValid = {
  __typename?: 'PaymentMethodValid';
  /** Is this payment-method considered valid */
  paymentMethodValid: Scalars['Boolean']['output'];
};

/** Status of whether the PayNow modal has been shown (show, dismissed, disabled) */
export enum PaynowModalStatusOptions {
  /** Disabled Paynow Modal */
  Disabled = 'disabled',
  /** Dismissed Paynow Modal */
  Dismissed = 'dismissed',
  /** Show Paynow Modal */
  Show = 'show'
}

/** Details of a Paynow remittance */
export type PaynowRemittance = {
  __typename?: 'PaynowRemittance';
  /** Related timesheets */
  eventDeliveries?: Maybe<Array<EventDelivery>>;
  /** ID of the remittance */
  id?: Maybe<Scalars['ID']['output']>;
  /** Invoice linked to the remittance */
  invoice?: Maybe<Invoice>;
  /** When was this remittance paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** What percentage of fees has been charged for Paynow */
  paynowFeePercentage: Scalars['String']['output'];
  /** When was this remittance requested */
  requestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Total amount invoicable */
  totalInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  /** Net amount invoicable */
  totalNetAmount?: Maybe<Scalars['Float']['output']>;
  /** Total paynow fee chargable */
  totalPaynowFee?: Maybe<Scalars['Float']['output']>;
  /** Type of the remittance */
  type?: Maybe<Scalars['String']['output']>;
};

/** Details of an per km rate that could be applied to an agreement through agreed rate */
export type PerKmRateAttributes = {
  /** Rate charged in cents */
  rateCents: Scalars['Int']['input'];
  /** ID of NDIS Service Category/Mable Service this relates to */
  serviceCategoryableId: Scalars['ID']['input'];
  /** Type of NDIS Service Category/Mable Service this relates to */
  serviceCategoryableType: Scalars['String']['input'];
};

/** Returns result of a check for whether the per-km rate is within acceptable bounds */
export type PerKmRateValid = {
  __typename?: 'PerKmRateValid';
  /** Message about the validity of the rate */
  message?: Maybe<Scalars['String']['output']>;
  /** Is this rate valid */
  perKmRateValid: Scalars['Boolean']['output'];
};

/** Category of the worker's personality eg 'Outgoing and engaging' */
export type Personality = {
  __typename?: 'Personality';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** Details for a phonecall */
export type PhoneCall = {
  __typename?: 'PhoneCall';
  /** user info */
  caller?: Maybe<User>;
  /** Contact numbers during this phonecall */
  contactNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Conversation between the parties of the phonecall */
  conversation?: Maybe<Conversation>;
  /** Number called during this phonecall */
  recipientNumber?: Maybe<Scalars['String']['output']>;
  /** Expire time of current twilio proxy session */
  sessionExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Details about a user about to be blocked */
export type PhoneCallsBlock = {
  /** ID of the user to be blocked for phone calls */
  blockedUserId: Scalars['ID']['input'];
  /** Detailed comment explaining why this user is being blocked */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Reason-category for why this user is being blocked */
  reason?: InputMaybe<PhoneCallsBlockReasons>;
};

/** Why is this phonecall being blocked */
export enum PhoneCallsBlockReasons {
  /** Inappropriate conduct */
  InappropriateConduct = 'inappropriate_conduct',
  /** Offensive conduct */
  OffensiveConduct = 'offensive_conduct',
  /** Other */
  Other = 'other',
  /** Persistent calling */
  PersistentCalling = 'persistent_calling',
  /** Persistent messaging */
  PersistentMessaging = 'persistent_messaging',
  /** Safety concerns */
  SafetyConcerns = 'safety_concerns',
  /** Unprofessional behaviour */
  UnprofessionalBehaviour = 'unprofessional_behaviour'
}

/** Details about validity of phone (eg when checking if the number has been banned) */
export type PhoneValid = {
  __typename?: 'PhoneValid';
  /** Is this phone number valid */
  phoneValid: Scalars['Boolean']['output'];
};

/** A schedule for phone verification */
export type PhoneVerificationSchedule = {
  __typename?: 'PhoneVerificationSchedule';
  /** Whether the schedule is expired */
  expired: Scalars['Boolean']['output'];
  /** The date of the schedule */
  scheduleDate: Scalars['ISO8601Date']['output'];
  /** The time slot for the phone verification. It can be morning or afternoon */
  timeSlot: Scalars['String']['output'];
};

/** Attributes for creating or updating a phone verification schedule */
export type PhoneVerificationScheduleAttributes = {
  /** The date for the phone verification */
  scheduleDate: Scalars['ISO8601Date']['input'];
  /** The preferred time slot for the phone verification */
  timeSlot: PhoneVerificationScheduleTimeSlot;
};

/** Represents different time slots available for phone verification scheduling. */
export enum PhoneVerificationScheduleTimeSlot {
  /** 12 PM to 5 PM */
  Afternoon = 'afternoon',
  /** 9 AM to 11:59 AM */
  Morning = 'morning'
}

/** Agreed NDIS support items in an agreement */
export type PlanSupportItem = {
  __typename?: 'PlanSupportItem';
  /** ID of the plan-support-item */
  id: Scalars['ID']['output'];
  /** Name of the plan-support-item */
  name: Scalars['String']['output'];
};

/** Represents a support-session that has been scheduled in the calendar */
export type PlannedSupportSession = {
  __typename?: 'PlannedSupportSession';
  /** ID of the agreement this session falls under */
  agreementId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when this session was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description of the planned session */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the session */
  id: Scalars['ID']['output'];
  /** Timesheets (event_deliveries) for this session */
  supportHours?: Maybe<Array<EventDelivery>>;
  /** Title of the session */
  title?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this session was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Details of a planned support-session */
export type PlannedSupportSessionAttributes = {
  /** Description of the support session */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Title of the support session */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes of the police check status for a worker */
export type PoliceCheck = {
  __typename?: 'PoliceCheck';
  /** Do we allow a user to BYO their police-check from another organisation */
  byoEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** URL of the BYO police check */
  checkedByoUrl?: Maybe<Scalars['String']['output']>;
  /** Status of the check */
  checkedStatus?: Maybe<CheckedCheckStatusOptions>;
  /** Type of check */
  checkedType?: Maybe<CheckedCheckTypeOptions>;
  /** URL to fetch the check */
  checkedUrl?: Maybe<Scalars['String']['output']>;
  /** Is the police-check expired */
  expired?: Maybe<Scalars['Boolean']['output']>;
  /** Is the police-check expired or expiring soon */
  renewalDue?: Maybe<Scalars['Boolean']['output']>;
};

/** Details of a police check declaration */
export type PoliceCheckDeclaration = {
  __typename?: 'PoliceCheckDeclaration';
  /** Does the police check allow unsupervised contact */
  byoAllowedUnsupervisedContact: Scalars['Boolean']['output'];
  /** Was the police check from a supported provider */
  byoFromSupportedProvider: Scalars['Boolean']['output'];
  /** Has this user passed a police check */
  byoPoliceCheck: Scalars['Boolean']['output'];
};

/** Details of a police check */
export type PoliceCheckDeclarationAttributes = {
  /** Does the police check allow unsupervised contact */
  byoAllowedUnsupervisedContact: Scalars['Boolean']['input'];
  /** Was the police check from a supported provider */
  byoFromSupportedProvider: Scalars['Boolean']['input'];
  /** Has this user passed a police check */
  byoPoliceCheck: Scalars['Boolean']['input'];
};

/** Fields for the posted job object */
export type PostedJob = {
  __typename?: 'PostedJob';
  /** Indicates if the job is viewable to the public - some jobs need to be manually approved by Mable */
  approved: Scalars['Boolean']['output'];
  /** Badges of the job */
  badges?: Maybe<PostedJobBadge>;
  /** Description of the carer associated with this job */
  carerDescription?: Maybe<Scalars['String']['output']>;
  /** Client who posted the job */
  client: User;
  /** Fields of the client that posted the job */
  clientFields?: Maybe<JobClientFields>;
  /** Description of the consumer/client associated with this job */
  consumerDescription?: Maybe<Scalars['String']['output']>;
  /** Days-of-the-week requested for this job */
  days?: Maybe<PostedJobDay>;
  /** Estimated hours per period required to satisfy this job eg four hours per month */
  estimatedHoursPerPeriod?: Maybe<Scalars['Float']['output']>;
  /** Estimated hours per week required to satisfy this job */
  estimatedHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  /** ID of the service recommendation process-object the customer went through when posting this job (if any) */
  expressJobSelectionsId?: Maybe<Scalars['ID']['output']>;
  /** Frequency of Job (eg ongoing/once_off) */
  frequency?: Maybe<PostedJobFrequencyOptions>;
  /** Hours-of-the-day required for this job */
  hours?: Maybe<PostedJobsHours>;
  /** The descriptive version of hours (eg 'Less than 5 hours per week') */
  hoursDescription?: Maybe<Scalars['String']['output']>;
  /** Whose equipment will be used */
  houseworkEquipment?: Maybe<PostedJobHouseworkEquipment>;
  /** List of housework to be done */
  houseworkKind?: Maybe<Array<PostedJobHousework>>;
  /** ID of the job */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether this job is eligible for instant booking based on client payment and funding status */
  isInstantBookAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Detailed description of what this job entails */
  jobDescription?: Maybe<Scalars['String']['output']>;
  /** Kind of job - public/private/flex */
  jobKind: JobKind;
  /** Job sessions that the client created for this job */
  jobSessions?: Maybe<Array<JobSession>>;
  /** Location of the job */
  location: Location;
  /** Has the client indicated they're open to working with a team of workers */
  openToTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Where the job is being created from */
  origin?: Maybe<Scalars['String']['output']>;
  /** Associated parent-job of this job (eg when a job has been copied/pasted as a new job) */
  parentJobId?: Maybe<Scalars['ID']['output']>;
  /** This is the person receiving the support - may differ from the client eg the client may be posting on behalf of their child/parent who is the participant */
  participant?: Maybe<Participant>;
  /** Preferred worker attributes */
  preferredWorker: PreferredWorker;
  /** Number of workers who have applied for the job */
  requestersCount: Scalars['Int']['output'];
  /** Scheduled Event derived unique ID - when job is created from a calendar event */
  scheduledEventDerivedUniqueId?: Maybe<Scalars['String']['output']>;
  /** ScheduledEventOccurrence.id - when job is created from a calendar event */
  scheduledEventOccurrenceId?: Maybe<Scalars['ID']['output']>;
  /** Scheduling of Job */
  scheduling?: Maybe<PostedJobSchedulingOptions>;
  /** Services the client searched before creating this job */
  searchedServices?: Maybe<Array<Scalars['String']['output']>>;
  /** Service categories that this job will cover */
  serviceCategories?: Maybe<Array<ServiceCategory>>;
  /** Additional details of each service for this job */
  serviceDetails?: Maybe<PostedJobServiceDetails>;
  /** Frequency of the job (weekly, fortnightly, monthly) */
  sessionFrequency?: Maybe<PostedJobSessionFrequencyOptions>;
  /** Detailed description of the session frequency */
  sessionFrequencyDescription?: Maybe<Scalars['String']['output']>;
  /** Where the job creation was initiated from (eg a holiday_banner or the ready-made-jobs CTA) */
  source?: Maybe<Scalars['String']['output']>;
  /** Status of the job - for client and worker */
  status: JobStatus;
  /** ID of the support-activity process-object the customer went through when posting this job (if any) */
  supportActivityId?: Maybe<Scalars['ID']['output']>;
  /** Summary of support details */
  supportDetails?: Maybe<Array<JobSupportDetails>>;
  /** The kind of setting the support will be provided eg company/outdoors/sports */
  supportKind?: Maybe<Array<PostedJobSupport>>;
  /** Location where the support will take place eg home/community/both */
  supportLocation?: Maybe<PostedJobSupportLocation>;
  /** How many sessions of support are needed per period */
  supportSessionsPerPeriod?: Maybe<Scalars['Int']['output']>;
  /** How many sessions of support are needed per week */
  supportSessionsPerWeek?: Maybe<Scalars['Int']['output']>;
  /** ID of the terminated agreement this job was spawned from */
  terminatedAgreementId?: Maybe<Scalars['ID']['output']>;
  /** Timestamps for job created/updated etc */
  timestamps?: Maybe<JobTimestamps>;
  /** Detailed descrition of the timing of the job */
  timingDescription?: Maybe<Scalars['String']['output']>;
  /** Short title describing the job */
  title?: Maybe<Scalars['String']['output']>;
  /** What kind of transport is required */
  transportKind?: Maybe<Array<PostedJobTransport>>;
  /** Destination of the transport */
  transportLocation?: Maybe<Array<PostedJobTransportLocation>>;
  /** UUID of the job */
  uuid?: Maybe<Scalars['String']['output']>;
  /** Whose vehicle will be used for transport */
  vehicleRequirement?: Maybe<PostedJobVehicleRequirement>;
  /** Any further details needed for the vehicle used */
  vehicleRequirementDetails?: Maybe<Scalars['String']['output']>;
  /** Fields of the worker linked to this job */
  workerFields?: Maybe<JobWorkerFields>;
};

/** Answers if admin kind */
export enum PostedJobAdminKind {
  Appointments = 'appointments',
  Bills = 'bills',
  Other = 'other',
  Paperwork = 'paperwork',
  Skills = 'skills',
  With = 'with'
}

/** Advanced search filters - at this stage just gender */
export type PostedJobAdvancedFilterAttributes = {
  /** Filter by gender preference */
  gender?: InputMaybe<Array<PostedJobsGenderPref>>;
};

/** Actions customers can apply to a posted job */
export type PostedJobAllowedActions = {
  __typename?: 'PostedJobAllowedActions';
  /** Archive a job */
  archive: Scalars['Boolean']['output'];
  /** Decline a job (worker) */
  decline: Scalars['Boolean']['output'];
  /** Reply to a job */
  reply: Scalars['Boolean']['output'];
  /** Report a job */
  report: Scalars['Boolean']['output'];
};

/** Data summarising a job to be displayed on the front end */
export type PostedJobBadge = {
  __typename?: 'PostedJobBadge';
  /** Days */
  days?: Maybe<Scalars['String']['output']>;
  /** Details */
  details?: Maybe<Array<Scalars['String']['output']>>;
  /** Hours */
  hours?: Maybe<Scalars['String']['output']>;
  /** Organisation */
  organisation?: Maybe<Scalars['String']['output']>;
  /** Summary */
  summary?: Maybe<Array<Scalars['String']['output']>>;
};

/** Filters a client can use on the list of jobs */
export enum PostedJobClientFilterOptions {
  /** All current, archived and private jobs */
  All = 'all',
  /** Archived jobs */
  Archived = 'archived',
  /** Current jobs */
  Current = 'current',
  /** All flex jobs */
  Flex = 'flex',
  /** Archived flex jobs */
  FlexArchived = 'flex_archived',
  /** Current flex jobs */
  FlexCurrent = 'flex_current',
  /** Pending flex jobs */
  FlexPending = 'flex_pending',
  /** Pending jobs */
  Pending = 'pending',
  /** All private jobs */
  Private = 'private',
  /** Archived private jobs */
  PrivateArchived = 'private_archived',
  /** Current private jobs */
  PrivateCurrent = 'private_current',
  /** Pending private jobs */
  PrivatePending = 'private_pending'
}

/** Client-facing state of the posted job (used internally) */
export enum PostedJobClientStateOptions {
  /** archived */
  Archived = 'archived',
  /** cancelled */
  Cancelled = 'cancelled',
  /** expired */
  Expired = 'expired',
  /** expiring_soon */
  ExpiringSoon = 'expiring_soon',
  /** fulfilled */
  Fulfilled = 'fulfilled',
  /** pending */
  Pending = 'pending'
}

/** Client-facing status of the posted job (viewable by the client) */
export enum PostedJobClientStatusOptions {
  /** Archived */
  Archived = 'archived',
  /** Cancelled */
  Cancelled = 'cancelled',
  /** Expired */
  Expired = 'expired',
  /** Filled */
  Fulfilled = 'fulfilled',
  /** Open */
  Open = 'open'
}

/** The connection type for PostedJob. */
export type PostedJobConnection = {
  __typename?: 'PostedJobConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PostedJobEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PostedJob>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** CRUD actions allowed to be to performed on a posted job */
export enum PostedJobCreateUpdateActionOptions {
  /** Create a public, private or last-minute job */
  Create = 'create',
  /** New job object. Does not persist in DB */
  New = 'new',
  /** Update an existing job */
  Update = 'update'
}

/** Autogenerated input type of PostedJobCreateUpdate */
export type PostedJobCreateUpdateInput = {
  /** Name of the action we are performing on this job - create/update/new */
  action: PostedJobCreateUpdateActionOptions;
  /** New attribute values of the job */
  attributes?: InputMaybe<PostedJobStandardAttributes>;
  /** ID of the coordinator managed client */
  clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the posted job to alter */
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of PostedJobCreateUpdate */
export type PostedJobCreateUpdatePayload = {
  __typename?: 'PostedJobCreateUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The PostedJob we're manipulating */
  postedJob?: Maybe<PostedJob>;
};

/** Clients indicate days they are available for a job, including these fields */
export type PostedJobDay = {
  __typename?: 'PostedJobDay';
  /** An array containing actual days and times requested */
  details?: Maybe<Array<Day>>;
  /** A summary of requested days eg "Mondays, Tuesdays and Wednesdays" */
  summary?: Maybe<Scalars['String']['output']>;
  /** An array of required days and times eg ['required_monday_afternoon', 'required_tuesday_morning'] */
  times?: Maybe<Array<Scalars['String']['output']>>;
};

/** Which days is the client available for this job */
export type PostedJobDaysRequired = {
  fridayTimes?: InputMaybe<PostedJobTimesRequired>;
  mondayTimes?: InputMaybe<PostedJobTimesRequired>;
  saturdayTimes?: InputMaybe<PostedJobTimesRequired>;
  sundayTimes?: InputMaybe<PostedJobTimesRequired>;
  thursdayTimes?: InputMaybe<PostedJobTimesRequired>;
  tuesdayTimes?: InputMaybe<PostedJobTimesRequired>;
  wednesdayTimes?: InputMaybe<PostedJobTimesRequired>;
};

/** Answers of dietary requirements */
export enum PostedJobDietaryRequirements {
  DairyFree = 'dairy_free',
  EggFree = 'egg_free',
  Fodmap = 'fodmap',
  GlutenFree = 'gluten_free',
  Halal = 'halal',
  Kosher = 'kosher',
  NutFree = 'nut_free',
  Other = 'other',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian'
}

/** An edge in a connection. */
export type PostedJobEdge = {
  __typename?: 'PostedJobEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PostedJob>;
};

/** Attributes specific to a flex (last minute) job - used when it's being created/updated */
export type PostedJobFlexAttributes = {
  /** Description of attributes wanted in the carer */
  carerDescription?: InputMaybe<Scalars['String']['input']>;
  /** Description of the client */
  consumerDescription?: InputMaybe<Scalars['String']['input']>;
  /** When the job is to end */
  endTime: Scalars['String']['input'];
  /** Description of what the carer needs to do to fulfil this job */
  jobDescription: Scalars['String']['input'];
  /** Where the job is being created from */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** ID of the participant of this job (may differ from the job-poster) */
  participantId?: InputMaybe<Scalars['ID']['input']>;
  /** The derived unique id of the virtual scheduled event that was used to populate the job */
  scheduledEventDerivedUniqueId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the scheduled event occurrence that was used to populate the job */
  scheduledEventOccurrenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Search filters used to narrow the list of possible workers */
  searchFilter: PostedJobSearchFilterAttribute;
  /** Where the job creation was initiated from */
  source?: InputMaybe<Scalars['String']['input']>;
  /** When the job is to start */
  startTime: Scalars['String']['input'];
  /** Offset to UTC time in integer */
  timezoneOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Descriptive title of the job */
  title: Scalars['String']['input'];
};

/** Frequency options for a posted job - whether ongoing or once-off job */
export enum PostedJobFrequencyOptions {
  /** once_off */
  OnceOff = 'once_off',
  /** ongoing */
  Ongoing = 'ongoing'
}

/** Fulfil and cancel allow a reason - which has an option-type which must belong to this set */
export enum PostedJobFulfilCancelReasonOptions {
  /** I don't need any more applicants */
  CancelledEnoughApplicants = 'cancelled_enough_applicants',
  /** I made a mistake */
  CancelledMistake = 'cancelled_mistake',
  /** I no longer require support */
  CancelledNotRequired = 'cancelled_not_required',
  /** I found a worker somewhere else */
  CancelledOffPlatform = 'cancelled_off_platform',
  /** I found a worker on Mable */
  CancelledOnPlatform = 'cancelled_on_platform',
  /** It hasn't been filled yet, but I already have enough applicants */
  FulfilledEnoughApplicants = 'fulfilled_enough_applicants',
  /** I made a mistake */
  FulfilledMistake = 'fulfilled_mistake',
  /** I found a worker somewhere else */
  FulfilledOffPlatform = 'fulfilled_off_platform',
  /** I found a worker on Mable */
  FulfilledOnPlatform = 'fulfilled_on_platform'
}

/** Answers for gardening equipment */
export enum PostedJobGardeningEquipment {
  Clients = 'clients',
  Unsure = 'unsure',
  Workers = 'workers'
}

/** Answers for gardening work */
export enum PostedJobGardeningKind {
  Hedge = 'hedge',
  Lawn = 'lawn',
  Other = 'other',
  Skills = 'skills',
  Tidying = 'tidying',
  Watering = 'watering',
  Weeding = 'weeding',
  With = 'with'
}

/** Types of housework to be done by worker */
export enum PostedJobHousework {
  Bathroom = 'bathroom',
  Bed = 'bed',
  Dishwashing = 'dishwashing',
  Laundry = 'laundry',
  Mopping = 'mopping',
  Other = 'other',
  Skills = 'skills',
  Tidying = 'tidying',
  Vacuuming = 'vacuuming'
}

/** Household equipment types (whether worker will bring or use client equipment) */
export enum PostedJobHouseworkEquipment {
  Clients = 'clients',
  Unsure = 'unsure',
  Workers = 'workers'
}

/** Options for posted job kind: eg whether Public/Private/Flex or SupportNeed */
export enum PostedJobKindOptions {
  /** flex */
  Flex = 'flex',
  /** private */
  Private = 'private',
  /** public */
  Public = 'public'
}

/** Answers for maintenance equipment */
export enum PostedJobMaintenanceEquipment {
  Clients = 'clients',
  Unsure = 'unsure',
  Workers = 'workers'
}

/** Answers for maintenance */
export enum PostedJobMaintenanceKind {
  Damage = 'damage',
  Furniture = 'furniture',
  Gutters = 'gutters',
  LightBulbs = 'light_bulbs',
  Other = 'other',
  SmokeDetectors = 'smoke_detectors',
  Upkeep = 'upkeep'
}

/** Answers of meal kind */
export enum PostedJobMealKind {
  Delivery = 'delivery',
  Freezer = 'freezer',
  Fresh = 'fresh',
  Other = 'other',
  Planning = 'planning',
  Shopping = 'shopping',
  Skills = 'skills',
  With = 'with'
}

/** Answers for mobility kind */
export enum PostedJobMobilityKind {
  Hoist = 'hoist',
  Manual = 'manual'
}

/** Why is this job being blocked/unblocked */
export enum PostedJobReportReasons {
  /** Offering work outside of platform */
  Backdoor = 'backdoor',
  /** Other content unsuitable for this platform */
  Other = 'other',
  /** Contains offensive language */
  Profanity = 'profanity',
  /** Organisation looking to recruit */
  Recruitment = 'recruitment'
}

/** Job scheduling types eg whether flexible/specific times */
export enum PostedJobSchedulingOptions {
  /** flexible */
  Flexible = 'flexible',
  /** specific */
  Specific = 'specific'
}

/** Filter pre-sets used to restrict a set of searched jobs */
export type PostedJobSearchFilterAttribute = {
  /** Filter jobs using the given advanced filter-set (supplied in another field) */
  advanced?: InputMaybe<PostedJobAdvancedFilterAttributes>;
  /** The simplest search - all jobs */
  basicSearch?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter jobs by suburb in the location */
  suburb?: InputMaybe<SuburbSearchAttributes>;
};

/** The details of each selected service */
export type PostedJobServiceDetails = {
  __typename?: 'PostedJobServiceDetails';
  /** What kind of administration activities to do */
  adminKind?: Maybe<Array<PostedJobAdminKind>>;
  /** Dietary requirements for the client */
  dietaryRequirements?: Maybe<Array<PostedJobDietaryRequirements>>;
  /** Whose equipment will be used */
  gardeningEquipment?: Maybe<Array<PostedJobGardeningEquipment>>;
  /** What kinds of gardening activities to do */
  gardeningKind?: Maybe<Array<PostedJobGardeningKind>>;
  /** Whose equipment will be used */
  maintenanceEquipment?: Maybe<Array<PostedJobMaintenanceEquipment>>;
  /** What kind of maintenance activities to do */
  maintenanceKind?: Maybe<Array<PostedJobMaintenanceKind>>;
  /** What kinds of meal activities to do */
  mealKind?: Maybe<Array<PostedJobMealKind>>;
  /** What kind of mobility support is required */
  mobilityKind?: Maybe<Array<PostedJobMobilityKind>>;
  /** How many people will be needed to transfer */
  transferCount?: Maybe<Array<PostedJobTransferCount>>;
  /** What kinds of transfer equipment to use */
  transferEquipment?: Maybe<Array<PostedJobTransferEquipment>>;
  /** What kinds of transfer activities to do */
  transferKind?: Maybe<Array<PostedJobTransferKind>>;
};

/** The details of each selected service from the posted job flow */
export type PostedJobServiceDetailsInput = {
  /** What kind of administration activities to do */
  adminKind?: InputMaybe<Array<PostedJobAdminKind>>;
  /** Dietary requirements for the client */
  dietaryRequirements?: InputMaybe<Array<PostedJobDietaryRequirements>>;
  /** Whose equipment will be used */
  gardeningEquipment?: InputMaybe<Array<PostedJobGardeningEquipment>>;
  /** What kinds of gardening activities to do */
  gardeningKind?: InputMaybe<Array<PostedJobGardeningKind>>;
  /** Whose equipment will be used */
  maintenanceEquipment?: InputMaybe<Array<PostedJobMaintenanceEquipment>>;
  /** What kind of maintenance activities to do */
  maintenanceKind?: InputMaybe<Array<PostedJobMaintenanceKind>>;
  /** What kinds of meal activities to do */
  mealKind?: InputMaybe<Array<PostedJobMealKind>>;
  /** What kind of mobility support is required */
  mobilityKind?: InputMaybe<Array<PostedJobMobilityKind>>;
  /** How many people will be needed to transfer */
  transferCount?: InputMaybe<Array<PostedJobTransferCount>>;
  /** What kinds of transfer equipment to use */
  transferEquipment?: InputMaybe<Array<PostedJobTransferEquipment>>;
  /** What kinds of transfer activities to do */
  transferKind?: InputMaybe<Array<PostedJobTransferKind>>;
};

/** Session frequency options for a posted job - whether weekly, fortnightly or monthly */
export enum PostedJobSessionFrequencyOptions {
  /** fortnight */
  Fortnight = 'fortnight',
  /** month */
  Month = 'month',
  /** once_off */
  OnceOff = 'once_off',
  /** week */
  Week = 'week'
}

/** Order of posted jobs with respect to post date */
export enum PostedJobSortOrder {
  /** Ascending */
  Asc = 'asc',
  /** Descending */
  Desc = 'desc'
}

/** Standard set of attributes for a posted job */
export type PostedJobStandardAttributes = {
  /** Description of what the client wants in a potential carer */
  carerDescription?: InputMaybe<Scalars['String']['input']>;
  /** Description of the client and their needs */
  consumerDescription?: InputMaybe<Scalars['String']['input']>;
  /** Days and times the client is available for this job */
  daysAndTimes?: InputMaybe<PostedJobDaysRequired>;
  /** Estimated number of hours per period the client needs the job to be done */
  estimatedHoursPerPeriod?: InputMaybe<Scalars['Float']['input']>;
  /** Estimated number of hours per week the client needs the job to be done */
  estimatedHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  /** Id of the service recommendation when posting express jobs */
  expressJobSelectionsId?: InputMaybe<Scalars['ID']['input']>;
  /** Frequency of the job (per week) */
  frequency?: InputMaybe<PostedJobFrequencyOptions>;
  /** Client hours of availability for the job */
  hours?: InputMaybe<PostedJobsHours>;
  /** Whose equipment will be used for housework */
  houseworkEquipment?: InputMaybe<PostedJobHouseworkEquipment>;
  /** What kind of housework needs doing */
  houseworkKind?: InputMaybe<Array<PostedJobHousework>>;
  /** Description of what the job will entail */
  jobDescription: Scalars['String']['input'];
  /** ID of the user draft that we created this job from */
  jobDraftId?: InputMaybe<Scalars['ID']['input']>;
  /** Attributes for job-sessions related to this job */
  jobSessions?: InputMaybe<Array<JobSessionAttributes>>;
  /** Job kind eg public/private/flex */
  kind: PostedJobKindOptions;
  /** Client is open to working with a team rather than a single worker */
  openToTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Where the job is being created from */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Parent job if this is a copy of another */
  parentJobId?: InputMaybe<Scalars['ID']['input']>;
  /** Participant ID if differing from the person that created the job (eg parent on behalf of child) */
  participantId?: InputMaybe<Scalars['ID']['input']>;
  /** Derived unique ID for the scheduled event that this job is going to replace */
  scheduledEventDerivedUniqueId?: InputMaybe<Scalars['String']['input']>;
  /** ScheduledEventOccurrence ID for the scheduled event that this job is going to replace */
  scheduledEventOccurrenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Job scheduling types eg whether flexible/specific times */
  scheduling?: InputMaybe<PostedJobSchedulingOptions>;
  /** Extra search filters pertaining to this job (eg gender prefs) */
  searchFilter: PostedJobSearchFilterAttribute;
  /** Additional details of each service for this job */
  serviceDetails?: InputMaybe<PostedJobServiceDetailsInput>;
  /** Frequency of the job (weekly, fortnightly, monthly)  */
  sessionFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Where the job creation was initiated from */
  source?: InputMaybe<Scalars['String']['input']>;
  /** When the job is to start */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** ID of the support activity used to build the draft for this job */
  supportActivityId?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of setting the support will be provided */
  supportKind?: InputMaybe<Array<PostedJobSupport>>;
  /** Locations where support will take place eg home/community/both */
  supportLocation?: InputMaybe<PostedJobSupportLocation>;
  /** How many support sessions does the client want per period eg two sessions per week */
  supportSessionsPerPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** How many support sessions does the client want per week */
  supportSessionsPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the terminated agreement this job was spawned from */
  terminatedAgreementId?: InputMaybe<Scalars['ID']['input']>;
  /** Description of the timing of this job */
  timingDescription?: InputMaybe<Scalars['String']['input']>;
  /** Descriptive title for this job */
  title: Scalars['String']['input'];
  /** Kind of transport required */
  transportKind?: InputMaybe<Array<PostedJobTransport>>;
  /** Destination of the transport */
  transportLocation?: InputMaybe<Array<PostedJobTransportLocation>>;
  /** Vehicle requirements - whether clients or workers car */
  vehicleRequirement?: InputMaybe<PostedJobVehicleRequirement>;
  /** Vehicle requirements details (eg big enough to hold walker/chair) */
  vehicleRequirementDetails?: InputMaybe<Scalars['String']['input']>;
};

/** Job states */
export enum PostedJobStateOptions {
  Approved = 'approved',
  Authorised = 'authorised',
  Expired = 'expired',
  ExpiringSoon = 'expiring_soon',
  Pulled = 'pulled',
  Unapproved = 'unapproved'
}

/** The kind of setting the support will be provided eg company, outdoors, sports */
export enum PostedJobSupport {
  Company = 'company',
  Interest = 'interest',
  Learning = 'learning',
  Other = 'other',
  Outdoors = 'outdoors',
  Skills = 'skills',
  Social = 'social',
  Sports = 'sports'
}

/** Locations where support will take place eg home/community/both */
export enum PostedJobSupportLocation {
  Both = 'both',
  Community = 'community',
  Home = 'home',
  Unsure = 'unsure'
}

/** At what times is the client available for this job */
export type PostedJobTimesRequired = {
  /** Afternoon hours */
  afternoon?: InputMaybe<Scalars['Boolean']['input']>;
  /** Evening hours */
  evening?: InputMaybe<Scalars['Boolean']['input']>;
  /** Morning hours */
  morning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Answers for transfer count */
export enum PostedJobTransferCount {
  One = 'one',
  Two = 'two',
  Unsure = 'unsure'
}

/** Answers for transfer equipment */
export enum PostedJobTransferEquipment {
  Board = 'board',
  FullHoist = 'full_hoist',
  None = 'none',
  Other = 'other',
  StandingHoist = 'standing_hoist',
  Walker = 'walker',
  Wheelchair = 'wheelchair'
}

/** Answers for transfer kind */
export enum PostedJobTransferKind {
  Bed = 'bed',
  Chairs = 'chairs',
  Other = 'other',
  Shower = 'shower',
  Toilet = 'toilet',
  Vehicles = 'vehicles'
}

/** Kind of transport required */
export enum PostedJobTransport {
  Clients = 'clients',
  Other = 'other',
  Public = 'public',
  Skills = 'skills',
  Workers = 'workers'
}

/** Destination of the transport */
export enum PostedJobTransportLocation {
  Appointments = 'appointments',
  Other = 'other',
  Shopping = 'shopping',
  Social = 'social',
  Work = 'work'
}

/** Vehicle requirements - whether clients or workers car */
export enum PostedJobVehicleRequirement {
  No = 'no',
  Unsure = 'unsure',
  Yes = 'yes'
}

/** Status of job based on workers-activity on job eg offer-sent */
export enum PostedJobWorkerStatusOptions {
  /** accepted */
  Accepted = 'accepted',
  /** Archived */
  Archived = 'archived',
  /** declined */
  Declined = 'declined',
  /** Not Available */
  NotAvailable = 'not_available',
  /** Not Interested */
  NotInterested = 'not_interested',
  /** offer sent */
  Offered = 'offered',
  /** Open */
  Open = 'open',
  /** pending */
  Pending = 'pending',
  /** rejected */
  Rejected = 'rejected',
  /** Replied */
  Replied = 'replied',
  /** withdrew */
  Withdrew = 'withdrew'
}

/** Customer's gender preference for this job */
export enum PostedJobsGenderPref {
  /** Female */
  Female = 'female',
  /** Male */
  Male = 'male',
  /** No Preference (default) */
  Nopref = 'nopref'
}

/** Customer's availability hours for this job */
export enum PostedJobsHours {
  /** More than 20 hours */
  FullTime = 'full_time',
  /** 10 to 20 hours */
  High = 'high',
  /** Less than 5 hours */
  Low = 'low',
  /** 5 to 10 hours */
  Med = 'med'
}

/** Column with which to order searched posted jobs */
export enum PostedJobsOrder {
  /** Sort by creation date, most recent first (default) */
  Age = 'age',
  /** Sort by creation date, oldest first */
  AgeOld = 'age_old',
  /** Sort by distance */
  Distance = 'distance'
}

/** Which page are we displaying for this posted job */
export enum PostedJobsPage {
  AdminAndMaintenance = 'admin_and_maintenance',
  Gardening = 'gardening',
  Housework = 'housework',
  Meal = 'meal',
  Social = 'social',
  TransferAndMobility = 'transfer_and_mobility',
  Transport = 'transport'
}

/** Service Categories customer can choose for this job */
export enum PostedJobsServiceCategories {
  /** Allied Health */
  AlliedHealth = 'allied_health',
  /** Daily living, social and community */
  DailyLiving = 'daily_living',
  /** Personal care */
  PersonalCare = 'personal_care'
}

/** Worker preference eg No pets or non-smoker */
export type Preference = {
  __typename?: 'Preference';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** Field for worker preferences (eg preferred gender) */
export type PreferredWorker = {
  __typename?: 'PreferredWorker';
  /** Preferred worker gender */
  gender?: Maybe<PostedJobsGenderPref>;
};

/** Attributes for pre-filling flex jobs from scheduled events */
export type PrefillFlexJobAttributes = {
  __typename?: 'PrefillFlexJobAttributes';
  /** Consumer description of the job */
  consumerDescription?: Maybe<Scalars['String']['output']>;
  /** Duration of the job */
  duration: Scalars['Float']['output'];
  /** Gender preferences */
  gender?: Maybe<Scalars['String']['output']>;
  /** Description of the job */
  jobDescription?: Maybe<Scalars['String']['output']>;
  /** List of service types for the job */
  services?: Maybe<Array<Scalars['String']['output']>>;
  /** Start time for the job */
  startTime: Scalars['ISO8601DateTime']['output'];
  /** Attributes for describing a location */
  suburbSelector: SuburbAttributes;
  /** Title for the job */
  title?: Maybe<Scalars['String']['output']>;
};

/** The previous search format for a consumer searching for a support worker */
export type PreviousSearch = PreviousSearchForWorker;

/** Attributes of the previous search (filters etc) that a client did when searching for a support-worker */
export type PreviousSearchForWorker = {
  __typename?: 'PreviousSearchForWorker';
  /** Advanced search filters */
  advanced: PreviousSearchForWorkerAdvanced;
  /** Basic search (text strings) */
  basicSearch: Array<Scalars['String']['output']>;
  /** Suburb text-search */
  suburb: SuburbAttributes;
};

/** Attributes of an advanced search-filter set - when a client is searching for a support-worker */
export type PreviousSearchForWorkerAdvanced = {
  __typename?: 'PreviousSearchForWorkerAdvanced';
  /** Filter workers by whether they are ABN verified */
  abnVerified?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter workers by days they are available */
  availableDays?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter workers by their care-knowledge (eg Dementia/Vision impairment) */
  careKnowledge?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by cultural background */
  culturalBackgrounds?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by gender */
  gender?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter workers by their interests */
  interests?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by languages spoken */
  languages?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by type (eg Personal-care/Allied) */
  myType?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter workers by whether they have been verified to have passed the NDIS worker screening */
  ndisWorkerScreeningVerified?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by personality (eg outgoing) */
  personality?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by other properties (eg pet-friendly) */
  properties?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by qualifications they hold */
  qualifications?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter workers by their religion */
  religions?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter by restrictions (eg non-smoking) */
  restrictions?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter workers by whether they have a verified working-with-children check */
  reviewChildrenCheckVerified?: Maybe<Array<Scalars['String']['output']>>;
  /** Filter workers by the services they offer */
  services?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents either a WorkerProfile or ClientProfile */
export type Profile = ClientProfile | WorkerProfile;

/** Brief details of one step in the profile-build process */
export type ProfileBuilderItem = {
  __typename?: 'ProfileBuilderItem';
  /** Has this step been completed */
  completed: Scalars['Boolean']['output'];
  /** Link to the page to complete this step */
  link: Scalars['String']['output'];
  /** Name of the step */
  name: Scalars['String']['output'];
};

/** Details of a section of the profile-builder proess */
export type ProfileBuilderSection = {
  __typename?: 'ProfileBuilderSection';
  /** Has this step been completed */
  completed: Scalars['Boolean']['output'];
  /** Is this section displayable */
  displaySection: Scalars['Boolean']['output'];
  /** Items in this section */
  items: Array<ProfileBuilderItem>;
  /** Name for this section */
  name: Scalars['String']['output'];
};

/** Current completion-status of worker profile */
export type ProfileStatus = {
  __typename?: 'ProfileStatus';
  /** Profile completion percentage */
  percentage?: Maybe<Scalars['Int']['output']>;
  /** Shows steps user has completed. Only request data relevant to individual contractor or business carer, not both */
  status?: Maybe<ProfileStepStatus>;
};

/** Shows steps user has completed */
export type ProfileStepStatus = {
  __typename?: 'ProfileStepStatus';
  /** Completed the about step */
  about: Scalars['Boolean']['output'];
  /** Completed the availability step */
  availability: Scalars['Boolean']['output'];
  /** Completed the badges step */
  badges: Scalars['Boolean']['output'];
  /** Completed the bank-account step */
  bankAccount: Scalars['Boolean']['output'];
  /** Completed the care-experience step */
  careExperience: Scalars['Boolean']['output'];
  /** Completed the cultural background step */
  culturalBackground: Scalars['Boolean']['output'];
  /** Completed the education step */
  education: Scalars['Boolean']['output'];
  /** Completed the immunisation step */
  immunisation: Scalars['Boolean']['output'];
  /** Completed the interests step */
  interests: Scalars['Boolean']['output'];
  /** Completed the languages step */
  languages: Scalars['Boolean']['output'];
  /** Completed the locations step */
  locations: Scalars['Boolean']['output'];
  /** Completed the NDIS screening step */
  ndisScreening: Scalars['Boolean']['output'];
  /** Completed the preferences step */
  preferences: Scalars['Boolean']['output'];
  /** Completed the rates step */
  rates: Scalars['Boolean']['output'];
  /** Completed the religion step */
  religion: Scalars['Boolean']['output'];
  /** Completed the work history step */
  workHistory: Scalars['Boolean']['output'];
};

/** Details about a step in the profile-completion process */
export type ProfileSteps = {
  __typename?: 'ProfileSteps';
  /** Is this step complete */
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the step */
  name?: Maybe<Scalars['String']['output']>;
  /** Value of the step */
  value?: Maybe<Scalars['String']['output']>;
};

/** Set of changes proposed for the profile */
export type ProposedChanges = {
  __typename?: 'ProposedChanges';
  /** Change short bio */
  about?: Maybe<Scalars['String']['output']>;
  /** Change avatar */
  avatar?: Maybe<Scalars['String']['output']>;
};

/** Proposed date-change data for a certification */
export type ProposedChangesSelectedDate = {
  __typename?: 'ProposedChangesSelectedDate';
  /** Proposed date of the certification */
  date?: Maybe<Scalars['String']['output']>;
  /** Has this certification been selected */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Proposed new issue date for a certification (eg police check) */
export type ProposedChangesSelectedDateAttributes = {
  /** Date of issue for this certification */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Has this certification been selected */
  selected?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Proposed date-change data for a working-with-children check */
export type ProposedChangesWwcc = {
  __typename?: 'ProposedChangesWwcc';
  /** Uploaded certification */
  asset?: Maybe<Scalars['String']['output']>;
  /** Expiry date */
  expiry?: Maybe<Scalars['String']['output']>;
  /** Registration number */
  number?: Maybe<Scalars['String']['output']>;
};

/** Potential changes to the data for the working-with-children check */
export type ProposedChangesWwccAttributes = {
  /** Uploaded asset (the WWCC certificate) */
  asset: Scalars['String']['input'];
  /** Expiry date for the WWCC */
  expiry: Scalars['String']['input'];
  /** The registration number for the WWCC */
  number: Scalars['String']['input'];
};

/** Autogenerated input type of ProvideFeedback */
export type ProvideFeedbackInput = {
  /** Send `true` to make this review anonymous */
  anonymous: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Write your review */
  description: Scalars['String']['input'];
  /** ID of the worker */
  receiverId: Scalars['ID']['input'];
  /** Overall experience. Value 1-5. */
  value: Scalars['Int']['input'];
};

/** Autogenerated return type of ProvideFeedback */
export type ProvideFeedbackPayload = {
  __typename?: 'ProvideFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the saved rating */
  rating?: Maybe<Rating>;
};

/** Autogenerated input type of ProvideMeetAndGreetFeedback */
export type ProvideMeetAndGreetFeedbackInput = {
  /** Is the client requesting a callback */
  callbackRequest?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Comments about the meet and greet */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** ID of the relevant meet and greet */
  meetAndGreetId: Scalars['ID']['input'];
  /** Category of the result of the meeting */
  meetingResult?: InputMaybe<MeetAndGreetFeedbackResultOptions>;
  /** Reason for giving feedback */
  reason?: InputMaybe<MeetAndGreetFeedbackReasonOptions>;
};

/** Autogenerated return type of ProvideMeetAndGreetFeedback */
export type ProvideMeetAndGreetFeedbackPayload = {
  __typename?: 'ProvideMeetAndGreetFeedbackPayload';
  /** Retruned accepted reason */
  acceptedReasons?: Maybe<Array<MeetAndGreetAcceptedFeedbackReason>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returned details about the meet and greet */
  meetAndGreet: MeetAndGreet;
};

/** Details about provider onboarded clients */
export type ProviderOnboardingInformation = {
  __typename?: 'ProviderOnboardingInformation';
  /** client funding organisation name */
  fundingOrganisationName?: Maybe<Scalars['String']['output']>;
  /** has client got a need profile created */
  hasParticipantNeedProfile?: Maybe<Scalars['Boolean']['output']>;
  /** has client posted a job yet */
  hasPostedJob?: Maybe<Scalars['Boolean']['output']>;
  /** Date need profile was last synced */
  needProfileLastSyncDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Homemade or Mable */
  signupSource?: Maybe<Scalars['String']['output']>;
  /** has the user viewed the welcome page */
  viewedProviderWelcomePage?: Maybe<Scalars['Boolean']['output']>;
};

/** Attributes of a public holiday */
export type PublicHoliday = {
  __typename?: 'PublicHoliday';
  /** Is this a holiday for all states */
  allStates?: Maybe<Scalars['Boolean']['output']>;
  /** What date is this holiday held */
  date: Scalars['ISO8601DateTime']['output'];
  /** The title/name of the holiday */
  holidayTitle: Scalars['String']['output'];
  /** What states is this holiday for (if not all) */
  states?: Maybe<Array<Scalars['String']['output']>>;
};

/** How much does this worker fit with the jobs qualification prerequisites */
export type QualificationCoverage = {
  __typename?: 'QualificationCoverage';
  /** desired */
  desired?: Maybe<Coverage>;
  /** overall */
  overall?: Maybe<Scalars['Float']['output']>;
  /** required */
  required?: Maybe<Coverage>;
};

/** Sub category values under qualifications category */
export enum Qualifications {
  Qualifications = 'qualifications'
}

/** Root query type */
export type Query = {
  __typename?: 'Query';
  /** ABN lookup */
  abnLookup?: Maybe<AbnLookup>;
  /** Get agreement */
  agreement?: Maybe<Agreement>;
  /** Get agreement pre-fill data from an application */
  agreementPrefillData?: Maybe<AgreementPrefillData>;
  /** Get agreement requests */
  agreementRequests?: Maybe<Array<AgreementRequest>>;
  /** Check if agreement has scheduled events */
  agreementWithScheduledEvents: AgreementWithScheduledEvents;
  /** Get billing details */
  billing: Billing;
  /** Get budget support types */
  budgetSupportTypes?: Maybe<CarerBudgetSupport>;
  /** Calculate worker rate */
  calculatedRate?: Maybe<RateWithFee>;
  /** Get qualifications that a carer holds */
  carerQualifications?: Maybe<CarerQualificationConnection>;
  /** Get carer reliability assessment */
  carerReliabilityAssessment?: Maybe<CarerReliabilityAssessment>;
  /** Get client dashboard */
  clientDashboard?: Maybe<ClientDashboard>;
  /** Get client onboarding status */
  clientOnboardingStatus?: Maybe<ClientOnboardingStatus>;
  /** Get static questions for client posted jobs */
  clientPostedJobStaticQuestions?: Maybe<Array<JobStaticQuestion>>;
  /** Get client posted jobs */
  clientPostedJobs?: Maybe<PostedJobConnection>;
  /** Get service categories for client posted jobs */
  clientPostedJobsServiceCategories: Array<ServiceCategories>;
  /** Get client search worker filters */
  clientSearchWorkerFilters?: Maybe<Array<SearchFilterCategory>>;
  /** Search for workers */
  clientSearchWorkers?: Maybe<WorkerProfileSearchNodeConnection>;
  /** Get client support plan info */
  clientSupportPlanInfo?: Maybe<SupportPlanInfo>;
  /** Get worker preferences of the client */
  clientWorkerPreferences?: Maybe<WorkerPreferences>;
  /** Get client workers */
  clientWorkers?: Maybe<AgreementConnection>;
  /** Get all clients of an organisation/coordinator */
  clients?: Maybe<ClientConnection>;
  /** Get clients with open jobs */
  clientsWithOpenJobs?: Maybe<UserConnection>;
  /** Get code of conduct acknowledgement status */
  codeOfConductAcknowledgementStatus?: Maybe<CodeOfConductAcknowledgementStatus>;
  /** Get connection requests */
  connectionRequests?: Maybe<RequestConnection>;
  /** Get conversation details */
  conversationDetails?: Maybe<Conversation>;
  /** Check if conversation exists */
  conversationExists?: Maybe<ConversationExists>;
  /** Get conversations */
  conversations?: Maybe<ConversationConnection>;
  /** Get coordinator clients */
  coordinatorClients?: Maybe<UserConnection>;
  /** Get coordinator posted jobs */
  coordinatorPostedJobs?: Maybe<PostedJobConnection>;
  /** Get default rate */
  defaultRates?: Maybe<DefaultRate>;
  /** Check if client is eligible for group chat */
  eligibleForGroupChat: EligibleForGroupChat;
  /** Check if user is eligible for identity verification */
  eligibleForIdentityVerification: IdentityVerificationEligibility;
  /** Get lists of a carer services in relation to a job */
  eligibleServicesForAgreement?: Maybe<EligibleServicesForAgreement>;
  /** Get eoi applications */
  eoiApplications?: Maybe<EoiRequestConnection>;
  /** Get eoi shares */
  eoiShares?: Maybe<EoiRequestConnection>;
  /** Get event deliveries */
  eventDeliveries?: Maybe<EventDeliveryConnection>;
  /** Get event delivery details */
  eventDelivery?: Maybe<EventDelivery>;
  /** Fetch pre-populated posted job fields for express job */
  expressJobDraft: PostedJob;
  /** Fetch pre-populated posted jobs for a express job session */
  expressJobDraftsForSession: Array<PostedJob>;
  /** Get express job recommendation options */
  expressJobRecommendationOptions: Array<ExpressJobRecommendationOptions>;
  /** Fetch session-data for clients going through express-job flow */
  expressJobSession: ExpressJobSession;
  /** Returns list of available gender options */
  gender?: Maybe<Array<GenderIdentity>>;
  /** Get result bulk message for carer */
  getResultBulkMessageCarer: BulkMessageCarer;
  /** Get wallet by ID */
  getWallet?: Maybe<Wallet>;
  /** Return a list of all user wallets */
  getWallets?: Maybe<Array<Wallet>>;
  /** Get group chat read info */
  groupChatReadInfo?: Maybe<GroupChatInfoReadState>;
  /** Get incident cases */
  incidentCases?: Maybe<IncidentCaseConnection>;
  /** Get job notification filters */
  jobNotificationFilters?: Maybe<Array<JobNotificationFilter>>;
  /** Get last job response answers */
  lastJobResponseAnswers?: Maybe<Array<JobResponseAnswer>>;
  /** Get mable fees */
  mableFees?: Maybe<MableFee>;
  /** Get meet and greet details */
  meetAndGreet?: Maybe<MeetAndGreet>;
  /** Get meet and greet meeting type options */
  meetAndGreetMeetingTypeOptions?: Maybe<Array<MeetAndGreetMeetingTypes>>;
  /** Get minimum rate */
  minimumRate?: Maybe<MinimumRate>;
  /** Get clients of the worker */
  myClients?: Maybe<AgreementConnection>;
  /** Get my shortlist */
  myShortlist?: Maybe<Array<ShortlistItem>>;
  /** Get workers of the client */
  myWorkers?: Maybe<AgreementConnection>;
  /** Get NDIS plan */
  ndisPlan?: Maybe<NdisPlan>;
  /** Get NDIS support areas */
  ndisSupportAreas: Array<NdisSupportArea>;
  /** Get NDIS support items */
  ndisSupportItems?: Maybe<Array<NdisSupportItem>>;
  /** Get notification allow banner */
  notificationAllowBanner?: Maybe<NotificationAllowBanner>;
  /** Get org admin organisation term */
  orgAdminOrganisationTerm?: Maybe<OrganisationTerm>;
  /** Get organisation */
  organisation?: Maybe<Organisation>;
  /** Get active phone call details */
  phoneCall?: Maybe<PhoneCall>;
  /** Get police check details */
  policeCheck?: Maybe<PoliceCheck>;
  /** Get posted job */
  postedJob?: Maybe<PostedJob>;
  /** Get jobs responses for coordinator clients jobs */
  postedJobResponses?: Maybe<JobResponseConnection>;
  /** Get attributes to prefill a last minute job from a scheduled event session */
  prefillLastMinuteJobFromSession?: Maybe<PrefillFlexJobAttributes>;
  /** Get profile builder sections */
  profileBuilderSections?: Maybe<Array<ProfileBuilderSection>>;
  /** Get provider onboarding information */
  providerOnboardingInformation: ProviderOnboardingInformation;
  /** Get public holidays */
  publicHolidays?: Maybe<Array<PublicHoliday>>;
  /** Check if user qualifies for mobile rating prompt */
  qualifiesForMobileRatingPrompt?: Maybe<MobileRatingPromptQualification>;
  /** Get quick replies for workers */
  quickReplies?: Maybe<Array<QuickReply>>;
  /** Check if GQL is able to serve requests */
  readiness: Readiness;
  /** Get recommended jobs for the current worker */
  recommendedJobs?: Maybe<PostedJobConnection>;
  /** Get recommended state rates */
  recommendedStateRates: Array<RecommendedStateRate>;
  /** Get recommended workers */
  recommendedWorkers?: Maybe<RecommendedWorkers>;
  /** Get a specific worker reference */
  reference?: Maybe<Reference>;
  /** Get worker references */
  references?: Maybe<ReferenceConnection>;
  /** Get scheduled event */
  scheduledEvent?: Maybe<ScheduledEventDetail>;
  /** Get scheduled events */
  scheduledEvents?: Maybe<ScheduledEventConnection>;
  /** Get scheduled events by date range */
  scheduledEventsByDateRange?: Maybe<ScheduledEventDateRange>;
  /** Search for funding organisations */
  searchFundingOrgs?: Maybe<OrganisationConnection>;
  /** Search for jobs */
  searchJobs?: Maybe<PostedJobConnection>;
  /** Search for suburb */
  searchSuburb?: Maybe<Array<Location>>;
  /** Search for workers by name */
  searchWorkersByName?: Maybe<WorkerProfileSearchNodeConnection>;
  /** Get sendbird channel detail */
  sendbirdChannelDetail?: Maybe<SendbirdChannelDetail>;
  /** Get services */
  services?: Maybe<Array<Service>>;
  /** Get shared or replied jobs by client */
  sharedOrRepliedJobsByClient?: Maybe<Array<PostedJob>>;
  /** Export shift notes */
  shiftNotesExport?: Maybe<ShiftNotesExport>;
  /** Get shortlist items */
  shortlistItems?: Maybe<ShortlistItemConnection>;
  /** Get static data */
  staticData: StaticData;
  /** Get superannuation figures */
  superannuationFigures?: Maybe<Superannuation>;
  /** Get superannuation payments */
  superannuationPayments?: Maybe<SuperannuationAsyncResponse>;
  /** Get support health change */
  supportHealthChange?: Maybe<SupportHealthChangeForEventDelivery>;
  /** Get support health change answers */
  supportHealthChangeAnswers?: Maybe<Array<SupportHealthChangeAnswerForEventDelivery>>;
  /** Get support health change questionnaires */
  supportHealthChangeQuestionnaires?: Maybe<Array<SupportNoteQuestionnaire>>;
  /** Get support notes */
  supportNotes?: Maybe<SupportNoteConnection>;
  /** Get worker testimonials */
  testimonials?: Maybe<Array<Testimonial>>;
  /** Get timesheets */
  timesheets?: Maybe<Timesheet>;
  /** Get UI global banner status */
  uiGlobalBannerStatus: UiGlobalBannerStatus;
  /** Get undelivered sessions linked to agreement, for a determined time range */
  undeliveredSessionsForAgreement?: Maybe<ScheduledEventDateRange>;
  /** Get latest upcoming prompt */
  upcomingPrompt?: Maybe<UpcomingPrompt>;
  /** Get user details */
  user?: Maybe<User>;
  /** Get user deletion status */
  userDeletionStatus?: Maybe<UserDeletionStatus>;
  /** Get user draft */
  userDraft: UserDraft;
  /** Get user drafts */
  userDrafts: Array<UserDraft>;
  /** Get user organisation term */
  userOrganisationTerm?: Maybe<UserOrganisationTerm>;
  /** Check if string contains banned words */
  validateBannedWords: BannedWords;
  /** Validate email */
  validateEmail: EmailValid;
  /** Validate payment method */
  validatePaymentMethod: PaymentMethodValid;
  /** Validate per km rate */
  validatePerKmRate: PerKmRateValid;
  /** Validate phone number */
  validatePhoneBanned: PhoneValid;
  /** Get worker dashboard */
  workerDashboard?: Maybe<WorkerDashboard>;
  /** Get detail about how well a worker matches to a given jobs prerequisites */
  workerJobMatchExplanations?: Maybe<Array<WorkerJobExplanation>>;
  /** Get worker profile */
  workerProfile?: Maybe<WorkerProfile>;
  /** Get tags for workers */
  workersTags?: Maybe<WorkersTags>;
};


/** Root query type */
export type QueryAbnLookupArgs = {
  abn: Scalars['String']['input'];
};


/** Root query type */
export type QueryAgreementArgs = {
  id: Scalars['ID']['input'];
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type */
export type QueryAgreementPrefillDataArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QueryAgreementWithScheduledEventsArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryBillingArgs = {
  fromDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  invoiceStatementId?: InputMaybe<Scalars['ID']['input']>;
  toDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


/** Root query type */
export type QueryBudgetSupportTypesArgs = {
  consumerUserId?: InputMaybe<Scalars['ID']['input']>;
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryCalculatedRateArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  baseRate: Scalars['Float']['input'];
  budgetSupportTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  consumerId?: InputMaybe<Scalars['ID']['input']>;
  grandfatheredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
  timeAndPlace?: InputMaybe<TimeAndPlace>;
};


/** Root query type */
export type QueryCarerQualificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CarerQualificationSortInput>;
};


/** Root query type */
export type QueryCarerReliabilityAssessmentArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryClientOnboardingStatusArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryClientPostedJobStaticQuestionsArgs = {
  page: PostedJobsPage;
};


/** Root query type */
export type QueryClientPostedJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters: Array<PostedJobClientFilterOptions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryClientPostedJobsServiceCategoriesArgs = {
  category?: InputMaybe<PostedJobsServiceCategories>;
};


/** Root query type */
export type QueryClientSearchWorkerFiltersArgs = {
  filters?: InputMaybe<CarerProfileCategories>;
};


/** Root query type */
export type QueryClientSearchWorkersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkerSearchFilterAttribute>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  previousSearchToken?: InputMaybe<Scalars['String']['input']>;
  saveFilters?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type */
export type QueryClientWorkersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  filter?: InputMaybe<AgreementStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  terminated?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type */
export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  providerClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QueryClientsWithOpenJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryCodeOfConductAcknowledgementStatusArgs = {
  conversationId: Scalars['ID']['input'];
};


/** Root query type */
export type QueryConnectionRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ExpressionOfInterestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isResponder?: InputMaybe<Scalars['Boolean']['input']>;
  jobUuid?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Root query type */
export type QueryConversationDetailsArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryConversationExistsArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sendbirdChannelUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Root query type */
export type QueryCoordinatorClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QueryCoordinatorPostedJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ManageJobsSearchFilterAttribute>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryEligibleServicesForAgreementArgs = {
  consumerId: Scalars['ID']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryEoiApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ExpressionOfInterestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobUuid?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Root query type */
export type QueryEoiSharesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  expiresInDays?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ExpressionOfInterestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobUuid?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Root query type */
export type QueryEventDeliveriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  carerId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeliveredSessions?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyWithHealthMoodChanges?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithIncident?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ShiftNoteSortInput>;
};


/** Root query type */
export type QueryEventDeliveryArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryExpressJobDraftArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryExpressJobDraftsForSessionArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryExpressJobSessionArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryGetResultBulkMessageCarerArgs = {
  asyncJobId: Scalars['String']['input'];
};


/** Root query type */
export type QueryGetWalletArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryIncidentCasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<IncidentCaseFilterData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryLastJobResponseAnswersArgs = {
  answerTypes?: InputMaybe<Array<JobResponseAnswerOptions>>;
};


/** Root query type */
export type QueryMableFeesArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryMeetAndGreetArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryMyClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AgreementStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  terminated?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type */
export type QueryMyWorkersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AgreementStatusFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  terminated?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root query type */
export type QueryNdisSupportItemsArgs = {
  ndisSupportAreaId: Scalars['ID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QueryNotificationAllowBannerArgs = {
  deviceUuid: Scalars['String']['input'];
};


/** Root query type */
export type QueryOrganisationArgs = {
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  consumerUserId: Scalars['ID']['input'];
};


/** Root query type */
export type QueryPhoneCallArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  conversationId: Scalars['ID']['input'];
};


/** Root query type */
export type QueryPostedJobArgs = {
  id: Scalars['ID']['input'];
};


/** Root query type */
export type QueryPostedJobResponsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<JobResponsesFiltersAttribute>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobId: Scalars['ID']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryPrefillLastMinuteJobFromSessionArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  derivedUniqueId: Scalars['String']['input'];
};


/** Root query type */
export type QueryPublicHolidaysArgs = {
  fromDatetime: Scalars['ISO8601DateTime']['input'];
  toDatetime: Scalars['ISO8601DateTime']['input'];
};


/** Root query type */
export type QueryRecommendedJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<PostedJobFrequencyOptions>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryRecommendedStateRatesArgs = {
  carerType: RecommendedStateRateCarer;
  state: AustralianStates;
};


/** Root query type */
export type QueryRecommendedWorkersArgs = {
  jobId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryReferenceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryScheduledEventArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  derivedUniqueId?: InputMaybe<Scalars['String']['input']>;
  occurrenceId?: InputMaybe<Scalars['String']['input']>;
  occurrenceIdType?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QueryScheduledEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryScheduledEventsByDateRangeArgs = {
  fromDatetime: Scalars['ISO8601DateTime']['input'];
  toDatetime: Scalars['ISO8601DateTime']['input'];
};


/** Root query type */
export type QuerySearchFundingOrgsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fundingSourceCode: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/** Root query type */
export type QuerySearchJobsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchFilter?: InputMaybe<JobSearch>;
  task: WorkerJobSearchTaskOptions;
};


/** Root query type */
export type QuerySearchSuburbArgs = {
  query: Scalars['String']['input'];
};


/** Root query type */
export type QuerySearchWorkersByNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};


/** Root query type */
export type QuerySendbirdChannelDetailArgs = {
  channelUrl: Scalars['String']['input'];
};


/** Root query type */
export type QueryServicesArgs = {
  code: ServiceCodeOptions;
};


/** Root query type */
export type QuerySharedOrRepliedJobsByClientArgs = {
  clientId: Scalars['ID']['input'];
};


/** Root query type */
export type QueryShiftNotesExportArgs = {
  carerId?: InputMaybe<Scalars['ID']['input']>;
  includeDeliveredSessions?: InputMaybe<Scalars['Boolean']['input']>;
  onlyWithIncident?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ShiftNoteSortInput>;
};


/** Root query type */
export type QueryShortlistItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QuerySuperannuationFiguresArgs = {
  endTime: Scalars['ISO8601DateTime']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  startTime: Scalars['ISO8601DateTime']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QuerySuperannuationPaymentsArgs = {
  endTime: Scalars['ISO8601DateTime']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  startTime: Scalars['ISO8601DateTime']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QuerySupportHealthChangeArgs = {
  eventDeliveryId: Scalars['ID']['input'];
};


/** Root query type */
export type QuerySupportHealthChangeAnswersArgs = {
  supportHealthChangeId: Scalars['ID']['input'];
};


/** Root query type */
export type QuerySupportHealthChangeQuestionnairesArgs = {
  funding?: InputMaybe<SupportNoteQuestionnaireFunding>;
};


/** Root query type */
export type QuerySupportNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<SupportNoteFilterData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Root query type */
export type QueryUiGlobalBannerStatusArgs = {
  bannerId: Scalars['String']['input'];
};


/** Root query type */
export type QueryUndeliveredSessionsForAgreementArgs = {
  agreementId: Scalars['ID']['input'];
  fromDatetime: Scalars['ISO8601DateTime']['input'];
  toDatetime: Scalars['ISO8601DateTime']['input'];
};


/** Root query type */
export type QueryUpcomingPromptArgs = {
  category: UpcomingPromptCategory;
};


/** Root query type */
export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Root query type */
export type QueryUserDraftArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  kind: UserDraftKind;
};


/** Root query type */
export type QueryUserDraftsArgs = {
  kind: UserDraftKind;
};


/** Root query type */
export type QueryUserOrganisationTermArgs = {
  consumerId: Scalars['ID']['input'];
};


/** Root query type */
export type QueryValidateBannedWordsArgs = {
  words: Scalars['String']['input'];
};


/** Root query type */
export type QueryValidateEmailArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


/** Root query type */
export type QueryValidatePaymentMethodArgs = {
  paymentMethodToken: Scalars['String']['input'];
};


/** Root query type */
export type QueryValidatePerKmRateArgs = {
  perKmRateDollars: Scalars['Float']['input'];
};


/** Root query type */
export type QueryValidatePhoneBannedArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QueryWorkerJobMatchExplanationsArgs = {
  jobUuids: Array<Scalars['Uuid']['input']>;
  userUuid: Scalars['Uuid']['input'];
};


/** Root query type */
export type QueryWorkerProfileArgs = {
  mechanism?: InputMaybe<Scalars['String']['input']>;
  permalink?: InputMaybe<Scalars['String']['input']>;
  searchToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};


/** Root query type */
export type QueryWorkersTagsArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
  workerIds: Array<Scalars['ID']['input']>;
};

/** Quick reply between a support-worker and client */
export type QuickReply = {
  __typename?: 'QuickReply';
  /** ID of the reply */
  id: Scalars['ID']['output'];
  /** Key to the reply */
  key: Scalars['String']['output'];
  /** Text of a link */
  linkText: Scalars['String']['output'];
  /** Detailed message */
  messageText: Scalars['String']['output'];
  /** Options */
  options: Array<Option>;
};

/** Detail of the rate this worker will charge for their care */
export type Rate = {
  __typename?: 'Rate';
  /** Net dollars charged to the client */
  clientNetDollars?: Maybe<Scalars['String']['output']>;
  /** Dollar rate to show at worker profile */
  dollars?: Maybe<Scalars['String']['output']>;
  /** Flat rate OR hourly rate. `True` for flat rate. */
  flatRate: Scalars['Boolean']['output'];
  /** Gross rate charged */
  grossDollars?: Maybe<Scalars['String']['output']>;
  /** ID of the rate information */
  id: Scalars['ID']['output'];
  /** Rate in cents */
  rateCents?: Maybe<Scalars['Int']['output']>;
  /** Description of the rate */
  rateDescription?: Maybe<Scalars['String']['output']>;
  /** Name of the rate */
  rateName?: Maybe<Scalars['String']['output']>;
  /** Rate schedule (when this will be scharged eg daytime/evening/overnight) */
  rateSchedule?: Maybe<RateSchedule>;
  /** Net dollars the worker will receive */
  workerNetDollars?: Maybe<Scalars['String']['output']>;
};

/** Details of an agreed pay-rate for the carer */
export type RateAttributes = {
  /** assign `true` to delete the rate */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of Budget-support this relates to */
  budgetSupportTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Is this a flat-rate */
  flatRate: Scalars['Boolean']['input'];
  /** ID of the carer rate object */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Description of the carer rate */
  rateDescription?: InputMaybe<Scalars['String']['input']>;
  /** Rate charged in dollars */
  rateDollars: Scalars['Float']['input'];
  /** Name of the rate */
  rateName: Scalars['String']['input'];
  /** Extra atttributes attached to this rate */
  rateScheduleAttributes?: InputMaybe<RateScheduleAttributes>;
};

/** Detail about when a worker-rate will be charged */
export type RateSchedule = {
  __typename?: 'RateSchedule';
  /** Will this be charged in the daytime */
  daytime?: Maybe<Scalars['Boolean']['output']>;
  /** Will this be charged in the evening */
  evening?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the rate-schedule */
  id: Scalars['ID']['output'];
  /** Will this be charged overnight */
  overnight?: Maybe<Scalars['Boolean']['output']>;
  /** Will this be charged on a public holiday */
  publicHoliday?: Maybe<Scalars['Boolean']['output']>;
  /** Will this be charged on Saturdays */
  saturday?: Maybe<Scalars['Boolean']['output']>;
  /** Will this be charged on Sundays */
  sunday?: Maybe<Scalars['Boolean']['output']>;
  /** Will this be charged on weekdays */
  weekday?: Maybe<Scalars['Boolean']['output']>;
};

/** Attributes of a Rate-schedule - one of the posted set of rates charged by a support-worker */
export type RateScheduleAttributes = {
  /** Is this a daytime rate */
  daytime: Scalars['Boolean']['input'];
  /** Is this an evening rate */
  evening: Scalars['Boolean']['input'];
  /** ID of the rate-schedule */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Is this an overnight rate */
  overnight: Scalars['Boolean']['input'];
  /** Is this a public-holiday rate */
  publicHoliday: Scalars['Boolean']['input'];
  /** Is this a Saturday rate */
  saturday: Scalars['Boolean']['input'];
  /** Is this a Sunday rate */
  sunday: Scalars['Boolean']['input'];
  /** Is this a weekday rate */
  weekday: Scalars['Boolean']['input'];
};

/** Calculated rate with fee information for a support-worker */
export type RateWithFee = {
  __typename?: 'RateWithFee';
  /** The relevant NDIS cap-rate */
  capRate?: Maybe<Scalars['String']['output']>;
  /** Does this rate exceed the cap rate */
  exceedCapRate: Scalars['Boolean']['output'];
  /** Alert indicating this rate has gone over the NDIS price-limit for this budget support-type and time of day */
  priceLimitAlertToDType?: Maybe<Scalars['String']['output']>;
  /** Alert indicating this rate has gone over the NDIS price-limit for this budget support-type and day of the week */
  priceLimitAlertType?: Maybe<Scalars['String']['output']>;
  /** The calculated rate including Mable's fees */
  rateWithFee: Scalars['String']['output'];
  /** Location of the support */
  supportLocation?: Maybe<Scalars['String']['output']>;
  /** Name of the support */
  supportName?: Maybe<Scalars['String']['output']>;
  /** Type of the support */
  supportType?: Maybe<Scalars['String']['output']>;
};

/** Details of a client rating for this worker */
export type Rating = {
  __typename?: 'Rating';
  /** Is this an anonymous rating */
  anonymous: Scalars['Boolean']['output'];
  /** When was this created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Detailed description of why they gave this rating */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the rating */
  id: Scalars['ID']['output'];
  /** Person being rated */
  receiver: User;
  /** Person giving the rating */
  sender: User;
  /** Should we show the description */
  showDescription: Scalars['Boolean']['output'];
  /** Status of the rating */
  status?: Maybe<Scalars['String']['output']>;
  /** Value given for this rating */
  value: Scalars['Int']['output'];
};

/** Indicates if the application is ready to serve requests */
export type Readiness = {
  __typename?: 'Readiness';
  /** Indicates if the application is ready to serve requests */
  ok: Scalars['Boolean']['output'];
};

/** A list of recommended workers for client based on a job they've posted */
export type Recommendation = {
  __typename?: 'Recommendation';
  /** Rational as to why this worker was recommended. */
  explanation: RecommendationExplanation;
  /** Details of the recommended worker. */
  worker: WorkerProfile;
};

/** Rational for why this worker is recommended for a job. */
export type RecommendationExplanation = {
  __typename?: 'RecommendationExplanation';
  /** Indication of the availability overlap between a SP and the job. 0 means none, 100 means complete, and anything in between is partial. */
  availabilityOverlap: Scalars['Int']['output'];
  /** Indication of the service match between a SP and the job. 0 means none, 100 means complete, and anything in between is partial. */
  overallServiceCoverage: Scalars['Int']['output'];
};

/** A recommended charge-rate for a specific type of support-worker in a specific Australian state */
export type RecommendedStateRate = {
  __typename?: 'RecommendedStateRate';
  /** Timestamp for when this rate was calculated */
  calculatedDate: Scalars['ISO8601DateTime']['output'];
  /** Carer type (eg Personal/Social) that this rate applies to */
  carerType: Scalars['String']['output'];
  /** Max of the recommended rate range */
  maxRange: Scalars['String']['output'];
  /** Min of the recommended rate range */
  minRange: Scalars['String']['output'];
  /** Name of the rate */
  rateName: Scalars['String']['output'];
  /** Type of the rate (eg hourly/flat) */
  rateType: Scalars['String']['output'];
  /** State this rate applies to */
  state: Scalars['String']['output'];
};

/** Carer types for which a recommended state-rate might apply */
export enum RecommendedStateRateCarer {
  /** Personal */
  Personal = 'personal',
  /** SSDA */
  Social = 'social'
}

/** A list of recommended workers for client based on a job they've posted */
export type RecommendedWorkers = {
  __typename?: 'RecommendedWorkers';
  /** Details of each recommended worker. */
  recommendations?: Maybe<Array<Recommendation>>;
  /**
   * Deprecated: Details of each worker
   * @deprecated Use recommendations field instead
   */
  workers?: Maybe<Array<WorkerProfile>>;
};

/** Valid types of recurrence for a scheduled-event/session */
export enum RecurrenceOptions {
  /** A daily session in the schedule */
  Daily = 'daily',
  /** A fortnightly session in the schedule */
  Fortnightly = 'fortnightly',
  /** A monthly session in the schedule */
  Monthly = 'monthly',
  /** A one_off session in the schedule */
  OneOff = 'one_off',
  /** A weekly session in the schedule */
  Weekly = 'weekly'
}

/** start and end time for recurrence */
export type RecurrenceTimes = {
  /** time occurrence ends */
  end: Scalars['String']['input'];
  /** time occurrence starts */
  start: Scalars['String']['input'];
};

/** Information about a worker's professional reference */
export type Reference = {
  __typename?: 'Reference';
  /** Name of the business where carer and referee worked together */
  business?: Maybe<Scalars['String']['output']>;
  /** The profile of the carer */
  carerProfile?: Maybe<WorkerProfile>;
  /** Creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Reference declined timestamp */
  declinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reference reminder 1 sent at */
  deliveryAt1?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reference reminder 2 sent at */
  deliveryAt2?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reference reminder 3 sent at */
  deliveryAt3?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Delivery channel (email/sms) for reference reminder 1 */
  deliveryChannel1?: Maybe<Scalars['String']['output']>;
  /** Delivery channel (email/sms) for reference reminder 2 */
  deliveryChannel2?: Maybe<Scalars['String']['output']>;
  /** Delivery channel (email/sms) for reference reminder 3 */
  deliveryChannel3?: Maybe<Scalars['String']['output']>;
  /** How long has the referee known the carer? */
  durationKnown?: Maybe<Scalars['String']['output']>;
  /** Referee's email */
  email?: Maybe<Scalars['String']['output']>;
  /** How does the referee know the carer? */
  howDoYouKnow?: Maybe<Scalars['String']['output']>;
  /** ID of the reference */
  id: Scalars['ID']['output'];
  /** Is this reference for a current job */
  isCurrentJob?: Maybe<Scalars['Boolean']['output']>;
  /** When did the carer finish at this job */
  jobFinishedAt?: Maybe<Scalars['String']['output']>;
  /** When did the carer start at this job */
  jobStartedAt?: Maybe<Scalars['String']['output']>;
  /** Job title of the carer */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** last name of the referee */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Job title of the referee */
  myRole?: Maybe<Scalars['String']['output']>;
  /** Name of the referee */
  name?: Maybe<Scalars['String']['output']>;
  /** Confirm that this referee is not a family member */
  notAFamilyMember?: Maybe<Scalars['Boolean']['output']>;
  /** Referee's phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Status of the reference */
  status?: Maybe<Scalars['String']['output']>;
  /** Token to help identify the reference */
  token?: Maybe<Scalars['String']['output']>;
  /** Type of reference (professional/personal) */
  typeOf?: Maybe<Scalars['String']['output']>;
  /** Updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Has this reference been witnessed */
  witnessed?: Maybe<Scalars['Boolean']['output']>;
};

/** Data for removing a user from a sdendbird channel */
export type ReferenceAttributesType = {
  /** Business of the referer */
  business?: InputMaybe<Scalars['String']['input']>;
  /** The sendbird channel name */
  channelName: Scalars['String']['input'];
  /** The sendbird channel url */
  channelUrl: Scalars['String']['input'];
  /** This is the user id of a coordinator's client */
  clientId?: InputMaybe<Scalars['Int']['input']>;
  /** Known duration of the job */
  durationKnown?: InputMaybe<Scalars['String']['input']>;
  /** Email of the referer */
  email?: InputMaybe<Scalars['String']['input']>;
  /** How does the referer know the support-worker */
  howDoYouKnow?: InputMaybe<Scalars['String']['input']>;
  /** Is the support-worker currently working at the job */
  isCurrentJob?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when the support-worker finished at the job */
  jobFinishedAt?: InputMaybe<Scalars['String']['input']>;
  /** Date when the support-worker started at the job */
  jobStartedAt?: InputMaybe<Scalars['String']['input']>;
  /** Job title of the referer */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the referer */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Role of the support-worker at the job */
  myRole?: InputMaybe<Scalars['String']['input']>;
  /** Name of the referer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Confirms that the referer is not a family member of the support-worker */
  notAFamilyMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone of the referer */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** UID of the user being removed */
  removedUserUid: Array<Scalars['String']['input']>;
  /** Has the reference been witnessed */
  witnessed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for Reference. */
export type ReferenceConnection = {
  __typename?: 'ReferenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReferenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Reference>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Attributes for Reference Create */
export type ReferenceCreateAttributesType = {
  /** Business of the referer */
  business?: InputMaybe<Scalars['String']['input']>;
  /** Known duration of the job */
  durationKnown?: InputMaybe<Scalars['String']['input']>;
  /** Email of the referer */
  email?: InputMaybe<Scalars['String']['input']>;
  /** How does the referer know the support-worker */
  howDoYouKnow?: InputMaybe<Scalars['String']['input']>;
  /** Is the support-worker currently working at the job */
  isCurrentJob?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when the support-worker finished at the job */
  jobFinishedAt?: InputMaybe<Scalars['String']['input']>;
  /** Date when the support-worker started at the job */
  jobStartedAt?: InputMaybe<Scalars['String']['input']>;
  /** Job title of the referer */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the referer */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Role of the support-worker at the job */
  myRole?: InputMaybe<Scalars['String']['input']>;
  /** Name of the referer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Confirms that the referer is not a family member of the support-worker */
  notAFamilyMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone of the referer */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Has the reference been witnessed */
  witnessed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An edge in a connection. */
export type ReferenceEdge = {
  __typename?: 'ReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Reference>;
};

/** Attributes for Updating a Reference given to a support-worker */
export type ReferenceUpdateAttributesType = {
  /** Business of the referer */
  business?: InputMaybe<Scalars['String']['input']>;
  /** Known duration of the job */
  durationKnown?: InputMaybe<Scalars['String']['input']>;
  /** Email of the referer */
  email?: InputMaybe<Scalars['String']['input']>;
  /** How does the referer know the support-worker */
  howDoYouKnow?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Reference to update */
  id: Scalars['Int']['input'];
  /** Is the support-worker currently working at the job */
  isCurrentJob?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date when the support-worker finished at the job */
  jobFinishedAt?: InputMaybe<Scalars['String']['input']>;
  /** Date when the support-worker started at the job */
  jobStartedAt?: InputMaybe<Scalars['String']['input']>;
  /** Job title of the referer */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the referer */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Role of the support-worker at the job */
  myRole?: InputMaybe<Scalars['String']['input']>;
  /** Name of the referer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Confirms that the referer is not a family member of the support-worker */
  notAFamilyMember?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone of the referer */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Has the reference been witnessed */
  witnessed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Name of a person's religion */
export type Religion = {
  __typename?: 'Religion';
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Display name */
  name: Scalars['String']['output'];
  /** Has this been selected */
  selected: Scalars['Boolean']['output'];
  /** Sorts the services in given order */
  sortValue: Scalars['String']['output'];
};

/** Religions of a client or support-worker - can be used to filter workers for a client */
export enum ReligionOptions {
  Anglican = 'Anglican',
  Buddhist = 'Buddhist',
  Catholic = 'Catholic',
  Christian = 'Christian',
  GreekOrthodox = 'GreekOrthodox',
  Hindu = 'Hindu',
  Islamic = 'Islamic',
  Jewish = 'Jewish',
  None = 'None',
  Other = 'Other',
  Presbyterian = 'Presbyterian',
  RussianOrthodox = 'RussianOrthodox',
  Sikh = 'Sikh',
  Spiritual = 'Spiritual',
  UnitingChurch = 'UnitingChurch'
}

/** Autogenerated input type of RemoveSavedJob */
export type RemoveSavedJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the posted job being deleted */
  postedJobId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSavedJob */
export type RemoveSavedJobPayload = {
  __typename?: 'RemoveSavedJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the posted job if success, otherwise null */
  shortlist?: Maybe<ShortlistItem>;
};

/** Autogenerated input type of RemoveUserSendbirdChannel */
export type RemoveUserSendbirdChannelInput = {
  /** Attributes required for the removal */
  attributes: ReferenceAttributesType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveUserSendbirdChannel */
export type RemoveUserSendbirdChannelPayload = {
  __typename?: 'RemoveUserSendbirdChannelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns true if removal has been successful */
  removeUserSendbirdChannelResponse?: Maybe<RemoveUserSendbirdChannelResponse>;
};

/** The response to the attempt to remove a user from a sendbird channel */
export type RemoveUserSendbirdChannelResponse = {
  __typename?: 'RemoveUserSendbirdChannelResponse';
  /** Returns sendbird_channel details */
  sendbirdChannelDetail?: Maybe<SendbirdChannelDetail>;
  /** Was the user removed successfully */
  userRemovedSuccessfully?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of ReplaceSessionsFromAgreement */
export type ReplaceSessionsFromAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the agreement we're replacing sessions on */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ReplaceSessionsFromAgreement */
export type ReplaceSessionsFromAgreementPayload = {
  __typename?: 'ReplaceSessionsFromAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns true if events were created without errors */
  status: Scalars['Boolean']['output'];
};

/** Attributes for one user reporting or (un)blocking another user or job */
export type ReportBlockUnblockAttributes = {
  /** What action will be performed (report/block/unblock) */
  action: IncidentActions;
  /** Reason given for this change in status */
  blockReason?: InputMaybe<BlockReasons>;
  /** Comment given for why this is happening */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Category of reason for why this user is being reported */
  conversationReportReason?: InputMaybe<ConversationReportReasons>;
  /** Category of reason for why this job is being reported */
  postedJobReportReason?: InputMaybe<PostedJobReportReasons>;
  /** Category of reason for why this user is being blocked */
  unblockReason?: InputMaybe<UnblockReasons>;
};

/** Autogenerated input type of ReportBlockUnblock */
export type ReportBlockUnblockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID if the action is conversation_report / The posted job ID if the action is posted_job_report / The user ID if the action is block or unblock */
  entityId: Scalars['ID']['input'];
  /** Relevant attributes for this action */
  payload?: InputMaybe<ReportBlockUnblockAttributes>;
};

/** Autogenerated return type of ReportBlockUnblock */
export type ReportBlockUnblockPayload = {
  __typename?: 'ReportBlockUnblockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the details of the created incident */
  incident?: Maybe<Incident>;
};

/** Expression of Interest */
export type Request = {
  __typename?: 'Request';
  /** Timestamp when the object was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Current requester for expression of interest */
  eoiRequester?: Maybe<Requester>;
  /** Current responder for expression of interest */
  eoiResponder?: Maybe<Responder>;
  /** Unique identifier for the object */
  id: Scalars['ID']['output'];
  /** Indicative rates for expression of interest */
  indicativeRates?: Maybe<Array<IndicativeRate>>;
  /** Flag indicating the current user (user fetching the object) is the responder or not */
  isResponder: Scalars['Boolean']['output'];
  /** The job associated with the current object, if any */
  job?: Maybe<PostedJob>;
  /** Job detail for job related to expression of interest */
  jobDetail?: Maybe<JobDetail>;
  /** Matching detail for expression of interest */
  matchingDetail?: Maybe<MatchingDetail>;
  /** Message content, if available */
  message?: Maybe<Scalars['String']['output']>;
  /** Message metadata, if available */
  messageMeta?: Maybe<MessageMeta>;
  /** User who initiated the request */
  requester: User;
  /** Avatar URL of the requester */
  requesterAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the requester has dismissed the object */
  requesterDismissed: Scalars['Boolean']['output'];
  /** First name of the requester */
  requesterFirstName?: Maybe<Scalars['String']['output']>;
  /** Last name of the requester */
  requesterLastName?: Maybe<Scalars['String']['output']>;
  /** Current state of the requester in the workflow */
  requesterState: Scalars['String']['output'];
  /** User designated as the responder */
  responder: User;
  /** Flag indicating whether the responder has dismissed the object */
  responderDismissed: Scalars['Boolean']['output'];
  /** Current state of the responder in the workflow */
  responderState: Scalars['String']['output'];
  /** Overall state of the object */
  state: Scalars['String']['output'];
  /** Timeslots for expression of Interest */
  timeslots?: Maybe<Array<Timeslot>>;
  /** Timestamp when the object was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Universally Unique Identifier for the object */
  uuid: Scalars['ID']['output'];
  /** Timestamp when the object will expire */
  willExpireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of RequestAgreement */
export type RequestAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the conversation between the requestor and the requestee */
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestAgreement */
export type RequestAgreementPayload = {
  __typename?: 'RequestAgreementPayload';
  /** The requested agreement (or the existing request) */
  agreement?: Maybe<Agreement>;
  /** The agreement request */
  agreementRequest?: Maybe<AgreementRequest>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Request. */
export type RequestConnection = {
  __typename?: 'RequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Request>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RequestEdge = {
  __typename?: 'RequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Request>;
};

/** Autogenerated input type of RequestFeedback */
export type RequestFeedbackInput = {
  /** ID of the client */
  clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RequestFeedback */
export type RequestFeedbackPayload = {
  __typename?: 'RequestFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the rating if the client already gave one. Otherwise this field returns null */
  rating?: Maybe<Rating>;
  /** Returns null if the client already gave feedback. Otherwise this field returns the status of the request */
  status?: Maybe<Scalars['String']['output']>;
};

/** Requester for expression of interest */
export type Requester = {
  __typename?: 'Requester';
  /** About the member */
  about?: Maybe<Scalars['String']['output']>;
  /** Avatar URL of the member */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Delivered hour group of the member */
  deliveredHourGroup?: Maybe<Scalars['String']['output']>;
  /** Distance away from the member */
  distanceAway?: Maybe<Scalars['Float']['output']>;
  /** First name of the member */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender of the member */
  gender?: Maybe<Scalars['String']['output']>;
  /** Kind of the member */
  kind?: Maybe<Scalars['String']['output']>;
  /** Last name of the member */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Loyalty information for the member */
  loyalty?: Maybe<Loyalty>;
  /** Services offered by the member */
  offeredServices?: Maybe<Array<Scalars['String']['output']>>;
  /** Review count of the member */
  reviewCount?: Maybe<Scalars['Int']['output']>;
  /** Review rating of the member */
  reviewRating?: Maybe<Scalars['Float']['output']>;
  /** State of the member */
  state: Scalars['String']['output'];
  /** Universally Unique Identifier for the member */
  uuid: Scalars['ID']['output'];
};

/** Autogenerated input type of ResendUnlockInstructions */
export type ResendUnlockInstructionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user */
  email: Scalars['String']['input'];
};

/** Autogenerated return type of ResendUnlockInstructions */
export type ResendUnlockInstructionsPayload = {
  __typename?: 'ResendUnlockInstructionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Response status of the attempt to send */
  response?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RespondToAgreementOffer */
export type RespondToAgreementOfferInput = {
  /** What action are we performing (accept/decline) */
  action: AgreementResponseOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the agreement we are responding to */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RespondToAgreementOffer */
export type RespondToAgreementOfferPayload = {
  __typename?: 'RespondToAgreementOfferPayload';
  /** The agreement we are responding to */
  agreement: Agreement;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RespondToMeetAndGreet */
export type RespondToMeetAndGreetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the meet and greet */
  id: Scalars['ID']['input'];
  /** Response to meet and greet */
  response: MeetAndGreetResponseOptions;
};

/** Autogenerated return type of RespondToMeetAndGreet */
export type RespondToMeetAndGreetPayload = {
  __typename?: 'RespondToMeetAndGreetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns created meet and greet */
  meetAndGreet?: Maybe<MeetAndGreet>;
};

/** Responder for expression of interest */
export type Responder = {
  __typename?: 'Responder';
  /** About the member */
  about?: Maybe<Scalars['String']['output']>;
  /** Avatar URL of the member */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Delivered hour group of the member */
  deliveredHourGroup?: Maybe<Scalars['String']['output']>;
  /** Distance away from the member */
  distanceAway?: Maybe<Scalars['Float']['output']>;
  /** First name of the member */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender of the member */
  gender?: Maybe<Scalars['String']['output']>;
  /** Kind of the member */
  kind?: Maybe<Scalars['String']['output']>;
  /** Last name of the member */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Loyalty information for the member */
  loyalty?: Maybe<Loyalty>;
  /** Services offered by the member */
  offeredServices?: Maybe<Array<Scalars['String']['output']>>;
  /** Review count of the member */
  reviewCount?: Maybe<Scalars['Int']['output']>;
  /** Review rating of the member */
  reviewRating?: Maybe<Scalars['Float']['output']>;
  /** State of the member */
  state: Scalars['String']['output'];
  /** Universally Unique Identifier for the member */
  uuid: Scalars['ID']['output'];
};

/** Data about a Worker's responsiveness */
export type Response = {
  __typename?: 'Response';
  /** Response rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Response-time that will be publicly visible - null unless it's in the acceptable range (<24hrs) */
  time?: Maybe<Scalars['String']['output']>;
  /** Accurate response-time - only privately visible to the worker */
  timePersonal?: Maybe<Scalars['String']['output']>;
  /** Is the worker very responsive */
  veryResponsive?: Maybe<Scalars['Boolean']['output']>;
};

/** Editing details of an RSVP */
export enum RsvpEditOptions {
  /** The attendee has said 2  */
  No = 'no',
  /** The attendee has said 1  */
  Yes = 'yes'
}

/** RSVP for attendees of a scheduled event/session (non_responded, accepted or declined) */
export enum RsvpOptions {
  /** The attendee has said 2  */
  No = 'no',
  /** The attendee has said 0  */
  NotResponded = 'not_responded',
  /** The attendee has said 1  */
  Yes = 'yes'
}

/** Represents a type of schedule in the calendar */
export type Schedule = PlannedSupportSession | UnplannedSupportSession;

/** Types of possible scheduled-event/session */
export enum ScheduleOptions {
  PlannedSupportSession = 'PlannedSupportSession'
}

/** Channel through which an attendee has been invited through */
export enum ScheduleSource {
  /** Plan session has invited from agreement */
  Agreement = 'agreement',
  /** Plan session has invited from calendar */
  Calendar = 'calendar',
  /** Plan session has invited from chat */
  Chat = 'chat'
}

/** Details of scheduled-event/session */
export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  /** Current agreement between the creator and attendee of a session */
  agreementId?: Maybe<Scalars['ID']['output']>;
  /** Whether the user wants to receive check in/check out for this event */
  carerCheckInCheckOutReminder?: Maybe<Scalars['Boolean']['output']>;
  /** Session checked in at time */
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Session checked out at time */
  checkedOutAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Session creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Creator of session */
  creator: User;
  /** Delivered Session details for the occurrence */
  deliveredSession?: Maybe<DeliveredSession>;
  /** Derived unique ID for the session */
  derivedUniqueId?: Maybe<Scalars['String']['output']>;
  /** End time of the session */
  endingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the scheduled event */
  id: Scalars['ID']['output'];
  /** Is the current session a main event */
  isMainEvent: Scalars['Boolean']['output'];
  /** Is the session recurring */
  isRecurring: Scalars['Boolean']['output'];
  /**
   * Last minute job created from cancelled session
   * @deprecated renamed to postedJob
   */
  lastMinuteJob?: Maybe<PostedJob>;
  /** ID or derived unique ID of the occurrence */
  occurrenceId: Scalars['String']['output'];
  /** Type of occurrence ID */
  occurrenceIdType: SessionIdTypeValues;
  /** Indicates if this sessions overlaps another session with the same attendees */
  overlaps?: Maybe<Scalars['Boolean']['output']>;
  /** Posted job created from cancelled session */
  postedJob?: Maybe<PostedJob>;
  /** Rules for how session will recur */
  recurringRules?: Maybe<ScheduledEventRecurrence>;
  /** Date of the session */
  schedule: Scalars['String']['output'];
  /** Type of session */
  scheduleType: Schedule;
  /** Attendees of the session */
  scheduledEventAttendees: Array<ScheduledEventAttendees>;
  /** Start time of the session */
  startingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status of the session */
  status?: Maybe<SessionStatus>;
  /** Timezone the session is happening in ie 'Australia/Sydney' */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Session update timestamp */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attendee of a scheduled-event/session */
export type ScheduledEventAttendees = {
  __typename?: 'ScheduledEventAttendees';
  /** Can the attandee create a last minute job from a calendar event */
  canCreateReplacementLmj: Scalars['Boolean']['output'];
  /** Creation timestamp for the attendee */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Soft-delete timestamp for the attendee */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the attendee */
  id: Scalars['ID']['output'];
  /** Is the RSVP for a single occurrence only */
  isRsvpSingleOccurrence?: Maybe<Scalars['Boolean']['output']>;
  /** Reminder notification-period in seconds */
  notifyBeforeSeconds?: Maybe<Scalars['Int']['output']>;
  /** Attendees rsvp data for the scheduled event */
  rsvp: RsvpOptions;
  /** Reason for RSVP */
  rsvpReason?: Maybe<Scalars['String']['output']>;
  /** Detail of the scheduled-event/session */
  scheduledEvent: ScheduledEvent;
  /** Any rescheduling requests made for this session */
  scheduledEventRescheduleRequests?: Maybe<Array<ScheduledEventRescheduleRequest>>;
  /** Update timestamp for the attendee */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-data for the attendee invited to the session */
  user: User;
};

/** Arguments to create scheduled-events/sessions */
export type ScheduledEventAttributes = {
  /** Agreement between the creator and invitee */
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether the user wants to receive check in/check out notifications */
  checkInCheckOutReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notification for the other attendee of the session */
  clientReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notification for the creator of the session */
  creatorReminder: Scalars['Boolean']['input'];
  /** The date that the session finishes. By default, same as start date, unless finishing overnight; dd/mm/yyyy format */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** The time that the session ends, hh:mm AM/PM format */
  endTime: Scalars['String']['input'];
  /** Whether the user wants to notify the other participant about the update */
  notifyParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  /** participant_ids are other members in the session, which is accepted as an array of user_ids */
  participantIds: Array<Scalars['Int']['input']>;
  /** Support session inputs needed when the scheduleType is 'Support Session' */
  plannedSupportSession?: InputMaybe<PlannedSupportSessionAttributes>;
  /** Recurrence details */
  recurrence: ScheduledEventRecurrenceAttributes;
  /** Type of session */
  scheduleType: ScheduleOptions;
  /** Offset to UTC time in integer */
  scheduledAtTzoffset?: InputMaybe<Scalars['Int']['input']>;
  /** Channel through which an attendee has been invited */
  source?: InputMaybe<ScheduleSource>;
  /** The date that the session starts, dd/mm/yyyy format */
  startDate: Scalars['String']['input'];
  /** The time that the session starts, hh:mm AM/PM format */
  startTime: Scalars['String']['input'];
  /** Timezone name - full name (eg. 'Australia/Sydney') */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Record who is responsible for the cancellation */
export enum ScheduledEventCancelledBy {
  /** Cancelled by carer_on_behalf_of_client */
  CarerOnBehalfOfClient = 'carer_on_behalf_of_client',
  /** Cancelled by carer_other */
  CarerOther = 'carer_other',
  /** Cancelled by carer_self */
  CarerSelf = 'carer_self',
  /** Cancelled by client_not_needed */
  ClientNotNeeded = 'client_not_needed',
  /** Cancelled by client_on_behalf_of_carer */
  ClientOnBehalfOfCarer = 'client_on_behalf_of_carer',
  /** Cancelled by client_other */
  ClientOther = 'client_other',
  /** Cancelled by client_self */
  ClientSelf = 'client_self'
}

/** The connection type for ScheduledEvent. */
export type ScheduledEventConnection = {
  __typename?: 'ScheduledEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ScheduledEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ScheduledEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** The result of searching for scheduled-events/sessions within a date-range */
export type ScheduledEventDateRange = {
  __typename?: 'ScheduledEventDateRange';
  /** Have any sessions been created in this date-range */
  hasCreatedScheduledEvents?: Maybe<Scalars['Boolean']['output']>;
  /** Are there any sessions after the date-range */
  scheduledEventAfterDateRange?: Maybe<Scalars['Boolean']['output']>;
  /** Details of the sessions within the date-range */
  scheduledEvents: Array<ScheduledEvent>;
};

/** Details of a scheduled-event/session */
export type ScheduledEventDetail = {
  __typename?: 'ScheduledEventDetail';
  /** Current agreement between the creator and attendee of a session */
  agreementId?: Maybe<Scalars['ID']['output']>;
  /** Whether the user wants to receive check in/check out for this event */
  carerCheckInCheckOutReminder?: Maybe<Scalars['Boolean']['output']>;
  /** Sendbird channel URL relating to this session */
  channelUrl?: Maybe<Scalars['String']['output']>;
  /** Session checked in at time */
  checkedInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Session checked out at time */
  checkedOutAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Session creation timestamp */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Creator of session */
  creator: User;
  /** Delivered Session details for the occurrence */
  deliveredSession?: Maybe<DeliveredSession>;
  /** Derived unique ID for the session */
  derivedUniqueId?: Maybe<Scalars['String']['output']>;
  /** End time of the session */
  endingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the scheduled event */
  id: Scalars['ID']['output'];
  /** Is the current session a main event */
  isMainEvent: Scalars['Boolean']['output'];
  /** Is the session recurring */
  isRecurring: Scalars['Boolean']['output'];
  /**
   * Last minute job created from cancelled session
   * @deprecated renamed to postedJob
   */
  lastMinuteJob?: Maybe<PostedJob>;
  /** ID or derived unique ID of the occurrence */
  occurrenceId: Scalars['String']['output'];
  /** Type of occurrence ID */
  occurrenceIdType: SessionIdTypeValues;
  /** Indicates if this sessions overlaps another session with the same attendees */
  overlaps?: Maybe<Scalars['Boolean']['output']>;
  /** Posted job created from cancelled session */
  postedJob?: Maybe<PostedJob>;
  /** Rules for how session will recur */
  recurringRules?: Maybe<ScheduledEventRecurrence>;
  /** Date of the session */
  schedule: Scalars['String']['output'];
  /** Type of session */
  scheduleType: Schedule;
  /** Attendees of the session */
  scheduledEventAttendees: Array<ScheduledEventAttendees>;
  /** Start time of the session */
  startingAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status of the session */
  status?: Maybe<SessionStatus>;
  /** Timezone the session is happening in ie 'Australia/Sydney' */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Session update timestamp */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** An edge in a connection. */
export type ScheduledEventEdge = {
  __typename?: 'ScheduledEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ScheduledEvent>;
};

/** Describes whether changes to a scheduled-event/session are for a single session or multiple sessions */
export enum ScheduledEventEditOptions {
  /** Editing for multiple_occurrence */
  MultipleOccurrence = 'multiple_occurrence',
  /** Editing for single_occurrence */
  SingleOccurrence = 'single_occurrence'
}

/** Rules for how scheduled-event/session will recur */
export type ScheduledEventRecurrence = {
  __typename?: 'ScheduledEventRecurrence';
  /** What days will the session recur on */
  days?: Maybe<Array<Scalars['String']['output']>>;
  /** With what interval will the session recur */
  interval?: Maybe<Scalars['Int']['output']>;
  /** The monthly day a session will recur on */
  monthlyDay?: Maybe<Scalars['String']['output']>;
  /** The week of the month the scheduled event recurs on */
  monthlyWeekOptions?: Maybe<Scalars['String']['output']>;
  /** What type of recurrence will the session employ */
  recurrenceType: Scalars['String']['output'];
  /** The session will recur until this timestamp */
  untilTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When does the recurrence start */
  weekStart?: Maybe<Scalars['Int']['output']>;
};

/** Details of the recurrence of a scheduled-event/session */
export type ScheduledEventRecurrenceAttributes = {
  /** What days the session is recurring on for a weekly or fortnightly recurrence */
  days?: InputMaybe<Array<DayOptions>>;
  /** The date that the recurrence will finish on, dd/mm/yyyy format */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Day of the month for a monthly recurrence */
  monthlyDay?: InputMaybe<DayOptions>;
  /** Week options for a monthly recurrence */
  monthlyWeekOptions?: InputMaybe<WeekOptions>;
  /** The type of recurrence a session has */
  recurrenceType: RecurrenceOptions;
};

/** Details of a request to reschedule a scheduled-event/session */
export type ScheduledEventRescheduleRequest = {
  __typename?: 'ScheduledEventRescheduleRequest';
  /** Creation timestamp for the reschedule-request */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Reason the reschedule request was declined */
  declineReason?: Maybe<Scalars['String']['output']>;
  /** Unique id of the session */
  derivedUniqueId: Scalars['String']['output'];
  /** Requested new end-time for the session */
  endingAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the reschedule request */
  id: Scalars['ID']['output'];
  /** Any notes about the reschedule request */
  notes?: Maybe<Scalars['String']['output']>;
  /** Is the attendee requesting the event be recurring */
  recurring: Scalars['Boolean']['output'];
  /** Requested recurrence rules */
  recurringRules: ScheduledEventRecurrence;
  /** Requested new start-time for the session */
  startingAt: Scalars['ISO8601DateTime']['output'];
  /** Status of the reschedule-request */
  status: ScheduledEventRescheduleRequestStatuses;
  /** Timezone the session is going to take place in */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Update timestamp for the reschedule-request */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attributes required when an attendee requests that a scheduled-event/session is to be rescheduled */
export type ScheduledEventRescheduleRequestAttributes = {
  /** Derived unique id of the session */
  derivedUniqueId: Scalars['String']['input'];
  /** The date that the session finishes. By default, same as start date, unless finishing overnight; dd/mm/yyyy format */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** The time that the session will end, hh:mm AM/PM format */
  endTime: Scalars['String']['input'];
  /** Notes about the time proposal */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Reccurence details */
  recurrence: ScheduledEventRecurrenceAttributes;
  /** Attendee ID */
  scheduledEventAttendeeId: Scalars['ID']['input'];
  /** The date that the session will start, dd/mm/yyyy format */
  startDate: Scalars['String']['input'];
  /** The time that the session will start, hh:mm AM/PM format */
  startTime: Scalars['String']['input'];
  /** Timezone the session is occurring in eg 'Australia/Sydney' */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Status of a reschedule request (pending/accepted/declined) */
export enum ScheduledEventRescheduleRequestStatuses {
  Accepted = 'accepted',
  Declined = 'declined',
  Pending = 'pending'
}

/** Details of the update for a scheduled-event/session RSVP */
export type ScheduledEventRsvpUpdate = {
  /** Who is responsible for the cancellation? */
  cancelledBy?: InputMaybe<ScheduledEventCancelledBy>;
  /** Edit is for all or single occurrence */
  editOption?: InputMaybe<ScheduledEventEditOptions>;
  /** Reason for the rsvp exception */
  exceptionReason?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not to notify participant about the decline */
  notifyParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attendees rsvp for the session */
  rsvp?: InputMaybe<RsvpEditOptions>;
};

/** Attributes of a saved search-filter */
export type SearchFilter = {
  __typename?: 'SearchFilter';
  /** If not null, render a 'more information' tooltip dialog with the included lines of text */
  dialog?: Maybe<Array<Scalars['String']['output']>>;
  /** ID of the search-filter */
  id?: Maybe<Scalars['ID']['output']>;
  /** Should we render this filter to draw attention to its dialog box */
  important?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the filter - shown to users */
  name: Scalars['String']['output'];
  /** Order to display each option, lowest first. Not consecutive. */
  order?: Maybe<Scalars['Int']['output']>;
  /** Should we display as one of the top options, outside of the Show More block */
  showByDefault?: Maybe<Scalars['Boolean']['output']>;
  /** An internal string for the filter; this can be accepted by search queries */
  sortValue: Scalars['String']['output'];
};

/** Attributes of search filters used when a client searches for support-workers */
export type SearchFilterCategory = {
  __typename?: 'SearchFilterCategory';
  /** Does this category map to a WorkerAdvancedSearchFilterAttribute type */
  advanced?: Maybe<Scalars['Boolean']['output']>;
  /** Unique code that can be used for reference purposes */
  code: Scalars['String']['output'];
  /** Description of this category */
  description?: Maybe<Scalars['String']['output']>;
  /** Search filters used */
  filters?: Maybe<Array<SearchFilter>>;
  /** Display-name for the category */
  name: Scalars['String']['output'];
  /** Should the items in this category be shown as a dropdown rather than as a list of checkboxes */
  showAsDropdown?: Maybe<Scalars['Boolean']['output']>;
  /** Subcategories of this category */
  subcategories?: Maybe<Array<SearchFilterCategory>>;
};

/** Used for showing conditional sections in worker profile */
export type SectionVisibility = {
  __typename?: 'SectionVisibility';
  /** When `false`, Hide the apply to job button in job details view */
  applyToJob: Scalars['Boolean']['output'];
  /** flags for new care experience */
  careExperienceFlags: CareExperienceFlags;
  /** When `true`, Show `Delivered XX to XX support hours on Mable since dd/mm/yyyy` label in worker profile Using `deliveredHourRange` and `memberSince` fields */
  showDeliveredHoursCombinedLabel: Scalars['Boolean']['output'];
  /** When `true`, Show `On Mable since dd/mm/yyyy` label in worker profile Using `memberSince` fields */
  showMemberSinceLabel: Scalars['Boolean']['output'];
  /** When `true`, Show `New` label in worker profile */
  showNewLabel: Scalars['Boolean']['output'];
  /** When `true`, Show submit ABN cta */
  showSubmitAbnCta: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendMessageToCarersOnBehalfOfClient */
export type SendMessageToCarersOnBehalfOfClientInput = {
  /** IDs of the carers that will be the recipients of the message */
  carerIds: Array<Scalars['ID']['input']>;
  /** ID of the client on whose behalf the coordinator is messaging */
  clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Main body of the message to the carers */
  message: Scalars['String']['input'];
  /** ID of the job that will be shared with the given carers */
  postedJob?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SendMessageToCarersOnBehalfOfClient */
export type SendMessageToCarersOnBehalfOfClientPayload = {
  __typename?: 'SendMessageToCarersOnBehalfOfClientPayload';
  /** Return ID of the sidekiq job that will do the messaging */
  asyncJobId?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Attributes received when a party sends an agreement offer */
export type SendOfferAttributes = {
  /** Whether the participants have agreed on dates and times for their support sessions */
  agreedOnSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Service that will be undertaken by the carer */
  agreedService?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user that this agreement will be for */
  consumerUserId: Scalars['ID']['input'];
  /** Detail of agreed days and times the service will be undertaken */
  daysAndTimes?: InputMaybe<DaysAndTimes>;
  /** Expected day this agreement will end */
  expectedEndDate?: InputMaybe<Scalars['String']['input']>;
  /** Expected day this agreement will start */
  expectedStartDate?: InputMaybe<Scalars['String']['input']>;
  /** Whether it's an ongoing on once off job */
  jobFrequency?: InputMaybe<PostedJobFrequencyOptions>;
  /** Whether it's a a weekly, fornightly, monthly or other job */
  jobOccurrence?: InputMaybe<AgreementJobOccurrenceOptions>;
  /** Rate charged per Km travelled - in dollars */
  perKmRateDollars?: InputMaybe<Scalars['Float']['input']>;
  /** Item IDs for agreed NDIS support items in the agreement */
  planSupportItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** ID of the original job-post this agreement was in response to */
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
  /** Details of carer rates that will be charged for this agreement */
  ratesInDollars: Array<RateAttributes>;
  /** Timing details of your support sessions e.g. 9am to 11am every fortnight */
  scheduleDescription?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for cancelling sessions */
  supportCancel?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for changing or adding sessions */
  supportChange?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for feedback, complaints or disputes */
  supportFeedback?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for minimum hours, finishing early and overtime */
  supportMinHours?: InputMaybe<Scalars['String']['input']>;
  /** ??? Are travel expenses expected for this agreement */
  travelExpenseFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of SendOffer */
export type SendOfferInput = {
  /** Attributes of a valid offer */
  attributes: SendOfferAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendOffer */
export type SendOfferPayload = {
  __typename?: 'SendOfferPayload';
  /** The agreement we're altering */
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Attributes received when a party sends an agreement offer */
export type SendOfferWithStructuredRatesAttributes = {
  /** Details of the structured rates for this agreement */
  agreedRates: AgreedRateAttributes;
  /** Service that will be undertaken by the carer */
  agreedService?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user that this agreement will be for */
  consumerUserId: Scalars['ID']['input'];
  /** Rate charged per Km travelled - in dollars */
  perKmRateDollars?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the original job-post this agreement was in response to */
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
  /** Support terms for cancelling sessions */
  supportCancel?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for changing or adding sessions */
  supportChange?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for feedback, complaints or disputes */
  supportFeedback?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for minimum hours, finishing early and overtime */
  supportMinHours?: InputMaybe<Scalars['String']['input']>;
  /** Are travel expenses expected for this agreement */
  travelExpenseFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of SendOfferWithStructuredRates */
export type SendOfferWithStructuredRatesInput = {
  /** Attributes of a valid offer */
  attributes: SendOfferWithStructuredRatesAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendOfferWithStructuredRates */
export type SendOfferWithStructuredRatesPayload = {
  __typename?: 'SendOfferWithStructuredRatesPayload';
  /** The agreement we're altering */
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Attributes of a sendbird channel */
export type SendbirdChannelAttributes = {
  /** Custom channel name for group chat */
  channelName?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the other members in the channel */
  participantIds: Array<Scalars['Int']['input']>;
  /** Channel type: group or one-on-one */
  type: SendbirdChannelOptions;
};

/** Details of the sendbird channel that a conversation uses */
export type SendbirdChannelDetail = {
  __typename?: 'SendbirdChannelDetail';
  /** What type of channel is this */
  channelType: SendbirdChannelOptions;
  /** URL used for fetching the channel details */
  channelUrl?: Maybe<Scalars['String']['output']>;
  /** Conversation that uses this channel */
  conversation: Conversation;
  /** ID of the sendbird channel */
  id: Scalars['ID']['output'];
};

/** Response from a request for a sendbird channel */
export type SendbirdChannelDetailResponse = {
  __typename?: 'SendbirdChannelDetailResponse';
  /** Does this sendbird channel have messages */
  isConversationEmpty: Scalars['Boolean']['output'];
  /** Details about this sendbird channel */
  sendbirdChannelDetail?: Maybe<SendbirdChannelDetail>;
};

/** Valid types of sendbird channel */
export enum SendbirdChannelOptions {
  GroupChat = 'group_chat',
  OneOnOne = 'one_on_one'
}

/** Attributes of an individual service that a support-worker can provide to a client */
export type Service = {
  __typename?: 'Service';
  /** Detailed data about the service to return to the frontend to display in a dialog */
  dialog: Array<Scalars['String']['output']>;
  /** Display-ready name for this service */
  displayName?: Maybe<Scalars['String']['output']>;
  /** ID of the service */
  id: Scalars['ID']['output'];
  /** Should we render this filter to draw attention to its dialog box */
  important: Scalars['Boolean']['output'];
  /** Name of the service */
  name: Scalars['String']['output'];
  /** ndis service category or mable service */
  serviceType: ServiceCategoryableType;
  /** An internal string for the filter; this can be accepted by search queries */
  sortValue: Scalars['String']['output'];
};

/** Service-categories group related services eg Personal Care (PC) */
export type ServiceCategories = {
  __typename?: 'ServiceCategories';
  /** Contains a longer description/further details of the category, often in html */
  details: Scalars['String']['output'];
  /** ID of the Srvice category - usually a short string */
  id: Scalars['String']['output'];
  /** Important? - seems unused */
  isImportant: Scalars['Boolean']['output'];
  /** Subtitle for secondary info eg if quals are needed */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** Descriptive title of the category */
  title: Scalars['String']['output'];
  /** service that is no longer supported */
  unsupported?: Maybe<Scalars['Boolean']['output']>;
};

/** Attributes of a service-category - a category that contains other individual services that can be provided by a support-worker */
export type ServiceCategory = {
  __typename?: 'ServiceCategory';
  /** String-based code for the service-category (eg nursing_list) */
  code: Scalars['String']['output'];
  /** ID of the service-category */
  id: Scalars['ID']['output'];
  /** Name of the service-category */
  name: Scalars['String']['output'];
  /** Individual services within the category */
  services?: Maybe<Array<Service>>;
};

/** It represents a Service or a BudgetSupportType */
export type ServiceCategoryable = BudgetSupportType | Service;

/** Type of service or service category for an agreed rate */
export enum ServiceCategoryableType {
  /** Mable service */
  MableService = 'mable_service',
  /** NDIS service category */
  NdisServiceCategory = 'ndis_service_category'
}

/** Service codes eg basic_companionship, basic_community, etc */
export enum ServiceCodeOptions {
  AlliedList = 'allied_list',
  AsianBackground = 'asian_background',
  BasicAdminMaint = 'basic_admin_maint',
  BasicAllied = 'basic_allied',
  BasicAlliedOccupationalTherapy = 'basic_allied_occupational_therapy',
  BasicAlliedPhysiotherapy = 'basic_allied_physiotherapy',
  BasicAlliedPsychological = 'basic_allied_psychological',
  BasicAlliedSpeechTherapy = 'basic_allied_speech_therapy',
  BasicAssessPlanning = 'basic_assess_planning',
  BasicAssistEat = 'basic_assist_eat',
  BasicAssistMed = 'basic_assist_med',
  BasicCommunity = 'basic_community',
  BasicCompanionship = 'basic_companionship',
  BasicGardening = 'basic_gardening',
  BasicHousework = 'basic_housework',
  BasicLightMassExercise = 'basic_light_mass_exercise',
  BasicManualHandling = 'basic_manual_handling',
  BasicMeal = 'basic_meal',
  BasicNurse = 'basic_nurse',
  BasicPalliativePersonal = 'basic_palliative_personal',
  BasicShowering = 'basic_showering',
  BasicTransport = 'basic_transport',
  CareKnowledgeAgedCare = 'care_knowledge_aged_care',
  CareKnowledgeChronic = 'care_knowledge_chronic',
  CareKnowledgeDisability = 'care_knowledge_disability',
  CareKnowledgeGeneral = 'care_knowledge_general',
  CareKnowledgeMental = 'care_knowledge_mental',
  Cultures = 'cultures',
  Interests = 'interests',
  Languages = 'languages',
  MiddleEastBackground = 'middle_east_background',
  NurseType = 'nurse_type',
  NursingList = 'nursing_list',
  PcQualifications = 'pc_qualifications',
  Personalities = 'personalities',
  PsList = 'ps_list',
  Qualifications = 'qualifications',
  ReligionsBackground = 'religions_background',
  RestrictionsList = 'restrictions_list',
  SocAndDomList = 'soc_and_dom_list',
  SouthEastEuropeBackground = 'south_east_europe_background',
  WestEuropeBackground = 'west_europe_background'
}

/** How much does this worker fit with the jobs service prerequisites */
export type ServiceCoverage = {
  __typename?: 'ServiceCoverage';
  /** desired services */
  desiredServices?: Maybe<Coverage>;
  /** desired worker services */
  desiredWorkerTypes?: Maybe<Coverage>;
  /** overall */
  overall?: Maybe<Scalars['Float']['output']>;
  /** required services */
  requiredServices?: Maybe<Coverage>;
  /** required worker services */
  requiredWorkerTypes?: Maybe<Coverage>;
};

/** Snapshot of service mappings at the time of application */
export type ServiceMappingSnapshot = {
  __typename?: 'ServiceMappingSnapshot';
  /** List of budget support type IDs */
  budgetSupportTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** List of service IDs */
  serviceIds?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Sub category values under services category */
export enum Services {
  MyType = 'my_type',
  ServicesAlliedHealth = 'services_allied_health',
  ServicesPersonalCare = 'services_personal_care',
  ServicesSocialAndDomestic = 'services_social_and_domestic'
}

/** Fields for the services match object */
export type ServicesMatch = {
  __typename?: 'ServicesMatch';
  /** match value */
  match: Match;
  /** percentage match for the worker */
  percentage: Scalars['Int']['output'];
};

/** Type used for identifying persisted or projected sessions */
export type SessionId = {
  /** Persisted or projected id value */
  id: Scalars['String']['input'];
  /** Type of id */
  idType: SessionIdTypeValues;
};

/** Session Id type */
export enum SessionIdTypeValues {
  Persisted = 'persisted',
  Projected = 'projected'
}

/** Feedback of the impression a user had of this session */
export type SessionImpression = {
  __typename?: 'SessionImpression';
  /** Conversation between the current user and others */
  conversation: Conversation;
  /** Timestamp when the impression was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Feedback on the session */
  feedback?: Maybe<Scalars['String']['output']>;
  /** ID of the impression */
  id: Scalars['ID']['output'];
  /** Response from the mobile rating-prompt */
  response: MobileRatingPromptOptions;
  /** Timestamp when the impression was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User giving this feedback */
  user: User;
};

/** Attributes of a session impression - feedback from a user about their session */
export type SessionImpressionAttribute = {
  /** ID of the conversation between the people involved in the session */
  conversationId: Scalars['Int']['input'];
  /** Feedback about this session */
  feedback?: InputMaybe<Scalars['String']['input']>;
  /** What type of impression is this - positive/negative */
  response: SessionImpressionOptions;
};

/** What type of impression is this - positive/negative */
export enum SessionImpressionOptions {
  /** negative */
  Negative = 'negative',
  /** positive */
  Positive = 'positive'
}

/** Statuses of a session's service */
export enum SessionServiceStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Statuses of a session */
export enum SessionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Confirmed = 'confirmed',
  Declined = 'declined',
  Pending = 'pending'
}

/** Autogenerated input type of SharePostedJob */
export type SharePostedJobInput = {
  /** Body of the message to share */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Captures how the client-worker connection was made eg through search, recommended worker etc */
  mechanism?: InputMaybe<ConversationMechanismOptions>;
  /** ID of the posted job to manipulate */
  postedJobId: Scalars['ID']['input'];
  /** URL of the sendbird channel to share through */
  sendbirdChannelUrl: Scalars['String']['input'];
};

/** Autogenerated return type of SharePostedJob */
export type SharePostedJobPayload = {
  __typename?: 'SharePostedJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** status of the request */
  sharePostedJobResponse?: Maybe<SharePostedJobResponse>;
};

/** Status of the job shared with a worker */
export type SharePostedJobResponse = {
  __typename?: 'SharePostedJobResponse';
  /** The viewable status of the request */
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SharePostedJobWithWorkers */
export type SharePostedJobWithWorkersInput = {
  /** ID of the client */
  clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the posted job to share */
  postedJobId: Scalars['ID']['input'];
  /** Array of support provider IDs */
  supportProviderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of SharePostedJobWithWorkers */
export type SharePostedJobWithWorkersPayload = {
  __typename?: 'SharePostedJobWithWorkersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The status of the job enqueuing */
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ShareShiftNote */
export type ShareShiftNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the client doing the sharing */
  contactId: Scalars['ID']['input'];
  /** UUID of the delivered session this note references to */
  deliveredSessionUuid?: InputMaybe<Scalars['String']['input']>;
  /** ID of the event-delivery (shift) this note references */
  eventDeliveryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ShareShiftNote */
export type ShareShiftNotePayload = {
  __typename?: 'ShareShiftNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Status of the request */
  status?: Maybe<Scalars['String']['output']>;
};

/** Information about workers references/endorsement that will be made visible to others */
export type ShareableReferencesSummary = {
  __typename?: 'ShareableReferencesSummary';
  /** Detail of the reference */
  data: Array<Scalars['String']['output']>;
  /** Display heading */
  heading: Scalars['String']['output'];
  /** Is the reference still pending */
  pending: Scalars['Boolean']['output'];
  /** Is the reference visible */
  visible: Scalars['Boolean']['output'];
};

/** Attributes of a shift-note that covers what happened during a shift */
export type ShiftNote = {
  __typename?: 'ShiftNote';
  /** Attached documents for this shift-note */
  attachments?: Maybe<ShiftNoteAttachment>;
  /** Can this shift-note be shared with the client */
  canShareShiftNote?: Maybe<Scalars['Boolean']['output']>;
  /** Description of the shift-note contains all the details of the shift */
  description?: Maybe<Scalars['String']['output']>;
  /** Contacts relevant for this shift-note */
  sharedContacts?: Maybe<Array<Contact>>;
  /** How many contacts is this shift-note relevant to */
  sharedContactsCount?: Maybe<Scalars['Int']['output']>;
};

/** Details of a shift-note that covers what happened during a shift */
export type ShiftNoteAsset = {
  __typename?: 'ShiftNoteAsset';
  /** Attached file */
  asset?: Maybe<Asset>;
  /** What kind of shift note is this */
  category?: Maybe<Scalars['String']['output']>;
  /** Timestamp for when shift note was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Timestamp for when shift-note was soft-deleted */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reason for deleting the shift note */
  deletionReason?: Maybe<DeletionReasonOptions>;
  /** Associated timesheet for the shift */
  eventDelivery?: Maybe<EventDelivery>;
  /** ID of the shift note */
  id?: Maybe<Scalars['ID']['output']>;
  /** Timestamp for when shift note was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attributes of document(s) attached to a shift-note */
export type ShiftNoteAttachment = {
  __typename?: 'ShiftNoteAttachment';
  /** Can we delete this attachment */
  canDeleteFlag?: Maybe<Scalars['Boolean']['output']>;
  /** Images of the relevant document(s) */
  images?: Maybe<Array<ShiftNoteAsset>>;
};

/** Details of how to sort a list of shift notes (eg by name or delivery_date) */
export type ShiftNoteSortInput = {
  /** Direction of the sort (asc/desc) */
  direction: Scalars['String']['input'];
  /** Field to sort by (from a valid list) */
  field: ShiftNotesOrder;
};

/** Attributes of an export of shift-notes */
export type ShiftNotesExport = {
  __typename?: 'ShiftNotesExport';
  /** All of the export-data */
  content?: Maybe<Scalars['String']['output']>;
};

/** Valid options for sorting a list of shift notes */
export enum ShiftNotesOrder {
  /** Sort by delivered start time */
  DeliveryDate = 'delivery_date',
  /** Sort by carer name */
  Name = 'name'
}

/** Individual item in a user's shortlist (either of support-workers or posted-jobs) */
export type ShortlistItem = {
  __typename?: 'ShortlistItem';
  /** ID of the shortlist item */
  id: Scalars['ID']['output'];
  /** How the client-worker connection was made eg through search, recommended worker etc */
  mechanism?: Maybe<ConversationMechanismOptions>;
  /** The carer-profile of the support-worker that this shortlist-item represents */
  profile: WorkerProfile;
  /** The shortlisted resource-type, can be CarerProfile or PostedJob */
  shortlistResource: ShortlistResource;
  /** User that owns this shortlist */
  user: User;
};

/** The connection type for ShortlistItem. */
export type ShortlistItemConnection = {
  __typename?: 'ShortlistItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ShortlistItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ShortlistItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ShortlistItemEdge = {
  __typename?: 'ShortlistItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ShortlistItem>;
};

/** Represents either a WorkerProfile or PostedJob */
export type ShortlistResource = PostedJob | WorkerProfile;

/** Possible sources through which a user signed up */
export enum SignUpSource {
  /** Signed up through HomeMade */
  HomeMade = 'HomeMade',
  /** Signed up through Mable */
  Mable = 'Mable'
}

/** Sort type for ManageRequests queries */
export type Sort = {
  /** Sort ascending or descending */
  createdAt?: InputMaybe<SortDirection>;
  /** Sort ascending or descending */
  topMatch?: InputMaybe<SortDirection>;
};

/** Sort direction ascending (asc) or descending (desc) */
export enum SortDirection {
  /** Sort in ascending order */
  Asc = 'asc',
  /** Sort in descending order */
  Desc = 'desc'
}

/** Possible values for the state */
export enum State {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Expired = 'expired',
  InvitationDeclined = 'invitation_declined',
  Invited = 'invited',
  JobCancelled = 'job_cancelled',
  Pending = 'pending'
}

/** Global static data */
export type StaticData = {
  __typename?: 'StaticData';
  /** Fee-percentage charged to carers */
  carerFee?: Maybe<Scalars['Float']['output']>;
  /** Fee-percentage charged to clients */
  consumerFee?: Maybe<Scalars['Float']['output']>;
  /** Returns current superannuation rate */
  superannuationRate?: Maybe<Scalars['Float']['output']>;
};

/** Details of a GraphQL subscription */
export type Subscription = {
  __typename?: 'Subscription';
  /** Subscription for the latest user details */
  account: AccountPayload;
  /** Create a job reply for applying to a job */
  createdJobReply: CreatedJobReplyPayload;
};


/** Details of a GraphQL subscription */
export type SubscriptionCreatedJobReplyArgs = {
  postedJobId: Scalars['ID']['input'];
};

/** Attributes for describing a suburb to be selected (eg in a select-dropdown) */
export type SuburbAttributes = {
  __typename?: 'SuburbAttributes';
  /** Index - ordering of the suburb */
  idx: Scalars['Int']['output'];
  /** Text - name of the suburb */
  txt: Scalars['String']['output'];
};

/** Details of suburb to filter a worker-search for a client */
export type SuburbSearchAttributes = {
  /** ID of the suburb */
  idx: Scalars['ID']['input'];
  /** Text-based search string */
  txt: Scalars['String']['input'];
};

/** Details of superannuation data for a worker */
export type Superannuation = {
  __typename?: 'Superannuation';
  /** Superannuation amount due */
  amountDue: Scalars['Float']['output'];
  /** Data table of historical payments - generated asynchronously */
  paymentsDataTable: SuperannuationAsyncResponse;
  /** Worker superannuation rate */
  rate: Scalars['Float']['output'];
  /** Total amount of superannuation due */
  totalAmountDue: Scalars['Float']['output'];
};

/** Information about the asynchonous job that will fetch the payments data table feeding the superannuation calculator */
export type SuperannuationAsyncResponse = {
  __typename?: 'SuperannuationAsyncResponse';
  /** Error message if the job was unsuccessful */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Was the job generated sucessfully */
  jobCreatedSuccessfully?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the sidekiq job */
  jobId?: Maybe<Scalars['String']['output']>;
};

/** Attributes of a Support-area covered by an NDIS plan */
export type SupportArea = {
  __typename?: 'SupportArea';
  /** Amount covered by this support-area */
  amount?: Maybe<Scalars['Float']['output']>;
  /** ID of the support-area */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of the support-area */
  name?: Maybe<Scalars['String']['output']>;
  /** ID of the NDIS support-area this covers */
  ndisSupportAreaId?: Maybe<Scalars['ID']['output']>;
  /** Support-items covered by this support-area */
  supportItemsAttributes?: Maybe<Array<SupportItem>>;
};

/** Area of support that an NDIS plan covers */
export type SupportAreaAttributes = {
  /** Destroys this support-area if true */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Amount of support provided for */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** ID of this support-area */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the related NDIS support plan */
  ndisPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the NDIS support-area covered */
  ndisSupportAreaId?: InputMaybe<Scalars['ID']['input']>;
  /** More detail of the support-item covered by this support-area */
  supportItemsAttributes?: InputMaybe<Array<SupportItemAttributes>>;
};

/** Information about the duration of an individual kind of support during a shift */
export type SupportDuration = {
  __typename?: 'SupportDuration';
  /** Reference to the relevant timesheet */
  eventDelivery?: Maybe<Scalars['String']['output']>;
  /** ID of the relevant timesheet */
  eventDeliveryId?: Maybe<Scalars['ID']['output']>;
  /** How many hours was this service performed */
  hours?: Maybe<Scalars['Int']['output']>;
  /** ID of the support duration */
  id?: Maybe<Scalars['ID']['output']>;
  /** How many minutes was this service performed */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** Name of the support service */
  name?: Maybe<Scalars['String']['output']>;
  /** ID relating this service back to an item on the support-plan */
  planSupportItemId?: Maybe<Scalars['ID']['output']>;
};

/** Attributes for a new SupportDuration which records length of time spent on a specific service */
export type SupportDurationAttributes = {
  /** ID of the related timesheet */
  eventDeliveryId?: InputMaybe<Scalars['ID']['input']>;
  /** Hours spent on this service */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the support duration */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Minutes spent on the service */
  minutes?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the service provided */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID linking back to the relevant item on the support-plan */
  planSupportItemId?: InputMaybe<Scalars['ID']['input']>;
};

/** Details noted about a change in the clients health */
export type SupportHealthChange = {
  __typename?: 'SupportHealthChange';
  /** Any additional description of the health change */
  healthChangeAdditionalDetails?: Maybe<Scalars['String']['output']>;
  /** ID of the health change record */
  id?: Maybe<Scalars['ID']['output']>;
  /** Was a change observed */
  noObservation?: Maybe<Scalars['Boolean']['output']>;
  /** Should we share the health change information (with the client?) */
  shareHealthChangeInformation?: Maybe<Scalars['Boolean']['output']>;
  /** Answers to health-change questions */
  supportHealthChangeAnswers?: Maybe<Array<SupportHealthChangeAnswer>>;
};

/** Answer details for a question about any observed health changes */
export type SupportHealthChangeAnswer = {
  __typename?: 'SupportHealthChangeAnswer';
  /** Answer to this question */
  answer?: Maybe<Scalars['Boolean']['output']>;
  /** What is the question asked */
  supportNoteQuestion?: Maybe<Scalars['String']['output']>;
  /** ID of the related questionnaire */
  supportNoteQuestionnaireId?: Maybe<Scalars['ID']['output']>;
};

/** Attributes of a health-change answer - questions ask if certain aspects of the participant's health changed and the answer is yes/no */
export type SupportHealthChangeAnswerAttributes = {
  /** Did the participant's health change in this way */
  answer: Scalars['Boolean']['input'];
  /** ID of the question - covering what aspect of health has changed */
  questionId: Scalars['ID']['input'];
};

/** Answer details for a question about any observed health changes */
export type SupportHealthChangeAnswerForEventDelivery = {
  __typename?: 'SupportHealthChangeAnswerForEventDelivery';
  /** Is this answer active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Is there an answer to this question */
  answer?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the answer */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the client HCP funded */
  isFundingHcp?: Maybe<Scalars['Boolean']['output']>;
  /** Is the client NDIS funded */
  isFundingNdis?: Maybe<Scalars['Boolean']['output']>;
  /** What kind of question is this */
  questionType?: Maybe<Scalars['String']['output']>;
  /** What is the question asked */
  supportNoteQuestion?: Maybe<Scalars['String']['output']>;
  /** ID of the related questionnaire */
  supportNoteQuestionnaireId?: Maybe<Scalars['ID']['output']>;
};

/** Details noted about a change in the clients health */
export type SupportHealthChangeForEventDelivery = {
  __typename?: 'SupportHealthChangeForEventDelivery';
  /** Returns timesheet data */
  eventDelivery?: Maybe<EventDelivery>;
  /** Any additional description of the health change */
  healthChangeAdditionalDetails?: Maybe<Scalars['String']['output']>;
  /** ID of the health change record */
  id?: Maybe<Scalars['ID']['output']>;
  /** Was a change observed */
  noObservation?: Maybe<Scalars['Boolean']['output']>;
  /** Should we share the health change information (with the client?) */
  shareHealthChangeInformation?: Maybe<Scalars['Boolean']['output']>;
  /** Answers to health-change questions */
  supportHealthChangeAnswers?: Maybe<Array<SupportHealthChangeAnswerForEventDelivery>>;
};

/** Individual support-item covering a kind of care the client is provided-for under their plan. Grouped under a support-area. */
export type SupportItem = {
  __typename?: 'SupportItem';
  /** ID of the support-item */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of the support-item */
  name?: Maybe<Scalars['String']['output']>;
  /** Combination of name and NDIS number for display */
  nameWithCode?: Maybe<Scalars['String']['output']>;
  /** NDIS ID of this support-item */
  ndisSupportItemId?: Maybe<Scalars['ID']['output']>;
};

/** More detail of the support-item covered by an NDIS support-area (as part of an NDIS support-plan) */
export type SupportItemAttributes = {
  /** Destroys this support-item if true */
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the support-item */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** NDIS support-item ID covered by this support-item */
  ndisSupportItemId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the plan support-area that relates to this support-item */
  planSupportAreaId?: InputMaybe<Scalars['ID']['input']>;
};

/** Note written about anything relevant that occurred during the support-shift */
export type SupportNote = {
  __typename?: 'SupportNote';
  /** State of the timesheet (as opposed to the combined state that includes invoicing state) */
  actualState?: Maybe<Scalars['String']['output']>;
  /** ID of the agreed_rate */
  agreedRateId?: Maybe<Scalars['ID']['output']>;
  /** Agreement against which the service has been delivered */
  agreement: Agreement;
  /** ID of the related agreement */
  agreementRateId?: Maybe<Scalars['ID']['output']>;
  /** When was this timesheet approved */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Can the current-target delete this asset */
  canDeleteAssets?: Maybe<Scalars['Boolean']['output']>;
  /** Can the current target edit an approved timesheet */
  canEditApproved?: Maybe<Scalars['Boolean']['output']>;
  /** Can the curent target query the payment status */
  canQuery?: Maybe<Scalars['Boolean']['output']>;
  /** The carer involved */
  carer?: Maybe<NorestrictUser>;
  /** Phone number of the carer */
  carerContactPhone?: Maybe<Scalars['String']['output']>;
  /** Full name of the carer */
  carerFullName?: Maybe<Scalars['String']['output']>;
  /** ID of the invoice-statement for this carer */
  carerInvoiceStatementId?: Maybe<Scalars['ID']['output']>;
  /** When was the carer paid for this timesheet */
  carerPaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Was the carer paid by paynow */
  carerPaidByPaynow?: Maybe<Scalars['Boolean']['output']>;
  /** What is the status of the carer payment */
  carerPaidStatus?: Maybe<Scalars['String']['output']>;
  /** Details of the client receiving the services */
  client?: Maybe<User>;
  /** Returns true if the client has approved the first event delivery */
  clientFirstApproved?: Maybe<Scalars['Boolean']['output']>;
  /** When was payment for this timesheet collected */
  collectedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is payment overdue */
  collectionOverdue?: Maybe<Scalars['Boolean']['output']>;
  /** The person responsible for the person being cared for (possibly the same as the participant) */
  consumer?: Maybe<NorestrictUser>;
  /** When did the consumer pay */
  consumerPaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Code for the payment method used for the payment */
  consumerPaymentMethodCode?: Maybe<Scalars['String']['output']>;
  /** UUID of the coordinator managing timesheet */
  coordinatorUuid?: Maybe<Scalars['String']['output']>;
  /** When the tinesheet was first created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is this timesheet deletable */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** When was the service delivered to the client */
  deliveredAt: Scalars['String']['output'];
  /** Cost of the delivered care covered by this timesheet */
  deliveredCost?: Maybe<Scalars['String']['output']>;
  /** When the delivered care ended */
  deliveredEndTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How many hours of care were delivered */
  deliveredHours?: Maybe<Scalars['Float']['output']>;
  /** Displayable string of how many hours and minutes were delivered */
  deliveredHoursAndMinutes?: Maybe<Scalars['String']['output']>;
  /** ID of the delivered session linked to the event-delivery */
  deliveredSessionId?: Maybe<Scalars['ID']['output']>;
  /** When did the delivered care begin */
  deliveredStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** On what date was the care delivered (start date) */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  /** How many hours (truncated) was the delivered care */
  deliveryHours?: Maybe<Scalars['Int']['output']>;
  /** After removing the hours, how many minutes of care were left over */
  deliveryMinutes?: Maybe<Scalars['Int']['output']>;
  /** Displayable delivery time */
  deliveryTime?: Maybe<Scalars['String']['output']>;
  /** At what time of day did the care end */
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is this eligible for expresspay */
  expresspayEligible?: Maybe<Scalars['Boolean']['output']>;
  /** What percentage of fees will be applied to the carer rate */
  feePercentage?: Maybe<Scalars['String']['output']>;
  /** First name of the carer */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Formatted string to show GST */
  formattedGstClient?: Maybe<Scalars['String']['output']>;
  /** Was an incident reported for this timesheet */
  hasIncident?: Maybe<Scalars['Boolean']['output']>;
  /** Health answers */
  healthAnswers?: Maybe<Array<Scalars['String']['output']>>;
  /** Details of any change in health observed during care */
  healthChangeDetail?: Maybe<SupportHealthChangeForEventDelivery>;
  /** The reason why HorizonOne offer was declined */
  horizonOfferDeclinedReason?: Maybe<Scalars['String']['output']>;
  /** Status of the HorizonOne offer */
  horizonOfferStatus?: Maybe<Scalars['String']['output']>;
  /** ??? The reason why HorizonOne offer showed a warning */
  horizonOfferWarningReason?: Maybe<Scalars['String']['output']>;
  /** The date at which the HorizonOne offer was approved */
  horizonOneOfferApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The date at which the HorizonOne offer was declined */
  horizonOneOfferDeclinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** What hourly fee is the carer charging */
  hourlyFee?: Maybe<Scalars['String']['output']>;
  /** What hourly fee is the carer charging if paid with paynow */
  hourlyPaynowFee?: Maybe<Scalars['String']['output']>;
  /** ID of this event-delivery (timesheet) */
  id: Scalars['ID']['output'];
  /** An incident arising during this shift (if any) */
  incidentCase?: Maybe<IncidentCase>;
  /** Incident report information */
  incidentReport?: Maybe<IncidentReport>;
  /** Has payment for this session been advanced */
  invoiceCarerAdvanced?: Maybe<Scalars['Boolean']['output']>;
  /** Link to an invoice-related asset */
  invoiceLink?: Maybe<Scalars['String']['output']>;
  /** Time at which this timesheet was invoiced */
  invoicedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is this tinmsheet pending */
  isPending?: Maybe<Scalars['Boolean']['output']>;
  /** How many km were travelled during care */
  kmTravelled?: Maybe<Scalars['Float']['output']>;
  /** What time was the invoice manually advanced */
  manuallyAdvancedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Hourly rate charged (net of fees) */
  netHourlyRate?: Maybe<Scalars['String']['output']>;
  /** Net pay (including paynow fee) */
  netPayIncludingPaynowFee: Scalars['Float']['output'];
  /** ID of the carer */
  otherUserId?: Maybe<Scalars['ID']['output']>;
  /** When was the invoice paid */
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The person being cared-for */
  participant?: Maybe<Participant>;
  /** Date by which payment is due */
  paymentDueByDate?: Maybe<Scalars['String']['output']>;
  /** Tooltip to display next to payment info */
  paymentTooltip?: Maybe<Scalars['String']['output']>;
  /** When was paynow approved */
  paynowApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is paynow available for this invoice */
  paynowAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** When was paynow declined */
  paynowDeclinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Is paynow displayable */
  paynowDisplayable?: Maybe<Scalars['Boolean']['output']>;
  /** Fee percentage for paynow */
  paynowFeePercentage?: Maybe<Scalars['String']['output']>;
  /** Has paynow been requested */
  paynowRequested?: Maybe<Scalars['Boolean']['output']>;
  /** At what time was paynow requested */
  paynowRequestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status of the paynow request */
  paynowRequestedStatus?: Maybe<Scalars['String']['output']>;
  /** Rate charged for travel per km */
  perKmRate?: Maybe<Scalars['Float']['output']>;
  /** State of per km rate on agreement at time of creation */
  perKmRateAvailable: Scalars['Boolean']['output'];
  /** Displayable string for paynow rate in dollars */
  perKmRateInDollars?: Maybe<Scalars['String']['output']>;
  /** Returns true if SP is eligible for QuickPay */
  quickpayEligible?: Maybe<Scalars['Boolean']['output']>;
  /** When SP will be paid if QuickPay eligible */
  quickpayScheduledDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Rate carer is charging for care */
  rate?: Maybe<Scalars['String']['output']>;
  /** What kind of rate is this (flat-rate or hourly) */
  rateKindLabel?: Maybe<Scalars['String']['output']>;
  /** ID of the occurrence that is linked to this timesheet's delivered session */
  scheduledEventOccurrenceId?: Maybe<Scalars['ID']['output']>;
  /** ID for the Service category */
  serviceCategoryableId?: Maybe<Scalars['ID']['output']>;
  /** Shift-note associated with this timesheet */
  shiftNote?: Maybe<ShiftNote>;
  /** Should a related incident be shown to the client */
  showIncidentToClient?: Maybe<Scalars['Boolean']['output']>;
  /** Should we display the NDIS items for this timesheet */
  showNdisItems?: Maybe<Scalars['Boolean']['output']>;
  /** At what time of day did the care start */
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Combined state that includes the timesheet and details about invoicing */
  state?: Maybe<Scalars['String']['output']>;
  /** What durations were covered by this timesheet */
  supportDurations?: Maybe<Array<SupportDuration>>;
  /** Details of a health-change noted by carer */
  supportHealthChange?: Maybe<SupportHealthChangeForEventDelivery>;
  /** Answers to health-change questions */
  supportHealthChangeAnswers?: Maybe<Array<SupportHealthChangeAnswerForEventDelivery>>;
  /** Questions about a health-change that have been checked */
  supportHealthChangeCheckedQuestions?: Maybe<Array<Scalars['String']['output']>>;
  /** Total amount paid for support given */
  supportTotal: Scalars['String']['output'];
  /** Invoice is due to be paid at this time */
  toBePaidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The formatted user cost */
  total: Scalars['String']['output'];
  /** The total of the calculated fees */
  totalFee?: Maybe<Scalars['String']['output']>;
  /** The total calculated paynow fees */
  totalPaynowFee: Scalars['Float']['output'];
  /** The total travel expense */
  totalTravelExpense?: Maybe<Scalars['String']['output']>;
  /** The total of the travel fees */
  totalTravelFee?: Maybe<Scalars['String']['output']>;
  /** The kms multipled by the fee per km */
  totalTravelledInDollars?: Maybe<Scalars['String']['output']>;
  /** Total on timesheet with total travel cost. */
  totalWithTravelCost?: Maybe<Scalars['String']['output']>;
  /** The travel rate */
  travelRate?: Maybe<Scalars['String']['output']>;
  /** Warn the carer that the timesheet has been edited */
  warnEdit?: Maybe<Scalars['Boolean']['output']>;
  /** Any warnings */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
  /** Does this timesheet have an incident */
  withIncidentCase?: Maybe<Scalars['Boolean']['output']>;
  /** Is there a banner associated with this timesheet */
  withInfoBanner?: Maybe<Scalars['Boolean']['output']>;
  /** Is there a health-change support-note */
  withSupportHealthChange?: Maybe<Scalars['Boolean']['output']>;
  /** Returns true if this is the first event delivery that the worker has submitted */
  workerFirstDelivered?: Maybe<Scalars['Boolean']['output']>;
  /** When was the worker payment queried */
  workerPaymentQueriedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for SupportNote. */
export type SupportNoteConnection = {
  __typename?: 'SupportNoteConnection';
  csvDownloadParam?: Maybe<Scalars['String']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupportNoteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SupportNote>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SupportNoteEdge = {
  __typename?: 'SupportNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportNote>;
};

/** Filters to reduce the scope of the support-notes being fetched */
export type SupportNoteFilterData = {
  /** Only delivered support notes */
  deliveredOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by delivery hour start time - from this value */
  deliveredStartFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by delivery hour start time - to this value */
  deliveredStartTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by creation time - from this value */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Will filter only shift notes that contain health-and-wellbeing notes */
  onlyWithHealthWellbeingNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Will filter only shift notes that contain Incidents */
  onlyWithIncidents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Will filter only shift notes that contain unread Incidents */
  onlyWithUnreadIncidents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Details of column to order the shift-notes by */
  orderByColumn?: InputMaybe<SupportNoteOrderColumn>;
  /** Direction of ordering (asc/desc) */
  orderDirection?: InputMaybe<SupportNoteOrderDirection>;
  /** What field will we use the search_text to filter by */
  searchByField?: InputMaybe<ComplianceSearchField>;
  /** Filter by this search-text in the field given in search_by_field */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Filter by Statuses */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by creation time - to this value */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Valid columns for ordering a list of support-notes (eg client_name/delivered_start_time) */
export enum SupportNoteOrderColumn {
  ClientName = 'client_name',
  DeliveredAt = 'delivered_at',
  DeliveredEndTime = 'delivered_end_time',
  DeliveredStartTime = 'delivered_start_time',
  SupportWorkerName = 'support_worker_name'
}

/** Allowed ordering directions for ordering a list of support-notes */
export enum SupportNoteOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

/** Attributes of a Support-note questionnaire */
export type SupportNoteQuestionnaire = {
  __typename?: 'SupportNoteQuestionnaire';
  /** Is this questionnaire active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the questionnaire */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is the client HCP-funded (determines which questionnaire they receive) */
  isFundingHcp?: Maybe<Scalars['Boolean']['output']>;
  /** Is the client NDIS-funded (determines which questionnaire they receive) */
  isFundingNdis?: Maybe<Scalars['Boolean']['output']>;
  /** The question */
  question?: Maybe<Scalars['String']['output']>;
  /** Type of question this is */
  questionType?: Maybe<Scalars['String']['output']>;
};

/** Funding types allowed for support-notes health-change questionnaires */
export enum SupportNoteQuestionnaireFunding {
  Hcp = 'hcp',
  Ndis = 'ndis'
}

/** Support plan information for a client */
export type SupportPlanInfo = {
  __typename?: 'SupportPlanInfo';
  /** File containing the support-plan */
  supportPlanAsset?: Maybe<Asset>;
  /** Support Plan Expiry Date */
  supportPlanExpiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Details of a tax statement */
export type TaxStatement = {
  __typename?: 'TaxStatement';
  /** Link to the deduction statement */
  deductionStatementPdf?: Maybe<Scalars['String']['output']>;
  /** Link to the income statement */
  incomeStatementPdf?: Maybe<Scalars['String']['output']>;
  /** Dollar total amount for the timeperiod, net of fees */
  net?: Maybe<Scalars['Float']['output']>;
  /** Dollar amount total for the timeperiod */
  total?: Maybe<Scalars['Float']['output']>;
  /** Year this tax statement covers */
  year?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TerminateAgreement */
export type TerminateAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the agreement we're terminating */
  id: Scalars['ID']['input'];
  /** Reason for the termination */
  reason?: InputMaybe<TerminationReasonInput>;
};

/** Autogenerated return type of TerminateAgreement */
export type TerminateAgreementPayload = {
  __typename?: 'TerminateAgreementPayload';
  /** Agreement we're terminating */
  agreement: Agreement;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** When terminating an agreement, this is the reason given */
export type TerminationReasonInput = {
  /** Reason given - when one of the valid options */
  terminationReason?: InputMaybe<AgreementTerminationReasonOptions>;
  /** Reason given - if not in the set of given options */
  terminationReasonOther?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes of a Testimonial for a support-worker */
export type Testimonial = {
  __typename?: 'Testimonial';
  /** URL for the avatar of a user. We use initials from name if avatar_url is blank */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Content of the testimonial */
  content: Scalars['String']['output'];
  /** Name of the testimonial */
  name: Scalars['String']['output'];
  /** Position used for ordering testimonials */
  position: Scalars['Int']['output'];
};

/** Time and place of a calculated rate */
export type TimeAndPlace = {
  /** Description of this time-and-place */
  description?: InputMaybe<Scalars['String']['input']>;
  /** End time of this time-and-place */
  endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** PostcodeGeo/location for this rate */
  postCodeGeoId?: InputMaybe<Scalars['ID']['input']>;
  /** Rate schedule for the calculated rate */
  rateSchedule?: InputMaybe<RateScheduleAttributes>;
  /** Start time of this time-and-place */
  startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Whether it's a a weekday_daytime, weekday_evening, weekday_overnight, saturday, sunday... */
export enum TimeBlock {
  PublicHoliday = 'public_holiday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  WeekdayDaytime = 'weekday_daytime',
  WeekdayEvening = 'weekday_evening',
  WeekdayOvernight = 'weekday_overnight'
}

/** Timesheet details */
export type Timesheet = {
  __typename?: 'Timesheet';
  /** ID of the timesheet */
  id?: Maybe<Scalars['ID']['output']>;
  /** Number of timesheets that are unapproved and have registered a health change */
  totalUnapproveWithHealthChange?: Maybe<Scalars['Int']['output']>;
};

/** Attributes of a new timesheet */
export type TimesheetAttributes = {
  /** ID of the agreed rate */
  agreedRateId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of associated agreement */
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the agreement rate */
  agreementRateId?: InputMaybe<Scalars['ID']['input']>;
  /** End time for the timesheet */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** ID of the timesheet */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Title for Incident (if any) */
  incident?: InputMaybe<Scalars['String']['input']>;
  /** Actions taken for this incident */
  incidentActionsTake?: InputMaybe<Scalars['String']['input']>;
  /** Incident Also notified to */
  incidentAlreadyNotified?: InputMaybe<Scalars['String']['input']>;
  /** Incident Date */
  incidentDate?: InputMaybe<Scalars['String']['input']>;
  /** Incident Description */
  incidentDetail?: InputMaybe<Scalars['String']['input']>;
  /** Injuries or Damages reported */
  incidentInjuriesDamage?: InputMaybe<Scalars['String']['input']>;
  /** Location at which the incident occurred */
  incidentLocation?: InputMaybe<Scalars['String']['input']>;
  /** Reported to Organisation by Worker */
  incidentReportToOrg?: InputMaybe<IncidentReportToOrgOptions>;
  /** Legacy field - not in use */
  incidentShortQuestionnaire?: InputMaybe<Scalars['String']['input']>;
  /** Mitigation Steps taken */
  incidentStepsPrevent?: InputMaybe<Scalars['String']['input']>;
  /** Incident Time */
  incidentTime?: InputMaybe<Scalars['String']['input']>;
  /** Before the Incident */
  incidentWhat?: InputMaybe<Scalars['String']['input']>;
  /** Person Involved in incident */
  incidentWho?: InputMaybe<Scalars['String']['input']>;
  /** Witnesses to the incident */
  incidentWitness?: InputMaybe<Scalars['String']['input']>;
  /** Km travelled during care */
  kmTravelled?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the scheduled event occurrence for this timesheet */
  scheduledEventOccurrenceId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the scheduled event associated with this timesheet */
  scheduledEventUniqueId?: InputMaybe<Scalars['String']['input']>;
  /** ID of NDIS Service Category/Mable Service the timesheet rate relates to */
  serviceCategoryableId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of NDIS Service Category/Mable Service the timesheet rate relates to */
  serviceCategoryableType?: InputMaybe<Scalars['String']['input']>;
  /** Any notes written about this shift */
  shiftNotes?: InputMaybe<Scalars['String']['input']>;
  /** Should we show the incident to the client */
  showIncidentToClient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start time of the shift */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Details of the duration of each kind of support */
  supportDurationsAttributes?: InputMaybe<Array<SupportDurationAttributes>>;
};

/** Timeslot for Expression of Interest */
export type Timeslot = {
  __typename?: 'Timeslot';
  /** End time */
  endTime: Scalars['String']['output'];
  /** Start time */
  startTime: Scalars['String']['output'];
  /** Day of the week */
  weekDay: Scalars['String']['output'];
};

/** Autogenerated input type of TriggerPrivacyProtectionNudge */
export type TriggerPrivacyProtectionNudgeInput = {
  /** Sendbird URL of the channel that triggers this message */
  channelUrl: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TriggerPrivacyProtectionNudge */
export type TriggerPrivacyProtectionNudgePayload = {
  __typename?: 'TriggerPrivacyProtectionNudgePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Privacy-protection response message returned */
  response?: Maybe<Scalars['String']['output']>;
};

/** Attributes of a global banner displayed to the user */
export type UiGlobalBannerStatus = {
  __typename?: 'UiGlobalBannerStatus';
  /** ID of the banner */
  bannerId: Scalars['String']['output'];
  /** Name of the banner */
  bannerName?: Maybe<Scalars['String']['output']>;
  /** Should the banner be displayed */
  displayStatus: Scalars['Boolean']['output'];
};

/** Details needed to clear a blocked user */
export type Unblock = {
  /** ID of the user to be blocked for phone calls */
  blockedUserId: Scalars['ID']['input'];
  /** Comment explaining why this user is being unblocked */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Reason-category for unblocking this user */
  reason?: InputMaybe<UnblockReasonOptions>;
};

/** Autogenerated input type of Unblock */
export type UnblockInput = {
  /** Details required to clear a blocked user */
  attributes: Unblock;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Unblock */
export type UnblockPayload = {
  __typename?: 'UnblockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return true if there was a block that was cleared */
  unblocked?: Maybe<Scalars['Boolean']['output']>;
};

/** Options to go alongside why this user is being unblocked */
export enum UnblockReasonOptions {
  /** Accidentally blocked */
  AccidentallyBlocked = 'accidentally_blocked',
  /** Change in account ownership */
  ChangeInAccountOwnership = 'change_in_account_ownership',
  /** Resolved dispute */
  ResolvedDispute = 'resolved_dispute'
}

/** Why is this user being unblocked */
export enum UnblockReasons {
  /** Accidentally blocked */
  AccidentallyBlocked = 'accidentally_blocked',
  /** Change in account ownership */
  ChangeInAccountOwnership = 'change_in_account_ownership',
  /** Resolved dispute */
  ResolvedDispute = 'resolved_dispute'
}

/** Represents a support-session linked to an unplanned delivered session */
export type UnplannedSupportSession = {
  __typename?: 'UnplannedSupportSession';
  /** ID of the agreement this session falls under */
  agreementId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp when this session was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description of the planned session */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the session */
  id: Scalars['ID']['output'];
  /** Timesheets (event_deliveries) for this session */
  supportHours?: Maybe<Array<EventDelivery>>;
  /** Title of the session */
  title?: Maybe<Scalars['String']['output']>;
  /** Timestamp when this session was updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Upcoming Prompt fields */
export type UpcomingPrompt = {
  __typename?: 'UpcomingPrompt';
  /** Category of the prompt */
  category?: Maybe<Scalars['String']['output']>;
  /** Data that will be used by frontend for prompt display */
  data?: Maybe<Data>;
  /** ID of upcoming prompt */
  id: Scalars['ID']['output'];
  /** Kind of prompt */
  kind?: Maybe<UpcomingPromptKind>;
  /** Outcome of the prompt */
  outcome?: Maybe<UpcomingPromptOutcome>;
};

/** Category of upcoming prompt */
export enum UpcomingPromptCategory {
  NeedUnfilled = 'need_unfilled'
}

/** Kind of upcoming prompt */
export enum UpcomingPromptKind {
  PromptDelayedAfterAgreementAccepted = 'prompt_delayed_after_agreement_accepted',
  PromptOnAgreementAccepted = 'prompt_on_agreement_accepted'
}

/** Outcome of upcoming prompt */
export enum UpcomingPromptOutcome {
  Accept = 'accept',
  Decline = 'decline',
  Ineligible = 'ineligible'
}

/** Autogenerated input type of UpdateAgreementTermsAcceptedAt */
export type UpdateAgreementTermsAcceptedAtInput = {
  /** Attributes for updating the terms-accepted date */
  attributes: UpdateTermsAcceptedAtAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAgreementTermsAcceptedAt */
export type UpdateAgreementTermsAcceptedAtPayload = {
  __typename?: 'UpdateAgreementTermsAcceptedAtPayload';
  /** The agreement we're altering */
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** When updating an agreement, these are the attributes given */
export type UpdateAttributes = {
  /** Whether the participants have agreed on dates and times for their support sessions */
  agreedOnSchedule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Service that will be undertaken by the carer */
  agreedService?: InputMaybe<Scalars['String']['input']>;
  /** ID of the person requesting services */
  consumerUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Detail of agreed days and times the service will be undertaken */
  daysAndTimes?: InputMaybe<DaysAndTimes>;
  /** Expected day this agreement will end */
  expectedEndDate?: InputMaybe<Scalars['String']['input']>;
  /** Expected day this agreement will start */
  expectedStartDate?: InputMaybe<Scalars['String']['input']>;
  /** ID of the agreement */
  id: Scalars['ID']['input'];
  /** Whether it's an ongoing on once off job */
  jobFrequency?: InputMaybe<PostedJobFrequencyOptions>;
  /** Whether it's a a weekly, fornightly, monthly or other job */
  jobOccurrence?: InputMaybe<AgreementJobOccurrenceOptions>;
  /** Rate charged per Km travelled - in dollars */
  perKmRateDollars?: InputMaybe<Scalars['Float']['input']>;
  /** Item IDs for agreed NDIS support items in the agreement */
  planSupportItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** ID of the original job-post this agreement was in response to */
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
  /** Hourly rates negotiated for this agreement - in dollars */
  ratesInDollars: Array<RateAttributes>;
  /** Timing details of your support sessions e.g. 9am to 11am every fortnight */
  scheduleDescription?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for cancelling sessions */
  supportCancel?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for changing or adding sessions */
  supportChange?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for feedback, complaints or disputes */
  supportFeedback?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for minimum hours, finishing early and overtime */
  supportMinHours?: InputMaybe<Scalars['String']['input']>;
  /** ??? Are travel expenses expected for this agreement */
  travelExpenseFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateCarerReliabilityAssessment */
export type UpdateCarerReliabilityAssessmentInput = {
  /** Attributes to be updated */
  carerReliabilityAttributes: CarerReliabilityAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the carer reliability assessment to update */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCarerReliabilityAssessment */
export type UpdateCarerReliabilityAssessmentPayload = {
  __typename?: 'UpdateCarerReliabilityAssessmentPayload';
  /** Returns the updated carer reliability assessment */
  carerReliabilityAssessment?: Maybe<CarerReliabilityAssessment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCircumventionBannerFlag */
export type UpdateCircumventionBannerFlagInput = {
  /** Attributes stored with the flag */
  attributes: ConversationsUpdateCircumventionBannerFlagAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCircumventionBannerFlag */
export type UpdateCircumventionBannerFlagPayload = {
  __typename?: 'UpdateCircumventionBannerFlagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Has the user dismissed the banner */
  consumerDismissedCircumventionBanner?: Maybe<Scalars['Boolean']['output']>;
};

/** Kinds of action that can update a conversation */
export enum UpdateConversationActionOptions {
  /** Archive the conversation */
  Archive = 'archive',
  /** Restore the archived conversation */
  Restore = 'restore'
}

/** Autogenerated input type of UpdateConversation */
export type UpdateConversationInput = {
  /** Action to be performed on the conversation: accept, archive, or restore */
  action: UpdateConversationActionOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the conversation */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateConversation */
export type UpdateConversationPayload = {
  __typename?: 'UpdateConversationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated conversation */
  conversation?: Maybe<Conversation>;
};

/** Autogenerated input type of UpdateEducateTrainingTaskCompleted */
export type UpdateEducateTrainingTaskCompletedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Kind of training that we are updating training-completion for */
  taskName: EducateTrainingTask;
};

/** Autogenerated return type of UpdateEducateTrainingTaskCompleted */
export type UpdateEducateTrainingTaskCompletedPayload = {
  __typename?: 'UpdateEducateTrainingTaskCompletedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Date of SIRS completion */
  sirsCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Date of WCC completion */
  wccCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Set of actions possible to update an incident case */
export enum UpdateIncidentCaseActionOptions {
  /** Mark the incident as read */
  Read = 'read'
}

/** Autogenerated input type of UpdateIncidentCase */
export type UpdateIncidentCaseInput = {
  /** Accept archive or restore */
  action: UpdateIncidentCaseActionOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the incident report */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateIncidentCase */
export type UpdateIncidentCasePayload = {
  __typename?: 'UpdateIncidentCasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the updated incident case */
  incident?: Maybe<IncidentCase>;
};

/** What action are we performing for this job-notification filter */
export enum UpdateJobNotificationFilterActionOptions {
  /** Add a new filter (filters is required) */
  Add = 'add',
  /** Delete an existing filter, by either matching filter, or ID */
  Delete = 'delete'
}

/** Autogenerated input type of UpdateJobNotificationFilter */
export type UpdateJobNotificationFilterInput = {
  /** What action are we performing (eg add/delete) */
  action: UpdateJobNotificationFilterActionOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Job-search filter data used to filter job-notifications */
  filters?: InputMaybe<JobSearch>;
  /** ID of the job-notification filter */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateJobNotificationFilter */
export type UpdateJobNotificationFilterPayload = {
  __typename?: 'UpdateJobNotificationFilterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns updated details of the job-notification filter */
  jobNotificationFilter: JobNotificationFilter;
};

/** Autogenerated input type of UpdateMultipleSessions */
export type UpdateMultipleSessionsInput = {
  /** Attributes required to update a session */
  attributes: ScheduledEventAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Details identifying the starting session */
  sessionId: SessionId;
};

/** Autogenerated return type of UpdateMultipleSessions */
export type UpdateMultipleSessionsPayload = {
  __typename?: 'UpdateMultipleSessionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated scheduled-event/session */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Autogenerated input type of UpdateOffer */
export type UpdateOfferInput = {
  /** Common attributes for updatiga n agreement */
  attributes: UpdateAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOffer */
export type UpdateOfferPayload = {
  __typename?: 'UpdateOfferPayload';
  /** The agreement we're altering */
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Attributes received when a party sends an agreement offer */
export type UpdateOfferWithStructuredRatesAttributes = {
  /** Details of the structured rates for this agreement */
  agreedRates: AgreedRateAttributes;
  /** Service that will be undertaken by the carer */
  agreedService: Scalars['String']['input'];
  /** ID of the user that this agreement will be for */
  consumerUserId: Scalars['ID']['input'];
  /** ID of the agreement being updated */
  id: Scalars['ID']['input'];
  /** Rate charged per Km travelled - in dollars */
  perKmRateDollars?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the original job-post this agreement was in response to */
  postedJobId?: InputMaybe<Scalars['ID']['input']>;
  /** Support terms for cancelling sessions */
  supportCancel?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for changing or adding sessions */
  supportChange?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for feedback, complaints or disputes */
  supportFeedback?: InputMaybe<Scalars['String']['input']>;
  /** Support terms for minimum hours, finishing early and overtime */
  supportMinHours?: InputMaybe<Scalars['String']['input']>;
  /** Are travel expenses expected for this agreement */
  travelExpenseFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateOfferWithStructuredRates */
export type UpdateOfferWithStructuredRatesInput = {
  /** required attributes to update an agreement */
  attributes: UpdateOfferWithStructuredRatesAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOfferWithStructuredRates */
export type UpdateOfferWithStructuredRatesPayload = {
  __typename?: 'UpdateOfferWithStructuredRatesPayload';
  /** The agreement we're altering */
  agreement: Agreement;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateOrganisationTerm */
export type UpdateOrganisationTermInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes required to update the terms */
  organisationTermAttributes: OrganisationTermUpdateAttributes;
};

/** Autogenerated return type of UpdateOrganisationTerm */
export type UpdateOrganisationTermPayload = {
  __typename?: 'UpdateOrganisationTermPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Return the new update organisation */
  organisationTerm?: Maybe<OrganisationTerm>;
};

/** Actions allowed to update a posted job */
export enum UpdatePostedJobActionOptions {
  /** Archive a posted job */
  Archive = 'archive',
  /** Cancel a posted job */
  Cancel = 'cancel',
  /** Fulfil a posted job */
  Fulfil = 'fulfil'
}

/** Autogenerated input type of UpdatePostedJobStatus */
export type UpdatePostedJobStatusInput = {
  /** Action we are performing on this job */
  action: UpdatePostedJobActionOptions;
  /** ID of the associated agreement to update when fulfilling */
  agreementId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Message to use when notifying unsuccessful workers */
  message?: InputMaybe<Scalars['String']['input']>;
  /** The PostedJob we're manipulating */
  postedJobId: Scalars['ID']['input'];
  /** Reason for fulfilling or cancelling this job */
  reason?: InputMaybe<PostedJobFulfilCancelReasonOptions>;
};

/** Autogenerated return type of UpdatePostedJobStatus */
export type UpdatePostedJobStatusPayload = {
  __typename?: 'UpdatePostedJobStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Posted Job to update */
  postedJob: PostedJob;
};

/** Autogenerated input type of UpdateReference */
export type UpdateReferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Details of the reference to be updated */
  referenceAttributes: ReferenceUpdateAttributesType;
};

/** Autogenerated return type of UpdateReference */
export type UpdateReferencePayload = {
  __typename?: 'UpdateReferencePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated Reference */
  reference: Reference;
};

/** Attributes used when updating a scheduled-event/session */
export type UpdateScheduledEventAttributes = {
  /** Whether the user wants to receive check in/check out notifications */
  checkInCheckOutReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notification for the other attendee of the session */
  clientReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notification for the creator of the session */
  creatorReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date that the session finishes. By default, same as start date, unless finishing overnight; dd/mm/yyyy format */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** The time that the session ends, hh:mm AM/PM format */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user wants to notify the other participant about the update */
  notifyParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  /** participant_ids are other members in the session, which is accepted as an array of user_ids */
  participantIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Support session inputs needed when the scheduleType is 'Support Session' */
  plannedSupportSession?: InputMaybe<PlannedSupportSessionAttributes>;
  /** Recurrence details */
  recurrence?: InputMaybe<UpdateScheduledEventRecurrenceAttributes>;
  /** Type of session */
  scheduleType?: InputMaybe<ScheduleOptions>;
  /** Offset to UTC time in integer */
  scheduledAtTzoffset?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the request to reschedule */
  scheduledEventRescheduleRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** The date that the session starts, dd/mm/yyyy format */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** The time that the session starts, hh:mm AM/PM format */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Timezone name - full name (eg. 'Australia/Sydney') */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Type of edit */
  update: EditOptions;
};

/** Autogenerated input type of UpdateScheduledEvent */
export type UpdateScheduledEventInput = {
  /** Attributes required to update a scheduled-event/session */
  attributes: UpdateScheduledEventAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Derived unique id of the session */
  derivedUniqueId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the occurrence which may be persisted or projected based on id_type */
  occurrenceId?: InputMaybe<Scalars['String']['input']>;
  /** Type of occurrence_id being passed */
  occurrenceIdType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateScheduledEventNotifySeconds */
export type UpdateScheduledEventNotifySecondsInput = {
  /** The new reminder-timing */
  attendeeReminderOption?: InputMaybe<Scalars['Int']['input']>;
  /** The new reminder-timing for both users */
  attendeesReminderOption?: InputMaybe<AttendeesReminderOption>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the scheduled_event */
  scheduledEventId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateScheduledEventNotifySeconds */
export type UpdateScheduledEventNotifySecondsPayload = {
  __typename?: 'UpdateScheduledEventNotifySecondsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated session */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Autogenerated return type of UpdateScheduledEvent */
export type UpdateScheduledEventPayload = {
  __typename?: 'UpdateScheduledEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated scheduled-event/session */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Details for updating the recurrence of a scheduled-event/session */
export type UpdateScheduledEventRecurrenceAttributes = {
  /** What days the session is recurring on for a weekly or fortnightly recurrence */
  days?: InputMaybe<Array<DayOptions>>;
  /** The date that the recurrence will finish on, dd/mm/yyyy format */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Day of the month for a montly recurrence */
  monthlyDay?: InputMaybe<DayOptions>;
  /** Week options for a monthly recurrence */
  monthlyWeekOptions?: InputMaybe<WeekOptions>;
  /** The type of recurrence a session has */
  recurrenceType?: InputMaybe<RecurrenceOptions>;
};

/** Autogenerated input type of UpdateScheduledEventRsvp */
export type UpdateScheduledEventRsvpInput = {
  /** Scheduled-event/session RSVP update attributes */
  attributes: ScheduledEventRsvpUpdate;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Derived unique ID for the session */
  derivedUniqueId?: InputMaybe<Scalars['String']['input']>;
  /** Id of the occurrence */
  occurrenceId?: InputMaybe<Scalars['String']['input']>;
  /** Id type of the occurrence */
  occurrenceIdType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateScheduledEventRsvp */
export type UpdateScheduledEventRsvpPayload = {
  __typename?: 'UpdateScheduledEventRsvpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated session */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Autogenerated input type of UpdateSessionImpression */
export type UpdateSessionImpressionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the conversation this impression relates to */
  conversationId: Scalars['ID']['input'];
  /** New feedback */
  feedback: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateSessionImpression */
export type UpdateSessionImpressionPayload = {
  __typename?: 'UpdateSessionImpressionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns updated session impression */
  sessionImpression?: Maybe<SessionImpression>;
};

/** Autogenerated input type of UpdateSingleSession */
export type UpdateSingleSessionInput = {
  /** Attributes required to update a session */
  attributes: ScheduledEventAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Details identifying a session */
  sessionId: SessionId;
};

/** Autogenerated return type of UpdateSingleSession */
export type UpdateSingleSessionPayload = {
  __typename?: 'UpdateSingleSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated scheduled-event/session */
  scheduledEvent?: Maybe<ScheduledEvent>;
};

/** Autogenerated input type of UpdateSupportHealthChangeAnswers */
export type UpdateSupportHealthChangeAnswersInput = {
  /** Details of the answer to each of the health-change questions */
  answerAttributes: Array<SupportHealthChangeAnswerAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Additional information about any health-change including notes */
  healthChangeAttributes: HealthChangeAttributes;
  /** ID of the SupportHealthChange object storing this information */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSupportHealthChangeAnswers */
export type UpdateSupportHealthChangeAnswersPayload = {
  __typename?: 'UpdateSupportHealthChangeAnswersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated support-health-change object */
  supportHealthChange?: Maybe<SupportHealthChangeForEventDelivery>;
};

/** When updating the date at which terms for the agreement were accepted, these are the attributes given */
export type UpdateTermsAcceptedAtAttributes = {
  /** ID of the user who requested the care */
  consumerUserId: Scalars['ID']['input'];
  /** Date that the terms were accepted at */
  termsAcceptedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated input type of UpdateUpcomingPrompt */
export type UpdateUpcomingPromptInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** id of upcomingPrompt */
  id: Scalars['ID']['input'];
  /** outcome of prompt */
  outcome: UpcomingPromptOutcome;
};

/** Autogenerated return type of UpdateUpcomingPrompt */
export type UpdateUpcomingPromptPayload = {
  __typename?: 'UpdateUpcomingPromptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** upcoming prompt record */
  upcomingPrompt?: Maybe<UpcomingPrompt>;
};

/** Autogenerated input type of UpdateUserGlobalBanner */
export type UpdateUserGlobalBannerInput = {
  /** ID of the banner */
  bannerId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Should we display this banner to the user */
  displayStatus: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateUserGlobalBanner */
export type UpdateUserGlobalBannerPayload = {
  __typename?: 'UpdateUserGlobalBannerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated user global banner */
  updatedGlobalBanner: UiGlobalBannerStatus;
};

/** Autogenerated input type of UpdateWallet */
export type UpdateWalletInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** All the wallet attributes */
  walletAttributes: WalletAttributes;
};

/** Autogenerated return type of UpdateWallet */
export type UpdateWalletPayload = {
  __typename?: 'UpdateWalletPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated wallet */
  wallet?: Maybe<Wallet>;
};

/** All the attributes for updating wallets status */
export type UpdateWalletsStatusAttributes = {
  /** Wallet ids to update status */
  ids: Array<Scalars['ID']['input']>;
  /** Updated status. Should be one of active/paused/inactive */
  status: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateWalletsStatus */
export type UpdateWalletsStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes to update wallets status */
  walletsStatusAttributes: UpdateWalletsStatusAttributes;
};

/** Autogenerated return type of UpdateWalletsStatus */
export type UpdateWalletsStatusPayload = {
  __typename?: 'UpdateWalletsStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated wallet details */
  wallets?: Maybe<Array<Wallet>>;
};

/** Autogenerated input type of UpdateWorkerAvailability */
export type UpdateWorkerAvailabilityInput = {
  /** Is this worker available at all */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this worker available for job opportunities */
  availableForJobOpportunities?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** What is this workers desired number of work hours */
  desiredHours?: InputMaybe<Scalars['Int']['input']>;
  /** Is this worker available on Friday */
  friday?: InputMaybe<Scalars['Boolean']['input']>;
  /** What times is this worker available on Friday */
  fridayTimes?: InputMaybe<Array<AvailabilityTimeAttributes>>;
  /** Is this worker available on Monday */
  monday?: InputMaybe<Scalars['Boolean']['input']>;
  /** What times is this worker available on Monday */
  mondayTimes?: InputMaybe<Array<AvailabilityTimeAttributes>>;
  /** Is this worker available on Saturday */
  saturday?: InputMaybe<Scalars['Boolean']['input']>;
  /** What times is this worker available on Saturday */
  saturdayTimes?: InputMaybe<Array<AvailabilityTimeAttributes>>;
  /** Is this worker available on Sunday */
  sunday?: InputMaybe<Scalars['Boolean']['input']>;
  /** What times is this worker available on Sunday */
  sundayTimes?: InputMaybe<Array<AvailabilityTimeAttributes>>;
  /** Is this worker available on Thursday */
  thursday?: InputMaybe<Scalars['Boolean']['input']>;
  /** What times is this worker available on Thursday */
  thursdayTimes?: InputMaybe<Array<AvailabilityTimeAttributes>>;
  /** Is this worker available on Tuesday */
  tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  /** What times is this worker available on Tuesday */
  tuesdayTimes?: InputMaybe<Array<AvailabilityTimeAttributes>>;
  /** Is this worker available on Wednesday */
  wednesday?: InputMaybe<Scalars['Boolean']['input']>;
  /** What times is this worker available on Wednesday */
  wednesdayTimes?: InputMaybe<Array<AvailabilityTimeAttributes>>;
};

/** Autogenerated return type of UpdateWorkerAvailability */
export type UpdateWorkerAvailabilityPayload = {
  __typename?: 'UpdateWorkerAvailabilityPayload';
  /** Details about the workers availability */
  availability: Availability;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Allowed actions for updating worker location */
export enum UpdateWorkerLocationActionOptions {
  /** Add a new location by post_code_geo_id */
  Add = 'add',
  /** Delete an existing location by id of the worker location */
  Delete = 'delete'
}

/** Autogenerated input type of UpdateWorkerLocation */
export type UpdateWorkerLocationInput = {
  /** Available actions to perfor: (add/delete) */
  action: UpdateWorkerLocationActionOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Send `true` to ignore the warning and save the location */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the location, if deleting */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** PostCodeGeo of the new worker location */
  postCodeGeoId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateWorkerLocation */
export type UpdateWorkerLocationPayload = {
  __typename?: 'UpdateWorkerLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated work location */
  location?: Maybe<Location>;
};

/** What action to perform when updating a worker rate */
export enum UpdateWorkerRateActionOptions {
  /** Delete carer rate by rate_name */
  Delete = 'delete',
  /** Update carer rate if exists (by rate_name) otherwise insert */
  Upsert = 'upsert'
}

/** Autogenerated input type of UpdateWorkerRate */
export type UpdateWorkerRateInput = {
  /** Action to perform (upsert/delete) */
  action: UpdateWorkerRateActionOptions;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Details of a specific worker-rate */
  rateAttributes: WorkerRateAttributes;
};

/** Autogenerated return type of UpdateWorkerRate */
export type UpdateWorkerRatePayload = {
  __typename?: 'UpdateWorkerRatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated rate */
  rate?: Maybe<Rate>;
};

/** Details of a user */
export type User = {
  __typename?: 'User';
  /** Whether current user has accepted Tax and super sync terms and conditions */
  acceptedTaxAndSuperSyncTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  /** The type of the user's account */
  accountType: UserAccountTypes;
  /** Indicates whether the user's account is active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Active optimizely or other experiments for the user */
  activeExperiments?: Maybe<UserActiveExperiment>;
  /** User's address, visible only to the users with an agreement */
  address?: Maybe<Scalars['String']['output']>;
  /** Street address for the user */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Address line 2 */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** Age of the user */
  age?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the user is approved */
  approved: Scalars['Boolean']['output'];
  /** Whether current user is an approved carer but doesn't have a timesheet yet */
  approvedCarerWithoutTimesheet?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the user should be asked for a flu shot */
  askForFluShot: Scalars['Boolean']['output'];
  /** User's avatar image */
  avatar?: Maybe<Avatar>;
  /** User's birth date, visible only to the user themselves. */
  birthDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User's Calendly link for scheduling meetings */
  calendlyLink?: Maybe<Scalars['String']['output']>;
  /** Indicates if the user can create last minute jobs */
  canCreateLmj?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the user would like to receive emails about new support workers */
  carersInArea?: Maybe<Scalars['Boolean']['output']>;
  /** The type of client account, the returned values are 'Independent', 'Client Managed', 'Coordinator Managed' and 'Third Party Coordinator' */
  clientAccountType?: Maybe<Scalars['String']['output']>;
  /** The name of the client type. The returned values are 'Coordinator Managed', 'Self Managed' and 'Independent'. */
  clientTypeName?: Maybe<Scalars['String']['output']>;
  /** Percentage of the user's profile that has been completed */
  completedProfilePercent?: Maybe<Scalars['Int']['output']>;
  /** Indicates if the user given consent to collect sensitive information */
  consentToCollectSensitiveInformation?: Maybe<Scalars['Boolean']['output']>;
  /** User's contact phone number, visible only to the users with an agreement */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** Whether the contact phone number is verified via SMS code or phone call */
  contactPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Coordinator assigned to account if present */
  coordinator?: Maybe<Coordinator>;
  /** Timestamp of the last update to the user's COVID vaccine status */
  covidVaccineUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Indicates if per kilometer travel is disabled */
  disablePerKmTravel?: Maybe<Scalars['Boolean']['output']>;
  /** The display name of the user, visible only to the authorized users. */
  displayName: Scalars['String']['output'];
  /** The email address of the user, visible only to the user themselves. */
  email: Scalars['String']['output'];
  /** The first name of the user. */
  firstName: Scalars['String']['output'];
  /** Timestamp when flex feature was enabled for the userm which indicates if sp has enabled available for LMJ */
  flexEnabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The full name of the user. */
  fullName: Scalars['String']['output'];
  /** The gender of the user. */
  gender?: Maybe<Scalars['String']['output']>;
  /** Whether the user has any active agreements */
  hasActiveAgreement: Scalars['Boolean']['output'];
  /** Whether the user has a soft ban suspension */
  hasActiveSoftBan?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has any timesheets approved. */
  hasApprovedTimesheet?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has received the COVID-19 vaccine. */
  hasCovidVaccine?: Maybe<Scalars['Boolean']['output']>;
  /** Whether there are any pending notifications regarding fair work for the user. */
  hasFairworkPendingNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has any accepted agreement. */
  hasFirstAgreement: Scalars['Boolean']['output'];
  /** Whether the user reached the maximum number of times they can receive a verification SMS code */
  hasMaxedSmsVerificationRequests?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has the mobile app installed. */
  hasMobileApp?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has any timesheets pending that have auto-approval turned off. */
  hasPendingTimesheetsWithAutoApprovalOff: Scalars['Boolean']['output'];
  /** The Horizon One offer details for the user. */
  horizonOneOffer?: Maybe<HorizonOneOffer>;
  /** The unique identifier of the user. */
  id: Scalars['ID']['output'];
  /** Whether the user is funded by Support at Home funding. */
  isHcpFunded?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user has completed the onboarding process. */
  isOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user wish to receives the emails about jobs in their area. */
  jobsInArea?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The timestamp of the user's last login via mobile.
   * @deprecated This field is no longer maintained and will always return null
   */
  lastMobileLoginAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The last name of the user, visible with an agreement. */
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * The timestamp of the user's last login via web.
   * @deprecated This field is no longer maintained and will always return null
   */
  lastWebLoginAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The URL for the user to access the Learning Hub. */
  learningHubAccessUrl?: Maybe<Scalars['String']['output']>;
  /** The legal first name of the user, visible only to the user themselves. */
  legalFirstName?: Maybe<Scalars['String']['output']>;
  /** The legal last name of the user, visible only to the user themselves. */
  legalLastName?: Maybe<Scalars['String']['output']>;
  /** The legal middle name of the user, visible only to the user themselves. */
  legalMiddleName?: Maybe<Scalars['String']['output']>;
  /** The middle name of the user. */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Whether the user is agency-managed under the National Disability Insurance Scheme (NDIS). */
  ndisAgencyManaged?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user is funded under the National Disability Insurance Scheme (NDIS). */
  ndisFunded?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user is part of the NDIS but not managed by the NDIA. */
  ndisNonNdia?: Maybe<Scalars['Boolean']['output']>;
  /** NDIS plan */
  ndisPlan?: Maybe<NdisPlan>;
  /** Whether the user needs to be notified of automatic sessions termination */
  needsToBeNotifiedOfAutomaticSessionsTermination: Scalars['Boolean']['output'];
  /** User work type */
  normalizedType: Scalars['String']['output'];
  /** Whether current target is opted in to carer reliability assessment */
  optInCarerReliabilityAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Organisation details */
  organisation?: Maybe<Organisation>;
  /** Original email address */
  originalEmail?: Maybe<Scalars['String']['output']>;
  /** List of participants */
  participants?: Maybe<Array<Participant>>;
  /** Tokenised credit card value from payment gateway */
  paymentToken?: Maybe<Scalars['String']['output']>;
  /** Indicates if paynow trial is enabled */
  paynowTrialEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** User's permalink */
  permalink: Scalars['String']['output'];
  /** The user's phone verification schedule. */
  phoneVerificationSchedule?: Maybe<PhoneVerificationSchedule>;
  /** postcode of address */
  postcode?: Maybe<Scalars['String']['output']>;
  /** PostCodeGeo record id */
  postcodeGeoId?: Maybe<Scalars['Int']['output']>;
  /** Previous search filter */
  previousSearch?: Maybe<Scalars['JSON']['output']>;
  /** The previous worker search this user performed, if client */
  previousSearchStructured?: Maybe<PreviousSearch>;
  /** Whether the user has a primary emergency contact */
  primaryEmergencyContact?: Maybe<Scalars['Boolean']['output']>;
  /** whether the user is privately funded */
  privatlyFunded?: Maybe<Scalars['Boolean']['output']>;
  /** User profile */
  profile?: Maybe<Profile>;
  /** Profile steps */
  profileSteps?: Maybe<Array<ProfileSteps>>;
  /** Whether current target is eligible for insurance on quickpay enabled agreements */
  quickpayInsured?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving agreements emails */
  receiveAgreementsEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving event deliveries emails */
  receiveEventDeliveriesEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving messages emails */
  receiveMessagesEmails?: Maybe<Scalars['Boolean']['output']>;
  /** Opt-in for receiving planned session reminder emails */
  receivePlannedSessionReminderEmails: Scalars['Boolean']['output'];
  /** Opt-in for receiving SMS */
  receiveSms?: Maybe<Scalars['Boolean']['output']>;
  /** User roles */
  roles: Array<Scalars['String']['output']>;
  /** The source from which the user signed up */
  signupSource: SignUpSource;
  /** SMS verification status */
  smsVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Statutory declaration outstanding flag */
  statDecOutstanding?: Maybe<Scalars['Boolean']['output']>;
  /** state of address */
  state?: Maybe<Scalars['String']['output']>;
  /** Timezone at user's location */
  timezone: Scalars['String']['output'];
  /** Total earnings of the user */
  totalEarnings?: Maybe<Scalars['Float']['output']>;
  /** Total earnings current financial year */
  totalEarningsInCurrentFinancialYear?: Maybe<Scalars['Float']['output']>;
  /** Truncated name */
  truncatedName: Scalars['String']['output'];
  /** Short unique identifier */
  uid?: Maybe<Scalars['String']['output']>;
  /** Use preferred names for legal documents flag */
  usePreferredNamesForLegal?: Maybe<Scalars['Boolean']['output']>;
  /** Whether current target has used quickpay in any agreement in the past */
  usedQuickpay?: Maybe<Scalars['Boolean']['output']>;
  /** Whether current target has blocked this user */
  userHasBlocked?: Maybe<Scalars['Boolean']['output']>;
  /** Whether current target is blocked by this user */
  userIsBlocked?: Maybe<Scalars['Boolean']['output']>;
  /** Universally unique identifier of the user */
  uuid?: Maybe<Scalars['String']['output']>;
  /** If user should see prompt about posting a job */
  viewedPostNewJobPrompt?: Maybe<Scalars['Boolean']['output']>;
  /** If user should see provider onboarding welcome page on login */
  viewedProviderWelcomePage?: Maybe<Scalars['Boolean']['output']>;
};

/** Types of user accounts we support */
export enum UserAccountTypes {
  Admin = 'Admin',
  Carer = 'Carer',
  Consumer = 'Consumer',
  Coordinator = 'Coordinator',
  Organisation = 'Organisation'
}

/** Attributes of a user-account we want to update */
export type UserAccountUpdateAttributes = {
  /** Address line 1 */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Birthdate */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Attributes for a carer-profile if the user is a support-worker */
  carerProfileAttributes?: InputMaybe<CarerProfileAttributes>;
  /** Would the client like to receive emails about new support workers in their area */
  carersInArea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contact phone */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Email of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Existing password of the user (to confirm we are authorised to change the details) */
  existingPassword?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Would the support-worker like to receive emails about new jobs posted in their area */
  jobsInArea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal first name */
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Legal last name */
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal middle name */
  legalMiddleName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Would the client like to receive carer reliability assessments */
  optInCarerReliabilityAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** New password for the user */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Confirmation of the new password */
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  /** Postcode */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** Primary emergency contact */
  primaryEmergencyContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Would the user like to receive agreement emails */
  receiveAgreementsEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Would the user like to receive timesheet/event-delivery emails */
  receiveEventDeliveriesEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Would the user like to receive emails when they are messaged */
  receiveMessagesEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Would the user like to receive emails reminding them of planned sessions */
  receivePlannedSessionReminderEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /** Would the user like to receive SMS notifications */
  receiveSms?: InputMaybe<Scalars['Boolean']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Use preferred names for legal */
  usePreferredNamesForLegal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UserAccountUpdate */
export type UserAccountUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes we want to update */
  userAttributes: UserAccountUpdateAttributes;
};

/** Autogenerated return type of UserAccountUpdate */
export type UserAccountUpdatePayload = {
  __typename?: 'UserAccountUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated user */
  user?: Maybe<User>;
};

/** Active experiments for the user */
export type UserActiveExperiment = {
  __typename?: 'UserActiveExperiment';
  /** Support providers first jobs reference in profile feature flag value */
  spFirstJobsReferencesInProfile?: Maybe<Experiment>;
  /**
   * Show matching jobs in onboarding to support provider feature flag value
   * @deprecated Optimizely will be replaced soon.
   */
  spShowMatchingJobsInOnboarding?: Maybe<Experiment>;
  /** Session impression collection in the chats feature flag value */
  tcSessionImpressionCollection?: Maybe<Experiment>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of UserDelete */
export type UserDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserDelete */
export type UserDeletePayload = {
  __typename?: 'UserDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the soft deleted user */
  user?: Maybe<User>;
};

/** Attributes of a request to determine if a user can be deleted */
export type UserDeletionStatus = {
  __typename?: 'UserDeletionStatus';
  /** Can the user can be deleted */
  canDelete: Scalars['Boolean']['output'];
  /** Reasons why the user cannot be deleted */
  reasons?: Maybe<Array<Scalars['String']['output']>>;
};

/** Details of a User Draft */
export type UserDraft = {
  __typename?: 'UserDraft';
  /** Content of the draft - a json blob of fields filled out */
  content?: Maybe<Scalars['String']['output']>;
  /** Time draft was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the draft */
  id?: Maybe<Scalars['ID']['output']>;
  /** Kind of the draft eg postedJobPublic/Private */
  kind?: Maybe<Scalars['String']['output']>;
  /** Posted Job created from this draft */
  postedJob?: Maybe<PostedJob>;
  /** ID of a related SupportActivity object used to create this draft */
  supportActivityId?: Maybe<Scalars['ID']['output']>;
  /** Time draft was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Attributes of a UserDraft */
export type UserDraftAttributes = {
  /** Content is the json blob of data containing all the detail a user has entered for this draft */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID of the draft */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Kind of the draft eg postedJobPublic/Private */
  kind?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UserDraftCreateDeleteUpdate */
export type UserDraftCreateDeleteUpdateInput = {
  /** Which action are we performing (create/update/delete) */
  action: CreateDeleteUpdateOptions;
  /** What attribute are we applying to the draft */
  attributes: UserDraftAttributes;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserDraftCreateDeleteUpdate */
export type UserDraftCreateDeleteUpdatePayload = {
  __typename?: 'UserDraftCreateDeleteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns user draft details. */
  userDraft?: Maybe<UserDraft>;
};

/** What kind of User Draft is saved here eg postedJobPublic */
export enum UserDraftKind {
  PostedJob = 'postedJob',
  PostedJobPrivate = 'postedJobPrivate',
  PostedJobPublic = 'postedJobPublic',
  PostedJobSupportNeed = 'postedJobSupportNeed'
}

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** Details of a customer's accepted organisations terms (and extra data about the organisation and customer) */
export type UserOrganisationTerm = {
  __typename?: 'UserOrganisationTerm';
  /** Name of the customer's carer */
  carerFirstName?: Maybe<Scalars['String']['output']>;
  /** First name of the customer */
  consumerFirstName?: Maybe<Scalars['String']['output']>;
  /** Detail of the accepted terms */
  contentOfTerms?: Maybe<Scalars['String']['output']>;
  /** Customer email */
  email?: Maybe<Scalars['String']['output']>;
  /** ID of the customer */
  id?: Maybe<Scalars['ID']['output']>;
  /** Is this client linked to an organisation */
  isClientLinkedToOrg?: Maybe<Scalars['Boolean']['output']>;
  /** Should we show the terms popup */
  isShowingTermPopup?: Maybe<Scalars['Boolean']['output']>;
  /** Primary email of the organisation */
  organisationEmail?: Maybe<Scalars['String']['output']>;
  /** Name of the organisation */
  organisationName?: Maybe<Scalars['String']['output']>;
  /** Primary phone number of the organisation */
  organisationPhone?: Maybe<Scalars['String']['output']>;
  /** Customer's Phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Status of the terms acceptance */
  status?: Maybe<Scalars['String']['output']>;
  /** Website of the organisation */
  website?: Maybe<Scalars['String']['output']>;
};

/** What options for actions are we taking for organisation-terms (eg accepted/cancelled) */
export enum UserOrganisationTermStatusOptions {
  Accepted = 'accepted',
  Cancelled = 'cancelled'
}

/** Autogenerated input type of UserPasswordRecovery */
export type UserPasswordRecoveryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new password */
  password: Scalars['String']['input'];
  /** Security-token for the password-reset operation */
  resetPasswordToken: Scalars['String']['input'];
};

/** Autogenerated return type of UserPasswordRecovery */
export type UserPasswordRecoveryPayload = {
  __typename?: 'UserPasswordRecoveryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns result of attempt to change password: either success response or error */
  response?: Maybe<Scalars['String']['output']>;
};

/** Token for fetching a sendbird session */
export type UserSendbirdSessionToken = {
  __typename?: 'UserSendbirdSessionToken';
  /** Return session token */
  sessionToken: Scalars['String']['output'];
};

/** Autogenerated input type of View */
export type ViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the request to update */
  requestUuid: Scalars['ID']['input'];
};

/** Autogenerated return type of View */
export type ViewPayload = {
  __typename?: 'ViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the response of the update (JSON containing status and body) */
  response: Scalars['JSON']['output'];
};

/** Represent wallet of the user */
export type Wallet = {
  __typename?: 'Wallet';
  /** Balance remaining in wallet */
  balance?: Maybe<Scalars['Int']['output']>;
  /** Contribution rate for the wallet */
  contributionRate?: Maybe<Scalars['Float']['output']>;
  /** Effective balance remaining in wallet(balance without transactions processing transactions) */
  effectiveBalance?: Maybe<Scalars['Int']['output']>;
  /** ID of the wallet */
  id?: Maybe<Scalars['ID']['output']>;
  /** Kind of wallet */
  kind: Scalars['String']['output'];
  /** Status of the wallet */
  status?: Maybe<Scalars['String']['output']>;
  /** Total contribution returned to bank account */
  totalContributionReturns?: Maybe<Scalars['Float']['output']>;
  /** Total wallet contributions */
  totalContributions?: Maybe<Scalars['Float']['output']>;
  /** Total wallet contributions in current year */
  totalContributionsInCurrentFinancialYear?: Maybe<Scalars['Float']['output']>;
  /** Total amount earned */
  totalEarnedSinceOptingIn?: Maybe<Scalars['Int']['output']>;
  /** Total amount paid out since user opted in */
  totalPaidOutSinceOptingIn?: Maybe<Scalars['Int']['output']>;
  /** Paginated wallet transactions */
  transactions?: Maybe<WalletTransactionConnection>;
  /** ID of the user to which the wallet belong */
  userId?: Maybe<Scalars['ID']['output']>;
  /** Wallet payout destination saved for wallet */
  walletPayoutDestination?: Maybe<WalletPayoutDestination>;
  /** Wallet transactions */
  walletTransactions?: Maybe<Array<WalletTransaction>>;
};


/** Represent wallet of the user */
export type WalletTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes of a wallet */
export type WalletAttributes = {
  /** Contribution rate for the wallet */
  contributionRate?: InputMaybe<Scalars['Float']['input']>;
  /** Id of the Wallet */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Kind of the wallet */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Status of the wallet */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Wallet payout destination object */
export type WalletPayoutDestination = {
  __typename?: 'WalletPayoutDestination';
  /** Payout destination account name */
  account?: Maybe<BankAccountDetails>;
  /** Payout destination account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Payout destination bsb number */
  bsbNumber?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /** Kind of wallet */
  kind: Scalars['String']['output'];
  /** Reference */
  reference?: Maybe<Scalars['String']['output']>;
  /** Wallet id */
  walletId: Scalars['String']['output'];
};

/** Wallet payout destination input fields */
export type WalletPayoutDestinationAttributes = {
  /** Account name of designated account to transfer to */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Account number of designated account to transfer to */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Account type of designated account to transfer to */
  accountType?: InputMaybe<Scalars['String']['input']>;
  /** BSB of designated account to transfer to */
  bsbNumber?: InputMaybe<Scalars['String']['input']>;
  /** Kind of the wallet */
  kind: Scalars['String']['input'];
  /** Reference for superannuation account */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Id of the wallet */
  walletId: Scalars['ID']['input'];
};

/** Details of a transaction for this wallet */
export type WalletTransaction = {
  __typename?: 'WalletTransaction';
  /** Account details linked to payout destination */
  account?: Maybe<BankAccountDetails>;
  /** How much amount is being transferred */
  amount: Scalars['Int']['output'];
  /** Contribution rate of wallet transaction */
  contributionRate: Scalars['Float']['output'];
  /** When the transaction is created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description for the transaction */
  description: Scalars['String']['output'];
  /** ID for the transaction */
  id: Scalars['ID']['output'];
  /** Unique identifier of wallet transactions */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Invoice number fetching from invoice statement */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** To identify return transactions */
  isReturn: Scalars['Boolean']['output'];
  /** Either of same_day or wallet */
  mechanism?: Maybe<Scalars['String']['output']>;
  /** Reference of the transaction */
  reference?: Maybe<Scalars['String']['output']>;
  /** Status of the transaction */
  status?: Maybe<Scalars['String']['output']>;
  /** How many support hours are included in this transaction */
  supportHours: Scalars['Float']['output'];
  /** Type(credit or debit) of transaction */
  transactionType: Scalars['String']['output'];
};

/** The connection type for WalletTransaction. */
export type WalletTransactionConnection = {
  __typename?: 'WalletTransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletTransactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WalletTransaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WalletTransactionEdge = {
  __typename?: 'WalletTransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WalletTransaction>;
};

/** Week options for recurring scheduled-event/session */
export enum WeekOptions {
  /** first week of the month */
  First = 'first',
  /** fourth week of the month */
  Fourth = 'fourth',
  /** last week of the month */
  Last = 'last',
  /** second week of the month */
  Second = 'second',
  /** third week of the month */
  Third = 'third'
}

/** Rules for weekly and fortnightly recurrence */
export type WeeklyFortnightlyRecurrenceRules = {
  /** Day of the week the session recurs */
  day: Scalars['String']['input'];
  /** times sessions recurrs */
  times: Array<RecurrenceTimes>;
};

/** Information about the worker's past work history */
export type WorkHistory = {
  __typename?: 'WorkHistory';
  /** Company the person was working for */
  company: Scalars['String']['output'];
  /** Job end date/current */
  endAt: Scalars['String']['output'];
  /** Were personal care services provided at this job? */
  serviceProvided?: Maybe<Scalars['Boolean']['output']>;
  /** Job start date */
  startAt: Scalars['String']['output'];
  /** Job title/role */
  title: Scalars['String']['output'];
};

/** Attributes for an item of work history */
export type WorkHistoryAttributes = {
  /** Name of Company */
  company: Scalars['String']['input'];
  /** Current OR end date in dd/mm/yyyy format */
  endAt: Scalars['String']['input'];
  /** Start date in dd/mm/yyyy format */
  startAt: Scalars['String']['input'];
  /** Job title/role */
  title: Scalars['String']['input'];
};

/** Advanced search filter details for the client worker-search */
export type WorkerAdvancedSearchFilterAttribute = {
  /** Filter by workers that are ABN verified */
  abnVerified?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter workers by availability days */
  availableDays?: InputMaybe<Array<DayOptions>>;
  /** Filter workers by given care knowledge */
  careKnowledge?: InputMaybe<Array<CareKnowledgeOptions>>;
  /** Filter workers by cultural backgrounds */
  culturalBackgrounds?: InputMaybe<Array<CulturalBackgroundOptions>>;
  /** Filter workers by gender */
  gender?: InputMaybe<Array<PostedJobsGenderPref>>;
  /** Filter workers by interests */
  interests?: InputMaybe<Array<InterestOptions>>;
  /** Filter workers by languages */
  languages?: InputMaybe<Array<LanguageOptions>>;
  /** Filter workers by carer type */
  myType?: InputMaybe<Array<Carer>>;
  /** Filter workers by whether they are NDIS screening verified */
  ndisWorkerScreeningVerified?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter workers by personality traits (eg outgoing vs relaxed) */
  personality?: InputMaybe<Array<WorkerPersonalityOptions>>;
  /** Filter workers by properties */
  properties?: InputMaybe<Array<WorkerPropertiesOptions>>;
  /** Filter workers by qualifications they hold */
  qualifications?: InputMaybe<Array<WorkerQualificationsOptions>>;
  /** Filter workers by religions */
  religions?: InputMaybe<Array<ReligionOptions>>;
  /** Filter workers by specified restrictions (eg pet friendly) */
  restrictions?: InputMaybe<Array<WorkerPreferenceOptions>>;
  /** Filter workers by whether they have a reviewed childrens check */
  reviewChildrenCheckVerified?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter workers by services they offer */
  services?: InputMaybe<Array<WorkerDialogServices>>;
};

/** Attributes of a support-worker account */
export type WorkerAttributes = {
  /** Address line 1 */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Birthdate */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Gender */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of a horizon-one offer */
  horizonOneOfferAttributes?: InputMaybe<HorizonOneOfferAttributes>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal first name */
  legalFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Legal last name */
  legalLastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal middle name */
  legalMiddleName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the worker needs to be notified of automatic sessions termination */
  needsToBeNotifiedOfAutomaticSessionsTermination?: InputMaybe<Scalars['Boolean']['input']>;
  /** Postcode */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** Primary emergency contact */
  primaryEmergencyContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Worker profile attributes */
  profile?: InputMaybe<WorkerProfileAttributes>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Use preferred names for legal */
  usePreferredNamesForLegal?: InputMaybe<Scalars['Boolean']['input']>;
};

/** All of the fields required for the worker dashboard. Components are shown as tiles on the dashboard. */
export type WorkerDashboard = {
  __typename?: 'WorkerDashboard';
  /** Component showing support-worker account/onboarding progress */
  accountProgress?: Maybe<WorkersAccountProgress>;
  /** Component showing text explaining how a worker can build their profile */
  buildYourProfile?: Maybe<WorkersBuildYourProfile>;
  /** Component showing COVID vaccine prompt */
  covidVaccineAction?: Maybe<WorkersCovidVaccineAction>;
  /** Component showing an onboarding checklist */
  dashboardChecklist?: Maybe<WorkersDashboardChecklist>;
  /** Component showing a set of tiles each displaying useful data for the worker eg agreements, expired documents, links, invitations etc */
  dashboardTiles?: Maybe<WorkersDashboardTiles>;
  /** Component flagging useful information about the worker - eg if they have an agreement or showing various modals */
  flags?: Maybe<WorkersFlags>;
  /** Component with the hero image associated with this dashboard */
  heroImage?: Maybe<WorkersHeroImage>;
  /** Component showing a promotion for the worker to turn on notifications for last-minute (flex) jobs */
  lmjPromotion?: Maybe<WorkersLmjPromotion>;
  /** Component showing mable-related news-items */
  mableNews?: Maybe<WorkersMableNews>;
  /** Component showing reminders for updates eg flu-shot, training and stat-dec */
  updatesDue?: Maybe<WorkersUpdatesDue>;
  /** Component showing an urgent call to action */
  urgentCallToAction?: Maybe<WorkersUrgentCallToAction>;
  /** Details about the support-worker viewing this dashboard */
  user?: Maybe<User>;
  /** Component showing a list of requirements for being a worker on Mable eg qualifications, WWC check and ABN */
  whatYouWillNeed?: Maybe<WorkersWhatYouWillNeed>;
};

/** Set of services that a worker supports - can be used to filter workers for a client */
export enum WorkerDialogServices {
  ActivitiesOutingsCommunity = 'activities_outings_community',
  Alliedhealthservices = 'alliedhealthservices',
  AssistanceWithEating = 'assistance_with_eating',
  BasicShowering = 'basic_showering',
  CarerAssessment = 'carer_assessment',
  CaseManagement = 'case_management',
  CatheterCare = 'catheter_care',
  Communityparticipationsportsactivities = 'communityparticipationsportsactivities',
  Companionship = 'companionship',
  Companionshipsocialsupport = 'companionshipsocialsupport',
  Continenceassessmentmanagement = 'continenceassessmentmanagement',
  DriversLicense = 'drivers_license',
  ExerciseAssistance = 'exercise_assistance',
  HoistTransfer = 'hoist_transfer',
  HomeMaintenance = 'home_maintenance',
  LightGardening = 'light_gardening',
  LightHousework = 'light_housework',
  LightMassage = 'light_massage',
  ManualHandling = 'manual_handling',
  Manualtransfermobility = 'manualtransfermobility',
  MealDelivery = 'meal_delivery',
  MealPreparation = 'meal_preparation',
  Mealdeliverypreparationshopping = 'mealdeliverypreparationshopping',
  Mealpreparationshopping = 'mealpreparationshopping',
  MedicationAssistance = 'medication_assistance',
  MedicationManagement = 'medication_management',
  NursingDegree = 'nursing_degree',
  OccupationalTherapy = 'occupational_therapy',
  PalliativeCare = 'palliative_care',
  PalliativeCarePersonal = 'palliative_care_personal',
  PersonalAssistant = 'personal_assistant',
  Physiotherapy = 'physiotherapy',
  PrePostAcuteHospitalCare = 'pre_post_acute_hospital_care',
  Psychological = 'psychological',
  RespiratoryCare = 'respiratory_care',
  Shopping = 'shopping',
  ShoweringAndDressing = 'showering_and_dressing',
  SpeechTherapy = 'speech_therapy',
  SportsAndExercise = 'sports_and_exercise',
  Statutorydeclaration = 'statutorydeclaration',
  Toileting = 'toileting',
  Transport = 'transport',
  VitalSigns = 'vital_signs',
  WoundCare = 'wound_care'
}

/** Actions that can be performed on Last-minute/flex jobs by the worker */
export enum WorkerFlexJobActionOptions {
  /** Decline last minute job offer */
  Decline = 'decline',
  /** Make Last minute Job offer */
  Offer = 'offer',
  /** Withdraw accepted last minute job offer */
  Withdraw = 'withdraw'
}

/** Worker interests - can be used to filter workers for a client */
export enum WorkerInterestOptions {
  Cooking = 'Cooking',
  CulturalFestivities = 'CulturalFestivities',
  Gardening = 'Gardening',
  IndoorGames = 'IndoorGames',
  Movies = 'Movies',
  Music = 'Music',
  Other = 'Other',
  Pets = 'Pets',
  PhotographyArt = 'PhotographyArt',
  Reading = 'Reading',
  Sports = 'Sports',
  Travel = 'Travel'
}

/** All of the fields required for Worker Jobs Explanation Type */
export type WorkerJobExplanation = {
  __typename?: 'WorkerJobExplanation';
  /** job UUID */
  jobUuid?: Maybe<Scalars['Uuid']['output']>;
  /** match explanation */
  matchExplanation?: Maybe<WorkerJobMatchExplanation>;
  /** support provider UUID */
  spUuid?: Maybe<Scalars['Uuid']['output']>;
};

/** worker job match explanation */
export type WorkerJobMatchExplanation = {
  __typename?: 'WorkerJobMatchExplanation';
  /** desired services */
  desiredServices?: Maybe<Scalars['String']['output']>;
  /** desired worker types */
  desiredWorkerTypes?: Maybe<Scalars['String']['output']>;
  /** eligibility */
  eligibility?: Maybe<Covered>;
  /** location relevance */
  locationRelevance?: Maybe<LocationRelevance>;
  /** qualification coverage */
  qualificationCoverage?: Maybe<QualificationCoverage>;
  /** required worker types */
  requiredWorkerTypes?: Maybe<Scalars['String']['output']>;
  /** service coverage */
  serviceCoverage?: Maybe<ServiceCoverage>;
};

/** A set of valid names for returning a filtered list of worker jobs eg recommended, replied, flex */
export enum WorkerJobSearchTaskOptions {
  /** Flex jobs (LMJs) */
  Flex = 'flex',
  /** Flex jobs (LMJs) that are available in next 4-48 hours */
  FlexRecommendations = 'flex_recommendations',
  /** Recommended one-off jobs */
  OneOff = 'one_off',
  /** Recommended jobs */
  Recommended = 'recommended',
  /** Replied jobs */
  Replied = 'replied',
  /** Search jobs by selected filters */
  Search = 'search'
}

/** Personality type for a worker - we can use this to filter workers for a client */
export enum WorkerPersonalityOptions {
  Outgoing = 'outgoing',
  Relaxed = 'relaxed'
}

/** Worker preferences - can be used to filter workers for a client */
export enum WorkerPreferenceOptions {
  Anyone = 'Anyone',
  FemaleOnly = 'FemaleOnly',
  MaleOnly = 'MaleOnly',
  NoPets = 'NoPets',
  NonSmoker = 'NonSmoker'
}

/** Worker preference type */
export type WorkerPreferences = {
  __typename?: 'WorkerPreferences';
  /** Carer description regarding a client's worker preference */
  carerDescription?: Maybe<Scalars['String']['output']>;
  /** Client's worker gender preference */
  gender?: Maybe<Array<Scalars['String']['output']>>;
  /** Other details regarding a client's worker preference */
  otherDetails?: Maybe<Scalars['String']['output']>;
  /** Participant support profile id that contains worker preferences */
  supportProfileId?: Maybe<Scalars['String']['output']>;
};

/** All the attributes for creating worker preferences */
export type WorkerPreferencesInput = {
  /** carer description of a client's worker preference */
  carerDescription?: InputMaybe<Scalars['String']['input']>;
  /** Client's worker gender preference */
  gender: Array<Scalars['String']['input']>;
  /** Other details regarding a client's worker preference */
  otherDetails?: InputMaybe<Scalars['String']['input']>;
};

/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfile = {
  __typename?: 'WorkerProfile';
  /** Worker's ABN */
  abn?: Maybe<Scalars['String']['output']>;
  /** Status of verifying the ABN */
  abnStatus?: Maybe<Scalars['Int']['output']>;
  /** Has the ABN been verified */
  abnVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Short bio of the worker */
  about?: Maybe<Scalars['String']['output']>;
  /** Admin badge: Gold/Silver/Bronze */
  adminBadges?: Maybe<Scalars['String']['output']>;
  /** Date at which registration as an Allied-Health professional expires */
  alliedRegistrationExpiry?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Registration number as an Allied-Health professional */
  alliedRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Data about when the worker is available to work (days/times) */
  availability: Availability;
  /** Date availability updated */
  availabilityUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Boolean to show/hide availability uplift feedback banner */
  availabilityUpliftFeedbackBannerVisible: Scalars['Boolean']['output'];
  /** All available badges */
  badges?: Maybe<Array<Badge>>;
  /** Worker's bank account */
  bankAccount?: Maybe<BankAccount>;
  /** Content to show to remind the worker to get their COVID Booster */
  boosterReminder?: Maybe<BoosterReminder>;
  /** ??? Passed to conversation_user_path */
  bypassEmptyCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Worker's uique set of experience and knowledge */
  careExperienceAndKnowledge?: Maybe<ExperienceAndKnowledge>;
  /** Does this worker have a working-with-children check (expired or current) */
  childrenCheckExists?: Maybe<Scalars['Boolean']['output']>;
  /** Expiry date for the working-with-children check */
  childrenCheckExpiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Registration number for this worker's working-with-children check */
  childrenCheckNumber?: Maybe<Scalars['String']['output']>;
  /** Relevant fields when visitor is a client */
  clientFields: ClientFields;
  /** Combined feedback */
  combinedFeedback?: Maybe<Scalars['Float']['output']>;
  /**
   * Has this worker gone through the COVID training
   * @deprecated No longer supported.
   */
  coronavirusTrainingExists?: Maybe<Scalars['Boolean']['output']>;
  /** What is the worker's COVID vaccination status */
  covidVaccineStatus?: Maybe<CovidVaccineStatusDisplayOptions>;
  /** Self declared COVID status confirmation */
  covidVaccineStatusConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Date at which this worker received their CPR training */
  cprIssueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Worker's list of cultural background(s) */
  culturalBackgrounds: Culture;
  /** Does this worker have a current working-with-children check */
  currentWorkingWithChildrenCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Hour range for `Delivered XX to XX support hours` label */
  deliveredHourGroup?: Maybe<Scalars['String']['output']>;
  /** If returned as part of a search, the distance from the current user (in kms) */
  distanceAway?: Maybe<Scalars['Float']['output']>;
  /** When does this worker's drivers licence expire */
  driversLicenceExpiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Details of where and what this worker has studied */
  educationAndTraining?: Maybe<Array<EducationAndTraining>>;
  /** Eligible for Tax and super sync */
  eligibleForTaxAndSuperSync: Scalars['Boolean']['output'];
  /** Eligible for Tax and super sync same day payout */
  eligibleForTaxAndSuperSyncSameDayPayout: Scalars['Boolean']['output'];
  /** Last name of Emergency Contact */
  emergencyContactsLastName?: Maybe<Scalars['String']['output']>;
  /** Name for Emergency Contact */
  emergencyContactsName?: Maybe<Scalars['String']['output']>;
  /** Phone for Emergency Contact */
  emergencyContactsPhone?: Maybe<Scalars['String']['output']>;
  /** Relationship of Emergency Contact to worker */
  emergencyContactsRelationship?: Maybe<Scalars['String']['output']>;
  /** Does the worker have an active registration as an Enrolled Nurse */
  enrolledNurseActiveRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Confirming that they will follow all the rules for being a Enrolled Nurse */
  enrolledNurseAgreeComplyRules?: Maybe<Scalars['Boolean']['output']>;
  /** Experiences with certain kinds of care */
  experiences: Experience;
  /** When was this workers first aid certificate issued */
  firstAidIssueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Checkbox for offering a free meet and greet to potential clients */
  firstHourForFree: Scalars['Boolean']['output'];
  /** Does the worker have an active suspension against them */
  hasActiveSuspension?: Maybe<Scalars['Boolean']['output']>;
  /** Has this worker received the COVID vaccine */
  hasCovidVaccine?: Maybe<Scalars['Boolean']['output']>;
  /** ?Legacy - it's hard-coded false for every file that defines it */
  hasFairworkPendingNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Has this worker received the seasonal flu vaccine */
  hasSeasonalFluShot?: Maybe<Scalars['Boolean']['output']>;
  /** Does the worker have at least one additional training (eg CPR, first-aid, drivers-licence) */
  hasSelectedAdditionalTraining?: Maybe<Scalars['Boolean']['output']>;
  /** Database ID of the worker */
  id: Scalars['ID']['output'];
  /** Immunisation section details */
  immunisation?: Maybe<Array<Immunisation>>;
  /** Most recent date of immunisation */
  immunisationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Has the worker gone through the infection-control training */
  infectionControlTrainingCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** If worker has declared bankruptcy, date it was declared */
  insuranceBankruptcyDate?: Maybe<Scalars['String']['output']>;
  /** Information on the circumstances leading to a declaration of bankruptcy */
  insuranceBankruptcyExplanation?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Combined General Liability claim against them, an explanation of that claim */
  insuranceClaimHistoryCgiExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made following a Combined General Liability claim against the worker (to prevent it in future) */
  insuranceClaimHistoryCgiPrevention?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Medical Malpractice or Professional Indemnity claim against them, an explanation of that claim */
  insuranceClaimHistoryMedPiExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made following a Medical Malpractice or Professional Indemnity claim against the worker (to prevent it in future) */
  insuranceClaimHistoryMedPiPrevention?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Personal Accident claim against them, an explanation of that claim */
  insuranceClaimHistoryPersonalAccidentExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made following a Personal Accident claim against the worker (to prevent it in future) */
  insuranceClaimHistoryPersonalAccidentPrevention?: Maybe<Scalars['String']['output']>;
  /** Details around the worker's insurance history */
  insuranceDetails?: Maybe<Array<Scalars['String']['output']>>;
  /** Date of first relevant paid care experience */
  insuranceFirstExperienceDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** If worker is aware of circumstances prompting a future claim against them, an explanation of that claim */
  insuranceFutureClaimAgainstExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made to prevent a future claim against the worker */
  insuranceFutureClaimAgainstPrevention?: Maybe<Scalars['String']['output']>;
  /** Has the worker had a Personal Accident claim against them */
  insurancePersonalAccident?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker had a Professional Indemnity claim against them */
  insuranceProfessionalIndemnity?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker had a Combined General Liability claim against them */
  insurancePublicLiability?: Maybe<Scalars['Boolean']['output']>;
  /** If worker has had a Workers Compensation claim, the date at which it occurred */
  insuranceWorkersCompClaimDate?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Workers Compensation claim, the main tasks/duties performed */
  insuranceWorkersCompClaimDuties?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Workers Compensation claim, the relevant employer name */
  insuranceWorkersCompClaimEmployerName?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Workers Compensation claim, an explanation of that claim */
  insuranceWorkersCompClaimExplanation?: Maybe<Scalars['String']['output']>;
  /** Worker's interests and hobbies */
  interests: Array<Interest>;
  /** Is carer migrated to availability uplift */
  isMigratedToAvailabilityUplift: Scalars['Boolean']['output'];
  /** Languages spoken by the worker */
  languages: Language;
  /** Is the worker LGBTI friendly */
  lgbtiFriendly?: Maybe<Scalars['Boolean']['output']>;
  /** Work location pins */
  locations?: Maybe<Array<Location>>;
  /** Loyalty badge name */
  loyaltyName?: Maybe<Scalars['String']['output']>;
  /** For how long has this worker been a member */
  memberSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** What type of worker is this (eg nurse, personal, social, allied) */
  myType?: Maybe<Array<Carer>>;
  /** Has the worker passed the NDIS worker screening check */
  ndisWorkerScreeningCheck?: Maybe<Scalars['Boolean']['output']>;
  /** NDIS Worker screening check has been verified by admin */
  ndisWorkerScreeningVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Is this worker a non-smoker */
  nonSmoker?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized type - from user */
  normalizedType: Scalars['String']['output'];
  /** The worker's Nursing registration number */
  nurseRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** The expiry date of the worker's Nursing registration */
  nursingRegistrationExpiry?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Platform services offered by the worker */
  offeredPlatformServices: Array<OfferedPlatformServiceItem>;
  /** Services offered by the worker */
  offeredServices: Array<OfferedServiceItem>;
  /** Details of the workers onboarding progress */
  onboardingStatus?: Maybe<OnboardingStatus>;
  /** Provides extra details when user selects other qualifications */
  otherQuals?: Maybe<Scalars['String']['output']>;
  /** Determine if PayNow modal should be shown */
  paynowModalStatus?: Maybe<Scalars['String']['output']>;
  /** Categories of the worker's personality eg 'Outgoing and engaging' */
  personalities: Array<Personality>;
  /** Description of the worker's personality */
  personality?: Maybe<Scalars['String']['output']>;
  /** Is the worker friendly towards pets */
  petFriendly?: Maybe<Scalars['Boolean']['output']>;
  /** Answers provided at police check step especially for BYO police check */
  policeCheckDeclaration?: Maybe<PoliceCheckDeclaration>;
  /** Street address for postal address */
  postalAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Suburb/state/postcode for postal address */
  postalAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Worker preferences eg No pets or non-smoker */
  preferences: Array<Preference>;
  /** Has the worker completed the Professional Responsibility training? */
  professionalResponsibilityTrainingCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Status of profile completion */
  profileStatus?: Maybe<ProfileStatus>;
  /** Set of changes proposed for the profile */
  proposedChanges?: Maybe<ProposedChanges>;
  /** Changes proposed for the about field */
  proposedChangesAbout?: Maybe<Scalars['String']['output']>;
  /** Proposed new avatar */
  proposedChangesAvatar?: Maybe<Scalars['String']['output']>;
  /** Changes proposed to CPR certification date */
  proposedChangesCprCertificate?: Maybe<ProposedChangesSelectedDate>;
  /** Changes proposed to drivers licence certification date */
  proposedChangesDriversLicense?: Maybe<ProposedChangesSelectedDate>;
  /** Changes proposed to first aid certification date */
  proposedChangesFirstAid?: Maybe<ProposedChangesSelectedDate>;
  /** Changes proposed to working-with-children check date */
  proposedChangesWwcc?: Maybe<ProposedChangesWwcc>;
  /** Worker qualifications eg required certificates in certain kinds of care */
  qualifications?: Maybe<Array<WorkerQualificationsOptions>>;
  /** Rates this worker will charge for their care */
  rates?: Maybe<Array<Rate>>;
  /** Ratings that other clients have given this worker */
  ratings?: Maybe<Array<Rating>>;
  /** Professional references for this worker */
  references?: Maybe<Array<Reference>>;
  /** Religion (if any) of the worker */
  religion: Array<Religion>;
  /** Worker responsiveness */
  response: Response;
  /** Has this worker reviewed their COVID training */
  reviewCoronavirusTrainingVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Has Mable verified this workers Professional Responsibility training? */
  reviewProfessionalResponsibilityTrainingVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Showing conditional sections in worker profile */
  sectionVisibility: SectionVisibility;
  /**
   * Legacy - Use `offeredServices` instead
   * @deprecated Use `WorkerProfile.offeredServices` instead.
   */
  services?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the worker has started setting up their profile */
  setupStarted?: Maybe<Scalars['Boolean']['output']>;
  /** Information about workers references/endorsement that will be made visible to others */
  shareableReferencesSummary?: Maybe<ShareableReferencesSummary>;
  /** Determine if drivers licence should be shown in additional training page */
  showDriversLicenseOption?: Maybe<Scalars['Boolean']['output']>;
  /** Should we show the paynow intro (eg if user is eligible for paynow and has other relevant requirements) */
  showPaynowIntro?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the statutory declaration for Overseas residency or citizenship */
  statDecHaveCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Does the worker declare they have been an overseas resident or ciizen */
  statDecOtherCountryResident?: Maybe<Scalars['Boolean']['output']>;
  /** Status of the working-with-chidren check */
  stateOfWwccIssue?: Maybe<Scalars['String']['output']>;
  /** Verification status of the statutory declaration for Overseas residency or citizenship */
  statutoryDeclarationStatus?: Maybe<Scalars['Boolean']['output']>;
  /** User object for this worker */
  user: User;
  /** ID of the user object for this worker */
  userId: Scalars['Int']['output'];
  /** Verified by Mable */
  verified?: Maybe<MableVerified>;
  /** Information about the worker's past work history */
  workHistory?: Maybe<Array<WorkHistory>>;
  /** Does the worker have a working-with-children check */
  workingWithChildren?: Maybe<Scalars['Boolean']['output']>;
};


/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfileCulturalBackgroundsArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfileExperiencesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfileInterestsArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfileLanguagesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfilePersonalitiesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfilePreferencesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for Worker Profile GraphQL Type */
export type WorkerProfileReligionArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Attributes for setting up a worker profile */
export type WorkerProfileAttributes = {
  /** Worker's ABN */
  abn?: InputMaybe<Scalars['String']['input']>;
  /** A quick summary to describe themself */
  about?: InputMaybe<Scalars['String']['input']>;
  /** Date at which registration as an Allied-Health professional expires */
  alliedRegistrationExpiry?: InputMaybe<Scalars['String']['input']>;
  /** Registration number as an Allied-Health professional */
  alliedRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Data about what days the worker is available to work */
  availableDays?: InputMaybe<Array<DayOptions>>;
  /** Bank account attributes */
  bankAccount?: InputMaybe<BankAccountAttributes>;
  /** When was the COVID-booster reminder dismissed */
  boosterReminderDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Worker's uique set of experience and knowledge */
  careExperienceAndKnowledge?: InputMaybe<CareExperienceAndKnowledgeAttributes>;
  /** Does this worker have a working-with-children check (expired or current) */
  childrenCheckExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Expiry date for the working-with-children check */
  childrenCheckExpiryDate?: InputMaybe<Scalars['String']['input']>;
  /** Registration number for this worker's working-with-children check */
  childrenCheckNumber?: InputMaybe<Scalars['String']['input']>;
  /** Has the modal for COVID-training been dismissed */
  covidModalDismissedAt?: InputMaybe<Scalars['String']['input']>;
  /** COVID-19 vaccination status */
  covidVaccineStatus?: InputMaybe<CovidVaccineStatusOptions>;
  /** Self declared COVID status confirmation */
  covidVaccineStatusConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date at which this worker received their CPR training */
  cprIssueDate?: InputMaybe<Scalars['String']['input']>;
  /** Worker's list of cultural background(s) */
  culturalBackgrounds?: InputMaybe<Array<CulturalBackgroundOptions>>;
  /** When does this worker's drivers licence expire */
  driversLicenceExpiryDate?: InputMaybe<Scalars['String']['input']>;
  /** Details of where and what this worker has studied */
  educationAndTraining?: InputMaybe<Array<EducationAndTrainingAttributes>>;
  /** Last name of Emergency Contact */
  emergencyContactsLastName?: InputMaybe<Scalars['String']['input']>;
  /** Name for Emergency Contact */
  emergencyContactsName?: InputMaybe<Scalars['String']['input']>;
  /** Phone for Emergency Contact */
  emergencyContactsPhone?: InputMaybe<Scalars['String']['input']>;
  /** Relationship of Emergency Contact to worker */
  emergencyContactsRelationship?: InputMaybe<ContactRelationshipOptions>;
  /** Does the worker have an active registration as an Enrolled Nurse */
  enrolledNurseActiveRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Confirming that they will follow all the rules for being a Enrolled Nurse */
  enrolledNurseAgreeComplyRules?: InputMaybe<Scalars['Boolean']['input']>;
  /** Experiences with certain kinds of care */
  experiences?: InputMaybe<Array<CareKnowledgeOptions>>;
  /** When was this workers first aid certificate issued */
  firstAidIssueDate?: InputMaybe<Scalars['String']['input']>;
  /** Checkbox for offering a free meet and greet to potential clients */
  firstHourForFree?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the worker had a COVID-19 vaccine */
  hasCovidVaccine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the worker had a flu vaccine this season */
  hasSeasonalFluShot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Immunisation date */
  immunisationDate?: InputMaybe<Scalars['String']['input']>;
  /** Has the worker gone through the infection-control training */
  infectionControlTrainingCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** If worker has declared bankruptcy, date it was declared */
  insuranceBankruptcyDate?: InputMaybe<Scalars['String']['input']>;
  /** Information on the circumstances leading to a declaration of bankruptcy */
  insuranceBankruptcyExplanation?: InputMaybe<Scalars['String']['input']>;
  /** If worker has had a Combined General Liability claim against them, an explanation of that claim */
  insuranceClaimHistoryCgiExplanation?: InputMaybe<Scalars['String']['input']>;
  /** What changes have been made following a Combined General Liability claim against the worker (to prevent it in future) */
  insuranceClaimHistoryCgiPrevention?: InputMaybe<Scalars['String']['input']>;
  /** If worker has had a Medical Malpractice or Professional Indemnity claim against them, an explanation of that claim */
  insuranceClaimHistoryMedPiExplanation?: InputMaybe<Scalars['String']['input']>;
  /** What changes have been made following a Medical Malpractice or Professional Indemnity claim against the worker (to prevent it in future) */
  insuranceClaimHistoryMedPiPrevention?: InputMaybe<Scalars['String']['input']>;
  /** If worker has had a Personal Accident claim against them, an explanation of that claim */
  insuranceClaimHistoryPersonalAccidentExplanation?: InputMaybe<Scalars['String']['input']>;
  /** What changes have been made following a Personal Accident claim against the worker (to prevent it in future) */
  insuranceClaimHistoryPersonalAccidentPrevention?: InputMaybe<Scalars['String']['input']>;
  /** Details around the worker's insurance history */
  insuranceDetails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Date of first relevant paid care experience */
  insuranceFirstExperienceDate?: InputMaybe<Scalars['String']['input']>;
  /** If worker is aware of circumstances prompting a future claim against them, an explanation of that claim */
  insuranceFutureClaimAgainstExplanation?: InputMaybe<Scalars['String']['input']>;
  /** What changes have been made to prevent a future claim against the worker */
  insuranceFutureClaimAgainstPrevention?: InputMaybe<Scalars['String']['input']>;
  /** Has the worker had a Personal Accident claim against them */
  insurancePersonalAccident?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the worker had a Professional Indemnity claim against them */
  insuranceProfessionalIndemnity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the worker had a Combined General Liability claim against them */
  insurancePublicLiability?: InputMaybe<Scalars['Boolean']['input']>;
  /** If worker has had a Workers Compensation claim, the date at which it occurred */
  insuranceWorkersCompClaimDate?: InputMaybe<Scalars['String']['input']>;
  /** If worker has had a Workers Compensation claim, the main tasks/duties performed */
  insuranceWorkersCompClaimDuties?: InputMaybe<Scalars['String']['input']>;
  /** If worker has had a Workers Compensation claim, the relevant employer name */
  insuranceWorkersCompClaimEmployerName?: InputMaybe<Scalars['String']['input']>;
  /** If worker has had a Workers Compensation claim, an explanation of that claim */
  insuranceWorkersCompClaimExplanation?: InputMaybe<Scalars['String']['input']>;
  /** Worker's interests and hobbies */
  interests?: InputMaybe<Array<InterestOptions>>;
  /** Languages spoken by the worker */
  languages?: InputMaybe<LanguageAttributes>;
  /** Adds a badge to your profile that shows support for people in the LGBTI community? */
  lgbtiFriendly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Main services provided eg personal, nursing, allied etc */
  myType?: InputMaybe<Array<Carer>>;
  /** Has the worker passed the NDIS worker screening check */
  ndisWorkerScreeningCheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this worker a non-smoker */
  nonSmoker?: InputMaybe<Scalars['Boolean']['input']>;
  /** The worker's Nursing registration number */
  nurseRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** The expiry date of the worker's Nursing registration */
  nursingRegistrationExpiry?: InputMaybe<Scalars['String']['input']>;
  /** Platform services offered by the worker. Those are the new, refactored, services aligned with long-term service taxonomy vision. */
  offeredPlatformServices?: InputMaybe<Array<OfferedPlatformService>>;
  /** Services offered by the worker - legacy solution exists for backwards compatibility */
  offeredServices?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Provides extra details when user selects other qualifications */
  otherQuals?: InputMaybe<Scalars['String']['input']>;
  /** Description of the worker's personality */
  personality?: InputMaybe<WorkerPersonalityOptions>;
  /** Is the worker friendly towards pets */
  petFriendly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Answers provided at police check step especially for BYO police check */
  policeCheckDeclarationAttributes?: InputMaybe<PoliceCheckDeclarationAttributes>;
  /** Street address for postal address */
  postalAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Suburb/state/postcode for postal address */
  postalAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Worker preferences eg No pets or non-smoker */
  preferences?: InputMaybe<Array<WorkerPreferenceOptions>>;
  /** Has the worker completed the Professional Responsibility training? */
  professionalResponsibilityTrainingCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Changes proposed for the about field */
  proposedChangesAbout?: InputMaybe<Scalars['String']['input']>;
  /** Proposed new avatar */
  proposedChangesAvatar?: InputMaybe<Scalars['String']['input']>;
  /** Changes proposed to CPR certification date */
  proposedChangesCprCertificate?: InputMaybe<ProposedChangesSelectedDateAttributes>;
  /** Changes proposed to drivers licence certification date */
  proposedChangesDriversLicense?: InputMaybe<ProposedChangesSelectedDateAttributes>;
  /** Changes proposed to first aid certification date */
  proposedChangesFirstAid?: InputMaybe<ProposedChangesSelectedDateAttributes>;
  /** Changes proposed to working-with-children check date */
  proposedChangesWwcc?: InputMaybe<ProposedChangesWwccAttributes>;
  /** Worker qualifications eg required certificates in certain kinds of care */
  qualifications?: InputMaybe<Array<WorkerQualificationsOptions>>;
  /** Religion (if any) of the worker */
  religions?: InputMaybe<Array<ReligionOptions>>;
  /** Has this worker reviewed their COVID training */
  reviewCoronavirusTrainingVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has Mable verified this workers Professional Responsibility training? */
  reviewProfessionalResponsibilityTrainingVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the worker has started setting up their profile */
  setupStarted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Has the worker completed the statutory declaration for Overseas residency or citizenship */
  statDecHaveCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does the worker declare they have been an overseas resident or ciizen */
  statDecOtherCountryResident?: InputMaybe<Scalars['Boolean']['input']>;
  /** Information about the worker's past work history */
  workHistory?: InputMaybe<Array<WorkHistoryAttributes>>;
};

/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNode = {
  __typename?: 'WorkerProfileSearchNode';
  /** Worker's ABN */
  abn?: Maybe<Scalars['String']['output']>;
  /** Status of verifying the ABN */
  abnStatus?: Maybe<Scalars['Int']['output']>;
  /** Has the ABN been verified */
  abnVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Short bio of the worker */
  about?: Maybe<Scalars['String']['output']>;
  /** Admin badge: Gold/Silver/Bronze */
  adminBadges?: Maybe<Scalars['String']['output']>;
  /** Date at which registration as an Allied-Health professional expires */
  alliedRegistrationExpiry?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Registration number as an Allied-Health professional */
  alliedRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Data about when the worker is available to work (days/times) */
  availability: Availability;
  /** Date availability updated */
  availabilityUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Boolean to show/hide availability uplift feedback banner */
  availabilityUpliftFeedbackBannerVisible: Scalars['Boolean']['output'];
  /** All available badges */
  badges?: Maybe<Array<Badge>>;
  /** Worker's bank account */
  bankAccount?: Maybe<BankAccount>;
  /** Content to show to remind the worker to get their COVID Booster */
  boosterReminder?: Maybe<BoosterReminder>;
  /** ??? Passed to conversation_user_path */
  bypassEmptyCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Worker's uique set of experience and knowledge */
  careExperienceAndKnowledge?: Maybe<ExperienceAndKnowledge>;
  /** Does this worker have a working-with-children check (expired or current) */
  childrenCheckExists?: Maybe<Scalars['Boolean']['output']>;
  /** Expiry date for the working-with-children check */
  childrenCheckExpiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Registration number for this worker's working-with-children check */
  childrenCheckNumber?: Maybe<Scalars['String']['output']>;
  /** Relevant fields when visitor is a client */
  clientFields: ClientFields;
  /** Combined feedback */
  combinedFeedback?: Maybe<Scalars['Float']['output']>;
  /**
   * Has this worker gone through the COVID training
   * @deprecated No longer supported.
   */
  coronavirusTrainingExists?: Maybe<Scalars['Boolean']['output']>;
  /** What is the worker's COVID vaccination status */
  covidVaccineStatus?: Maybe<CovidVaccineStatusDisplayOptions>;
  /** Self declared COVID status confirmation */
  covidVaccineStatusConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** Date at which this worker received their CPR training */
  cprIssueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Worker's list of cultural background(s) */
  culturalBackgrounds: Culture;
  /** Does this worker have a current working-with-children check */
  currentWorkingWithChildrenCheck?: Maybe<Scalars['Boolean']['output']>;
  /** Hour range for `Delivered XX to XX support hours` label */
  deliveredHourGroup?: Maybe<Scalars['String']['output']>;
  /** If returned as part of a search, the distance from the current user (in kms) */
  distanceAway?: Maybe<Scalars['Float']['output']>;
  /** When does this worker's drivers licence expire */
  driversLicenceExpiryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Details of where and what this worker has studied */
  educationAndTraining?: Maybe<Array<EducationAndTraining>>;
  /** Eligible for Tax and super sync */
  eligibleForTaxAndSuperSync: Scalars['Boolean']['output'];
  /** Eligible for Tax and super sync same day payout */
  eligibleForTaxAndSuperSyncSameDayPayout: Scalars['Boolean']['output'];
  /** Last name of Emergency Contact */
  emergencyContactsLastName?: Maybe<Scalars['String']['output']>;
  /** Name for Emergency Contact */
  emergencyContactsName?: Maybe<Scalars['String']['output']>;
  /** Phone for Emergency Contact */
  emergencyContactsPhone?: Maybe<Scalars['String']['output']>;
  /** Relationship of Emergency Contact to worker */
  emergencyContactsRelationship?: Maybe<Scalars['String']['output']>;
  /** Does the worker have an active registration as an Enrolled Nurse */
  enrolledNurseActiveRegistration?: Maybe<Scalars['Boolean']['output']>;
  /** Confirming that they will follow all the rules for being a Enrolled Nurse */
  enrolledNurseAgreeComplyRules?: Maybe<Scalars['Boolean']['output']>;
  /** Experiences with certain kinds of care */
  experiences: Experience;
  /** When was this workers first aid certificate issued */
  firstAidIssueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Checkbox for offering a free meet and greet to potential clients */
  firstHourForFree: Scalars['Boolean']['output'];
  /** Does the worker have an active suspension against them */
  hasActiveSuspension?: Maybe<Scalars['Boolean']['output']>;
  /** Has this worker received the COVID vaccine */
  hasCovidVaccine?: Maybe<Scalars['Boolean']['output']>;
  /** ?Legacy - it's hard-coded false for every file that defines it */
  hasFairworkPendingNotification?: Maybe<Scalars['Boolean']['output']>;
  /** Has this worker received the seasonal flu vaccine */
  hasSeasonalFluShot?: Maybe<Scalars['Boolean']['output']>;
  /** Does the worker have at least one additional training (eg CPR, first-aid, drivers-licence) */
  hasSelectedAdditionalTraining?: Maybe<Scalars['Boolean']['output']>;
  /** Database ID of the worker */
  id: Scalars['ID']['output'];
  /** Immunisation section details */
  immunisation?: Maybe<Array<Immunisation>>;
  /** Most recent date of immunisation */
  immunisationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Has the worker gone through the infection-control training */
  infectionControlTrainingCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** If worker has declared bankruptcy, date it was declared */
  insuranceBankruptcyDate?: Maybe<Scalars['String']['output']>;
  /** Information on the circumstances leading to a declaration of bankruptcy */
  insuranceBankruptcyExplanation?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Combined General Liability claim against them, an explanation of that claim */
  insuranceClaimHistoryCgiExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made following a Combined General Liability claim against the worker (to prevent it in future) */
  insuranceClaimHistoryCgiPrevention?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Medical Malpractice or Professional Indemnity claim against them, an explanation of that claim */
  insuranceClaimHistoryMedPiExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made following a Medical Malpractice or Professional Indemnity claim against the worker (to prevent it in future) */
  insuranceClaimHistoryMedPiPrevention?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Personal Accident claim against them, an explanation of that claim */
  insuranceClaimHistoryPersonalAccidentExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made following a Personal Accident claim against the worker (to prevent it in future) */
  insuranceClaimHistoryPersonalAccidentPrevention?: Maybe<Scalars['String']['output']>;
  /** Details around the worker's insurance history */
  insuranceDetails?: Maybe<Array<Scalars['String']['output']>>;
  /** Date of first relevant paid care experience */
  insuranceFirstExperienceDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** If worker is aware of circumstances prompting a future claim against them, an explanation of that claim */
  insuranceFutureClaimAgainstExplanation?: Maybe<Scalars['String']['output']>;
  /** What changes have been made to prevent a future claim against the worker */
  insuranceFutureClaimAgainstPrevention?: Maybe<Scalars['String']['output']>;
  /** Has the worker had a Personal Accident claim against them */
  insurancePersonalAccident?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker had a Professional Indemnity claim against them */
  insuranceProfessionalIndemnity?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker had a Combined General Liability claim against them */
  insurancePublicLiability?: Maybe<Scalars['Boolean']['output']>;
  /** If worker has had a Workers Compensation claim, the date at which it occurred */
  insuranceWorkersCompClaimDate?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Workers Compensation claim, the main tasks/duties performed */
  insuranceWorkersCompClaimDuties?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Workers Compensation claim, the relevant employer name */
  insuranceWorkersCompClaimEmployerName?: Maybe<Scalars['String']['output']>;
  /** If worker has had a Workers Compensation claim, an explanation of that claim */
  insuranceWorkersCompClaimExplanation?: Maybe<Scalars['String']['output']>;
  /** Worker's interests and hobbies */
  interests: Array<Interest>;
  /** Is carer migrated to availability uplift */
  isMigratedToAvailabilityUplift: Scalars['Boolean']['output'];
  /** Languages spoken by the worker */
  languages: Language;
  /** Is the worker LGBTI friendly */
  lgbtiFriendly?: Maybe<Scalars['Boolean']['output']>;
  /** Work location pins */
  locations?: Maybe<Array<Location>>;
  /** Loyalty badge name */
  loyaltyName?: Maybe<Scalars['String']['output']>;
  /** For how long has this worker been a member */
  memberSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** What type of worker is this (eg nurse, personal, social, allied) */
  myType?: Maybe<Array<Carer>>;
  /** Has the worker passed the NDIS worker screening check */
  ndisWorkerScreeningCheck?: Maybe<Scalars['Boolean']['output']>;
  /** NDIS Worker screening check has been verified by admin */
  ndisWorkerScreeningVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Is this worker a non-smoker */
  nonSmoker?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized type - from user */
  normalizedType: Scalars['String']['output'];
  /** The worker's Nursing registration number */
  nurseRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** The expiry date of the worker's Nursing registration */
  nursingRegistrationExpiry?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Platform services offered by the worker */
  offeredPlatformServices: Array<OfferedPlatformServiceItem>;
  /** Services offered by the worker */
  offeredServices: Array<OfferedServiceItem>;
  /** Details of the workers onboarding progress */
  onboardingStatus?: Maybe<OnboardingStatus>;
  /** Provides extra details when user selects other qualifications */
  otherQuals?: Maybe<Scalars['String']['output']>;
  /** Determine if PayNow modal should be shown */
  paynowModalStatus?: Maybe<Scalars['String']['output']>;
  /** Categories of the worker's personality eg 'Outgoing and engaging' */
  personalities: Array<Personality>;
  /** Description of the worker's personality */
  personality?: Maybe<Scalars['String']['output']>;
  /** Is the worker friendly towards pets */
  petFriendly?: Maybe<Scalars['Boolean']['output']>;
  /** Answers provided at police check step especially for BYO police check */
  policeCheckDeclaration?: Maybe<PoliceCheckDeclaration>;
  /** Street address for postal address */
  postalAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Suburb/state/postcode for postal address */
  postalAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Worker preferences eg No pets or non-smoker */
  preferences: Array<Preference>;
  /** Has the worker completed the Professional Responsibility training? */
  professionalResponsibilityTrainingCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Status of profile completion */
  profileStatus?: Maybe<ProfileStatus>;
  /** Set of changes proposed for the profile */
  proposedChanges?: Maybe<ProposedChanges>;
  /** Changes proposed for the about field */
  proposedChangesAbout?: Maybe<Scalars['String']['output']>;
  /** Proposed new avatar */
  proposedChangesAvatar?: Maybe<Scalars['String']['output']>;
  /** Changes proposed to CPR certification date */
  proposedChangesCprCertificate?: Maybe<ProposedChangesSelectedDate>;
  /** Changes proposed to drivers licence certification date */
  proposedChangesDriversLicense?: Maybe<ProposedChangesSelectedDate>;
  /** Changes proposed to first aid certification date */
  proposedChangesFirstAid?: Maybe<ProposedChangesSelectedDate>;
  /** Changes proposed to working-with-children check date */
  proposedChangesWwcc?: Maybe<ProposedChangesWwcc>;
  /** Worker qualifications eg required certificates in certain kinds of care */
  qualifications?: Maybe<Array<WorkerQualificationsOptions>>;
  /** Rates this worker will charge for their care */
  rates?: Maybe<Array<Rate>>;
  /** Ratings that other clients have given this worker */
  ratings?: Maybe<Array<Rating>>;
  /** Professional references for this worker */
  references?: Maybe<Array<Reference>>;
  /** Religion (if any) of the worker */
  religion: Array<Religion>;
  /** Worker responsiveness */
  response: Response;
  /** Has this worker reviewed their COVID training */
  reviewCoronavirusTrainingVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Has Mable verified this workers Professional Responsibility training? */
  reviewProfessionalResponsibilityTrainingVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Showing conditional sections in worker profile */
  sectionVisibility: SectionVisibility;
  /**
   * Legacy - Use `offeredServices` instead
   * @deprecated Use `WorkerProfile.offeredServices` instead.
   */
  services?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the worker has started setting up their profile */
  setupStarted?: Maybe<Scalars['Boolean']['output']>;
  /** Information about workers references/endorsement that will be made visible to others */
  shareableReferencesSummary?: Maybe<ShareableReferencesSummary>;
  /** Determine if drivers licence should be shown in additional training page */
  showDriversLicenseOption?: Maybe<Scalars['Boolean']['output']>;
  /** Should we show the paynow intro (eg if user is eligible for paynow and has other relevant requirements) */
  showPaynowIntro?: Maybe<Scalars['Boolean']['output']>;
  /** Has the worker completed the statutory declaration for Overseas residency or citizenship */
  statDecHaveCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Does the worker declare they have been an overseas resident or ciizen */
  statDecOtherCountryResident?: Maybe<Scalars['Boolean']['output']>;
  /** Status of the working-with-chidren check */
  stateOfWwccIssue?: Maybe<Scalars['String']['output']>;
  /** Verification status of the statutory declaration for Overseas residency or citizenship */
  statutoryDeclarationStatus?: Maybe<Scalars['Boolean']['output']>;
  /** User object for this worker */
  user: User;
  /** ID of the user object for this worker */
  userId: Scalars['Int']['output'];
  /** Verified by Mable */
  verified?: Maybe<MableVerified>;
  /** Information about the worker's past work history */
  workHistory?: Maybe<Array<WorkHistory>>;
  /** Does the worker have a working-with-children check */
  workingWithChildren?: Maybe<Scalars['Boolean']['output']>;
};


/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNodeCulturalBackgroundsArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNodeExperiencesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNodeInterestsArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNodeLanguagesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNodePersonalitiesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNodePreferencesArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** All of the fields required for searching Worker Profiles */
export type WorkerProfileSearchNodeReligionArgs = {
  selectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for WorkerProfileSearchNode. */
export type WorkerProfileSearchNodeConnection = {
  __typename?: 'WorkerProfileSearchNodeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkerProfileSearchNodeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WorkerProfileSearchNode>>>;
  /** Offset from the start of the search results */
  offset: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** What page of the search result has been requested */
  pageNumber: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  /** Total pages of search result */
  totalPages: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkerProfileSearchNodeEdge = {
  __typename?: 'WorkerProfileSearchNodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WorkerProfileSearchNode>;
};

/** More details worker properties - can be used to filter workers for a client */
export enum WorkerPropertiesOptions {
  HasCovidVaccine = 'has_covid_vaccine',
  HasSeasonalFluShot = 'has_seasonal_flu_shot',
  LgbtiFriendly = 'lgbti_friendly',
  NonSmoker = 'non_smoker',
  PetFriendly = 'pet_friendly'
}

/** Worker qualifications - can be used to filter workers for a client */
export enum WorkerQualificationsOptions {
  AgedCare_3 = 'aged_care_3',
  AgedCare_4 = 'aged_care_4',
  AlliedHealthDegree = 'allied_health_degree',
  Cert_3Home = 'cert_3_home',
  Cert_3IndividualAgedCare = 'cert_3_individual_aged_care',
  Cert_3IndividualDisability = 'cert_3_individual_disability',
  Cert_4Home = 'cert_4_home',
  CprCertificate = 'cpr_certificate',
  /** Indicate they have a police check */
  CriminalOffencePoliceCheck = 'criminal_offence_police_check',
  DriversLicense = 'drivers_license',
  EnrolledNurse = 'enrolled_nurse',
  FirstAid = 'first_aid',
  FourInDisabilities = 'four_in_disabilities',
  IndividualSupport_3 = 'individual_support_3',
  ManualHandlingCertified = 'manual_handling_certified',
  MedicationAssistanceQualified = 'medication_assistance_qualified',
  /** Indicates user has passed an NDIS worker screening check */
  NdisWorkerScreeningVerified = 'ndis_worker_screening_verified',
  NursingDegree = 'nursing_degree',
  OccupationalTherapy = 'occupational_therapy',
  Other = 'other',
  Physiotherapy = 'physiotherapy',
  Psychological = 'psychological',
  RegisteredNurse = 'registered_nurse',
  SpeechTherapy = 'speech_therapy',
  ThreeInDisabilities = 'three_in_disabilities',
  WorkingTowardDegree = 'working_toward_degree',
  /** Indicate user is a first year student */
  WorkingTowardDegreeFirstYear = 'working_toward_degree_first_year',
  Years_1OrMoreNurse = 'years_1_or_more_nurse',
  Years_2OrMorePersonal = 'years_2_or_more_personal'
}

/** Details of the rate that a support-worker will charge */
export type WorkerRateAttributes = {
  /** Is this a flat-rate */
  flatRate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rate amount in cents */
  rateCents?: InputMaybe<Scalars['Int']['input']>;
  /** A name for the rate */
  rateName: WorkerRateNameOptions;
};

/** Valid types of worker rates */
export enum WorkerRateNameOptions {
  /** 24HourShift - Enum does not support a value starting with number */
  DayShift = 'DayShift',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Weekday = 'Weekday',
  Weekend = 'Weekend'
}

/** Details used to filter the worker-search for a client */
export type WorkerSearchFilterAttribute = {
  /** Advanced search filter details */
  advanced?: InputMaybe<WorkerAdvancedSearchFilterAttribute>;
  /** Basic search filter */
  basicSearch?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Page we're up to - in a paginated set of results */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search string */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Suburb details to filter by */
  suburb?: InputMaybe<SuburbSearchAttributes>;
  /** Type of worker to filter results */
  workerType?: InputMaybe<Scalars['String']['input']>;
};

/** Fields for the worker tags object */
export type WorkerTags = {
  __typename?: 'WorkerTags';
  /** Support worker has worked with organisation */
  previouslyEngagedByOrganisation: Scalars['Boolean']['output'];
  /** services_match of the worker for the job */
  servicesMatch: ServicesMatch;
  /** Support worker stat dec verification status */
  statutoryDeclarationStatus: Scalars['Boolean']['output'];
  /** user_id of the worker */
  workerId: Scalars['ID']['output'];
};

/** Autogenerated input type of WorkerUpdate */
export type WorkerUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user we're updating */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Attributes of worker to update */
  userAttributes: WorkerAttributes;
};

/** Autogenerated return type of WorkerUpdate */
export type WorkerUpdatePayload = {
  __typename?: 'WorkerUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns the updated user */
  user?: Maybe<User>;
};

/** Data for the dashboard component showing support-worker account/onboarding progress */
export type WorkersAccountProgress = {
  __typename?: 'WorkersAccountProgress';
  /** What percent of progress is completed */
  percent?: Maybe<Scalars['Int']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Worker Dashboard Agreements Component */
export type WorkersAgreements = {
  __typename?: 'WorkersAgreements';
  /** Data for the agreement */
  data?: Maybe<Array<WorkersAgreementsData>>;
  /** Heading displayed for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Worker Dashboard Agreements Component Data */
export type WorkersAgreementsData = {
  __typename?: 'WorkersAgreementsData';
  /** Service that will be provided by the carer to the customer */
  agreedService?: Maybe<Scalars['String']['output']>;
  /** ID of amendment object - with agreement data being amended */
  amendmentId?: Maybe<Scalars['Int']['output']>;
  /** Actions that are available for this agreement */
  availableActions?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of carer eg Nurse */
  carerType?: Maybe<Scalars['String']['output']>;
  /** Age of the customer */
  consumerAge?: Maybe<Scalars['Int']['output']>;
  /** Gender of the customer */
  consumerGender?: Maybe<Scalars['String']['output']>;
  /** Is the customer the participant (the person receiving care) */
  consumerIsParticipant?: Maybe<Scalars['Boolean']['output']>;
  /** Relationship of customer to participant eg Parent/Self */
  consumerRelationship?: Maybe<Scalars['String']['output']>;
  /** Conversation between parties to this agreement */
  conversation?: Maybe<Conversation>;
  /** ID of conversation - see conversation for more attributes */
  conversationId?: Maybe<Scalars['Int']['output']>;
  /** First name of the other party to this agreement */
  firstNameOfOtherParticipant?: Maybe<Scalars['String']['output']>;
  /** ID of the agreement */
  id?: Maybe<Scalars['Int']['output']>;
  /** Full name of the other party */
  nameOfOtherParticipant?: Maybe<Scalars['String']['output']>;
  /** Permalink for the other party */
  otherParticipantsPermalink?: Maybe<Scalars['String']['output']>;
  /** Address for the other party */
  otherUserAddress?: Maybe<Scalars['String']['output']>;
  /** Avatar for the other party */
  otherUserAvatar?: Maybe<Scalars['String']['output']>;
  /** ID for the other party */
  otherUserId?: Maybe<Scalars['Int']['output']>;
  /** Phone for the other party */
  otherUserPhone?: Maybe<Scalars['String']['output']>;
  /** Agreed carer-rates in dollars */
  ratesInDollars?: Maybe<Array<WorkersAgreementsRates>>;
  /** Status of the agreement */
  status?: Maybe<Scalars['String']['output']>;
  /** ??? What tab this agreement appears on ??? */
  tab?: Maybe<Scalars['String']['output']>;
  /** When this agreement was terminated */
  terminatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Has the other party viewed the acceptance fo this agreement */
  viewedAcceptance?: Maybe<Scalars['Boolean']['output']>;
  /** ??? Welcome message */
  welcomeMessage?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Worker Dashboard Agreements Component Data / Rates in Dollars */
export type WorkersAgreementsRates = {
  __typename?: 'WorkersAgreementsRates';
  /** Is this a flat-rate */
  flatRate?: Maybe<Scalars['Boolean']['output']>;
  /** The rate in dollars */
  rateDollars?: Maybe<Scalars['Float']['output']>;
  /** Name for this rate */
  rateName?: Maybe<Scalars['String']['output']>;
  /** Rate including Mable fees */
  rateWithFee?: Maybe<Scalars['Float']['output']>;
};

/** Field definitions for Worker Dashboard Build Your Profile Type */
export type WorkersBuildYourProfile = {
  __typename?: 'WorkersBuildYourProfile';
  /** Body of the dashboard component */
  body?: Maybe<Scalars['String']['output']>;
  /** Heading of this dashboard component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Should the profile-builder section be visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for "Business Cards & Flyers" Component on the worker dashboard - it promotes use of business cards and flyers for the worker */
export type WorkersBusinessCardsAndFlyers = {
  __typename?: 'WorkersBusinessCardsAndFlyers';
  /** Details of business cards and flyers to be displayed in the component */
  data?: Maybe<WorkersBusinessCardsAndFlyersData>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** More detailed fields for "Business Cards & Flyers" Component on the worker dashboard */
export type WorkersBusinessCardsAndFlyersData = {
  __typename?: 'WorkersBusinessCardsAndFlyersData';
  /** URL link of the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Text of the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Detailed description to be displayed in the component */
  description?: Maybe<Scalars['String']['output']>;
};

/** Data for dashboard component showing COVID vaccine prompt */
export type WorkersCovidVaccineAction = {
  __typename?: 'WorkersCovidVaccineAction';
  /** Body of the prompt */
  body?: Maybe<Scalars['String']['output']>;
  /** HTTP action of the CTA link */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL of the CTA link */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Link-text of the CTA link */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Heading of the dashboard component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Data for the worker checklist on the dashboard */
export type WorkersDashboardChecklist = {
  __typename?: 'WorkersDashboardChecklist';
  /** Data to display for the worker checklist */
  data?: Maybe<WorkersDashboardChecklistData>;
  /** Is this dashboard component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Buttons listed in the dashboard component showing the onboarding checklist for a support-worker */
export type WorkersDashboardChecklistButtons = {
  __typename?: 'WorkersDashboardChecklistButtons';
  /** One of Internal or External */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** One of Primary or Secondary */
  ctaType?: Maybe<Scalars['String']['output']>;
};

/** Data for dashboard component showing the onboarding checklist for a support-worker */
export type WorkersDashboardChecklistData = {
  __typename?: 'WorkersDashboardChecklistData';
  /** An overview of how much progress the worker has made so far in this checklist */
  progress?: Maybe<WorkersDashboardChecklistProgress>;
  /** Details of the steps in the checklist */
  steps?: Maybe<Array<WorkersDashboardChecklistSteps>>;
};

/** Data showing the progress through the worker's dashboard onboarding-checklist */
export type WorkersDashboardChecklistProgress = {
  __typename?: 'WorkersDashboardChecklistProgress';
  /** Message to display alongside the progress */
  message?: Maybe<Scalars['String']['output']>;
  /** Percentage of the checklist complete so far */
  percentage?: Maybe<Scalars['Int']['output']>;
};

/** Details of the steps in the onboarding-checklist for a support-worker (displayed in the dashboard) */
export type WorkersDashboardChecklistSteps = {
  __typename?: 'WorkersDashboardChecklistSteps';
  /** Body of the component to be displayed */
  body?: Maybe<Scalars['String']['output']>;
  /** Buttons listed in the onboarding checklist */
  buttons?: Maybe<Array<WorkersDashboardChecklistButtons>>;
  /** Have the steps all been completed */
  completed?: Maybe<Scalars['Boolean']['output']>;
  /** What step are we up to */
  stepNumber?: Maybe<Scalars['Int']['output']>;
  /** Title of the dashboard component */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Worker Dashboard Dashboard Tiles Component */
export type WorkersDashboardTiles = {
  __typename?: 'WorkersDashboardTiles';
  /** Agreements this worker has made */
  agreements?: Maybe<WorkersAgreements>;
  /** Business cards and flyers for this worker */
  businessCardsAndFlyers?: Maybe<WorkersBusinessCardsAndFlyers>;
  /** Documents of this worker that have expired */
  expiredDocuments?: Maybe<WorkersExpiredDocuments>;
  /** Helpful links for this worker */
  helpfulLinks?: Maybe<WorkersHelpfulLinks>;
  /** Invitations for this worker */
  invitations?: Maybe<WorkersInvitations>;
  /** Messages for this worker */
  messages?: Maybe<WorkersMessages>;
  /** Recent jobs this worker has applied for */
  recentJobs?: Maybe<WorkersRecentJobs>;
  /** References for this worker */
  references?: Maybe<WorkersReferences>;
};

/** Fields for "Expired Documents" component on the worker dashboard - it lists any expired documents that the worker needs to update */
export type WorkersExpiredDocuments = {
  __typename?: 'WorkersExpiredDocuments';
  /** Detailed data about each expired document to display in the component */
  data?: Maybe<Array<WorkersExpiredDocumentsData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for an individual Expired Document - listed in the "Expired Documents" component on the worker dashboard */
export type WorkersExpiredDocumentsData = {
  __typename?: 'WorkersExpiredDocumentsData';
  /** Body-text to be displayed */
  body?: Maybe<Scalars['String']['output']>;
  /** URL of the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Text of the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** ID of the document */
  id?: Maybe<Scalars['String']['output']>;
  /** Image associated with the document */
  image?: Maybe<Scalars['String']['output']>;
  /** Field used for ordering the documents */
  order?: Maybe<Scalars['Int']['output']>;
  /** Title of the document */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Worker Dashboard Flags Component */
export type WorkersFlags = {
  __typename?: 'WorkersFlags';
  /** Does this worker have atleast 1 timesheet */
  hasTimesheets?: Maybe<Scalars['Boolean']['output']>;
  /** Does this worker have an agreement */
  haveAgreement?: Maybe<Scalars['Boolean']['output']>;
  /** Should we show the download-app CTA to this worker */
  showDownloadApp?: Maybe<Scalars['Boolean']['output']>;
  /** Should we show the stat-dec modal to this client */
  showStatDecModal?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Worker Dashboard Helpful Links Component */
export type WorkersHelpfulLinks = {
  __typename?: 'WorkersHelpfulLinks';
  /** Data that will be displayed in this component */
  data?: Maybe<Array<Scalars['String']['output']>>;
  /** Data for the list of links displayed in this component */
  dataMobile?: Maybe<Array<WorkersMobileLinks>>;
  /** Heading for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Worker Dashboard Hero Image Component */
export type WorkersHeroImage = {
  __typename?: 'WorkersHeroImage';
  /** Display text for the body of this dashboard tile */
  body?: Maybe<Scalars['String']['output']>;
  /** Heading for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** What phase is the hero image (eg just_started/approved etc) */
  phase?: Maybe<Scalars['String']['output']>;
  /** Subheading for this component */
  subheading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for Worker Dashboard Invitations Component */
export type WorkersInvitations = {
  __typename?: 'WorkersInvitations';
  /** Data for individual invitations displayed in this component */
  data?: Maybe<Array<WorkersInvitationsData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for a Worker Dashboard Invitation Component */
export type WorkersInvitationsData = {
  __typename?: 'WorkersInvitationsData';
  /** ID of the conversation between this support-worker and client */
  conversationId?: Maybe<Scalars['Int']['output']>;
  /** When this invitation was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** URL of the avatar of the sender of this invitation */
  senderAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Email of the sender of this invitation */
  senderEmail?: Maybe<Scalars['String']['output']>;
  /** Full name of the sender of this invitation */
  senderFullName?: Maybe<Scalars['String']['output']>;
  /** Status of this invitation */
  status?: Maybe<Scalars['String']['output']>;
  /** Unique user ID of the sender of this invitation */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Fields for "LMJ (last minute job) promotion" component on the worker induction-dashboard - it promotes turning on notifications for last-minute (flex) jobs */
export type WorkersLmjPromotion = {
  __typename?: 'WorkersLmjPromotion';
  /** Details to be displayed about the promotion */
  data?: Maybe<WorkersLmjPromotionData>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is the component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Detailed fields for "LMJ (last minute job) Promotion" component on the worker dashboard */
export type WorkersLmjPromotionData = {
  __typename?: 'WorkersLmjPromotionData';
  /** URL of the CTA link */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Text of the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Set of descriptions of the promotion */
  descriptions?: Maybe<Array<Scalars['String']['output']>>;
  /** Set of dropdown items displayed for the promotion */
  dropdownItems?: Maybe<Array<Scalars['String']['output']>>;
  /** Text explaining the dropdown */
  dropdownText?: Maybe<Scalars['String']['output']>;
};

/** Fields for "News" Component on the worker dashboard - it lists any Mable news-items we want the worker to see (eg learning-hub/COVID/tax-time news items) */
export type WorkersMableNews = {
  __typename?: 'WorkersMableNews';
  /** Details of individual news items */
  data?: Maybe<Array<WorkersMableNewsData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is the component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for an individual news item in the "News" component on the worker dashboard */
export type WorkersMableNewsData = {
  __typename?: 'WorkersMableNewsData';
  /** Body-text of the news item */
  body?: Maybe<Scalars['String']['output']>;
  /** URL of the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Text of the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Image to display alongside the news item */
  image?: Maybe<Scalars['String']['output']>;
  /** Column used for ordering news items */
  order?: Maybe<Scalars['Int']['output']>;
  /** Title of the news item */
  title?: Maybe<Scalars['String']['output']>;
};

/** field definitions for Worker Dashboard Messages Component */
export type WorkersMessages = {
  __typename?: 'WorkersMessages';
  /** Details of the message */
  data?: Maybe<Array<WorkersMessagesData>>;
  /** Main heading of the dashboard component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Worker Dashboard Messages Component Data */
export type WorkersMessagesData = {
  __typename?: 'WorkersMessagesData';
  /** Avatar of the client who wrote this message */
  clientAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the client who wrote the message */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Wen the message was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the message */
  id?: Maybe<Scalars['Int']['output']>;
  /** Date scheduled for the meet and greet */
  meetAndGreetDate?: Maybe<Scalars['String']['output']>;
  /** ID of the meet and greet */
  meetAndGreetId?: Maybe<Scalars['Int']['output']>;
  /** Location of the meet and greet */
  meetAndGreetPlace?: Maybe<Scalars['String']['output']>;
  /** Name of the person requested for the meet and greet */
  meetAndGreetRequesteeFirstName?: Maybe<Scalars['String']['output']>;
  /** Name of the person requesting the  meet and greet */
  meetAndGreetRequestorFirstName?: Maybe<Scalars['String']['output']>;
  /** Status of the meet and greet */
  meetAndGreetStatus?: Maybe<Scalars['String']['output']>;
  /** Time scheduled for the meet and greet */
  meetAndGreetTime?: Maybe<Scalars['String']['output']>;
  /** Type of meet and greet */
  meetAndGreetType?: Maybe<Scalars['String']['output']>;
  /** Body of the message */
  messageBody?: Maybe<Scalars['String']['output']>;
  /** Kind of message */
  messageKind?: Maybe<Scalars['String']['output']>;
  /** Who wrote the message */
  messageOwner?: Maybe<Scalars['String']['output']>;
  /** What type of participant is the other party */
  otherParticipantsWorkType?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Worker Helpful Links, Mobile version */
export type WorkersMobileLinks = {
  __typename?: 'WorkersMobileLinks';
  /** URL for the link */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the link */
  ctaText?: Maybe<Scalars['String']['output']>;
};

/** Fields for the "Recent Jobs" component on the worker Dashboard - it lists a set of recently posted jobs the worker might be interested in */
export type WorkersRecentJobs = {
  __typename?: 'WorkersRecentJobs';
  /** Details of recent jobs to be displayed */
  data?: Maybe<Array<WorkersRecentJobsData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is the component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for a recently posted job listed in the "Recent Jobs" component in the worker dashboard */
export type WorkersRecentJobsData = {
  __typename?: 'WorkersRecentJobsData';
  /** ID of the job */
  id?: Maybe<Scalars['Int']['output']>;
  /** Location of the job */
  jobLocation?: Maybe<Scalars['String']['output']>;
  /** Title of the job */
  title?: Maybe<Scalars['String']['output']>;
};

/** Fields for the "Workers References" component on the worker dashboard - it shows the status of their reference-requests */
export type WorkersReferences = {
  __typename?: 'WorkersReferences';
  /** Fields detailing a worker's reference-requests */
  data?: Maybe<Array<WorkersReferencesData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is the compnent visible in the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for an individual reference-request - listed on the "Workers References" component in the worker dashboard */
export type WorkersReferencesData = {
  __typename?: 'WorkersReferencesData';
  /** Summary detailing how reference-requests have been sent (eg through email/sms etc) */
  deliverySummary?: Maybe<Array<Scalars['String']['output']>>;
  /** Date of the last delivered reference-request */
  lastDeliveryDate?: Maybe<Scalars['String']['output']>;
  /** Publicly visible status of the reference-request */
  publicStatus?: Maybe<Scalars['String']['output']>;
  /** Full name of the person of whom a reference has been requested */
  refereeFullName?: Maybe<Scalars['String']['output']>;
  /** Details of the current status of the reference-request */
  state?: Maybe<WorkersReferencesState>;
};

/** Fields for the status of a worker's reference */
export type WorkersReferencesState = {
  __typename?: 'WorkersReferencesState';
  /** Status of the reference (eg initiated/complete_questionnaire/approved_reference) */
  status?: Maybe<Scalars['String']['output']>;
  /** Text explaining the status */
  text?: Maybe<Scalars['String']['output']>;
};

/** Fields for the workers tags object */
export type WorkersTags = {
  __typename?: 'WorkersTags';
  /** tags of all the workers */
  tags: Array<WorkerTags>;
};

/** Fields for the "Updates Due" component on the worker dashboard - it shows reminders for Mable-relevant updates eg flu-shot, NDIS training, and statutory-declaration */
export type WorkersUpdatesDue = {
  __typename?: 'WorkersUpdatesDue';
  /** Details of individual worker updates to be displayed */
  data?: Maybe<Array<WorkersUpdatesDueData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is the component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for individual Update - listed on the "Updates Due" component on the worker dashboard */
export type WorkersUpdatesDueData = {
  __typename?: 'WorkersUpdatesDueData';
  /** Body of the update */
  body?: Maybe<Scalars['String']['output']>;
  /** URL of the CTA */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Text of the CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Image associated with the update */
  image?: Maybe<Scalars['String']['output']>;
  /** Field for ordering the updates */
  order?: Maybe<Scalars['Int']['output']>;
  /** Title of the update */
  title?: Maybe<Scalars['String']['output']>;
};

/** Field definitions for Worker Dashboard Urgent Call To Action Component */
export type WorkersUrgentCallToAction = {
  __typename?: 'WorkersUrgentCallToAction';
  /** Data for the Call to Action component */
  data?: Maybe<WorkersUrgentCallToActionData>;
  /** Heading for this component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is this component visible */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Field definitions for Worker Dashboard Urgent Call To Action Component Data */
export type WorkersUrgentCallToActionData = {
  __typename?: 'WorkersUrgentCallToActionData';
  /** HTTP action for the CTA link */
  ctaAction?: Maybe<Scalars['String']['output']>;
  /** URL for the CTA link */
  ctaLink?: Maybe<Scalars['String']['output']>;
  /** Display-text for the CTA link */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** Input-type for the CTA link */
  ctaType?: Maybe<Scalars['String']['output']>;
  /** Display-text to explain the CTA link */
  description?: Maybe<Scalars['String']['output']>;
};

/** Fields for the "What You Will Need" component on the worker dashboard - it lists requirements needed for being a worker on Mable eg qualifications, WWC check, ABN data */
export type WorkersWhatYouWillNeed = {
  __typename?: 'WorkersWhatYouWillNeed';
  /** Details of list of 'what you will need' data */
  data?: Maybe<Array<WorkersWhatYouWillNeedData>>;
  /** Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** Is the component visible on the dashboard */
  visible?: Maybe<Scalars['Boolean']['output']>;
};

/** Fields for an individual item in the "What You Will Need" component on the worker dashboard */
export type WorkersWhatYouWillNeedData = {
  __typename?: 'WorkersWhatYouWillNeedData';
  /** Has this item been done */
  done?: Maybe<Scalars['Boolean']['output']>;
  /** Text explaining the list item */
  text?: Maybe<Scalars['String']['output']>;
};
